import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  ISO8601Date: any;
  ISO8601DateTime: any;
  JSON: any;
};

/** The available badge types for employee badges. */
export enum AchievementBadgeType {
  Counter = 'COUNTER',
  Milestone = 'MILESTONE',
  OneTime = 'ONE_TIME',
}

/** Represents an achievement category */
export type AchievementCategory = {
  /** list a Company Achievements */
  companyAchievements: Maybe<Array<CompanyAchievement>>;
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  enabled: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The available achievement statuses. */
export enum AchievementStatus {
  All = 'ALL',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
}

export enum ActionEnum {
  Complete = 'COMPLETE',
  Open = 'OPEN',
}

/** ActionItem type */
export type ActionItem = {
  action: Scalars['String'];
  actionable: Actionable;
  company: Company;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  creator: Employee;
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ActionItem. */
export type ActionItemConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ActionItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ActionItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ActionItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ActionItem>;
};

/** Actionable type */
export type Actionable = FreeformGoal | MetricGoalEmployee;

/** Available Actionable types */
export enum ActionableTypeEnum {
  EmployeeMetricGoal = 'EMPLOYEE_METRIC_GOAL',
  FreeformGoal = 'FREEFORM_GOAL',
}

/** Autogenerated input type of ActivateEmployee */
export type ActivateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Actors for Coaching */
export type Actor = Company | Employee;

/** Autogenerated input type of AddCoachingTopicToSession */
export type AddCoachingTopicToSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
  topicId: Scalars['ID'];
};

/** Autogenerated return type of AddCoachingTopicToSession. */
export type AddCoachingTopicToSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  coachingTopic: Maybe<CoachingTopic>;
  errors: Maybe<Array<ValidationError>>;
  publicNote: Maybe<CoachingSessionNote>;
};

/** Autogenerated input type of AddMember */
export type AddMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  groupId: Scalars['ID'];
};

/** Autogenerated input type of AddMemberReportingGroup */
export type AddMemberReportingGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  reportingGroupId: Scalars['ID'];
};

/** Autogenerated input type of AddNegativeFeedbackToCoachingTopic */
export type AddNegativeFeedbackToCoachingTopicInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  feedbackComment?: InputMaybe<Scalars['String']>;
  feedbackReason?: InputMaybe<NegativeFeedbackReasonEnum>;
  topicId: Scalars['ID'];
};

/** Autogenerated return type of AddNegativeFeedbackToCoachingTopic. */
export type AddNegativeFeedbackToCoachingTopicPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  coachingTopic: Maybe<CoachingTopic>;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of AddTeamMember */
export type AddTeamMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  teamId: Scalars['ID'];
};

/** Alignment Score Comparisons type */
export type AlignmentScoreComparisons = {
  current: Maybe<Scalars['Int']>;
  previous: Maybe<Scalars['Int']>;
};

/** Answerable types */
export enum AnswerableTypeEnum {
  QaReview = 'QA_REVIEW',
  QaReviewAudit = 'QA_REVIEW_AUDIT',
}

/** Autogenerated input type of AppealQaReview */
export type AppealQaReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  qaReviewId: Scalars['ID'];
  reasons: Array<QaAppealReasonInput>;
};

/** Autogenerated input type of ApplyCoachingTemplateToPublicNote */
export type ApplyCoachingTemplateToPublicNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  noteId: Scalars['ID'];
  templateId: Scalars['ID'];
};

/** Autogenerated return type of ApplyCoachingTemplateToPublicNote. */
export type ApplyCoachingTemplateToPublicNotePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  publicNote: Maybe<CoachingSessionNote>;
};

/** Autogenerated input type of ArchiveCoachingTemplate */
export type ArchiveCoachingTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ArchiveCoachingTemplate. */
export type ArchiveCoachingTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  coachingTemplate: Maybe<CoachingTemplate>;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of ArchiveFreeformGoal */
export type ArchiveFreeformGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of ArchiveMetricGoal */
export type ArchiveMetricGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: MetricGoalTypeEnum;
};

/** Autogenerated input type of ArchiveQaAssignment */
export type ArchiveQaAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Bring the list of Areas of Excellence that can be used in this company */
export type AreaOfExcellence = {
  caption: Scalars['String'];
  id: Scalars['Int'];
};

/** The status of the Areas of Excellence of the company, either all or just the ones that are selected */
export enum AreaOfExcellenceStatus {
  All = 'ALL',
  Selected = 'SELECTED',
}

/** Autogenerated input type of AssignLesson */
export type AssignLessonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  coachingSessionId: Scalars['ID'];
  lessonId: Scalars['ID'];
};

/** QaReview::Audit filter object */
export type AuditFilterInput = {
  assignmentIds?: InputMaybe<Array<Scalars['ID']>>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorIds?: InputMaybe<Array<Scalars['ID']>>;
  autofailed?: InputMaybe<Scalars['Boolean']>;
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  dateField?: InputMaybe<QaReviewDateFieldEnum>;
  dateRange: DateTimeRangeInput;
  excludeTags?: InputMaybe<Array<Scalars['String']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  includeTags?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  qaFormIds?: InputMaybe<Array<Scalars['ID']>>;
  reviewerIds?: InputMaybe<Array<Scalars['ID']>>;
  state?: InputMaybe<QaReviewStateEnum>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Available Audit fields for sorting */
export enum AuditSortFieldEnum {
  AuditorName = 'AUDITOR_NAME',
  AuditType = 'AUDIT_TYPE',
  CompletedAt = 'COMPLETED_AT',
  Interaction = 'INTERACTION',
  ReviewerName = 'REVIEWER_NAME',
  Score = 'SCORE',
  StartedAt = 'STARTED_AT',
}

/** Audit sorting parameters */
export type AuditSortInput = {
  direction?: SortDirectionEnum;
  field?: AuditSortFieldEnum;
};

/** Audit Type enum */
export enum AuditTypeEnum {
  Calibration = 'CALIBRATION',
  Regular = 'REGULAR',
}

/** Union of all auditable types */
export type AuditableUnion = QaReviewCalibrationAudit | QaReviewRegularAudit;

/** Represents an achievement badge */
export type Badge = {
  achievementKey: Scalars['String'];
  badgeType: Scalars['String'];
  description: Scalars['String'];
  iconSettings: Maybe<Scalars['JSON']>;
  imageUrl: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
  surprise: Scalars['Boolean'];
  threshold: Maybe<Scalars['Int']>;
  tierKey: Maybe<Scalars['String']>;
};

/** The maximum amount of agents to display in the leaderboard */
export type BoardSize = {
  options: Array<BoardSizeOption>;
  selected: Scalars['String'];
};

export type BoardSizeOption = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export type Brand = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated input type of BulkDeactivateEmployees */
export type BulkDeactivateEmployeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['ID']>;
  transfersToManager?: InputMaybe<Array<TransferToManagerInput>>;
};

/** Autogenerated return type of BulkDeactivateEmployees. */
export type BulkDeactivateEmployeesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  deactivatedTeamLeaders: Maybe<Array<Employee>>;
  deactivatedTeamMembers: Maybe<Array<Employee>>;
  errors: Maybe<Array<BulkDeactivationValidation>>;
};

/** Errors when bulk deactivating employees */
export type BulkDeactivationValidation = {
  message: Scalars['String'];
  type: BulkDeactivationValidationEnum;
};

/** Error types when deactivating employees */
export enum BulkDeactivationValidationEnum {
  /** Employee is not a team member of a manager to be deactivated */
  EmployeeCannotNotBeTransferred = 'EMPLOYEE_CANNOT_NOT_BE_TRANSFERRED',
  /** Managers that will be deactivated in this mutation cannot be a manager to be transferred to */
  ManagerToBeDeactivated = 'MANAGER_TO_BE_DEACTIVATED',
  /** User listed as the manager to transfer to is not a manager in the system */
  NotAManager = 'NOT_A_MANAGER',
  /** Employee not found in the system. Could be because of scope restrictions */
  NotFound = 'NOT_FOUND',
  /** Employee from a deactivated manager was not moved to another manager */
  OrphanedEmployee = 'ORPHANED_EMPLOYEE',
}

/** The surface area of what the metric was calculated from */
export enum CalculatedOverEnum {
  All = 'ALL',
  Group = 'GROUP',
}

/** Category Metric Result */
export type CategoricalMetricsResult = {
  category: Maybe<Scalars['String']>;
  categoryId: Maybe<Scalars['Int']>;
  count: Maybe<Scalars['Int']>;
  label: Maybe<Scalars['String']>;
  percent: Maybe<Scalars['Float']>;
};

/** The payload for the result of a metric by category. */
export type CategoricalMetricsResults = {
  areasEnabled: Maybe<Scalars['Boolean']>;
  categories: Maybe<Array<CategoricalMetricsResult>>;
};

/** Autogenerated input type of ChangeCompanyState */
export type ChangeCompanyStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  event: CompanyStateEvent;
};

/** The communication channels available to a company. */
export type Channel = {
  active: Scalars['Boolean'];
  enumId: Scalars['String'];
  id: Scalars['ID'];
  /** Whether surveys send through channel automatically or manually. */
  integrated: Scalars['Boolean'];
  integration: Maybe<ChannelableIntegration>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** Channel-integration mapping */
export type ChannelIntegrationInput = {
  channelId: Scalars['ID'];
  /** Pass an empty string to unassign already assigned integration */
  integrationId: Scalars['ID'];
};

/** Channel types */
export enum ChannelTypeEnum {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Phone = 'PHONE',
}

/** "QA Transcript/Audio" integrations that can be assigned to channels using polymorphic association */
export type ChannelableIntegration = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Progress cleared dates by the reward tier type */
export type ClearedAtByTier = {
  high: Maybe<Scalars['String']>;
  low: Maybe<Scalars['String']>;
  mid: Maybe<Scalars['String']>;
};

/** Coaching Session Coachees Data types */
export type CoacheesData = {
  closedActionItemsCount: Maybe<Scalars['Int']>;
  draftCoachingSessionId: Maybe<Scalars['Int']>;
  entityId: Scalars['Int'];
  entityType: Scalars['String'];
  imageUrl: Scalars['String'];
  lastSession: Maybe<Scalars['ISO8601DateTime']>;
  lastSessionId: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  openActionItemsCount: Maybe<Scalars['Int']>;
  parentName: Maybe<Scalars['String']>;
  sessionsCount: Maybe<Scalars['Int']>;
};

/** The connection type for CoacheesData. */
export type CoacheesDataConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoacheesDataEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoacheesData>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoacheesDataEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoacheesData>;
};

export type CoacheesDataFilterInput = {
  allHierarchy?: InputMaybe<Scalars['Boolean']>;
  dateRange: DateRangeInput;
  entityType?: InputMaybe<EntityTypeEnum>;
  excludeTeamIds?: InputMaybe<Array<Scalars['ID']>>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum CoacheesDataSearchFieldEnum {
  Name = 'NAME',
}

/** Search Coachees Data using a combination of `value` and `on` arguments. */
export type CoacheesDataSearchInput = {
  /** The fields you want to match on. */
  on: Array<CoacheesDataSearchFieldEnum>;
  /** The value you want to match. Can't be blank. */
  value: Scalars['String'];
};

export enum CoacheesDataSortFieldEnum {
  LastSession = 'LAST_SESSION',
  Name = 'NAME',
  OpenActionItemsCount = 'OPEN_ACTION_ITEMS_COUNT',
  SessionsCount = 'SESSIONS_COUNT',
}

export type CoacheesDataSortInput = {
  direction?: SortDirectionEnum;
  field?: CoacheesDataSortFieldEnum;
};

export type CoachingIntelligenceSettings = {
  createdAt: Scalars['ISO8601DateTime'];
  defaultModel: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  termsAccepted: Maybe<Scalars['Boolean']>;
  termsAcceptedAt: Maybe<Scalars['ISO8601DateTime']>;
  termsAcceptedBy: Maybe<Employee>;
  termsExpired: Scalars['Boolean'];
  termsExpiry: Scalars['Boolean'];
  termsExpiryAt: Maybe<Scalars['ISO8601DateTime']>;
  termsRevisionMatches: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Coaching Session type */
export type CoachingSession = {
  archived: Maybe<Scalars['Boolean']>;
  coach: Employee;
  coachingSessionFiles: CoachingSessionFileConnection;
  createdAt: Scalars['ISO8601DateTime'];
  employee: Employee;
  fileAttachments: CoachingSessionFileAttachmentConnection;
  id: Scalars['ID'];
  interactionAttachments: CoachingSessionInteractionAttachmentConnection;
  kudos: CoachingSessionKudoConnection;
  lessons: CoachingSessionLessonConnection;
  metricAttachments: CoachingSessionMetricAttachmentConnection;
  notes: Maybe<Scalars['String']>;
  primaryTeam: Team;
  private: Maybe<Scalars['Boolean']>;
  privateNotes: CoachingSessionNoteConnection;
  publicNotes: CoachingSessionNoteConnection;
  qaReviewAttachments: CoachingSessionQaReviewAttachmentConnection;
  resharedAt: Maybe<Scalars['ISO8601DateTime']>;
  sharedAt: Maybe<Scalars['ISO8601DateTime']>;
  solicitationAttachments: CoachingSessionSolicitationAttachmentConnection;
  /** Takeaway collection resolver */
  takeaways: TakeawayConnection;
  title: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  urlAttachments: CoachingSessionUrlAttachmentConnection;
};

/** Coaching Session type */
export type CoachingSessionCoachingSessionFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionFileAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionInteractionAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionKudosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionMetricAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionPrivateNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionPublicNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionQaReviewAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionSolicitationAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Coaching Session type */
export type CoachingSessionTakeawaysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TakeawayFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TakeawaySortInput>>;
};

/** Coaching Session type */
export type CoachingSessionUrlAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Attributes for creating a Coaching Session Action Item */
export type CoachingSessionActionItemInput = {
  coachingSessionId: Scalars['ID'];
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  isPositive?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  takeawayCategoryId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};

/** Attributes for update a Coaching Session Action Item */
export type CoachingSessionActionItemUpdateInput = {
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  isPositive?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  takeawayCategoryId?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
};

export type CoachingSessionActionItemsResponse = {
  categories: Maybe<Array<TakeawayCategoryStat>>;
  collection: TakeawayConnection;
};

export type CoachingSessionActionItemsResponseCollectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for CoachingSession. */
export type CoachingSessionConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSession>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum CoachingSessionDateFieldEnum {
  CreatedAt = 'CREATED_AT',
  SharedAt = 'SHARED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/** An edge in a connection. */
export type CoachingSessionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSession>;
};

/** Coaching Session File type */
export type CoachingSessionFile = {
  bucket: Scalars['String'];
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Coaching Session File Attachment type */
export type CoachingSessionFileAttachment = {
  coachingSession: CoachingSession;
  coachingSessionFile: CoachingSessionFile;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  notes: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CoachingSessionFileAttachment. */
export type CoachingSessionFileAttachmentConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionFileAttachmentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionFileAttachment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionFileAttachmentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionFileAttachment>;
};

/** The connection type for CoachingSessionFile. */
export type CoachingSessionFileConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionFileEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionFileEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionFile>;
};

export type CoachingSessionFilterInput = {
  dateField?: InputMaybe<CoachingSessionDateFieldEnum>;
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<CoachingSessionStatusEnum>;
};

/** Coaching Session Interaction Attachment type */
export type CoachingSessionInteractionAttachment = {
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  followUp: Maybe<FollowUp>;
  id: Scalars['ID'];
  interaction: Interaction;
  notes: Maybe<Scalars['String']>;
  summary: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CoachingSessionInteractionAttachment. */
export type CoachingSessionInteractionAttachmentConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionInteractionAttachmentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionInteractionAttachment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionInteractionAttachmentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionInteractionAttachment>;
};

/** Coaching Session Kudo type */
export type CoachingSessionKudo = {
  coachingSession: CoachingSession;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Employee;
  id: Scalars['ID'];
  text: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CoachingSessionKudo. */
export type CoachingSessionKudoConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionKudoEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionKudo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionKudoEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionKudo>;
};

/** Coaching Session Lesson type */
export type CoachingSessionLesson = {
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  extLessonId: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CoachingSessionLesson. */
export type CoachingSessionLessonConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionLessonEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionLesson>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionLessonEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionLesson>;
};

/** Coaching Session Metric Attachment type */
export type CoachingSessionMetricAttachment = {
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  dates: Maybe<Array<Scalars['String']>>;
  displayDiff: Maybe<Scalars['String']>;
  displayValue: Maybe<Scalars['String']>;
  employeeIds: Maybe<Array<Scalars['ID']>>;
  endDate: Scalars['ISO8601DateTime'];
  followUp: Maybe<FollowUp>;
  higherIsBetter: Scalars['Boolean'];
  id: Scalars['ID'];
  notes: Maybe<Scalars['String']>;
  rawDiff: Maybe<Scalars['Float']>;
  rawValue: Scalars['Float'];
  startDate: Scalars['ISO8601DateTime'];
  timeSeries: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CoachingSessionMetricAttachment. */
export type CoachingSessionMetricAttachmentConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionMetricAttachmentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionMetricAttachment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionMetricAttachmentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionMetricAttachment>;
};

/** Coaching Session Note type */
export type CoachingSessionNote = {
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Employee;
  id: Scalars['ID'];
  notes: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CoachingSessionNote. */
export type CoachingSessionNoteConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionNoteEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionNote>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionNoteEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionNote>;
};

/** Coaching Session QaReview Attachment type */
export type CoachingSessionQaReviewAttachment = {
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  followUp: Maybe<FollowUp>;
  id: Scalars['ID'];
  notes: Maybe<Scalars['String']>;
  qaReview: QaReviewRegular;
  score: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CoachingSessionQaReviewAttachment. */
export type CoachingSessionQaReviewAttachmentConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionQaReviewAttachmentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionQaReviewAttachment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionQaReviewAttachmentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionQaReviewAttachment>;
};

/** Coaching Session Solicitation Attachment type */
export type CoachingSessionSolicitationAttachment = {
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  followUp: Maybe<FollowUp>;
  id: Scalars['ID'];
  notes: Maybe<Scalars['String']>;
  solicitation: Solicitation;
  stars: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CoachingSessionSolicitationAttachment. */
export type CoachingSessionSolicitationAttachmentConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionSolicitationAttachmentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionSolicitationAttachment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionSolicitationAttachmentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionSolicitationAttachment>;
};

export enum CoachingSessionSortFieldEnum {
  Id = 'ID',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT',
}

export type CoachingSessionSortInput = {
  direction?: SortDirectionEnum;
  field?: CoachingSessionSortFieldEnum;
};

export enum CoachingSessionStatusEnum {
  Draft = 'DRAFT',
  Shared = 'SHARED',
}

/** Coaching Session Summary type */
export type CoachingSessionSummary = {
  coachingSession: CoachingSession;
  status: Scalars['String'];
  summary: Maybe<Scalars['String']>;
  summaryFeedback: Maybe<SummaryFeedback>;
};

/** Coaching Session Takeaway Category type */
export type CoachingSessionTakeawayCategory = {
  archived: Maybe<Scalars['Boolean']>;
  company: Company;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Employee;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Coaching Session Url Attachment type */
export type CoachingSessionUrlAttachment = {
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  url: Scalars['String'];
};

/** The connection type for CoachingSessionUrlAttachment. */
export type CoachingSessionUrlAttachmentConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingSessionUrlAttachmentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingSessionUrlAttachment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingSessionUrlAttachmentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingSessionUrlAttachment>;
};

/** Actions to update Coaching Intelligence settings */
export enum CoachingSettingsUpdateActionsEnum {
  AcceptTerms = 'ACCEPT_TERMS',
  Disable = 'DISABLE',
  Enable = 'ENABLE',
  RevokeTerms = 'REVOKE_TERMS',
}

/** Coaching Template type */
export type CoachingTemplate = {
  body: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  creator: TemplateActor;
  id: Scalars['ID'];
  lastUpdatedBy: Maybe<Employee>;
  name: Scalars['String'];
  status: CoachingTemplateStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  usageCount: Scalars['Int'];
};

/** The connection type for CoachingTemplate. */
export type CoachingTemplateConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CoachingTemplateEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CoachingTemplate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CoachingTemplateEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CoachingTemplate>;
};

/** Coaching Template History type */
export type CoachingTemplateHistory = {
  actor: Maybe<TemplateActor>;
  attributeName: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  /** @deprecated For Coaching Templates it is better to use actor */
  employee: Maybe<Employee>;
  event: Scalars['String'];
  valueAfter: Maybe<Scalars['String']>;
  valueBefore: Maybe<Scalars['String']>;
};

/** CoachingTemplateHistoryCollection type */
export type CoachingTemplateHistoryCollection = {
  /** A collection of paginated CoachingTemplateHistoryCollection */
  collection: Array<CoachingTemplateHistory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export enum CoachingTemplateStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

/** Coaching Topic type */
export type CoachingTopic = {
  addedToSessionAt: Maybe<Scalars['ISO8601DateTime']>;
  coachingSession: CoachingSession;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  negativeFeedback: Maybe<NegativeFeedback>;
  order: Maybe<Scalars['Int']>;
  references: Maybe<Array<TopicReference>>;
  topic: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** CoachingTopicCollection type */
export type CoachingTopicCollection = {
  /** A collection of paginated CoachingTopicCollection */
  collection: Array<CoachingTopic>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CoachingTopicsMetadata;
};

/** Coaching Topics metadata */
export type CoachingTopicsMetadata = {
  /** Current Page of loaded data */
  currentPage: Scalars['Int'];
  fetchingStatus: Scalars['String'];
  /** The number of items per page */
  limitValue: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  /** Current Page of loaded data */
  currentPage: Scalars['Int'];
  /** The number of items per page */
  limitValue: Scalars['Int'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int'];
};

/** Contains the details of a company. */
export type Company = {
  areasOfExcellence: Array<AreaOfExcellence>;
  brands: Array<Brand>;
  /** Company channels */
  channels: Maybe<Array<Channel>>;
  clearedAtByTier: Maybe<ClearedAtByTier>;
  customerVisibility: CompanyCustomerVisibilityEnum;
  defaultProfilePictureUrl: Maybe<Scalars['String']>;
  fiveStarRewards: Scalars['Boolean'];
  guidelineProfile: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
  positiveFeedbackComponents: CompanyPositiveFeedbackComponentEnum;
  profileImageSetting: CompanyProfileImageSetting;
  qaForms: Maybe<Array<QaFormDescription>>;
  rewards: Maybe<Array<CompanyReward>>;
  state: CompanyState;
  subdomain: Scalars['String'];
  thresholdsEnabled: Scalars['Boolean'];
};

/** Contains the details of a company. */
export type CompanyAreasOfExcellenceArgs = {
  status?: InputMaybe<AreaOfExcellenceStatus>;
};

/** Represents a company achievement */
export type CompanyAchievement = {
  achievementCategory: AchievementCategory;
  achievementKey: Scalars['String'];
  /** list a Company Achievement Badges */
  badges: Maybe<Array<Badge>>;
  company: Company;
  createdAt: Scalars['ISO8601DateTime'];
  /** list Employee Badges for a Company Achievement */
  employeeBadges: Maybe<Array<EmployeeBadgeUnion>>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  pathDescription: Maybe<Scalars['String']>;
  pathName: Maybe<Scalars['String']>;
  product: Maybe<Scalars['String']>;
  settings: Maybe<Scalars['JSON']>;
  threshold: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a company achievement */
export type CompanyAchievementEmployeeBadgesArgs = {
  employeeId?: InputMaybe<Scalars['ID']>;
};

/** The connection type for CompanyAchievement. */
export type CompanyAchievementConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CompanyAchievementEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CompanyAchievement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CompanyAchievementEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CompanyAchievement>;
};

/** Customer visibility */
export enum CompanyCustomerVisibilityEnum {
  AdminOnly = 'ADMIN_ONLY',
  AllEmployees = 'ALL_EMPLOYEES',
  ManagersAndAdmin = 'MANAGERS_AND_ADMIN',
}

/** Positive feedback components available for the company */
export enum CompanyPositiveFeedbackComponentEnum {
  AreasOfExcellence = 'AREAS_OF_EXCELLENCE',
  Off = 'OFF',
  Rewards = 'REWARDS',
}

/** Profile image setting */
export enum CompanyProfileImageSetting {
  DefaultOnly = 'DEFAULT_ONLY',
  UsersChoice = 'USERS_CHOICE',
  UsersChoiceWithDefault = 'USERS_CHOICE_WITH_DEFAULT',
}

/** Reward configuration in a company */
export type CompanyReward = {
  campaignId: Maybe<Scalars['String']>;
  caption: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  secondaryCampaignId: Maybe<Scalars['String']>;
  threshold: Maybe<Scalars['Int']>;
  tier: TierEnum;
};

export enum CompanyState {
  Churned = 'churned',
  Live = 'live',
  Purged = 'purged',
  Purging = 'purging',
}

export enum CompanyStateEvent {
  Churn = 'CHURN',
  Reactivate = 'REACTIVATE',
}

/** Autogenerated input type of CompleteActionItem */
export type CompleteActionItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of CompleteCalibration */
export type CompleteCalibrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CompleteCalibration. */
export type CompleteCalibrationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  qaCalibration: Maybe<QaCalibration>;
};

/** Autogenerated input type of CompleteFreeformGoal */
export type CompleteFreeformGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of CompleteMetricGoal */
export type CompleteMetricGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: MetricGoalTypeEnum;
};

/** Custom metadata type for complex SQL queries */
export type ComplexQueryMetadata = {
  /** Current Page of loaded data */
  currentPage: Scalars['Int'];
  /** The number of items per page */
  limitValue: Scalars['Int'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int'];
};

/** Autogenerated input type of ConfigureAreasOfExcellence */
export type ConfigureAreasOfExcellenceInput = {
  aoe: Array<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ConfigureRewards */
export type ConfigureRewardsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fiveStarRewards: Scalars['Boolean'];
  rewardConfiguration: RewardTiersConfiguration;
  thresholdsEnabled: Scalars['Boolean'];
};

/** Autogenerated input type of ConnectLessonly */
export type ConnectLessonlyInput = {
  apiKey: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  subdomain: Scalars['String'];
};

/** Country details */
export type Country = {
  code: Scalars['String'];
  name: Scalars['String'];
};

/** Autogenerated input type of CreateActionItem */
export type CreateActionItemInput = {
  action: Scalars['String'];
  actionableId: Scalars['ID'];
  actionableType: ActionableTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateActionItem. */
export type CreateActionItemPayload = {
  actionItem: Maybe<ActionItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of CreateAnswer */
export type CreateAnswerInput = {
  answerableId: Scalars['ID'];
  answerableType: AnswerableTypeEnum;
  answered?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  qaOptionId?: InputMaybe<Scalars['ID']>;
  qaQuestionId: Scalars['ID'];
};

/** Autogenerated input type of CreateAudit */
export type CreateAuditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  countTowardScore?: InputMaybe<Scalars['Boolean']>;
  hideReviewer?: InputMaybe<Scalars['Boolean']>;
  qaFormId: Scalars['ID'];
  qaReviewId: Scalars['ID'];
};

/** Autogenerated input type of CreateCalibrationAudit */
export type CreateCalibrationAuditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  qaAllocationId?: InputMaybe<Scalars['ID']>;
  qaAssignmentId?: InputMaybe<Scalars['ID']>;
  qaReviewId: Scalars['ID'];
};

/** Autogenerated input type of CreateCalibration */
export type CreateCalibrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  extInteractionId?: InputMaybe<Scalars['ID']>;
  extInteractionUrl?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  interactionSnapshotId?: InputMaybe<Scalars['ID']>;
  meetingAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  qaFormId: Scalars['ID'];
  questionExclIds?: InputMaybe<Array<Scalars['ID']>>;
  questionInclIds?: InputMaybe<Array<Scalars['ID']>>;
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  solicitationId?: InputMaybe<Scalars['ID']>;
  transcript?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCalibration. */
export type CreateCalibrationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  qaCalibration: Maybe<QaCalibration>;
};

/** Autogenerated input type of CreateCalibrationsExport */
export type CreateCalibrationsExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dates: DateRangeInput;
};

/** Autogenerated return type of CreateCalibrationsExport. */
export type CreateCalibrationsExportPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<ValidationErrors>;
  export: Maybe<Export>;
};

/** Autogenerated input type of CreateCoachingExport */
export type CreateCoachingExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dates: DateRangeInput;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
  includeEmployees?: InputMaybe<Scalars['Boolean']>;
  includeTeams?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of CreateCoachingExport. */
export type CreateCoachingExportPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<ValidationErrors>;
  export: Maybe<Export>;
};

/** Autogenerated input type of CreateCoachingSessionActionItem */
export type CreateCoachingSessionActionItemInput = {
  attributes: CoachingSessionActionItemInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCoachingSessionActionItem. */
export type CreateCoachingSessionActionItemPayload = {
  actionItem: Maybe<Takeaway>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of CreateCoachingSession */
export type CreateCoachingSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
};

/** Autogenerated input type of CreateCoachingSessionInteractionAttachment */
export type CreateCoachingSessionInteractionAttachmentInput = {
  attributes: SessionInteractionAttachmentInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCoachingSessionInteractionAttachment. */
export type CreateCoachingSessionInteractionAttachmentPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  interactionAttachment: Maybe<CoachingSessionInteractionAttachment>;
};

/** Autogenerated input type of CreateCoachingSessionPublicNote */
export type CreateCoachingSessionPublicNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
};

/** Autogenerated return type of CreateCoachingSessionPublicNote. */
export type CreateCoachingSessionPublicNotePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  publicNote: Maybe<CoachingSessionNote>;
};

/** Autogenerated input type of CreateCoachingTemplate */
export type CreateCoachingTemplateInput = {
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated return type of CreateCoachingTemplate. */
export type CreateCoachingTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  coachingTemplate: Maybe<CoachingTemplate>;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of CreateEmployee */
export type CreateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employee: EmployeeInput;
  employeeGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Allow employee to be invited without profile params */
  isInvitation?: InputMaybe<Scalars['Boolean']>;
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  supervisorId?: InputMaybe<Scalars['ID']>;
  temporaryPassword?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateFeedbackExportFromTemplate */
export type CreateFeedbackExportFromTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CreateFeedbackExportFromTemplate. */
export type CreateFeedbackExportFromTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  export: Maybe<Export>;
};

/** Autogenerated input type of CreateFeedbackExport */
export type CreateFeedbackExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<FeedbackExportFieldInput>>;
  filters?: InputMaybe<FeedbackExportFilterInput>;
};

/** Autogenerated return type of CreateFeedbackExport. */
export type CreateFeedbackExportPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  export: Maybe<Export>;
};

/** Autogenerated input type of CreateFeedbackExportTemplate */
export type CreateFeedbackExportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldSectionOptions?: InputMaybe<FieldSectionOptionsInput>;
  fields?: InputMaybe<Array<FeedbackExportFieldInput>>;
  filters?: InputMaybe<FeedbackExportFilterInput>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<FeedbackExportScheduleInput>;
};

/** Autogenerated return type of CreateFeedbackExportTemplate. */
export type CreateFeedbackExportTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  template: Maybe<FeedbackExportTemplate>;
};

/** Autogenerated input type of CreateFollowUp */
export type CreateFollowUpInput = {
  attributes: FollowUpInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateFollowUp. */
export type CreateFollowUpPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  followUp: Maybe<FollowUp>;
};

/** Autogenerated input type of CreateFreeformGoal */
export type CreateFreeformGoalInput = {
  actionItems?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  endedAt?: InputMaybe<Scalars['ISO8601Date']>;
  startedAt?: InputMaybe<Scalars['ISO8601Date']>;
  title: Scalars['String'];
};

/** Autogenerated return type of CreateFreeformGoal. */
export type CreateFreeformGoalPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  freeformGoal: Maybe<FreeformGoal>;
};

/** Autogenerated input type of Create */
export type CreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated input type of CreateMetricGoal */
export type CreateMetricGoalInput = {
  actionItems?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['ISO8601Date']>;
  entityId: Scalars['ID'];
  goal: Scalars['Float'];
  metricConfigId: Scalars['ID'];
  startedAt?: InputMaybe<Scalars['ISO8601Date']>;
  type: MetricGoalTypeEnum;
};

/** Autogenerated return type of CreateMetricGoal. */
export type CreateMetricGoalPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  metricGoal: Maybe<MetricGoalItem>;
};

/** Autogenerated input type of CreateMetricSet */
export type CreateMetricSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  metrics?: InputMaybe<Array<MetricInput>>;
  name: Scalars['String'];
};

/** Autogenerated return type of CreateMetricSet. */
export type CreateMetricSetPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Scalars['JSON']>;
  metricSet: Maybe<MetricSet>;
};

/** Autogenerated input type of CreateOrUpdateReward */
export type CreateOrUpdateRewardInput = {
  caption: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  image: Scalars['String'];
  rewardId?: InputMaybe<Scalars['ID']>;
  tier: TierEnum;
  translations?: InputMaybe<Array<RewardTranslation>>;
};

/** Autogenerated input type of CreateQaFormOverviewsExport */
export type CreateQaFormOverviewsExportInput = {
  autofailed?: InputMaybe<Scalars['Boolean']>;
  byChannelEnumId?: InputMaybe<Array<Scalars['ID']>>;
  byEmployeeId?: InputMaybe<Array<Scalars['ID']>>;
  byLanguage?: InputMaybe<Array<Scalars['String']>>;
  byPropertyId?: InputMaybe<Array<Scalars['ID']>>;
  byReviewerId?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dates: DateRangeInput;
  forReportingGroups?: InputMaybe<Array<Scalars['ID']>>;
  forTeams?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of CreateQaFormOverviewsExport. */
export type CreateQaFormOverviewsExportPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<ValidationErrors>;
  export: Maybe<Export>;
};

/** Attributes for creating a reporting group criterion */
export type CreateReportingGroupCriterionAttributes = {
  criterionType: ReportingGroupCriterionTypeEnum;
  operator: ReportingGroupCriterionOperatorEnum;
  period?: InputMaybe<ReportingGroupCriterionPeriodEnum>;
  periodValue?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateReportingGroup */
export type CreateReportingGroupInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  criteriaAttributes?: InputMaybe<Array<CreateReportingGroupCriterionAttributes>>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  filterable?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['String']>;
  matchAll?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
  permissionable?: InputMaybe<Scalars['Boolean']>;
  streamFooterDisplayable?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateReportingGroup. */
export type CreateReportingGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  reportingGroup: Maybe<ReportingGroup>;
};

/** Custom property filter input type */
export type CustomPropertyFilterInput = {
  filterMode: FilterModeEnum;
  propertyName: Scalars['ID'];
  rule: CustomPropertyFilterRuleInput;
};

/** Custom property filter rules, based on supported property filter types */
export type CustomPropertyFilterRuleInput = {
  boolean?: InputMaybe<Scalars['Boolean']>;
  contactReason?: InputMaybe<Array<Scalars['String']>>;
  duration?: InputMaybe<DurationFilterInput>;
  handleTime?: InputMaybe<IntegerRangeFilterInput>;
  integer?: InputMaybe<IntegerRangeFilterInput>;
  interactionLength?: InputMaybe<IntegerRangeFilterInput>;
  link?: InputMaybe<PresenceFilterEnum>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
  numberOfMessages?: InputMaybe<IntegerRangeFilterInput>;
  numberOfTouches?: InputMaybe<IntegerRangeFilterInput>;
  range?: InputMaybe<IntegerRangeFilterInput>;
  string?: InputMaybe<Array<Scalars['String']>>;
  uniqueId?: InputMaybe<Array<Scalars['String']>>;
};

/** Date-filter and metric calculation defaults */
export type DateFilterConfig = {
  availableDateRanges: Array<DateRangeEnum>;
  defaultDateRange: DateRangeEnum;
  defaultDateRangeSelections: Array<DateRangeEnum>;
  selectedDateRanges: Array<DateRangeEnum>;
  solicitationReportingTimestamp: SolicitationReportingTimestampEnum;
  startOfQuarter: StartOfQuarter;
  startOfWeek: WeekdayEnum;
};

/** Date range object */
export type DateRange = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};

/** Available date range options */
export enum DateRangeEnum {
  Last_3Days = 'LAST_3_DAYS',
  Last_5Days = 'LAST_5_DAYS',
  Last_7Days = 'LAST_7_DAYS',
  Last_14Days = 'LAST_14_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_60Days = 'LAST_60_DAYS',
  Last_90Days = 'LAST_90_DAYS',
  LastMonth = 'LAST_MONTH',
  LastQuarter = 'LAST_QUARTER',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR',
  ThisMonth = 'THIS_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  ThisWeek = 'THIS_WEEK',
  ThisYear = 'THIS_YEAR',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY',
}

/** Range of dates is ISO-8601 (YYYY-MM-DD) format. */
export type DateRangeInput = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};

/** Range of dates is ISO-8601 (YYYY-MM-DD HH:mm) format. */
export type DateTimeRangeInput = {
  endDate: Scalars['ISO8601DateTime'];
  startDate: Scalars['ISO8601DateTime'];
};

/** Start and end dates in ISO-8601 (YYYY-MM-DD) format. */
export type DatesInput = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};

/** Autogenerated input type of DeactivateEmployee */
export type DeactivateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DecimalOption = {
  label: Scalars['String'];
  value: Scalars['String'];
};

/** Autogenerated input type of DeleteAudit */
export type DeleteAuditInput = {
  auditId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteAudit. */
export type DeleteAuditPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  deletedId: Scalars['ID'];
};

/** Autogenerated input type of DeleteCalibration */
export type DeleteCalibrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteCalibration. */
export type DeleteCalibrationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  deletedId: Maybe<Scalars['ID']>;
  message: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteCoachingSessionActionItem */
export type DeleteCoachingSessionActionItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteCoachingSessionInteractionAttachment */
export type DeleteCoachingSessionInteractionAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteCoachingSessionInteractionAttachment. */
export type DeleteCoachingSessionInteractionAttachmentPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<Error>>;
  id: Maybe<Scalars['ID']>;
  message: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteFeedbackExportTemplate */
export type DeleteFeedbackExportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteFeedbackExportTemplate. */
export type DeleteFeedbackExportTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<Error>>;
  id: Maybe<Scalars['ID']>;
  message: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteFollowUp */
export type DeleteFollowUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteFollowUp. */
export type DeleteFollowUpPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<Error>>;
  id: Maybe<Scalars['ID']>;
  message: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteMetricSet */
export type DeleteMetricSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteTakeawayResponse = {
  id: Scalars['ID'];
  message: Scalars['String'];
};

/** Autogenerated input type of DiscardAudit */
export type DiscardAuditInput = {
  auditId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of DiscardReview */
export type DiscardReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  qaReviewId: Scalars['ID'];
};

/** Autogenerated input type of DisconnectLessonly */
export type DisconnectLessonlyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of DisconnectSnappyIntegration */
export type DisconnectSnappyIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of DuplicateFeedbackExportTemplate */
export type DuplicateFeedbackExportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DuplicateFeedbackExportTemplate. */
export type DuplicateFeedbackExportTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  feedbackExportTemplate: Maybe<FeedbackExportTemplate>;
};

export type DurationFilterInput = {
  gt: Scalars['Int'];
  lt: Scalars['Int'];
  unit: DurationFilterUnitEnum;
};

/** Unit supported for duration filter enum */
export enum DurationFilterUnitEnum {
  Minutes = 'MINUTES',
}

export type EligibilityStats = {
  added: Maybe<Scalars['Int']>;
  allPeriod: Maybe<Scalars['Int']>;
  removed: Maybe<Scalars['Int']>;
  total: Maybe<Scalars['Int']>;
};

/** An individual user who has a role, status, and profile. */
export type Employee = {
  canManageTeams: Scalars['Boolean'];
  channels: Maybe<Array<ChannelTypeEnum>>;
  /** Coaching Session collection resolver */
  coachingSessions: CoachingSessionConnection;
  customEmployeeId: Maybe<Scalars['String']>;
  customRole: Maybe<Role>;
  deactivated: Maybe<Scalars['Boolean']>;
  demotable: Maybe<Scalars['Boolean']>;
  email: Maybe<Scalars['String']>;
  employeeGroups: Maybe<Array<EmployeeGroup>>;
  employmentStatus: EmploymentStatusEnum;
  id: Scalars['ID'];
  isActive: Maybe<Scalars['Boolean']>;
  lastActive: Maybe<Scalars['ISO8601DateTime']>;
  licenseType: LicenseTypeEnum;
  locale: Maybe<Scalars['String']>;
  permissions: Maybe<EmployeePermissionsType>;
  primaryTeam: Maybe<Team>;
  profile: Maybe<Profile>;
  profileForEdit: Maybe<Profile>;
  reportingGroups: Maybe<Array<ReportingGroup>>;
  resetPasswordSentAt: Maybe<Scalars['ISO8601DateTime']>;
  startDate: Maybe<Scalars['ISO8601Date']>;
  status: StatusEnum;
  supervisor: Maybe<Supervisor>;
};

/** An individual user who has a role, status, and profile. */
export type EmployeeCoachingSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: CoachingSessionFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<CoachingSessionSortInput>>;
};

/** Represents an employee badge */
export type EmployeeBadge = {
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  badgeKey: Scalars['String'];
  badgeType: Scalars['String'];
  companyAchievement: CompanyAchievement;
  count: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  earnedAt: Maybe<Scalars['ISO8601DateTime']>;
  employee: Employee;
  iconSettings: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  selectedForProfile: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  threshold: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for EmployeeBadge. */
export type EmployeeBadgeConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EmployeeBadgeEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EmployeeBadge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Autogenerated return type of EmployeeBadgeEarned. */
export type EmployeeBadgeEarnedPayload = {
  badge: EmployeeBadge;
};

/** An edge in a connection. */
export type EmployeeBadgeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<EmployeeBadge>;
};

/** Represents either a persisted (earned) or non-persisted (unearned) employee badge */
export type EmployeeBadgeUnion = EmployeeBadge | NonPersistedEmployeeBadge;

/** EmployeeCollection type */
export type EmployeeCollection = {
  /** A collection of paginated EmployeeCollection */
  collection: Array<Employee>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** The connection type for Employee. */
export type EmployeeConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EmployeeEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Employee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployeeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Employee>;
};

/** Available filters when listing employees. */
export type EmployeeFilterInput = {
  canManageTeams?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Use roles argument when filtering on one or more roles */
  customRoleId?: InputMaybe<Scalars['ID']>;
  employeeGroup?: InputMaybe<Array<Scalars['ID']>>;
  employmentStatus?: InputMaybe<EmploymentStatusEnum>;
  goalCreatable?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
  lastActiveBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  permission?: InputMaybe<PermissionEnum>;
  qaRole?: InputMaybe<EmployeeQaRoleEnum>;
  reportingGroup?: InputMaybe<Array<Scalars['ID']>>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<StatusEnum>;
  /** @deprecated Use teams argument when filtering on one or more teams */
  team?: InputMaybe<Scalars['ID']>;
  teamLeader?: InputMaybe<Scalars['ID']>;
  teams?: InputMaybe<Array<Scalars['ID']>>;
};

export type EmployeeGroup = {
  description: Maybe<Employee>;
  id: Scalars['ID'];
  members: Maybe<Array<Employee>>;
  name: Scalars['String'];
  status: Maybe<EmployeeGroupStatusEnum>;
};

/** The connection type for EmployeeGroup. */
export type EmployeeGroupConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EmployeeGroupEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EmployeeGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployeeGroupEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<EmployeeGroup>;
};

/** Employee group statuses */
export enum EmployeeGroupStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type EmployeeInput = {
  canManageTeams?: InputMaybe<Scalars['Boolean']>;
  channels?: InputMaybe<Array<ChannelTypeEnum>>;
  customEmployeeId?: InputMaybe<Scalars['String']>;
  customRoleId: Scalars['ID'];
  deactivated?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  employmentStatus?: InputMaybe<EmploymentStatusEnum>;
  licenseType?: InputMaybe<LicenseTypeEnum>;
  locale?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<EmployeeProfileInput>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Employee permissions type */
export type EmployeePermissionsType = {
  canCreateGoal: Scalars['Boolean'];
};

/** Profile fields */
export type EmployeeProfileInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hometown?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  stateOrCountry?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Employee QA roles */
export enum EmployeeQaRoleEnum {
  Auditor = 'AUDITOR',
  Reviewee = 'REVIEWEE',
  Reviewer = 'REVIEWER',
}

/** Available fields to search employees. */
export enum EmployeeSearchFieldEnum {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Name = 'NAME',
  UniqueId = 'UNIQUE_ID',
}

/** Search employees using a combination of `value` and `on` arguments. */
export type EmployeeSearchInput = {
  /** The fields you want to match on. */
  on: Array<EmployeeSearchFieldEnum>;
  /** The value you want to match. Can't be blank. */
  value: Scalars['String'];
};

/** The possible fields to sort on. */
export enum EmployeeSortFieldEnum {
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  Name = 'NAME',
}

/** Sort the list of employees. */
export type EmployeeSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: EmployeeSortFieldEnum;
};

/** A user that can be mentioned in conversations */
export type EmployeesMentionable = {
  canManageTeams: Scalars['Boolean'];
  id: Scalars['ID'];
  primaryTeam: Maybe<LimitedTeam>;
  profile: LimitedProfile;
};

/** EmployeesMentionableCollection type */
export type EmployeesMentionableCollection = {
  /** A collection of paginated EmployeesMentionableCollection */
  collection: Array<EmployeesMentionable>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** The account status of the employee. */
export enum EmploymentStatusEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  Temp = 'TEMP',
  Unknown = 'UNKNOWN',
}

export enum EntityTypeEnum {
  Employee = 'EMPLOYEE',
  Group = 'GROUP',
}

/** An error with customized message */
export type Error = {
  /** A description of the error */
  message: Scalars['String'];
};

export type Export = {
  companyId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  creatorId: Scalars['ID'];
  creatorType: Scalars['String'];
  dateRangeField: Maybe<Scalars['String']>;
  endDate: Maybe<Scalars['ISO8601DateTime']>;
  expired: Scalars['Boolean'];
  exportType: Scalars['String'];
  fieldsCount: Maybe<Scalars['Int']>;
  finishedAt: Maybe<Scalars['ISO8601DateTime']>;
  generatedAt: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  includeRecoveryFeedback: Maybe<Scalars['Boolean']>;
  options: Maybe<Scalars['JSON']>;
  s3Url: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['ISO8601DateTime']>;
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  state: Scalars['String'];
  updatedAt: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for Export. */
export type ExportConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ExportEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Export>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ExportEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Export>;
};

export type ExportField = {
  id: Scalars['ID'];
  label: Maybe<Scalars['String']>;
};

export enum ExportSection {
  CustomProperties = 'CUSTOM_PROPERTIES',
  Marketing = 'MARKETING',
  SurveyResponse = 'SURVEY_RESPONSE',
}

export enum ExportSectionId {
  Customer = 'CUSTOMER',
  CustomProperties = 'CUSTOM_PROPERTIES',
  Employee = 'EMPLOYEE',
  Marketing = 'MARKETING',
  ServiceRecoveryRequest = 'SERVICE_RECOVERY_REQUEST',
  ServiceRecoveryResponse = 'SERVICE_RECOVERY_RESPONSE',
  SurveyRequest = 'SURVEY_REQUEST',
  SurveyResponse = 'SURVEY_RESPONSE',
  TeamLeader = 'TEAM_LEADER',
}

/** Available Export types for filtering */
export enum ExportTypeEnum {
  Calibrations = 'CALIBRATIONS',
  Coaching = 'COACHING',
  CustomSolicitations = 'CUSTOM_SOLICITATIONS',
  PerformanceMetrics = 'PERFORMANCE_METRICS',
  QaFormOverviews = 'QA_FORM_OVERVIEWS',
  Solicitations = 'SOLICITATIONS',
}

export type ExportsState = {
  inProgress: Scalars['Boolean'];
  unread: Scalars['Boolean'];
};

/** Available date ranges for exporting */
export enum FeedbackExportDateRangeEnum {
  Last_3Days = 'LAST_3_DAYS',
  Last_5Days = 'LAST_5_DAYS',
  Last_7Days = 'LAST_7_DAYS',
  Last_14Days = 'LAST_14_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_60Days = 'LAST_60_DAYS',
  Last_90Days = 'LAST_90_DAYS',
  LastMonth = 'LAST_MONTH',
  LastQuarter = 'LAST_QUARTER',
  LastWeek = 'LAST_WEEK',
  ThisMonth = 'THIS_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  ThisWeek = 'THIS_WEEK',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY',
}

/** Feedback field in the system */
export type FeedbackExportField = {
  id: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  section: Maybe<Section>;
  /** When true, the field will be included in the export */
  selected: Maybe<Scalars['Boolean']>;
  status: Maybe<FieldStatus>;
  type: Maybe<Field>;
  usedIn: Array<Scalars['String']>;
};

/** Feedback field in the system */
export type FeedbackExportFieldInput = {
  id: Scalars['String'];
  section?: InputMaybe<Section>;
  /** When true, the field will be included in the export */
  selected: Scalars['Boolean'];
  type?: InputMaybe<Field>;
};

/** What surveys to be filtered for the export */
export type FeedbackExportFilterInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  preselectedDateRange?: InputMaybe<FeedbackExportDateRangeEnum>;
  startOfQuarter?: InputMaybe<StartOfQuarterInput>;
  startOfWeek?: InputMaybe<WeekdayEnum>;
  surveyType?: InputMaybe<Array<Survey>>;
  withResponses?: InputMaybe<Scalars['Boolean']>;
};

/** When to run each export */
export type FeedbackExportSchedule = {
  day: Maybe<Scalars['Int']>;
  dayOfMonth: Maybe<Scalars['Int']>;
  dayOfWeek: Maybe<WeekdayEnum>;
  hour: Maybe<Scalars['Int']>;
  month: Maybe<Scalars['Int']>;
  week: Maybe<Scalars['Int']>;
};

/** When to run each export */
export type FeedbackExportScheduleInput = {
  /** Frequency of days */
  day?: InputMaybe<Scalars['Int']>;
  /** Day in the month to run the export */
  dayOfMonth?: InputMaybe<Scalars['Int']>;
  /** Day of the week to run the export */
  dayOfWeek?: InputMaybe<WeekdayEnum>;
  /** Hour to run the export */
  hour?: InputMaybe<Scalars['Int']>;
  /** Frequency of months */
  month?: InputMaybe<Scalars['Int']>;
  /** Frequency of weeks */
  week?: InputMaybe<Scalars['Int']>;
};

/** Export Section */
export type FeedbackExportSection = {
  fields: Array<FeedbackSectionField>;
  id: ExportSectionId;
  /** Identify template field for including future questions */
  includeFutureQuestionField: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  order: Scalars['Int'];
  /** Links response sections to their header/parent section */
  parentSectionLabel: Maybe<Scalars['String']>;
  surveyType: Maybe<Survey>;
};

/** The connection type for FeedbackExportSection. */
export type FeedbackExportSectionConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FeedbackExportSectionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<FeedbackExportSection>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type FeedbackExportSectionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<FeedbackExportSection>;
};

/** Information about the template */
export type FeedbackExportTemplate = {
  createdAt: Scalars['ISO8601DateTime'];
  employee: Employee;
  endDate: Maybe<Scalars['ISO8601Date']>;
  fieldSectionOptions: Maybe<FieldSectionOptions>;
  fields: Maybe<Array<FeedbackExportField>>;
  fieldsCount: Scalars['Int'];
  id: Scalars['ID'];
  includeArchived: Scalars['Boolean'];
  name: Scalars['String'];
  preselectedDateRange: Maybe<FeedbackExportDateRangeEnum>;
  schedule: Maybe<FeedbackExportSchedule>;
  startDate: Maybe<Scalars['ISO8601Date']>;
  startOfQuarter: Maybe<StartOfQuarter>;
  startOfWeek: Maybe<Scalars['String']>;
  surveyType: Maybe<Array<Survey>>;
  templateType: Template;
  withResponses: Scalars['Boolean'];
};

/** The connection type for FeedbackExportTemplate. */
export type FeedbackExportTemplateConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FeedbackExportTemplateEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<FeedbackExportTemplate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type FeedbackExportTemplateEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<FeedbackExportTemplate>;
};

/** Feedback Export Template filter input */
export type FeedbackExportTemplateFiltersInput = {
  templateType?: InputMaybe<Template>;
};

/** Section Field */
export type FeedbackSectionField = {
  id: Scalars['ID'];
  label: Scalars['String'];
  order: Scalars['Int'];
  usedIn: Array<Scalars['String']>;
};

export enum Field {
  CustomProperty = 'CUSTOM_PROPERTY',
  SurveyQuestion = 'SURVEY_QUESTION',
}

/** Sections with options for the export */
export type FieldSectionOptions = {
  surveyResponse: SurveyResponseOption;
};

/** Sections with options for the export */
export type FieldSectionOptionsInput = {
  surveyResponse?: InputMaybe<SurveyResponseOptionInput>;
};

export enum FieldStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

/** Contains filter_by values */
export enum FilterByEnum {
  Employees = 'EMPLOYEES',
  ReportingGroups = 'REPORTING_GROUPS',
  Teams = 'TEAMS',
}

/** Filter mode enum */
export enum FilterModeEnum {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}

/** FollowUp type */
export type FollowUp = {
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Employee;
  employee: Employee;
  followUpable: FollowUpable;
  id: Scalars['ID'];
  note: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for FollowUp. */
export type FollowUpConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FollowUpEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<FollowUp>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type FollowUpEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<FollowUp>;
};

/** FollowUp Filter Input type */
export type FollowUpFilterInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  employeeId: Scalars['ID'];
  type: FollowUpableTypeEnum;
};

/** FollowUp Input type */
export type FollowUpInput = {
  followUpableId: Scalars['ID'];
  followUpableType: FollowUpableTypeEnum;
  note?: InputMaybe<Scalars['String']>;
};

/** FollowUpable type */
export type FollowUpable = Interaction | QaReviewRegular | Solicitation;

export enum FollowUpableTypeEnum {
  Interaction = 'INTERACTION',
  QaReview = 'QA_REVIEW',
  Solicitation = 'SOLICITATION',
}

/** Freeform Goal type */
export type FreeformGoal = {
  actionItems: Maybe<Array<ActionItem>>;
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  company: Company;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  creator: Employee;
  employee: Employee;
  endedAt: Maybe<Scalars['ISO8601DateTime']>;
  endedByEmployee: Employee;
  id: Scalars['ID'];
  permissions: Maybe<GoalPermissionsType>;
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Freeform Goal type */
export type FreeformGoalActionItemsArgs = {
  status?: InputMaybe<GoalStatusEnum>;
};

/** The connection type for FreeformGoal. */
export type FreeformGoalConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FreeformGoalEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<FreeformGoal>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type FreeformGoalEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<FreeformGoal>;
};

/** Autogenerated input type of FulfillSnappyRewards */
export type FulfillSnappyRewardsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dates: DatesInput;
  employeeId?: InputMaybe<Scalars['ID']>;
  rewardId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of FulfillSnappyRewards. */
export type FulfillSnappyRewardsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  message: Maybe<Scalars['JSON']>;
};

export type GeneralMetric = MetricSelections & {
  id: Scalars['String'];
  options: Array<MetricOption>;
  selected: Array<Maybe<Scalars['String']>>;
  type: MetricConfigTypeEnum;
};

/** Goal filter object */
export type GoalFilterInput = {
  /** @deprecated Use creatorIds */
  creatorId?: InputMaybe<Scalars['ID']>;
  creatorIds?: InputMaybe<Array<Scalars['ID']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  entityIds?: InputMaybe<Array<Scalars['ID']>>;
  pattern?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<GoalStatusEnum>;
};

/** Goal permissions type */
export type GoalPermissionsType = {
  canCompleteActionItems: Maybe<Scalars['Boolean']>;
  canManageGoal: Scalars['Boolean'];
};

/** MetricGoal statuses */
export enum GoalStatusEnum {
  Active = 'ACTIVE',
  All = 'ALL',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE',
  NotArchived = 'NOT_ARCHIVED',
}

/** Goal types */
export enum GoalTypeEnum {
  All = 'ALL',
  EmployeeMetric = 'EMPLOYEE_METRIC',
  Freeform = 'FREEFORM',
  GroupMetric = 'GROUP_METRIC',
}

/** Category Identifier to be Used */
export enum IdentifierEnum {
  AreasOfExcellence = 'AREAS_OF_EXCELLENCE',
  AreasOfImprovement = 'AREAS_OF_IMPROVEMENT',
}

export type IntegerRangeFilterInput = {
  gt: Scalars['Int'];
  lt: Scalars['Int'];
};

/** Interaction details */
export type Interaction = {
  canShowSummary: Scalars['Boolean'];
  company: Company;
  createdAt: Scalars['ISO8601DateTime'];
  extInteractionId: Scalars['String'];
  extInteractionUrl: Maybe<Scalars['String']>;
  followUps: Maybe<FollowUpConnection>;
  id: Scalars['ID'];
  integrationId: Maybe<Scalars['ID']>;
  interactionEvents: Maybe<Array<InteractionEvent>>;
  lastEmployee: Maybe<Employee>;
  resolvedAt: Maybe<Scalars['ISO8601DateTime']>;
  /** Interaction QA Reviews */
  reviews: Maybe<QaReviewStandardConnection>;
  /** Interaction Solicitations */
  solicitations: Maybe<SolicitationConnection>;
  summary: Maybe<Scalars['String']>;
};

/** Interaction details */
export type InteractionFollowUpsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Interaction details */
export type InteractionReviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<InteractionQaReviewsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Interaction details */
export type InteractionSolicitationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<InteractionSolicitationsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Interaction. */
export type InteractionConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<InteractionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Interaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type InteractionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Interaction>;
};

/** Interaction Event details */
export type InteractionEvent = {
  audioFile: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata: Scalars['JSON'];
  occurredAt: Maybe<Scalars['ISO8601DateTime']>;
  order: Scalars['Int'];
  text: Maybe<Scalars['String']>;
};

/** Interaction Input type */
export type InteractionFilterInput = {
  dateRange: DateRangeInput;
  employeeId?: InputMaybe<Scalars['ID']>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  withFeedback?: InputMaybe<Scalars['Boolean']>;
  withQaReviews?: InputMaybe<Scalars['Boolean']>;
  withRecoveryFeedback?: InputMaybe<Scalars['Boolean']>;
};

export type InteractionQaReviewsFiltersInput = {
  employeeId?: InputMaybe<Scalars['ID']>;
};

/** Search interactions using a combination of `value` and `on` arguments */
export type InteractionSearchInput = {
  /** The fields you want to match on */
  on: Array<SearchFieldEnum>;
  /** The value you want to match. Can't be blank. */
  value: Scalars['String'];
};

export type InteractionSolicitationsFiltersInput = {
  employeeId?: InputMaybe<Scalars['ID']>;
};

export enum InteractionSortFieldEnum {
  FeedbackCount = 'FEEDBACK_COUNT',
  QaReviewCount = 'QA_REVIEW_COUNT',
  ResolvedAt = 'RESOLVED_AT',
}

/** Interaction sorting parameters */
export type InteractionSortInput = {
  direction?: SortDirectionEnum;
  field?: InteractionSortFieldEnum;
};

/** Contains information about a leaderboard metric's interval */
export type Interval = {
  options: Array<MetricOption>;
  selected: Scalars['String'];
};

/** Leaderboard */
export type Leaderboard = {
  config: LeaderboardConfig;
  intervals: Array<LeaderboardInterval>;
  topAgents: Array<TopAgent>;
};

/** Leaderboard Config Type */
export type LeaderboardConfig = {
  activeInterval: Scalars['String'];
  intervals: Array<Scalars['String']>;
  metricTitle: Scalars['String'];
  showStar: Scalars['Boolean'];
  thresholds: Threshold;
};

/** Leaderboard Interval Options Type */
export type LeaderboardInterval = {
  label: Scalars['String'];
  value: Scalars['String'];
};

/** Contains information about a the leaderboard metric selections */
export type LeaderboardMetrics = MetricSelections & {
  boardSizes: Maybe<BoardSize>;
  decimals: Maybe<ScoreDecimals>;
  id: Scalars['String'];
  intervals: Maybe<Interval>;
  options: Array<MetricOption>;
  selected: Array<Maybe<Scalars['String']>>;
  thresholds: Maybe<Threshold>;
  type: MetricConfigTypeEnum;
};

/** The input fields for updating the leaderboard's advanced settings */
export type LeaderboardSettingsInput = {
  boardSizeInput?: InputMaybe<Scalars['String']>;
  intervalTypeInput?: InputMaybe<Scalars['String']>;
  scoreDecimalsInput?: InputMaybe<Scalars['String']>;
  thresholdsInput?: InputMaybe<ThresholdInput>;
};

export type Lesson = {
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  archivedByUserId: Maybe<Scalars['ID']>;
  createdAt: Scalars['ISO8601DateTime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdatedAt: Scalars['ISO8601DateTime'];
  links: LessonOverviewLinks;
  public: Scalars['Boolean'];
  resourceType: Scalars['String'];
  retakeScore: Scalars['Int'];
  tags: Array<LessonlyTags>;
  title: Scalars['String'];
};

export type LessonAttachment = {
  id: Scalars['ID'];
  lessonId: Scalars['ID'];
};

export type LessonOverviewLinks = {
  overview: Scalars['String'];
  shareable: Scalars['String'];
};

export type Lessonly = {
  /** Current active status of the integration with Lessonly */
  enabled: Scalars['Boolean'];
  /** Lesson information */
  lesson: Maybe<Lesson>;
  /** Lessons available in the Lessonly account */
  lessons: Maybe<Array<Lesson>>;
};

export type LessonlyLessonArgs = {
  id: Scalars['ID'];
};

export type LessonlyIntegration = {
  companyId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LessonlyTags = {
  id: Scalars['ID'];
  name: Scalars['String'];
  resourceType: Scalars['String'];
};

/** Employee license type */
export enum LicenseTypeEnum {
  Flexible = 'FLEXIBLE',
  Standard = 'STANDARD',
}

/** Contains limited information about an employee. */
export type LimitedProfile = {
  fullName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
};

/** Contains limited information about a team. */
export type LimitedTeam = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Contains information that defines how a metric is configured. */
export type MetricConfig = {
  availableFilters: Maybe<Array<Scalars['String']>>;
  availableGroupBy: Maybe<Array<MetricGroupByEnum>>;
  customTitle: Maybe<Scalars['String']>;
  defaultGroupBy: Maybe<MetricGroupByEnum>;
  denominator: Maybe<Scalars['String']>;
  higherIsBetter: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  max: Maybe<Scalars['Int']>;
  metricName: MetricNameEnum;
  min: Maybe<Scalars['Int']>;
  nickname: Maybe<Scalars['String']>;
  numerator: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  questionIdentifier: Scalars['ID'];
  questionText: Maybe<Scalars['String']>;
  questionType: Maybe<Scalars['String']>;
  targetAnswers: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  /** Defines which product the config belongs to. */
  type: MetricConfigTypeEnum;
};

/** The possible types of metric configs. */
export enum MetricConfigTypeEnum {
  ExternalMetric = 'EXTERNAL_METRIC',
  Leaderboard = 'LEADERBOARD',
  OneOnOne = 'ONE_ON_ONE',
  Stream = 'STREAM',
  Trend = 'TREND',
}

/** The available filters that can be used to calculate a metric. */
export type MetricFilterInput = {
  brandingIds?: InputMaybe<Array<Scalars['ID']>>;
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  customProperties?: InputMaybe<Array<CustomPropertyFilterInput>>;
  dateRange: DateRangeInput;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  /** @deprecated Please use custom_properties instead */
  excludePropertyIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeTags?: InputMaybe<Array<Scalars['String']>>;
  /** @deprecated Please use custom_properties instead */
  includePropertyIds?: InputMaybe<Array<Scalars['ID']>>;
  includeTags?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  solicitationReportingTimestamp?: InputMaybe<SolicitationReportingTimestampEnum>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** MetricGoal::EmployeeGoal type */
export type MetricGoalEmployee = MetricGoalInterface & {
  actionItems: Maybe<Array<ActionItem>>;
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  company: Company;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  creator: Employee;
  displayValue: Maybe<Scalars['String']>;
  employee: Employee;
  endedAt: Maybe<Scalars['ISO8601DateTime']>;
  endedByEmployee: Employee;
  /** @deprecated Use threshold */
  goal: Scalars['Float'];
  id: Scalars['ID'];
  metricConfig: MetricConfig;
  permissions: Maybe<GoalPermissionsType>;
  reachedCount: Maybe<Scalars['Int']>;
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  threshold: Scalars['Float'];
  title: Scalars['String'];
  type: MetricGoalTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** MetricGoal::EmployeeGoal type */
export type MetricGoalEmployeeActionItemsArgs = {
  status?: InputMaybe<GoalStatusEnum>;
};

/** MetricGoal::GroupGoal type */
export type MetricGoalGroup = MetricGoalInterface & {
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  company: Company;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  creator: Employee;
  displayValue: Maybe<Scalars['String']>;
  endedAt: Maybe<Scalars['ISO8601DateTime']>;
  endedByEmployee: Employee;
  /** @deprecated Use threshold */
  goal: Scalars['Float'];
  group: Team;
  id: Scalars['ID'];
  metricConfig: MetricConfig;
  permissions: Maybe<GoalPermissionsType>;
  reachedCount: Maybe<Scalars['Int']>;
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  threshold: Scalars['Float'];
  title: Scalars['String'];
  type: MetricGoalTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** MetricGoal interface */
export type MetricGoalInterface = {
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  company: Company;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  creator: Employee;
  displayValue: Maybe<Scalars['String']>;
  endedAt: Maybe<Scalars['ISO8601DateTime']>;
  endedByEmployee: Employee;
  /** @deprecated Use threshold */
  goal: Scalars['Float'];
  id: Scalars['ID'];
  metricConfig: MetricConfig;
  reachedCount: Maybe<Scalars['Int']>;
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  threshold: Scalars['Float'];
  title: Scalars['String'];
  type: MetricGoalTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** MetricGoal Item */
export type MetricGoalItem = MetricGoalEmployee | MetricGoalGroup;

/** The connection type for MetricGoalItem. */
export type MetricGoalItemConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MetricGoalItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<MetricGoalItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MetricGoalItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<MetricGoalItem>;
};

/** MetricGoal types */
export enum MetricGoalTypeEnum {
  Employee = 'EMPLOYEE',
  Group = 'GROUP',
}

/** The available grouping fields for grouped-by metric calculations. */
export enum MetricGroupByEnum {
  AreasOfExcellence = 'AREAS_OF_EXCELLENCE',
  AreasOfImprovement = 'AREAS_OF_IMPROVEMENT',
  Brand = 'BRAND',
  Channel = 'CHANNEL',
  EmployeeId = 'EMPLOYEE_ID',
  Language = 'LANGUAGE',
  Option = 'OPTION',
  QaForm = 'QA_FORM',
  ReportingGroupId = 'REPORTING_GROUP_ID',
  Tags = 'TAGS',
  TeamId = 'TEAM_ID',
}

/** The payload for the result of a calculated grouped-by metric. */
export type MetricGroupResult = {
  areaIdentifier: Maybe<Scalars['String']>;
  calculatedOver: Maybe<CalculatedOverEnum>;
  groupBy: Maybe<Scalars['String']>;
  groupValue: Maybe<Scalars['String']>;
  groupValueId: Maybe<Scalars['ID']>;
  groupValueIds: Maybe<Array<Scalars['ID']>>;
  /** Contains the results for each of the caclulated metrics. */
  metricResult: Maybe<MetricResult>;
};

/** The connection type for MetricGroupResult. */
export type MetricGroupResultConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MetricGroupResultEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<MetricGroupResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MetricGroupResultEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<MetricGroupResult>;
};

/** The information needed to define a metric to be calculated. */
export type MetricInput = {
  metricName: MetricNameEnum;
  questionIdentifier: Scalars['ID'];
};

/** The possible metric names. */
export enum MetricNameEnum {
  Average = 'AVERAGE',
  Counts = 'COUNTS',
  CustomPercent = 'CUSTOM_PERCENT',
  Distribution = 'DISTRIBUTION',
  ExternalNonInteractionMetric = 'EXTERNAL_NON_INTERACTION_METRIC',
  NpsScore = 'NPS_SCORE',
  PercentAnswered = 'PERCENT_ANSWERED',
  PercentDetractors = 'PERCENT_DETRACTORS',
  PercentFiveStar = 'PERCENT_FIVE_STAR',
  PercentNegative = 'PERCENT_NEGATIVE',
  PercentOneStar = 'PERCENT_ONE_STAR',
  PercentPassives = 'PERCENT_PASSIVES',
  PercentPositive = 'PERCENT_POSITIVE',
  PercentPromoters = 'PERCENT_PROMOTERS',
  PercentRecovered = 'PERCENT_RECOVERED',
  PercentResolved = 'PERCENT_RESOLVED',
  PercentUnrecovered = 'PERCENT_UNRECOVERED',
  PercentUnresolved = 'PERCENT_UNRESOLVED',
  QaScore = 'QA_SCORE',
  ResponseRate = 'RESPONSE_RATE',
}

/** Contains information about a metric options */
export type MetricOption = {
  label: Scalars['String'];
  value: Scalars['String'];
};

/** The payload for the result of a single calculated metric. */
export type MetricResult = MetricResultInterface & {
  customTitle: Maybe<Scalars['String']>;
  displayPercentage: Maybe<Scalars['String']>;
  displayValue: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  higherIsBetter: Maybe<Scalars['Boolean']>;
  max: Maybe<Scalars['Int']>;
  metricName: MetricNameEnum;
  min: Maybe<Scalars['Int']>;
  nickname: Maybe<Scalars['String']>;
  questionIdentifier: Maybe<Scalars['String']>;
  questionText: Maybe<Scalars['String']>;
  /** @deprecated custom_title provide more usable title */
  title: Maybe<Scalars['String']>;
  totalPercentage: Maybe<Scalars['Float']>;
  totalResults: Maybe<Scalars['BigInt']>;
  value: Maybe<Scalars['Float']>;
};

/** The standard interface of a calculated metric result. */
export type MetricResultInterface = {
  customTitle: Maybe<Scalars['String']>;
  displayPercentage: Maybe<Scalars['String']>;
  displayValue: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  higherIsBetter: Maybe<Scalars['Boolean']>;
  max: Maybe<Scalars['Int']>;
  metricName: MetricNameEnum;
  min: Maybe<Scalars['Int']>;
  nickname: Maybe<Scalars['String']>;
  questionIdentifier: Maybe<Scalars['String']>;
  questionText: Maybe<Scalars['String']>;
  /** @deprecated custom_title provide more usable title */
  title: Maybe<Scalars['String']>;
  totalPercentage: Maybe<Scalars['Float']>;
  totalResults: Maybe<Scalars['BigInt']>;
  value: Maybe<Scalars['Float']>;
};

export type MetricSelectionUnion = GeneralMetric | LeaderboardMetrics;

/** Contains information about a metric option selections */
export type MetricSelections = {
  id: Scalars['String'];
  options: Array<MetricOption>;
  selected: Array<Maybe<Scalars['String']>>;
  type: MetricConfigTypeEnum;
};

export type MetricSet = {
  createdAt: Maybe<Scalars['ISO8601DateTime']>;
  default: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  metrics: Maybe<Array<MetricSetConfigOptions>>;
  name: Maybe<Scalars['String']>;
  order: Maybe<Scalars['Int']>;
  updatedAt: Maybe<Scalars['ISO8601DateTime']>;
  visibility: Maybe<Array<Team>>;
};

/** Contains metric config options for a metric set */
export type MetricSetConfigOptions = {
  id: Scalars['ID'];
  label: Scalars['String'];
  nickname: Maybe<Scalars['String']>;
  questionIdentifier: Maybe<Scalars['String']>;
  questionText: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** The possible fields to sort on. */
export enum MetricSortFieldEnum {
  /** Sort by the grouped entity, ex: employee_id. */
  GroupValue = 'GROUP_VALUE',
  /** Sort by the metric result value. */
  Value = 'VALUE',
}

/** Sort the metric results. */
export type MetricSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: MetricSortFieldEnum;
};

/** The payload for the result of a calculated trend/time-series metric. */
export type MetricTrendResult = MetricResultInterface & {
  customTitle: Maybe<Scalars['String']>;
  dateRanges: Maybe<Array<DateRange>>;
  /** The list of dates in the series that map to the time series results. */
  dates: Maybe<Array<Scalars['ISO8601Date']>>;
  displayPercentage: Maybe<Scalars['String']>;
  displayValue: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  higherIsBetter: Maybe<Scalars['Boolean']>;
  max: Maybe<Scalars['Int']>;
  metricName: MetricNameEnum;
  min: Maybe<Scalars['Int']>;
  nickname: Maybe<Scalars['String']>;
  questionIdentifier: Maybe<Scalars['String']>;
  questionText: Maybe<Scalars['String']>;
  timeSeries: Maybe<Array<TimeSeries>>;
  /** @deprecated custom_title provide more usable title */
  title: Maybe<Scalars['String']>;
  totalPercentage: Maybe<Scalars['Float']>;
  totalResults: Maybe<Scalars['BigInt']>;
  value: Maybe<Scalars['Float']>;
};

/** Autogenerated input type of ModifyMetricSet */
export type ModifyMetricSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  metrics?: InputMaybe<Array<MetricInput>>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ModifyMetricSet. */
export type ModifyMetricSetPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Scalars['JSON']>;
  metricSet: Maybe<MetricSet>;
};

/** The available mutations on the graph. */
export type Mutation = {
  activateEmployee: Maybe<Employee>;
  addCoachingTopicToSession: Maybe<AddCoachingTopicToSessionPayload>;
  addNegativeFeedbackToCoachingTopic: Maybe<AddNegativeFeedbackToCoachingTopicPayload>;
  appealQaReview: Maybe<QaAppeal>;
  applyCoachingTemplateToPublicNote: Maybe<ApplyCoachingTemplateToPublicNotePayload>;
  archiveCoachingTemplate: Maybe<ArchiveCoachingTemplatePayload>;
  archiveFreeformGoal: Maybe<FreeformGoal>;
  archiveMetricGoal: Maybe<MetricGoalItem>;
  /** Archive QA Assignment */
  archiveQaAssignment: Maybe<QaAssignment>;
  assignLesson: Maybe<Array<LessonAttachment>>;
  bulkDeactivateEmployees: Maybe<BulkDeactivateEmployeesPayload>;
  changeCompanyState: Maybe<Company>;
  completeActionItem: Maybe<ActionItem>;
  /** Completes a QA calibration */
  completeCalibration: Maybe<CompleteCalibrationPayload>;
  completeFreeformGoal: Maybe<FreeformGoal>;
  completeMetricGoal: Maybe<MetricGoalItem>;
  configureAreasOfExcellence: Maybe<Array<AreaOfExcellence>>;
  configureRewards: Maybe<Scalars['Boolean']>;
  connectLessonly: Maybe<LessonlyIntegration>;
  createActionItem: Maybe<CreateActionItemPayload>;
  /** Creates a QA answer */
  createAnswer: Maybe<QaAnswer>;
  /** Creates a QA review audit */
  createAudit: Maybe<QaReviewAudit>;
  /** Creates a QA calibration */
  createCalibration: Maybe<CreateCalibrationPayload>;
  /** Creates a QA review calibration audit */
  createCalibrationAudit: Maybe<QaReviewAudit>;
  createCalibtationsExport: Maybe<CreateCalibrationsExportPayload>;
  createCoachingExport: Maybe<CreateCoachingExportPayload>;
  createCoachingSession: Maybe<CoachingSession>;
  createCoachingSessionActionItem: Maybe<CreateCoachingSessionActionItemPayload>;
  createCoachingSessionInteractionAttachment: Maybe<CreateCoachingSessionInteractionAttachmentPayload>;
  createCoachingSessionPublicNote: Maybe<CreateCoachingSessionPublicNotePayload>;
  createCoachingTemplate: Maybe<CreateCoachingTemplatePayload>;
  createEmployee: Maybe<Employee>;
  createFeedbackExport: Maybe<CreateFeedbackExportPayload>;
  createFeedbackExportFromTemplate: Maybe<CreateFeedbackExportFromTemplatePayload>;
  createFeedbackExportTemplate: Maybe<CreateFeedbackExportTemplatePayload>;
  createFollowUp: Maybe<CreateFollowUpPayload>;
  createFreeformGoal: Maybe<CreateFreeformGoalPayload>;
  createMetricGoal: Maybe<CreateMetricGoalPayload>;
  createMetricSet: Maybe<CreateMetricSetPayload>;
  createOrUpdateReward: Maybe<RewardsTier>;
  createPerformanceMetricsExport: Maybe<PerformanceMetricsPayload>;
  createQaFormOverviewsExport: Maybe<CreateQaFormOverviewsExportPayload>;
  createReportingGroup: Maybe<CreateReportingGroupPayload>;
  deactivateEmployee: Maybe<Employee>;
  /** Deletes a QA review audit */
  deleteAudit: Maybe<DeleteAuditPayload>;
  /** Deletes a QA calibration */
  deleteCalibration: Maybe<DeleteCalibrationPayload>;
  /** Delete Coaching Session Action Items (takeaways) */
  deleteCoachingSessionActionItem: Maybe<DeleteTakeawayResponse>;
  deleteCoachingSessionInteractionAttachment: Maybe<DeleteCoachingSessionInteractionAttachmentPayload>;
  deleteFeedbackExportTemplate: Maybe<DeleteFeedbackExportTemplatePayload>;
  deleteFollowUp: Maybe<DeleteFollowUpPayload>;
  deleteMetricSet: Maybe<Array<MetricSet>>;
  /** Discards edits and restores a QA review audit to its completed state */
  discardAudit: Maybe<QaReviewAudit>;
  /** Discards edits and restores a QA review to its completed state */
  discardReview: Maybe<QaReviewRegular>;
  disconnectLessonly: Maybe<LessonlyIntegration>;
  disconnectSnappyIntegration: Maybe<SnappyApiKey>;
  duplicateFeedbackExportTemplate: Maybe<DuplicateFeedbackExportTemplatePayload>;
  employeeGroupAddMember: Maybe<EmployeeGroup>;
  employeeGroupCreate: Maybe<EmployeeGroup>;
  employeeGroupRemoveMember: Maybe<EmployeeGroup>;
  /** Fulfills all snappy rewards that fit the given filters */
  fulfillSnappyRewards: Maybe<FulfillSnappyRewardsPayload>;
  modifyMetricSet: Maybe<ModifyMetricSetPayload>;
  /** Publish a survey configuration */
  publishSurveyConfiguration: Maybe<PublishConfigurationPayload>;
  /** Marks Coaching Session as Recapped. Sends session to employee. */
  recapCoachingSession: Maybe<CoachingSession>;
  /** Records an answer for a QA calibration question */
  recordCalibrationAnswer: Maybe<RecordCalibrationAnswerPayload>;
  removeNegativeFeedbackFromCoachingTopic: Maybe<RemoveNegativeFeedbackFromCoachingTopicPayload>;
  reportingGroupAddMember: Maybe<ReportingGroup>;
  reportingGroupRemoveMember: Maybe<ReportingGroup>;
  resetEmployeePassword: Maybe<Employee>;
  /** Reset a survey configuration */
  resetSurveyConfiguration: Maybe<ResetConfigurationPayload>;
  resolveQaAppeal: Maybe<QaResolution>;
  /** Send a test email for a survey configuration */
  sendTestEmail: Maybe<SendTestEmailPayload>;
  setSnappyApiKey: Maybe<SnappyApiKey>;
  teamAddMember: Maybe<Team>;
  teamRemoveMember: Maybe<Team>;
  toggleAchievementCategory: AchievementCategory;
  toggleCompanyAchievement: CompanyAchievement;
  /** Enable or disable the service recovery survey */
  toggleServiceRecovery: Maybe<ToggleServiceRecoveryPayload>;
  unassignLesson: Maybe<Array<LessonAttachment>>;
  undoFreeformGoal: Maybe<UndoFreeformGoalPayload>;
  undoMetricGoal: Maybe<UndoMetricGoalPayload>;
  updateActionItem: Maybe<UpdateActionItemPayload>;
  /** Updates a QA answer */
  updateAnswer: Maybe<QaAnswer>;
  /** Updates a QA review audit */
  updateAudit: Maybe<QaReviewAudit>;
  /** Updates a QA calibration */
  updateCalibration: Maybe<UpdateCalibrationPayload>;
  /** Update company channel integrations */
  updateChannelIntegrations: Maybe<Array<Channel>>;
  updateCoachingIntelligenceSettings: Maybe<UpdateCoachingIntelligenceSettingsPayload>;
  /** Update Coaching Session Action Item Status */
  updateCoachingSessionActionItem: Maybe<Takeaway>;
  /** Update Coaching Session Action Item Attributes */
  updateCoachingSessionActionItemAttributes: Maybe<Takeaway>;
  updateCoachingSessionInteractionAttachment: Maybe<UpdateCoachingSessionInteractionAttachmentPayload>;
  updateCoachingSessionPublicNote: Maybe<UpdateCoachingSessionPublicNotePayload>;
  updateCoachingSummaryFeedback: Maybe<UpdateCoachingSummaryFeedbackPayload>;
  updateCoachingTemplate: Maybe<UpdateCoachingTemplatePayload>;
  /** Set DateFilterConfig attributes that belong to a company */
  updateDateFilterConfig: Maybe<DateFilterConfig>;
  updateEmployee: Maybe<Employee>;
  updateExportsLastReadAt: Maybe<UpdateExportsLastReadAtPayload>;
  updateFeedbackExportTemplate: Maybe<UpdateFeedbackExportTemplatePayload>;
  updateLeaderboardSettings: Maybe<LeaderboardMetrics>;
  updateMetricSelection: Maybe<GeneralMetric>;
  updateMetricSetOrder: Maybe<UpdateMetricSetOrderPayload>;
  updatePerformanceMetricSelections: Maybe<GeneralMetric>;
  /** Update QA Assignment */
  updateQaAssignment: Maybe<UpdateQaAssignmentPayload>;
  updateReportingGroup: Maybe<UpdateReportingGroupPayload>;
  /** Update a survey configuration */
  updateSurveyConfiguration: Maybe<UpdateConfigurationPayload>;
  updateTeamSettings: Maybe<Company>;
};

/** The available mutations on the graph. */
export type MutationActivateEmployeeArgs = {
  input: ActivateEmployeeInput;
};

/** The available mutations on the graph. */
export type MutationAddCoachingTopicToSessionArgs = {
  input: AddCoachingTopicToSessionInput;
};

/** The available mutations on the graph. */
export type MutationAddNegativeFeedbackToCoachingTopicArgs = {
  input: AddNegativeFeedbackToCoachingTopicInput;
};

/** The available mutations on the graph. */
export type MutationAppealQaReviewArgs = {
  input: AppealQaReviewInput;
};

/** The available mutations on the graph. */
export type MutationApplyCoachingTemplateToPublicNoteArgs = {
  input: ApplyCoachingTemplateToPublicNoteInput;
};

/** The available mutations on the graph. */
export type MutationArchiveCoachingTemplateArgs = {
  input: ArchiveCoachingTemplateInput;
};

/** The available mutations on the graph. */
export type MutationArchiveFreeformGoalArgs = {
  input: ArchiveFreeformGoalInput;
};

/** The available mutations on the graph. */
export type MutationArchiveMetricGoalArgs = {
  input: ArchiveMetricGoalInput;
};

/** The available mutations on the graph. */
export type MutationArchiveQaAssignmentArgs = {
  input: ArchiveQaAssignmentInput;
};

/** The available mutations on the graph. */
export type MutationAssignLessonArgs = {
  input: AssignLessonInput;
};

/** The available mutations on the graph. */
export type MutationBulkDeactivateEmployeesArgs = {
  input: BulkDeactivateEmployeesInput;
};

/** The available mutations on the graph. */
export type MutationChangeCompanyStateArgs = {
  input: ChangeCompanyStateInput;
};

/** The available mutations on the graph. */
export type MutationCompleteActionItemArgs = {
  input: CompleteActionItemInput;
};

/** The available mutations on the graph. */
export type MutationCompleteCalibrationArgs = {
  input: CompleteCalibrationInput;
};

/** The available mutations on the graph. */
export type MutationCompleteFreeformGoalArgs = {
  input: CompleteFreeformGoalInput;
};

/** The available mutations on the graph. */
export type MutationCompleteMetricGoalArgs = {
  input: CompleteMetricGoalInput;
};

/** The available mutations on the graph. */
export type MutationConfigureAreasOfExcellenceArgs = {
  input: ConfigureAreasOfExcellenceInput;
};

/** The available mutations on the graph. */
export type MutationConfigureRewardsArgs = {
  input: ConfigureRewardsInput;
};

/** The available mutations on the graph. */
export type MutationConnectLessonlyArgs = {
  input: ConnectLessonlyInput;
};

/** The available mutations on the graph. */
export type MutationCreateActionItemArgs = {
  input: CreateActionItemInput;
};

/** The available mutations on the graph. */
export type MutationCreateAnswerArgs = {
  input: CreateAnswerInput;
};

/** The available mutations on the graph. */
export type MutationCreateAuditArgs = {
  input: CreateAuditInput;
};

/** The available mutations on the graph. */
export type MutationCreateCalibrationArgs = {
  input: CreateCalibrationInput;
};

/** The available mutations on the graph. */
export type MutationCreateCalibrationAuditArgs = {
  input: CreateCalibrationAuditInput;
};

/** The available mutations on the graph. */
export type MutationCreateCalibtationsExportArgs = {
  input: CreateCalibrationsExportInput;
};

/** The available mutations on the graph. */
export type MutationCreateCoachingExportArgs = {
  input: CreateCoachingExportInput;
};

/** The available mutations on the graph. */
export type MutationCreateCoachingSessionArgs = {
  input: CreateCoachingSessionInput;
};

/** The available mutations on the graph. */
export type MutationCreateCoachingSessionActionItemArgs = {
  input: CreateCoachingSessionActionItemInput;
};

/** The available mutations on the graph. */
export type MutationCreateCoachingSessionInteractionAttachmentArgs = {
  input: CreateCoachingSessionInteractionAttachmentInput;
};

/** The available mutations on the graph. */
export type MutationCreateCoachingSessionPublicNoteArgs = {
  input: CreateCoachingSessionPublicNoteInput;
};

/** The available mutations on the graph. */
export type MutationCreateCoachingTemplateArgs = {
  input: CreateCoachingTemplateInput;
};

/** The available mutations on the graph. */
export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};

/** The available mutations on the graph. */
export type MutationCreateFeedbackExportArgs = {
  input: CreateFeedbackExportInput;
};

/** The available mutations on the graph. */
export type MutationCreateFeedbackExportFromTemplateArgs = {
  input: CreateFeedbackExportFromTemplateInput;
};

/** The available mutations on the graph. */
export type MutationCreateFeedbackExportTemplateArgs = {
  input: CreateFeedbackExportTemplateInput;
};

/** The available mutations on the graph. */
export type MutationCreateFollowUpArgs = {
  input: CreateFollowUpInput;
};

/** The available mutations on the graph. */
export type MutationCreateFreeformGoalArgs = {
  input: CreateFreeformGoalInput;
};

/** The available mutations on the graph. */
export type MutationCreateMetricGoalArgs = {
  input: CreateMetricGoalInput;
};

/** The available mutations on the graph. */
export type MutationCreateMetricSetArgs = {
  input: CreateMetricSetInput;
};

/** The available mutations on the graph. */
export type MutationCreateOrUpdateRewardArgs = {
  input: CreateOrUpdateRewardInput;
};

/** The available mutations on the graph. */
export type MutationCreatePerformanceMetricsExportArgs = {
  input: PerformanceMetricsInput;
};

/** The available mutations on the graph. */
export type MutationCreateQaFormOverviewsExportArgs = {
  input: CreateQaFormOverviewsExportInput;
};

/** The available mutations on the graph. */
export type MutationCreateReportingGroupArgs = {
  input: CreateReportingGroupInput;
};

/** The available mutations on the graph. */
export type MutationDeactivateEmployeeArgs = {
  input: DeactivateEmployeeInput;
};

/** The available mutations on the graph. */
export type MutationDeleteAuditArgs = {
  input: DeleteAuditInput;
};

/** The available mutations on the graph. */
export type MutationDeleteCalibrationArgs = {
  input: DeleteCalibrationInput;
};

/** The available mutations on the graph. */
export type MutationDeleteCoachingSessionActionItemArgs = {
  input: DeleteCoachingSessionActionItemInput;
};

/** The available mutations on the graph. */
export type MutationDeleteCoachingSessionInteractionAttachmentArgs = {
  input: DeleteCoachingSessionInteractionAttachmentInput;
};

/** The available mutations on the graph. */
export type MutationDeleteFeedbackExportTemplateArgs = {
  input: DeleteFeedbackExportTemplateInput;
};

/** The available mutations on the graph. */
export type MutationDeleteFollowUpArgs = {
  input: DeleteFollowUpInput;
};

/** The available mutations on the graph. */
export type MutationDeleteMetricSetArgs = {
  input: DeleteMetricSetInput;
};

/** The available mutations on the graph. */
export type MutationDiscardAuditArgs = {
  input: DiscardAuditInput;
};

/** The available mutations on the graph. */
export type MutationDiscardReviewArgs = {
  input: DiscardReviewInput;
};

/** The available mutations on the graph. */
export type MutationDisconnectLessonlyArgs = {
  input: DisconnectLessonlyInput;
};

/** The available mutations on the graph. */
export type MutationDisconnectSnappyIntegrationArgs = {
  input: DisconnectSnappyIntegrationInput;
};

/** The available mutations on the graph. */
export type MutationDuplicateFeedbackExportTemplateArgs = {
  input: DuplicateFeedbackExportTemplateInput;
};

/** The available mutations on the graph. */
export type MutationEmployeeGroupAddMemberArgs = {
  input: AddMemberInput;
};

/** The available mutations on the graph. */
export type MutationEmployeeGroupCreateArgs = {
  input: CreateInput;
};

/** The available mutations on the graph. */
export type MutationEmployeeGroupRemoveMemberArgs = {
  input: RemoveMemberInput;
};

/** The available mutations on the graph. */
export type MutationFulfillSnappyRewardsArgs = {
  input: FulfillSnappyRewardsInput;
};

/** The available mutations on the graph. */
export type MutationModifyMetricSetArgs = {
  input: ModifyMetricSetInput;
};

/** The available mutations on the graph. */
export type MutationPublishSurveyConfigurationArgs = {
  input: PublishConfigurationInput;
};

/** The available mutations on the graph. */
export type MutationRecapCoachingSessionArgs = {
  input: RecapCoachingSessionInput;
};

/** The available mutations on the graph. */
export type MutationRecordCalibrationAnswerArgs = {
  input: RecordCalibrationAnswerInput;
};

/** The available mutations on the graph. */
export type MutationRemoveNegativeFeedbackFromCoachingTopicArgs = {
  input: RemoveNegativeFeedbackFromCoachingTopicInput;
};

/** The available mutations on the graph. */
export type MutationReportingGroupAddMemberArgs = {
  input: AddMemberReportingGroupInput;
};

/** The available mutations on the graph. */
export type MutationReportingGroupRemoveMemberArgs = {
  input: RemoveMemberReportingGroupInput;
};

/** The available mutations on the graph. */
export type MutationResetEmployeePasswordArgs = {
  input: ResetEmployeePasswordInput;
};

/** The available mutations on the graph. */
export type MutationResetSurveyConfigurationArgs = {
  input: ResetConfigurationInput;
};

/** The available mutations on the graph. */
export type MutationResolveQaAppealArgs = {
  input: ResolveQaAppealInput;
};

/** The available mutations on the graph. */
export type MutationSendTestEmailArgs = {
  input: SendTestEmailInput;
};

/** The available mutations on the graph. */
export type MutationSetSnappyApiKeyArgs = {
  input: SetSnappyApiKeyInput;
};

/** The available mutations on the graph. */
export type MutationTeamAddMemberArgs = {
  input: AddTeamMemberInput;
};

/** The available mutations on the graph. */
export type MutationTeamRemoveMemberArgs = {
  input: RemoveTeamMemberInput;
};

/** The available mutations on the graph. */
export type MutationToggleAchievementCategoryArgs = {
  input: ToggleAchievementCategoryInput;
};

/** The available mutations on the graph. */
export type MutationToggleCompanyAchievementArgs = {
  input: ToggleCompanyAchievementInput;
};

/** The available mutations on the graph. */
export type MutationToggleServiceRecoveryArgs = {
  input: ToggleServiceRecoveryInput;
};

/** The available mutations on the graph. */
export type MutationUnassignLessonArgs = {
  input: UnassignLessonInput;
};

/** The available mutations on the graph. */
export type MutationUndoFreeformGoalArgs = {
  input: UndoFreeformGoalInput;
};

/** The available mutations on the graph. */
export type MutationUndoMetricGoalArgs = {
  input: UndoMetricGoalInput;
};

/** The available mutations on the graph. */
export type MutationUpdateActionItemArgs = {
  input: UpdateActionItemInput;
};

/** The available mutations on the graph. */
export type MutationUpdateAnswerArgs = {
  input: UpdateAnswerInput;
};

/** The available mutations on the graph. */
export type MutationUpdateAuditArgs = {
  input: UpdateAuditInput;
};

/** The available mutations on the graph. */
export type MutationUpdateCalibrationArgs = {
  input: UpdateCalibrationInput;
};

/** The available mutations on the graph. */
export type MutationUpdateChannelIntegrationsArgs = {
  input: UpdateIntegrationsInput;
};

/** The available mutations on the graph. */
export type MutationUpdateCoachingIntelligenceSettingsArgs = {
  input: UpdateCoachingIntelligenceSettingsInput;
};

/** The available mutations on the graph. */
export type MutationUpdateCoachingSessionActionItemArgs = {
  input: UpdateCoachingSessionActionItemInput;
};

/** The available mutations on the graph. */
export type MutationUpdateCoachingSessionActionItemAttributesArgs = {
  input: UpdateCoachingSessionActionItemAttributesInput;
};

/** The available mutations on the graph. */
export type MutationUpdateCoachingSessionInteractionAttachmentArgs = {
  input: UpdateCoachingSessionInteractionAttachmentInput;
};

/** The available mutations on the graph. */
export type MutationUpdateCoachingSessionPublicNoteArgs = {
  input: UpdateCoachingSessionPublicNoteInput;
};

/** The available mutations on the graph. */
export type MutationUpdateCoachingSummaryFeedbackArgs = {
  input: UpdateCoachingSummaryFeedbackInput;
};

/** The available mutations on the graph. */
export type MutationUpdateCoachingTemplateArgs = {
  input: UpdateCoachingTemplateInput;
};

/** The available mutations on the graph. */
export type MutationUpdateDateFilterConfigArgs = {
  input: UpdateDateFilterConfigInput;
};

/** The available mutations on the graph. */
export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput;
};

/** The available mutations on the graph. */
export type MutationUpdateExportsLastReadAtArgs = {
  input: UpdateExportsLastReadAtInput;
};

/** The available mutations on the graph. */
export type MutationUpdateFeedbackExportTemplateArgs = {
  input: UpdateFeedbackExportTemplateInput;
};

/** The available mutations on the graph. */
export type MutationUpdateLeaderboardSettingsArgs = {
  input: UpdateLeaderboardSettingsInput;
};

/** The available mutations on the graph. */
export type MutationUpdateMetricSelectionArgs = {
  input: UpdateMetricSelectionInput;
};

/** The available mutations on the graph. */
export type MutationUpdateMetricSetOrderArgs = {
  input: UpdateMetricSetOrderInput;
};

/** The available mutations on the graph. */
export type MutationUpdatePerformanceMetricSelectionsArgs = {
  input: UpdatePerformanceMetricSelectionsInput;
};

/** The available mutations on the graph. */
export type MutationUpdateQaAssignmentArgs = {
  input: UpdateQaAssignmentInput;
};

/** The available mutations on the graph. */
export type MutationUpdateReportingGroupArgs = {
  input: UpdateReportingGroupInput;
};

/** The available mutations on the graph. */
export type MutationUpdateSurveyConfigurationArgs = {
  input: UpdateConfigurationInput;
};

/** The available mutations on the graph. */
export type MutationUpdateTeamSettingsArgs = {
  input: UpdateTeamSettingsInput;
};

export type MyListStatus = {
  assigned: Scalars['Int'];
  assignedBefore: Scalars['Int'];
  isChanged: Scalars['Boolean'];
  revieweesStats: EligibilityStats;
  reviewersStats: EligibilityStats;
  totalAssignmentsAffected: Scalars['Int'];
};

/** Available My QA Assignment fields for sorting */
export enum MyQaAssignmentSortFieldEnum {
  CreatedAt = 'createdAt',
  Name = 'name',
  Progress = 'progress',
  TotalReviewees = 'totalReviewees',
  TotalReviewers = 'totalReviewers',
}

/** My QA Assignment sorting parameters */
export type MyQaAssignmentSortInput = {
  direction?: SortDirectionEnum;
  field?: MyQaAssignmentSortFieldEnum;
};

/** NegativeFeedback type */
export type NegativeFeedback = {
  comment: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  feedbackReason: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum NegativeFeedbackReasonEnum {
  Inaccurate = 'INACCURATE',
  Irrelevant = 'IRRELEVANT',
  Offensive = 'OFFENSIVE',
  Other = 'OTHER',
}

/** Represents a non-persisted employee badge */
export type NonPersistedEmployeeBadge = {
  badgeKey: Scalars['String'];
  badgeType: Scalars['String'];
  companyAchievement: CompanyAchievement;
  description: Scalars['String'];
  employee: Employee;
  iconSettings: Maybe<Scalars['JSON']>;
  imageUrl: Scalars['String'];
  instruction: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['String'];
  surprise: Maybe<Scalars['Boolean']>;
  threshold: Maybe<Scalars['Int']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** Past Goal type */
export type PastGoal = {
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  company: Company;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  creator: Employee;
  employeeId: Maybe<Scalars['ID']>;
  endedAt: Maybe<Scalars['ISO8601DateTime']>;
  endedByEmployee: Employee;
  entityId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  metricConfigId: Maybe<Scalars['ID']>;
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  threshold: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PastGoal. */
export type PastGoalConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PastGoalEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<PastGoal>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PastGoalEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<PastGoal>;
};

/** Past Goal filter object */
export type PastGoalFilterInput = {
  creatorIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  goalType?: InputMaybe<GoalTypeEnum>;
  pattern?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** The result of the performance highlight query */
export type PerformanceHighlight = {
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
  value: Scalars['Int'];
};

/** The possible performance highlights */
export enum PerformanceHighlightsEnum {
  Kudos = 'KUDOS',
  Qa = 'QA',
  SharedCoachingSessions = 'SHARED_COACHING_SESSIONS',
}

/** Autogenerated input type of PerformanceMetrics */
export type PerformanceMetricsInput = {
  allReportingGroups?: InputMaybe<Scalars['Boolean']>;
  brandingIds?: InputMaybe<Array<Scalars['ID']>>;
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customProperties?: InputMaybe<Array<CustomPropertyFilterInput>>;
  dates: DatesInput;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  /** @deprecated Do not allow property type based filtering, use custom_properties */
  excludePropertyIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeTags?: InputMaybe<Array<Scalars['String']>>;
  filterBy?: InputMaybe<Array<FilterByEnum>>;
  /** Add Areas of Excellence/Improvement counts for employee */
  includeAreas?: InputMaybe<Scalars['Boolean']>;
  /** Allow to export data for deactivated employees */
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Do not allow property type based filtering, use custom_properties */
  includePropertyIds?: InputMaybe<Array<Scalars['ID']>>;
  includeTags?: InputMaybe<Array<Scalars['String']>>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  priorDates?: InputMaybe<DatesInput>;
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  solicitationReportingTimestamp?: InputMaybe<SolicitationReportingTimestampEnum>;
  sort?: InputMaybe<MetricSortInput>;
  /** Used when exporting hidden data for given team. */
  teamId?: InputMaybe<Scalars['ID']>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of PerformanceMetrics. */
export type PerformanceMetricsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<ValidationErrors>;
  export: Maybe<Export>;
};

/** The available permissions for employees. */
export enum PermissionEnum {
  ReviewQa = 'REVIEW_QA',
}

/** Permissions for Takeaway actions */
export type Permissions = {
  completable: Scalars['Boolean'];
};

/** QA Assignment skipped solicitation reviewer data */
export type Person = {
  fullName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
};

export enum PresenceFilterEnum {
  NotPresent = 'NOT_PRESENT',
  Present = 'PRESENT',
}

/** Product areas that can be used to scope the results */
export enum ProductArea {
  Administrative = 'ADMINISTRATIVE',
  Coaching = 'COACHING',
  Feedback = 'FEEDBACK',
  Qa = 'QA',
  QaAppeal = 'QA_APPEAL',
  QaCalibration = 'QA_CALIBRATION',
}

/** Contains the personal details of an employee. */
export type Profile = {
  approved: Scalars['Boolean'];
  countryCode: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  fullName: Maybe<Scalars['String']>;
  hasCustomImage: Maybe<Scalars['Boolean']>;
  hometown: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  stateOrCountry: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
};

/** Property */
export type Property = {
  id: Scalars['ID'];
  value: Scalars['String'];
};

/** The connection type for Property. */
export type PropertyConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PropertyEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Property>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PropertyEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Property>;
};

/** Autogenerated input type of PublishConfiguration */
export type PublishConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  configurationId: Scalars['String'];
};

/** Autogenerated return type of PublishConfiguration. */
export type PublishConfigurationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  success: Scalars['Boolean'];
  surveyConfiguration: Maybe<SurveyConfiguration>;
};

/** QA Allocation data, relates to QaAssignment */
export type QaAllocation = {
  id: Scalars['ID'];
};

export type QaAllocationInput = {
  count: Scalars['Int'];
  type: QaAllocationTypeEnum;
  value: Scalars['String'];
};

/** The type of interaction to allocate */
export enum QaAllocationTypeEnum {
  /** Any interaction */
  Any = 'ANY',
  /** Interactions based on a channel */
  Channel = 'CHANNEL',
  /** Interactions based on a star range */
  Stars = 'STARS',
  /** Interactions that have a specific set of tags */
  Tags = 'TAGS',
}

/** QA Annotation details */
export type QaAnnotation = {
  comments: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  employee: Employee;
  id: Scalars['ID'];
  interactionEventId: Maybe<Scalars['ID']>;
  mediaType: Maybe<Scalars['String']>;
  qaReviewId: Scalars['ID'];
  start: Maybe<Scalars['Int']>;
  stop: Maybe<Scalars['Int']>;
};

/** Contains an answer for a review */
export type QaAnswer = {
  answerableId: Scalars['ID'];
  answerableType: Scalars['ID'];
  answered: Scalars['Boolean'];
  comments: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  qaOption: Maybe<QaOption>;
  qaQuestion: QaQuestion;
  updatedAt: Maybe<Scalars['ISO8601DateTime']>;
};

/** AnswerFilterInput type */
export type QaAnswerFilterInputt = {
  qaOptionId?: InputMaybe<Scalars['Int']>;
  qaQuestionId: Scalars['Int'];
};

/** Contains details of QaAppeal to QaReview */
export type QaAppeal = {
  createdAt: Scalars['ISO8601DateTime'];
  employee: Employee;
  id: Scalars['ID'];
  reasons: Array<QaAppealReason>;
  resolution: Maybe<QaResolution>;
};

/** Reasons for an appeal provided by an agent */
export type QaAppealReason = {
  note: Scalars['String'];
  qaAnswer: QaAnswer;
};

/** Reasons for appeal provided by agent */
export type QaAppealReasonInput = {
  note: Scalars['String'];
  qaAnswerId: Scalars['ID'];
};

/** QA Assignment data */
export type QaAssignment = QaAssignmentGeneralInterface & {
  allocateToTeamLeader: Scalars['Boolean'];
  allowBestMatch: Scalars['Boolean'];
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  archivedBy: Maybe<Employee>;
  assigned: Scalars['Int'];
  blind: Scalars['Boolean'];
  cadence: Scalars['String'];
  completed: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  effectiveAt: Maybe<Scalars['ISO8601DateTime']>;
  endDate: Scalars['ISO8601DateTime'];
  id: Maybe<Scalars['ID']>;
  initialStartDate: Maybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
  numberOfDays: Maybe<Scalars['Int']>;
  progress: Scalars['Int'];
  qaFormId: Maybe<Scalars['ID']>;
  qaReviewType: Maybe<Scalars['String']>;
  /** QA Assignment reviewees */
  reviewees: QaAssignmentRevieweeCollection;
  /** QA Assignment reviewers */
  reviewers: Array<QaAssignmentReviewer>;
  /** QA Assignment Skip Reason Stats */
  skipReasonStats: Array<QaAssignmentSkipReasonStats>;
  skipped: Scalars['Int'];
  startDate: Scalars['ISO8601DateTime'];
  totalActiveReviewees: Scalars['Int'];
  totalActiveReviewers: Scalars['Int'];
  totalCycles: Scalars['Int'];
  totalReportingGroups: Scalars['Int'];
  totalReviewees: Scalars['Int'];
  totalReviewers: Scalars['Int'];
  totalReviewsPerAgent: Scalars['Int'];
  totalReviewsPerReviewer: Scalars['Int'];
  totalTeams: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** QA Assignment data */
export type QaAssignmentRevieweesArgs = {
  filters?: InputMaybe<QaAssignmentRevieweesFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QaAssignmentRevieweesSortInput>;
};

/** QA Assignment data */
export type QaAssignmentSkipReasonStatsArgs = {
  reviewerId?: InputMaybe<Scalars['ID']>;
};

/** Possible validations on a reviewer in a QA Assignment. */
export enum QaAssignmentCadenceEnum {
  /** QA Assignment repeats based on a set number of days */
  Custom = 'CUSTOM',
  /** QA Assignment repeats on a monthly basis */
  Monthly = 'MONTHLY',
  /** QA Assignment repeats on a weekly basis */
  Weekly = 'WEEKLY',
}

export type QaAssignmentGeneralInterface = {
  allocateToTeamLeader: Scalars['Boolean'];
  allowBestMatch: Scalars['Boolean'];
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  archivedBy: Maybe<Employee>;
  assigned: Scalars['Int'];
  blind: Scalars['Boolean'];
  cadence: Scalars['String'];
  completed: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  effectiveAt: Maybe<Scalars['ISO8601DateTime']>;
  endDate: Scalars['ISO8601DateTime'];
  id: Maybe<Scalars['ID']>;
  initialStartDate: Maybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
  numberOfDays: Maybe<Scalars['Int']>;
  progress: Scalars['Int'];
  qaFormId: Maybe<Scalars['ID']>;
  qaReviewType: Maybe<Scalars['String']>;
  skipped: Scalars['Int'];
  startDate: Scalars['ISO8601DateTime'];
  totalActiveReviewees: Scalars['Int'];
  totalActiveReviewers: Scalars['Int'];
  totalCycles: Scalars['Int'];
  totalReviewees: Scalars['Int'];
  totalReviewers: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input to create or preview a QA Assignment */
export type QaAssignmentInput = {
  allocateToTeamLeader?: InputMaybe<Scalars['Boolean']>;
  allocations?: InputMaybe<Array<QaAllocationInput>>;
  allowBestMatch?: InputMaybe<Scalars['Boolean']>;
  blind?: InputMaybe<Scalars['Boolean']>;
  cadence?: InputMaybe<QaAssignmentCadenceEnum>;
  defaultQaFormId?: InputMaybe<Scalars['ID']>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  excludedEmployeeIds?: InputMaybe<Array<Scalars['ID']>>;
  filters?: InputMaybe<Scalars['JSON']>;
  includedRoleIds?: InputMaybe<Array<Scalars['ID']>>;
  initialStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  numberOfDays?: InputMaybe<Scalars['Int']>;
  qaReviewType?: InputMaybe<Scalars['String']>;
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  reportingGroupScopeId?: InputMaybe<Scalars['ID']>;
  reviewerIds?: InputMaybe<Array<Scalars['ID']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** QA Assignment data for the list */
export type QaAssignmentListItem = QaAssignmentGeneralInterface & {
  allocateToTeamLeader: Scalars['Boolean'];
  allowBestMatch: Scalars['Boolean'];
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  archivedBy: Maybe<Employee>;
  assigned: Scalars['Int'];
  blind: Scalars['Boolean'];
  cadence: Scalars['String'];
  completed: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  effectiveAt: Maybe<Scalars['ISO8601DateTime']>;
  endDate: Scalars['ISO8601DateTime'];
  id: Maybe<Scalars['ID']>;
  initialStartDate: Maybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
  numberOfDays: Maybe<Scalars['Int']>;
  progress: Scalars['Int'];
  qaFormId: Maybe<Scalars['ID']>;
  qaReviewType: Maybe<Scalars['String']>;
  skipped: Scalars['Int'];
  startDate: Scalars['ISO8601DateTime'];
  totalActiveReviewees: Scalars['Int'];
  totalActiveReviewers: Scalars['Int'];
  totalCycles: Scalars['Int'];
  totalReviewees: Scalars['Int'];
  totalReviewers: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** QaAssignmentListItemCollection type */
export type QaAssignmentListItemCollection = {
  /** A collection of paginated QaAssignmentListItemCollection */
  collection: Array<QaAssignmentListItem>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** QA Assignment next review data */
export type QaAssignmentNextReview = {
  blind: Maybe<Scalars['Boolean']>;
  partiallyMatched: Maybe<Scalars['Boolean']>;
  qaAllocation: Maybe<QaAllocation>;
  /** @deprecated Use qa_allocation.id */
  qaAllocationId: Maybe<Scalars['ID']>;
  qaAssignmentId: Maybe<Scalars['ID']>;
  qaReviewId: Maybe<Scalars['ID']>;
  qaReviewType: Scalars['String'];
  uuid: Maybe<Scalars['ID']>;
};

/** QA Assignment period data */
export type QaAssignmentPeriod = {
  assigned: Scalars['Int'];
  assignedBefore: Scalars['Int'];
  averageQaScore: Maybe<Scalars['Int']>;
  completed: Scalars['Int'];
  eligibleInteractionsCount: Scalars['Int'];
  endDate: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  interactionsCount: Scalars['Int'];
  progress: Scalars['Int'];
  /** QA Assignment Period Reviewees */
  reviewees: QaAssignmentPeriodRevieweeConnection;
  revieweesStats: EligibilityStats;
  /** QA Assignment Period Reviewers */
  reviewers: QaAssignmentPeriodReviewerConnection;
  reviewersStats: EligibilityStats;
  skipReasonStats: Maybe<Array<QaAssignmentSkipReasonStats>>;
  skipped: Maybe<Scalars['Int']>;
  startDate: Scalars['ISO8601DateTime'];
  /** @deprecated Use revieweesStats.total */
  totalReviewees: Scalars['Int'];
  /** @deprecated Use reviewersStats.total */
  totalReviewers: Scalars['Int'];
};

/** QA Assignment period data */
export type QaAssignmentPeriodRevieweesArgs = {
  activity?: InputMaybe<QaAssignmentRevieweeActivityEnum>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QaAssignmentPeriodRevieweesSortInput>;
};

/** QA Assignment period data */
export type QaAssignmentPeriodReviewersArgs = {
  activity?: InputMaybe<QaAssignmentReviewerActivityEnum>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QaAssignmentPeriodReviewersSortInput>;
};

/** QA Assignment reviewee data for Reviewee for current period */
export type QaAssignmentPeriodReviewee = {
  activity: Maybe<QaAssignmentRevieweeActivityEnum>;
  averageQaScore: Maybe<Scalars['Int']>;
  completed: Scalars['Int'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  isReviewable: Maybe<Scalars['Boolean']>;
  joinedAt: Maybe<Scalars['ISO8601DateTime']>;
  leftAt: Maybe<Scalars['ISO8601DateTime']>;
  leftReason: Maybe<Scalars['String']>;
  progress: Scalars['Int'];
};

/** The connection type for QaAssignmentPeriodReviewee. */
export type QaAssignmentPeriodRevieweeConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QaAssignmentPeriodRevieweeEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<QaAssignmentPeriodReviewee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QaAssignmentPeriodRevieweeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<QaAssignmentPeriodReviewee>;
};

/** Available QA Assignment reviewees fields for sorting */
export enum QaAssignmentPeriodRevieweesSortFieldEnum {
  Activity = 'ACTIVITY',
  FullName = 'FULL_NAME',
  Id = 'ID',
  Progress = 'PROGRESS',
}

/** QA Assignment period reviewees sorting parameters */
export type QaAssignmentPeriodRevieweesSortInput = {
  direction?: SortDirectionEnum;
  field?: QaAssignmentPeriodRevieweesSortFieldEnum;
};

/** QA Assignment reviewer data for the reviewer over the period */
export type QaAssignmentPeriodReviewer = {
  activity: Maybe<QaAssignmentReviewerActivityEnum>;
  assigned: Scalars['Int'];
  completed: Scalars['Int'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  joinedAt: Maybe<Scalars['ISO8601DateTime']>;
  leftAt: Maybe<Scalars['ISO8601DateTime']>;
  leftReason: Maybe<Scalars['String']>;
  progress: Scalars['Int'];
  skipped: Scalars['Int'];
  validationErrors: Array<ReviewerValidation>;
};

/** The connection type for QaAssignmentPeriodReviewer. */
export type QaAssignmentPeriodReviewerConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QaAssignmentPeriodReviewerEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<QaAssignmentPeriodReviewer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QaAssignmentPeriodReviewerEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<QaAssignmentPeriodReviewer>;
};

/** Available QA Assignment reviewers fields for sorting */
export enum QaAssignmentPeriodReviewersSortFieldEnum {
  Activity = 'ACTIVITY',
  FullName = 'FULL_NAME',
  Id = 'ID',
  Progress = 'PROGRESS',
}

/** QA Assignment period reviewers sorting parameters */
export type QaAssignmentPeriodReviewersSortInput = {
  direction?: SortDirectionEnum;
  field?: QaAssignmentPeriodReviewersSortFieldEnum;
};

/** QA Assignment periods data */
export type QaAssignmentPeriodsCollection = {
  collection: Array<QaAssignmentPeriod>;
  metadata: CollectionMetadata;
};

/** QA Assignment reviewee data */
export type QaAssignmentReviewee = {
  averageQaScore: Maybe<Scalars['Int']>;
  completed: Scalars['Int'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  progress: Scalars['Int'];
};

/** Available QA Assignment reviewee Activity filters */
export enum QaAssignmentRevieweeActivityEnum {
  Added = 'ADDED',
  AllPeriod = 'ALL_PERIOD',
  Removed = 'REMOVED',
}

/** QaAssignmentRevieweeCollection type */
export type QaAssignmentRevieweeCollection = {
  /** A collection of paginated QaAssignmentRevieweeCollection */
  collection: Array<QaAssignmentReviewee>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Available QA Assignment reviewees filters */
export type QaAssignmentRevieweesFiltersInput = {
  maxAverageQaScore?: InputMaybe<Scalars['Int']>;
  minAverageQaScore?: InputMaybe<Scalars['Int']>;
};

/** Available QA Assignment reviewees fields for sorting */
export enum QaAssignmentRevieweesSortFieldEnum {
  AverageQaScore = 'averageQaScore',
  Id = 'id',
}

/** QA Assignment reviewees sorting parameters */
export type QaAssignmentRevieweesSortInput = {
  direction?: SortDirectionEnum;
  field?: QaAssignmentRevieweesSortFieldEnum;
};

/** QA Assignment reviewer data */
export type QaAssignmentReviewer = {
  assigned: Scalars['Int'];
  completed: Scalars['Int'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  progress: Scalars['Int'];
  skipped: Scalars['Int'];
  validationErrors: Array<ReviewerValidation>;
};

/** Available QA Assignment reviewer Activity filters */
export enum QaAssignmentReviewerActivityEnum {
  Added = 'ADDED',
  AllPeriod = 'ALL_PERIOD',
  Removed = 'REMOVED',
}

/** Reviewer QA Assignment data for the list */
export type QaAssignmentReviewerListItem = QaAssignmentGeneralInterface & {
  allocateToTeamLeader: Scalars['Boolean'];
  allowBestMatch: Scalars['Boolean'];
  archivedAt: Maybe<Scalars['ISO8601DateTime']>;
  archivedBy: Maybe<Employee>;
  assigned: Scalars['Int'];
  assignedBefore: Scalars['Int'];
  blind: Scalars['Boolean'];
  cadence: Scalars['String'];
  completed: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  effectiveAt: Maybe<Scalars['ISO8601DateTime']>;
  endDate: Scalars['ISO8601DateTime'];
  id: Maybe<Scalars['ID']>;
  initialStartDate: Maybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
  numberOfDays: Maybe<Scalars['Int']>;
  progress: Scalars['Int'];
  qaFormId: Maybe<Scalars['ID']>;
  qaReviewType: Maybe<Scalars['String']>;
  revieweesStats: EligibilityStats;
  reviewersStats: EligibilityStats;
  skipped: Scalars['Int'];
  startDate: Scalars['ISO8601DateTime'];
  totalActiveReviewees: Scalars['Int'];
  totalActiveReviewers: Scalars['Int'];
  totalCycles: Scalars['Int'];
  totalReviewees: Scalars['Int'];
  totalReviewers: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** QaAssignmentReviewerListItemCollection type */
export type QaAssignmentReviewerListItemCollection = {
  /** A collection of paginated QaAssignmentReviewerListItemCollection */
  collection: Array<QaAssignmentReviewerListItem>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Predefined reason for skipping a QA assignment */
export type QaAssignmentSkipReason = {
  default: Scalars['Boolean'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
};

/** QA Assignment skip reason data */
export type QaAssignmentSkipReasonStats = {
  id: Scalars['ID'];
  reason: Scalars['String'];
  reasonDetails: Maybe<Array<Scalars['String']>>;
  totalSkipped: Scalars['Int'];
};

/** Available QA Assignment fields for sorting */
export enum QaAssignmentSortFieldEnum {
  ArchivedAt = 'archivedAt',
  CreatedAt = 'createdAt',
  Name = 'name',
  Progress = 'progress',
  TotalReviewees = 'totalReviewees',
  TotalReviewers = 'totalReviewers',
}

/** QA Assignment sorting parameters */
export type QaAssignmentSortInput = {
  direction?: SortDirectionEnum;
  field?: QaAssignmentSortFieldEnum;
};

/** QA Audit stats */
export type QaAuditStats = {
  auditorsTotal: Scalars['Int'];
  auditsTotal: Scalars['Int'];
  averageAuditScore: ValuesComparison;
  averageAuditScoreByRanges: Array<Scalars['Int']>;
};

/** Auditor stats */
export type QaAuditorStats = {
  auditor: Employee;
  /** count of completed audits */
  completedAudits: Scalars['Int'];
};

/** The connection type for QaAuditorStats. */
export type QaAuditorStatsConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QaAuditorStatsEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<QaAuditorStats>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QaAuditorStatsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<QaAuditorStats>;
};

/** QaCalibration object */
export type QaCalibration = {
  alignmentScore: Maybe<Scalars['Float']>;
  company: Company;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  employee: Employee;
  id: Scalars['ID'];
  interactionId: Maybe<Scalars['String']>;
  meetingAt: Maybe<Scalars['ISO8601DateTime']>;
  notes: Maybe<Scalars['String']>;
  ownerReviewId: Maybe<Scalars['ID']>;
  participants: EmployeeConnection;
  qaForm: QaForm;
  /** QA Reviews for a QA Calibration */
  qaReviews: QaReviewCalibrationConnection;
  selectedOptions: Scalars['JSON'];
  status: QaCalibrationStatusEnum;
  uuid: Scalars['String'];
};

/** QaCalibration object */
export type QaCalibrationParticipantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** QaCalibration object */
export type QaCalibrationQaReviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reviewerId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Array<QaCalibrationReviewSearchInput>>;
  status?: InputMaybe<QaCalibrationReviewStatusEnum>;
};

/** QaCalibrationCollection type */
export type QaCalibrationCollection = {
  /** A collection of paginated QaCalibrationCollection */
  collection: Array<QaCalibration>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: ComplexQueryMetadata;
};

/** Common count fields for QA Calibration */
export type QaCalibrationCountInterface = {
  /** Number of correct (selected as such at the end of calibration session) answers. */
  alignedAnswersCount: Maybe<Scalars['Int']>;
  /** Percentage of aligned answers */
  alignmentScore: Maybe<Scalars['Float']>;
  /** Number of answers submitted for calibration */
  answersCount: Maybe<Scalars['Int']>;
  /** Number of calibrations */
  calibrationsCount: Maybe<Scalars['Int']>;
};

/** QaCalibration Form Question object */
export type QaCalibrationFormQuestion = {
  alignmentScore: AlignmentScoreComparisons;
  id: Scalars['ID'];
  position: Scalars['Int'];
  sectionId: Scalars['ID'];
  sectionPosition: Scalars['Int'];
  sectionTitle: Scalars['String'];
  text: Scalars['String'];
};

/** The connection type for QaCalibrationFormQuestion. */
export type QaCalibrationFormQuestionConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QaCalibrationFormQuestionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<QaCalibrationFormQuestion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QaCalibrationFormQuestionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<QaCalibrationFormQuestion>;
};

/** The possible fields to sort on. */
export enum QaCalibrationFormQuestionSortFieldEnum {
  AlignmentScore = 'ALIGNMENT_SCORE',
  QuestionSection = 'QUESTION_SECTION',
  SectionTitle = 'SECTION_TITLE',
}

/** Sort the list of QA Calibration Form Questions. */
export type QaCalibrationFormQuestionSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field?: InputMaybe<QaCalibrationFormQuestionSortFieldEnum>;
};

/** QaFormSection with associated Calibration Questions */
export type QaCalibrationFormSectionBreakdown = {
  qaFormSection: QaFormSection;
  questions: Array<QaCalibrationQaQuestion>;
};

/** QaCalibrationQaQuestion object */
export type QaCalibrationQaQuestion = {
  qaAnswersWithReviewers: Array<QaCalibrationQuestionAnswerDetail>;
  qaCalibration: QaCalibration;
  qaQuestion: QaQuestion;
  selectedNaOption: Maybe<Scalars['Boolean']>;
  selectedOptionId: Maybe<Scalars['ID']>;
};

/** Detailed answer information for calibration questions */
export type QaCalibrationQuestionAnswerDetail = {
  qaAnswer: QaAnswer;
  reviewer: Employee;
};

/** Available fields to search reviewers. */
export enum QaCalibrationReviewSearchFieldEnum {
  Email = 'EMAIL',
  Name = 'NAME',
}

/** Search reviewers using a combination of `value` and `on` arguments. */
export type QaCalibrationReviewSearchInput = {
  on: Array<QaCalibrationReviewSearchFieldEnum>;
  value: Scalars['String'];
};

/** QaCalibration's reviews status enum */
export enum QaCalibrationReviewStatusEnum {
  All = 'ALL',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
}

/** QaCalibration scope enum */
export enum QaCalibrationScopeEnum {
  All = 'ALL',
  AllCompleted = 'ALL_COMPLETED',
  AllIncomplete = 'ALL_INCOMPLETE',
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Owned = 'OWNED',
}

/** Calibration scores overview for given date range */
export type QaCalibrationScore = QaCalibrationCountInterface & {
  /** Number of correct (selected as such at the end of calibration session) answers. */
  alignedAnswersCount: Maybe<Scalars['Int']>;
  /** Percentage of aligned answers */
  alignmentScore: Maybe<Scalars['Float']>;
  /** Number of answers submitted for calibration */
  answersCount: Maybe<Scalars['Int']>;
  /** Number of calibrations */
  calibrationsCount: Maybe<Scalars['Int']>;
  qaFormCalibrationScores: Maybe<Array<QaFormCalibrationScore>>;
};

/** The possible fields to sort on. */
export enum QaCalibrationSortFieldEnum {
  AlignmentScore = 'ALIGNMENT_SCORE',
  CompletedAt = 'COMPLETED_AT',
  CreatedAt = 'CREATED_AT',
  MeetingAt = 'MEETING_AT',
  OwnerName = 'OWNER_NAME',
  ParticipantsCount = 'PARTICIPANTS_COUNT',
  Progress = 'PROGRESS',
  Status = 'STATUS',
}

/** QaCalibration Status enum */
export enum QaCalibrationStatusEnum {
  AwaitingConsensus = 'AWAITING_CONSENSUS',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

/** QA Calibration trend data for a particular time range */
export type QaCalibrationTrend = {
  alignmentScores: Maybe<Array<Scalars['Float']>>;
};

/** Time series calibration data related to an object */
export type QaCalibrationTrendInterface = {
  /** The list of dates in the series that map to data provided in trend. */
  dates: Maybe<Array<Scalars['ISO8601Date']>>;
  trend: Maybe<QaCalibrationTrend>;
};

/** QA Calibrations filter object */
export type QaCalibrationsFilterInput = {
  dateRange: DateTimeRangeInput;
  scope?: InputMaybe<QaCalibrationScopeEnum>;
};

/** QA Calibration Review stats */
export type QaCalibtationReviewStats = {
  averageAlignmentScore: Scalars['Int'];
  calibrationsTotal: Scalars['Int'];
  calibrationsTotalByRanges: Array<Scalars['Int']>;
};

/** QaForm a.k.a Scorecard */
export type QaForm = {
  archived: Scalars['Boolean'];
  editable: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  qaFormSections: Maybe<Array<QaFormSection>>;
  qaReviewsCount: Scalars['Int'];
  questionCount: Scalars['Int'];
  sectionCount: Scalars['Int'];
  type: QaFormTypeEnum;
  weightedSections: Scalars['Boolean'];
};

/** Calibration scores for a particular Scorecard/QaForm for a given date range */
export type QaFormCalibrationScore = QaCalibrationCountInterface &
  QaCalibrationTrendInterface & {
    /** Number of correct (selected as such at the end of calibration session) answers. */
    alignedAnswersCount: Maybe<Scalars['Int']>;
    /** Percentage of aligned answers */
    alignmentScore: Maybe<Scalars['Float']>;
    /** Number of answers submitted for calibration */
    answersCount: Maybe<Scalars['Int']>;
    /** Number of calibrations */
    calibrationsCount: Maybe<Scalars['Int']>;
    /** The list of dates in the series that map to data provided in trend. */
    dates: Maybe<Array<Scalars['ISO8601Date']>>;
    qaForm: Maybe<QaForm>;
    qaFormSectionCalibrationScores: Maybe<Array<QaFormSectionCalibrationScore>>;
    trend: Maybe<QaCalibrationTrend>;
  };

/** The connection type for QaForm. */
export type QaFormConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QaFormEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<QaForm>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Information about QaForm type */
export type QaFormDescription = {
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type: QaFormTypeEnum;
};

/** An edge in a connection. */
export type QaFormEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<QaForm>;
};

/** QaFormSection */
export type QaFormSection = {
  defaultSection: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  position: Scalars['Int'];
  qaQuestions: Array<QaQuestion>;
  title: Scalars['String'];
  weight: Maybe<Scalars['Float']>;
};

/** Calibration scores for Scorecard/QaForm section for a given date range */
export type QaFormSectionCalibrationScore = QaCalibrationCountInterface &
  QaCalibrationTrendInterface & {
    /** Number of correct (selected as such at the end of calibration session) answers. */
    alignedAnswersCount: Maybe<Scalars['Int']>;
    /** Percentage of aligned answers */
    alignmentScore: Maybe<Scalars['Float']>;
    /** Number of answers submitted for calibration */
    answersCount: Maybe<Scalars['Int']>;
    /** Number of calibrations */
    calibrationsCount: Maybe<Scalars['Int']>;
    /** The list of dates in the series that map to data provided in trend. */
    dates: Maybe<Array<Scalars['ISO8601Date']>>;
    qaFormSection: Maybe<QaFormSection>;
    qaQuestionCalibrationScores: Maybe<Array<QaQuestionCalibrationScore>>;
    trend: Maybe<QaCalibrationTrend>;
  };

/** Type of the QAForm */
export enum QaFormTypeEnum {
  Audit = 'AUDIT',
  Regular = 'REGULAR',
}

/** Qa History object type */
export type QaHistory = {
  attributeName: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  employee: Maybe<Employee>;
  event: Scalars['String'];
  item: QaHistoryItem;
  valueAfter: Maybe<Scalars['String']>;
  valueBefore: Maybe<Scalars['String']>;
};

/** QaHistoryCollection type */
export type QaHistoryCollection = {
  /** A collection of paginated QaHistoryCollection */
  collection: Array<QaHistory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Objects which may be an item for QA History */
export type QaHistoryItem = QaAnswer | QaReviewRegular;

/** Contains an QA option type */
export type QaOption = {
  autofail: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  position: Scalars['Int'];
  qaQuestion: QaQuestion;
  score: Scalars['Float'];
  text: Scalars['String'];
  updatedAt: Maybe<Scalars['ISO8601DateTime']>;
};

/** QaQuestion */
export type QaQuestion = {
  id: Scalars['ID'];
  instructions: Maybe<Scalars['String']>;
  naOption: Scalars['Boolean'];
  position: Scalars['Int'];
  qaForm: QaForm;
  qaFormSection: QaFormSection;
  qaOptions: Maybe<Array<QaOption>>;
  text: Scalars['String'];
};

/** Calibration scores for a particular answer for a given date range */
export type QaQuestionCalibrationScore = QaCalibrationCountInterface & {
  /** Number of correct (selected as such at the end of calibration session) answers. */
  alignedAnswersCount: Maybe<Scalars['Int']>;
  /** Percentage of aligned answers */
  alignmentScore: Maybe<Scalars['Float']>;
  /** Number of answers submitted for calibration */
  answersCount: Maybe<Scalars['Int']>;
  /** Number of calibrations */
  calibrationsCount: Maybe<Scalars['Int']>;
  qaCalibrations: Maybe<Array<QaCalibration>>;
  qaQuestion: Maybe<QaQuestion>;
};

/** Contains reasons for QaAppeal resolution */
export type QaResolution = {
  createdAt: Scalars['ISO8601DateTime'];
  employee: Employee;
  id: Scalars['ID'];
  qaAppeal: QaAppeal;
  reasons: Array<QaResolutionReason>;
};

/** Reasons for a resolution of appeal provided by a reviewer */
export type QaResolutionReason = {
  note: Scalars['String'];
  qaAnswer: QaAnswer;
};

/** Reasons for resolution of agent's appeal provided by appeal reviewer */
export type QaResolutionReasonInput = {
  note: Scalars['String'];
  qaAnswerId: Scalars['ID'];
};

/** Qa Review appeal stats */
export type QaReviewAppealStats = {
  appealed: Scalars['Int'];
  resolved: Scalars['Int'];
  reviewsAcknowledged: Scalars['Int'];
};

/** QaReview::Audit object */
export type QaReviewAudit = {
  auditable: AuditableUnion;
  autofailed: Scalars['Boolean'];
  company: Company;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt: Maybe<Scalars['ISO8601DateTime']>;
  discardable: Scalars['Boolean'];
  hideEmployee: Scalars['Boolean'];
  hideReviewer: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  qaAllocationId: Maybe<Scalars['ID']>;
  qaAnswers: Array<QaAnswer>;
  qaAssignmentId: Maybe<Scalars['ID']>;
  qaForm: QaForm;
  qaReview: QaReviewRegular;
  reviewer: Employee;
  revised: Maybe<Scalars['Boolean']>;
  score: Maybe<Scalars['Float']>;
  scoreDisplayValue: Maybe<Scalars['Int']>;
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** QaReview::Audit custom object */
export type QaReviewAudits = {
  auditable: AuditableUnion;
  auditorFullName: Scalars['String'];
  autofailed: Scalars['Boolean'];
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  interactionId: Maybe<Scalars['String']>;
  originalScorecardName: Maybe<Scalars['String']>;
  reviewerFullName: Scalars['String'];
  reviewerImageUrl: Maybe<Scalars['String']>;
  revised: Maybe<Scalars['Boolean']>;
  score: Maybe<Scalars['Float']>;
  scorecard: Maybe<Scalars['String']>;
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
};

/** QaReviewAuditsCollection type */
export type QaReviewAuditsCollection = {
  /** A collection of paginated QaReviewAuditsCollection */
  collection: Array<QaReviewAudits>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** QaReview::Calibration object */
export type QaReviewCalibration = QaReviewStandardInterface & {
  acknowledgedAt: Maybe<Scalars['ISO8601DateTime']>;
  appealResolvedAt: Maybe<Scalars['ISO8601DateTime']>;
  appealedAt: Maybe<Scalars['ISO8601DateTime']>;
  channelId: Maybe<Scalars['Int']>;
  companyId: Maybe<Scalars['ID']>;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  countTowardScore: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt: Maybe<Scalars['ISO8601DateTime']>;
  employee: Employee;
  groupId: Maybe<Scalars['ID']>;
  hasFile: Scalars['Boolean'];
  hasTranscript: Scalars['Boolean'];
  hideReviewer: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  interaction: Interaction;
  interactionId: Scalars['ID'];
  interactionSnapshotId: Scalars['ID'];
  qaAllocationId: Maybe<Scalars['ID']>;
  qaAnswers: Array<QaAnswer>;
  qaAssignmentId: Maybe<Scalars['ID']>;
  qaCalibrationId: Maybe<Scalars['ID']>;
  qaForm: QaForm;
  reviewer: Employee;
  revised: Maybe<Scalars['Boolean']>;
  score: Maybe<Scalars['Float']>;
  sequenceId: Scalars['BigInt'];
  solicitationId: Scalars['ID'];
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  type: QaReviewTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['String'];
};

export type QaReviewCalibrationAudit = {
  id: Scalars['ID'];
};

/** The connection type for QaReviewCalibration. */
export type QaReviewCalibrationConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QaReviewCalibrationEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<QaReviewCalibration>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QaReviewCalibrationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<QaReviewCalibration>;
};

/** Date field for filtering purpose */
export enum QaReviewDateFieldEnum {
  Completed = 'COMPLETED',
  Started = 'STARTED',
}

/** QA Reviews filter object */
export type QaReviewFilterInput = {
  answerCriteria?: InputMaybe<QaAnswerFilterInputt>;
  assignmentIds?: InputMaybe<Array<Scalars['ID']>>;
  autofailed?: InputMaybe<Scalars['Boolean']>;
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  dateField?: InputMaybe<QaReviewDateFieldEnum>;
  dateRange: DateTimeRangeInput;
  excludeTags?: InputMaybe<Array<Scalars['String']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  includeTags?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  priorDateRange?: InputMaybe<DateTimeRangeInput>;
  qaFormIds?: InputMaybe<Array<Scalars['ID']>>;
  reviewerIds?: InputMaybe<Array<Scalars['ID']>>;
  state?: InputMaybe<QaReviewStateEnum>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
  teamMemberIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Message type */
export type QaReviewMessage = {
  content: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  employee: Employee;
  id: Scalars['ID'];
};

/** QaReview::Regular object */
export type QaReviewRegular = QaReviewStandardInterface & {
  acknowledgedAt: Maybe<Scalars['ISO8601DateTime']>;
  appealResolvedAt: Maybe<Scalars['ISO8601DateTime']>;
  appealedAt: Maybe<Scalars['ISO8601DateTime']>;
  channelId: Maybe<Scalars['Int']>;
  companyId: Maybe<Scalars['ID']>;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  countTowardScore: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt: Maybe<Scalars['ISO8601DateTime']>;
  discardable: Scalars['Boolean'];
  employee: Employee;
  events: Maybe<Array<InteractionEvent>>;
  followUps: Maybe<Array<FollowUp>>;
  groupId: Maybe<Scalars['ID']>;
  hasFile: Scalars['Boolean'];
  hasTranscript: Scalars['Boolean'];
  hideReviewer: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  interaction: Interaction;
  interactionId: Scalars['ID'];
  interactionSnapshotId: Scalars['ID'];
  messages: Maybe<Array<QaReviewMessage>>;
  origin: QaReviewRegularOriginEnum;
  qaAllocationId: Maybe<Scalars['ID']>;
  qaAnnotations: Maybe<Array<QaAnnotation>>;
  qaAnswers: Array<QaAnswer>;
  qaAssignmentId: Maybe<Scalars['ID']>;
  qaCalibrationId: Maybe<Scalars['ID']>;
  qaForm: QaForm;
  reviewer: Employee;
  revised: Maybe<Scalars['Boolean']>;
  score: Maybe<Scalars['Float']>;
  sequenceId: Scalars['BigInt'];
  solicitationId: Scalars['ID'];
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  type: QaReviewTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['String'];
};

export type QaReviewRegularAudit = {
  id: Scalars['ID'];
  qaForm: QaForm;
};

/** The connection type for QaReviewRegular. */
export type QaReviewRegularConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QaReviewRegularEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<QaReviewRegular>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QaReviewRegularEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<QaReviewRegular>;
};

/** QaReview::Regular origins */
export enum QaReviewRegularOriginEnum {
  Assignment = 'ASSIGNMENT',
  Initial = 'INITIAL',
  Stream = 'STREAM',
}

/** QA Review sorting parameters */
export type QaReviewSortInput = {
  direction?: SortDirectionEnum;
  field?: SortFieldEnum;
};

/** Regular of Calibration QA Review object */
export type QaReviewStandard = QaReviewCalibration | QaReviewRegular;

/** The connection type for QaReviewStandard. */
export type QaReviewStandardConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QaReviewStandardEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<QaReviewStandard>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type QaReviewStandardEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<QaReviewStandard>;
};

/** QaReview common interface */
export type QaReviewStandardInterface = {
  acknowledgedAt: Maybe<Scalars['ISO8601DateTime']>;
  appealResolvedAt: Maybe<Scalars['ISO8601DateTime']>;
  appealedAt: Maybe<Scalars['ISO8601DateTime']>;
  channelId: Maybe<Scalars['Int']>;
  companyId: Maybe<Scalars['ID']>;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  countTowardScore: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt: Maybe<Scalars['ISO8601DateTime']>;
  employee: Employee;
  groupId: Maybe<Scalars['ID']>;
  hasFile: Scalars['Boolean'];
  hasTranscript: Scalars['Boolean'];
  hideReviewer: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  interactionId: Scalars['ID'];
  interactionSnapshotId: Scalars['ID'];
  qaAllocationId: Maybe<Scalars['ID']>;
  qaAnswers: Array<QaAnswer>;
  qaAssignmentId: Maybe<Scalars['ID']>;
  qaCalibrationId: Maybe<Scalars['ID']>;
  qaForm: QaForm;
  reviewer: Employee;
  revised: Maybe<Scalars['Boolean']>;
  score: Maybe<Scalars['Float']>;
  sequenceId: Scalars['BigInt'];
  solicitationId: Scalars['ID'];
  startedAt: Maybe<Scalars['ISO8601DateTime']>;
  type: QaReviewTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['String'];
};

/** State of the QaReviews */
export enum QaReviewStateEnum {
  All = 'ALL',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
}

/** QA Review stats */
export type QaReviewStats = {
  appealStats: QaReviewAppealStats;
  averageQaScore: ValuesComparison;
  averageQaScoreByRanges: Array<Scalars['Int']>;
  qaAssignmentsAssigned: Scalars['Int'];
  qaScoreStandardDeviation: Scalars['Int'];
  reviewsOrigin: Maybe<QaReviewsOriginCount>;
  reviewsTotal: ValuesComparison;
  reviewsTotalByRanges: Array<Scalars['Int']>;
  teamMemberStats: QaReviewTeamMemberStats;
};

/** Team Member stats type */
export type QaReviewTeamMemberStats = {
  agentsTotal: Scalars['Int'];
  reviewedTeamMembersTotal: Scalars['Int'];
  reviewedTeamMembersTotalPrior: Scalars['Int'];
  teamMembersTotal: Scalars['Int'];
};

/** Type of the standard QaReview */
export enum QaReviewTypeEnum {
  QaReviewCalibration = 'QA_REVIEW_CALIBRATION',
  QaReviewRegular = 'QA_REVIEW_REGULAR',
}

/** Reviewer stats */
export type QaReviewerStats = {
  averageAuditAlignmentScore: Maybe<ValuesComparison>;
  averageAuditScore: Maybe<ValuesComparison>;
  averageQaScore: Maybe<ValuesComparison>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  reviewsTotal: ValuesComparison;
};

/** QaReviewerStatsCollection type */
export type QaReviewerStatsCollection = {
  /** A collection of paginated QaReviewerStatsCollection */
  collection: Array<QaReviewerStats>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Total count type */
export type QaReviewsOriginCount = {
  assignment: Scalars['Int'];
  initial: Scalars['Int'];
  stream: Scalars['Int'];
};

/** The available queries to enter the graph. */
export type Query = {
  /** list Achievement Categories */
  achievementCategories: Maybe<Array<AchievementCategory>>;
  /** Collection of ActionItems */
  actionItems: ActionItemConnection;
  /** Find QA Audit by ID */
  audit: Maybe<QaReviewAudit>;
  /** Audit stats */
  auditStats: Maybe<QaAuditStats>;
  /** Auditors stats */
  auditorStats: Maybe<QaAuditorStatsConnection>;
  /** QaReview audits for the current company */
  audits: QaReviewAuditsCollection;
  /** Get metrics based on categories (AOE, AOI) */
  calculateMetricByCategory: Maybe<CategoricalMetricsResults>;
  /** Calculate the result of one metric grouped by a field. */
  calculateMetricByGroup: Maybe<MetricGroupResultConnection>;
  /** Get top and bottom tag rankings sorted by metric */
  calculateMetricByTagRanking: Maybe<TagRankingsResult>;
  /** Calculate the trend/time-series results of a single metric. */
  calculateMetricTrend: Maybe<MetricTrendResult>;
  /** Calculate the trend/time-series results of a single metric grouped by a field. */
  calculateMetricTrendByGroup: Maybe<MetricTrendResult>;
  /** Calculate the result of one or many metrics. */
  calculateMetrics: Maybe<Array<MetricResult>>;
  /** QA Review Calibrations stats */
  calibrationStats: Maybe<QaCalibtationReviewStats>;
  channelableIntegrations: Array<ChannelableIntegration>;
  /** Company channels */
  channels: Array<Channel>;
  /** Coachees Data collection */
  coacheesData: CoacheesDataConnection;
  /** Returns coaching intelligence settings for a company */
  coachingIntelligenceSettings: CoachingIntelligenceSettings;
  /** Returns the active Terms & Conditions for Coaching Intelligence */
  coachingIntelligenceTc: TermsAndConditions;
  /** Coaching Session */
  coachingSession: CoachingSession;
  /** Coaching Session Action Item History query */
  coachingSessionActionItemHistory: Maybe<TakeawayHistoryCollection>;
  /** Action Items (takeaways) */
  coachingSessionActionItems: CoachingSessionActionItemsResponse;
  /** Coaching Session Summary */
  coachingSessionSummary: CoachingSessionSummary;
  /** Coaching Template returning query */
  coachingTemplate: Maybe<CoachingTemplate>;
  /** Coaching Template History query */
  coachingTemplateHistory: Maybe<CoachingTemplateHistoryCollection>;
  /** list Coaching Templates */
  coachingTemplates: Maybe<CoachingTemplateConnection>;
  /** Coaching Topics collection */
  coachingTopics: Maybe<CoachingTopicCollection>;
  /** The information about the current company. */
  company: Company;
  /** list Company Achievements */
  companyAchievements: Maybe<CompanyAchievementConnection>;
  countries: Array<Country>;
  /** Date-filter and metric calculation defaults */
  dateFilterConfig: DateFilterConfig;
  employee: Maybe<Employee>;
  /** list Employee Badges */
  employeeBadges: Maybe<EmployeeBadgeConnection>;
  employeeGroup: Maybe<EmployeeGroup>;
  /** The groups belonging to the current company. */
  employeeGroups: EmployeeGroupConnection;
  /** The employees belonging to the current company. */
  employees: EmployeeConnection;
  /** Returns a list of employees that can be mentioned in conversations, using social data scope. */
  employeesMentionable: EmployeesMentionableCollection;
  /** The employees belonging to the current company. */
  employeesPaginated: EmployeeCollection;
  /** Recent exports for given export type */
  exports: Maybe<Array<Export>>;
  /** Exports states current company */
  exportsState: ExportsState;
  exportsWithCursor: ExportConnection;
  /** Exportable fields from feedback */
  feedbackExportFields: Array<ExportField>;
  /** list Feedback Export Sections */
  feedbackExportSections: Maybe<FeedbackExportSectionConnection>;
  /** Feedback Export Template query */
  feedbackExportTemplate: Maybe<FeedbackExportTemplate>;
  /** list Feedback Export Templates */
  feedbackExportTemplates: Maybe<FeedbackExportTemplateConnection>;
  /** list FollowUp objects */
  followUps: Maybe<FollowUpConnection>;
  /** Freeform Goal details */
  freeformGoal: FreeformGoal;
  /** Freeform Goal collection */
  freeformGoals: FreeformGoalConnection;
  /** Interaction details */
  interaction: Maybe<Interaction>;
  /** Collection of Interactions */
  interactions: Maybe<InteractionConnection>;
  leaderboard: Leaderboard;
  lessonly: Maybe<Lessonly>;
  /** list Employee Badges */
  lifetimeBadges: Maybe<EmployeeBadgeConnection>;
  /** The metric configurations set up for the current company. */
  metricConfigs: Maybe<Array<MetricConfig>>;
  /** Metric Goal details */
  metricGoal: MetricGoalItem;
  /** Collection of Metric Goals */
  metricGoals: MetricGoalItemConnection;
  /** The metric options for the given metric type */
  metricSelectionOptions: Array<MetricSelectionUnion>;
  /** The metric set configurations set up for the current company. */
  metricSets: Array<MetricSet>;
  /** QA Assignments of the current reviewer */
  myQaAssignments: Maybe<QaAssignmentReviewerListItemCollection>;
  /** QA Assignments status of the current reviewer */
  myQaAssignmentsStatus: Maybe<MyListStatus>;
  /** Past Goals collection */
  pastGoals: PastGoalConnection;
  performanceHighlights: Array<PerformanceHighlight>;
  /** Preview QA Assignment */
  previewQaAssignment: QaAssignment;
  /** Company properties */
  properties: PropertyConnection;
  /** An appeal submitted for QaReview */
  qaAppeal: Maybe<QaAppeal>;
  /** QA Assignment details */
  qaAssignment: Maybe<QaAssignment>;
  /** Data for next QA Assignment review */
  qaAssignmentNextReview: Maybe<QaAssignmentNextReview>;
  /** QA Assignment results over time */
  qaAssignmentPeriods: Maybe<QaAssignmentPeriodsCollection>;
  /** A predefined reason for skipping a QA assignment */
  qaAssignmentSkipReasons: Maybe<Array<QaAssignmentSkipReason>>;
  /** Skipped solicitations for a QA Assignment */
  qaAssignmentSkippedSolicitations: Maybe<SkippedSolicitationsCollection>;
  /** QA Assignments of the current company */
  qaAssignments: Maybe<QaAssignmentListItemCollection>;
  /** Get QaCalibration item by ID */
  qaCalibration: QaCalibration;
  /** Collection of Form Questions for QaCalibration */
  qaCalibrationFormQuestions: QaCalibrationFormQuestionConnection;
  /** Find eligible QaCalibration Participants from sources */
  qaCalibrationParticipantsPreview: EmployeeConnection;
  /** Collection of Calibration Questions with Answers */
  qaCalibrationQuestionBreakdown: Array<QaCalibrationFormSectionBreakdown>;
  /** Calculate the alignment score for Calibrations in given date range. */
  qaCalibrationScores: Maybe<QaCalibrationScore>;
  /** Collection of QaCalibrations for the current company */
  qaCalibrations: QaCalibrationCollection;
  /** Find a QaForm by ID */
  qaForm: Maybe<QaForm>;
  /** Calculate the alignment score for Calibrations in given date range for specified QA Form */
  qaFormCalibrationScores: Maybe<QaFormCalibrationScore>;
  /** QaForm list */
  qaForms: QaFormConnection;
  /** Returns a QA History for a QA Review */
  qaHistory: Maybe<QaHistoryCollection>;
  /** Find Regular QA Review by ID */
  qaReviewRegular: QaReviewRegular;
  /** QaReview regulars for the current company */
  qaReviewRegulars: QaReviewRegularConnection;
  reportingGroup: Maybe<ReportingGroup>;
  reportingGroupCriterionTypeObjects: Array<ReportingGroupCriterionTypeObject>;
  reportingGroupParticipantsPreview: EmployeeConnection;
  /** The reporting groups belonging to the current company. */
  reportingGroups: ReportingGroupConnection;
  responseTags: Maybe<Array<ResponseTag>>;
  /** Review stats */
  reviewStats: Maybe<QaReviewStats>;
  /** Revieewers stats */
  reviewerStats: Maybe<QaReviewerStatsCollection>;
  /** Get all the rewards available for a given tier. */
  rewardsByTier: Array<RewardsTier>;
  /** The roles belonging to the current company. */
  roles: RoleConnection;
  /** The total employee count across roles based on role and employee filters */
  rolesEmployeeCount: RolesEmployeeCount;
  /** A collection of QA Assignment Skip Reason Details */
  skipReasonDetails: Maybe<Array<Scalars['String']>>;
  snappy: Snappy;
  /** Snappy integration campaigns */
  snappyCampaigns: Maybe<Array<SnappyCampaign>>;
  /** A list of all available supervisors for the given manager. */
  supervisors: SupervisorConnection;
  /** Survey Builder Configuration */
  surveyConfiguration: Maybe<SurveyConfiguration>;
  /** Survey Builder Configurations */
  surveyConfigurations: Maybe<Array<SurveyConfiguration>>;
  /** A team belonging to the current company. */
  team: Team;
  /** list Employee Badges */
  teamEmployeeBadges: Maybe<EmployeeBadgeConnection>;
  /** The teams belonging to the current company. */
  teams: TeamConnection;
};

/** The available queries to enter the graph. */
export type QueryAchievementCategoriesArgs = {
  status?: InputMaybe<AchievementStatus>;
};

/** The available queries to enter the graph. */
export type QueryActionItemsArgs = {
  actionableId: Scalars['ID'];
  actionableType: ActionableTypeEnum;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<GoalStatusEnum>;
};

/** The available queries to enter the graph. */
export type QueryAuditArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryAuditStatsArgs = {
  auditType?: InputMaybe<AuditTypeEnum>;
  filters?: InputMaybe<QaReviewFilterInput>;
};

/** The available queries to enter the graph. */
export type QueryAuditorStatsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryAuditsArgs = {
  filters?: InputMaybe<AuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AuditSortInput>;
};

/** The available queries to enter the graph. */
export type QueryCalculateMetricByCategoryArgs = {
  filters: MetricFilterInput;
  identifier: IdentifierEnum;
};

/** The available queries to enter the graph. */
export type QueryCalculateMetricByGroupArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: MetricFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  groupBy: MetricGroupByEnum;
  last?: InputMaybe<Scalars['Int']>;
  metric: MetricInput;
  sort?: InputMaybe<MetricSortInput>;
};

/** The available queries to enter the graph. */
export type QueryCalculateMetricByTagRankingArgs = {
  filters: MetricFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  metric: MetricInput;
};

/** The available queries to enter the graph. */
export type QueryCalculateMetricTrendArgs = {
  filters: MetricFilterInput;
  interval?: InputMaybe<TimePeriodEnum>;
  metric: MetricInput;
};

/** The available queries to enter the graph. */
export type QueryCalculateMetricTrendByGroupArgs = {
  filters: MetricFilterInput;
  groupBy: MetricGroupByEnum;
  interval?: InputMaybe<TimePeriodEnum>;
  metric: MetricInput;
};

/** The available queries to enter the graph. */
export type QueryCalculateMetricsArgs = {
  filters: MetricFilterInput;
  metrics: Array<MetricInput>;
};

/** The available queries to enter the graph. */
export type QueryCalibrationStatsArgs = {
  filters?: InputMaybe<QaReviewFilterInput>;
};

/** The available queries to enter the graph. */
export type QueryCoacheesDataArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: CoacheesDataFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Array<CoacheesDataSearchInput>>;
  sort?: InputMaybe<Array<CoacheesDataSortInput>>;
};

/** The available queries to enter the graph. */
export type QueryCoachingSessionArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryCoachingSessionActionItemHistoryArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryCoachingSessionActionItemsArgs = {
  filters?: InputMaybe<TakeawayFilterInput>;
  sort?: InputMaybe<Array<TakeawaySortInput>>;
};

/** The available queries to enter the graph. */
export type QueryCoachingSessionSummaryArgs = {
  sessionId: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryCoachingTemplateArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryCoachingTemplateHistoryArgs = {
  templateId: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryCoachingTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryCoachingTopicsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryCompanyAchievementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryCountriesArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The available queries to enter the graph. */
export type QueryEmployeeArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryEmployeeBadgesArgs = {
  after?: InputMaybe<Scalars['String']>;
  badgeKeys?: InputMaybe<Array<Scalars['String']>>;
  badgeType?: InputMaybe<AchievementBadgeType>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryEmployeeGroupArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryEmployeeGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EmployeeGroupStatusEnum>;
};

/** The available queries to enter the graph. */
export type QueryEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  between?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productArea?: InputMaybe<ProductArea>;
  search?: InputMaybe<Array<EmployeeSearchInput>>;
  sort?: InputMaybe<Array<EmployeeSortInput>>;
};

/** The available queries to enter the graph. */
export type QueryEmployeesMentionableArgs = {
  between?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  productArea?: InputMaybe<ProductArea>;
  search?: InputMaybe<Array<EmployeeSearchInput>>;
  sort?: InputMaybe<Array<EmployeeSortInput>>;
};

/** The available queries to enter the graph. */
export type QueryEmployeesPaginatedArgs = {
  between?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  productArea?: InputMaybe<ProductArea>;
  search?: InputMaybe<Array<EmployeeSearchInput>>;
  sort?: InputMaybe<Array<EmployeeSortInput>>;
};

/** The available queries to enter the graph. */
export type QueryExportsArgs = {
  exportType?: InputMaybe<ExportTypeEnum>;
};

/** The available queries to enter the graph. */
export type QueryExportsStateArgs = {
  exportType?: ExportTypeEnum;
};

/** The available queries to enter the graph. */
export type QueryExportsWithCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  exportType?: InputMaybe<ExportTypeEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryFeedbackExportFieldsArgs = {
  section: ExportSection;
};

/** The available queries to enter the graph. */
export type QueryFeedbackExportSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryFeedbackExportTemplateArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryFeedbackExportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<FeedbackExportTemplateFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryFollowUpsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<FollowUpFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryFreeformGoalArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryFreeformGoalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GoalFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryInteractionArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryInteractionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: InteractionFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productArea?: InputMaybe<ProductArea>;
  search?: InputMaybe<Array<InteractionSearchInput>>;
  sort?: InputMaybe<Array<InteractionSortInput>>;
};

/** The available queries to enter the graph. */
export type QueryLeaderboardArgs = {
  channel?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  interval?: InputMaybe<Scalars['String']>;
  reportingGroupIds?: InputMaybe<Array<Scalars['String']>>;
  time?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryLifetimeBadgesArgs = {
  after?: InputMaybe<Scalars['String']>;
  badgeKeys?: InputMaybe<Array<Scalars['String']>>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryMetricConfigsArgs = {
  metricName?: InputMaybe<Array<MetricNameEnum>>;
  type?: InputMaybe<Array<MetricConfigTypeEnum>>;
};

/** The available queries to enter the graph. */
export type QueryMetricGoalArgs = {
  id: Scalars['ID'];
  type: MetricGoalTypeEnum;
};

/** The available queries to enter the graph. */
export type QueryMetricGoalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GoalFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  type: MetricGoalTypeEnum;
};

/** The available queries to enter the graph. */
export type QueryMetricSelectionOptionsArgs = {
  type: Array<MetricConfigTypeEnum>;
};

/** The available queries to enter the graph. */
export type QueryMyQaAssignmentsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MyQaAssignmentSortInput>;
};

/** The available queries to enter the graph. */
export type QueryPastGoalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<PastGoalFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The available queries to enter the graph. */
export type QueryPerformanceHighlightsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  employeeId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<MetricFilterInput>;
  highlights: Array<PerformanceHighlightsEnum>;
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  teamId?: InputMaybe<Scalars['ID']>;
};

/** The available queries to enter the graph. */
export type QueryPreviewQaAssignmentArgs = {
  qaAssignment: QaAssignmentInput;
};

/** The available queries to enter the graph. */
export type QueryPropertiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterValues?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  propertyKeyId?: InputMaybe<Scalars['ID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

/** The available queries to enter the graph. */
export type QueryQaAppealArgs = {
  qaReviewId: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryQaAssignmentArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** The available queries to enter the graph. */
export type QueryQaAssignmentNextReviewArgs = {
  employeeId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  partialMatching?: InputMaybe<Scalars['Boolean']>;
};

/** The available queries to enter the graph. */
export type QueryQaAssignmentPeriodsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  periodIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** The available queries to enter the graph. */
export type QueryQaAssignmentSkippedSolicitationsArgs = {
  filters?: InputMaybe<SkippedSolicitationFilterInput>;
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SkippedSolicitationSortInput>>;
};

/** The available queries to enter the graph. */
export type QueryQaAssignmentsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  reviewerId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<QaAssignmentSortInput>;
};

/** The available queries to enter the graph. */
export type QueryQaCalibrationArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryQaCalibrationFormQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  qaFormId: Scalars['ID'];
  sort?: InputMaybe<QaCalibrationFormQuestionSortInput>;
};

/** The available queries to enter the graph. */
export type QueryQaCalibrationParticipantsPreviewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** The available queries to enter the graph. */
export type QueryQaCalibrationQuestionBreakdownArgs = {
  qaCalibrationId: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryQaCalibrationScoresArgs = {
  dateRange: DateRangeInput;
};

/** The available queries to enter the graph. */
export type QueryQaCalibrationsArgs = {
  filters?: InputMaybe<QaCalibrationsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};

/** The available queries to enter the graph. */
export type QueryQaFormArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryQaFormCalibrationScoresArgs = {
  dateRange: DateRangeInput;
  qaFormId: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryQaFormsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  type: QaFormTypeEnum;
};

/** The available queries to enter the graph. */
export type QueryQaHistoryArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryQaReviewRegularArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryQaReviewRegularsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<QaReviewFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QaReviewSortInput>;
};

/** The available queries to enter the graph. */
export type QueryReportingGroupArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryReportingGroupParticipantsPreviewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  criteriaAttributes?: InputMaybe<Array<CreateReportingGroupCriterionAttributes>>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  matchAll?: InputMaybe<Scalars['Boolean']>;
};

/** The available queries to enter the graph. */
export type QueryReportingGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ReportingGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productArea?: InputMaybe<ProductArea>;
};

/** The available queries to enter the graph. */
export type QueryResponseTagsArgs = {
  types?: InputMaybe<Array<ResponseTagTypeEnum>>;
};

/** The available queries to enter the graph. */
export type QueryReviewStatsArgs = {
  filters?: InputMaybe<QaReviewFilterInput>;
};

/** The available queries to enter the graph. */
export type QueryReviewerStatsArgs = {
  filters?: InputMaybe<QaReviewFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ReviewerSortInput>;
};

/** The available queries to enter the graph. */
export type QueryRewardsByTierArgs = {
  tier: TierEnum;
};

/** The available queries to enter the graph. */
export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<RoleFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Array<RoleSearchInput>>;
  sort?: InputMaybe<Array<RoleSortInput>>;
};

/** The available queries to enter the graph. */
export type QueryRolesEmployeeCountArgs = {
  employeeFilters?: InputMaybe<EmployeeFilterInput>;
  employeeSearch?: InputMaybe<Array<EmployeeSearchInput>>;
  productArea?: InputMaybe<ProductArea>;
  roleFilters?: InputMaybe<RoleFilterInput>;
  roleSearch?: InputMaybe<Array<RoleSearchInput>>;
};

/** The available queries to enter the graph. */
export type QuerySkipReasonDetailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The available queries to enter the graph. */
export type QuerySupervisorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Array<EmployeeSearchInput>>;
};

/** The available queries to enter the graph. */
export type QuerySurveyConfigurationArgs = {
  uuid: Scalars['String'];
};

/** The available queries to enter the graph. */
export type QueryTeamArgs = {
  id: Scalars['ID'];
};

/** The available queries to enter the graph. */
export type QueryTeamEmployeeBadgesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  teamIds: Array<Scalars['ID']>;
};

/** The available queries to enter the graph. */
export type QueryTeamsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TeamFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productArea?: InputMaybe<ProductArea>;
  search?: InputMaybe<Array<TeamSearchInput>>;
  sort?: InputMaybe<Array<TeamSortInput>>;
};

/** Autogenerated input type of RecapCoachingSession */
export type RecapCoachingSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RecordCalibrationAnswer */
export type RecordCalibrationAnswerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  naOption?: InputMaybe<Scalars['Boolean']>;
  qaCalibrationId: Scalars['ID'];
  qaOptionId?: InputMaybe<Scalars['ID']>;
  qaQuestionId: Scalars['ID'];
};

/** Autogenerated return type of RecordCalibrationAnswer. */
export type RecordCalibrationAnswerPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  qaCalibration: Maybe<QaCalibration>;
};

/** Autogenerated input type of RemoveMember */
export type RemoveMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  groupId: Scalars['ID'];
};

/** Autogenerated input type of RemoveMemberReportingGroup */
export type RemoveMemberReportingGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  reportingGroupId: Scalars['ID'];
};

/** Autogenerated input type of RemoveNegativeFeedbackFromCoachingTopic */
export type RemoveNegativeFeedbackFromCoachingTopicInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  topicId: Scalars['ID'];
};

/** Autogenerated return type of RemoveNegativeFeedbackFromCoachingTopic. */
export type RemoveNegativeFeedbackFromCoachingTopicPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  coachingTopic: Maybe<CoachingTopic>;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of RemoveTeamMember */
export type RemoveTeamMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  teamId: Scalars['ID'];
};

/** A reporting group */
export type ReportingGroup = {
  active: Scalars['Boolean'];
  ancestors: Maybe<ReportingGroupConnection>;
  children: Maybe<ReportingGroupConnection>;
  color: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  criteria: Maybe<Array<ReportingGroupCriterion>>;
  description: Maybe<Scalars['String']>;
  emoji: Maybe<Scalars['String']>;
  filterable: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  image: Maybe<Scalars['String']>;
  matchAll: Maybe<Scalars['Boolean']>;
  /** The employees belonging to the current company. */
  members: Maybe<EmployeeConnection>;
  name: Scalars['String'];
  parent: Maybe<ReportingGroup>;
  parentId: Maybe<Scalars['ID']>;
  streamFooterDisplayable: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A reporting group */
export type ReportingGroupAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A reporting group */
export type ReportingGroupChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A reporting group */
export type ReportingGroupMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  between?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productArea?: InputMaybe<ProductArea>;
  search?: InputMaybe<Array<EmployeeSearchInput>>;
  sort?: InputMaybe<Array<EmployeeSortInput>>;
};

/** The connection type for ReportingGroup. */
export type ReportingGroupConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportingGroupEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ReportingGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A reporting group criterion */
export type ReportingGroupCriterion = {
  criterionType: ReportingGroupCriterionTypeEnum;
  id: Scalars['ID'];
  operator: ReportingGroupCriterionOperatorEnum;
  period: Maybe<ReportingGroupCriterionPeriodEnum>;
  periodValue: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export enum ReportingGroupCriterionOperatorEnum {
  After = 'AFTER',
  Before = 'BEFORE',
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  Exclude = 'EXCLUDE',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  Include = 'INCLUDE',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL',
  NotEqual = 'NOT_EQUAL',
}

export enum ReportingGroupCriterionPeriodEnum {
  Date = 'DATE',
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
  Years = 'YEARS',
}

export enum ReportingGroupCriterionTypeEnum {
  Employees = 'EMPLOYEES',
  Groups = 'GROUPS',
  Locations = 'LOCATIONS',
  QaScore = 'QA_SCORE',
  Roles = 'ROLES',
  StarRating = 'STAR_RATING',
  Teams = 'TEAMS',
  Tenure = 'TENURE',
}

/** A reporting group criterion type */
export type ReportingGroupCriterionTypeObject = {
  criterionType: ReportingGroupCriterionTypeEnum;
  operators: Array<ReportingGroupCriterionOperatorEnum>;
  periods: Array<ReportingGroupCriterionPeriodEnum>;
};

/** An edge in a connection. */
export type ReportingGroupEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ReportingGroup>;
};

/** Available filters when listing reporting groups. */
export type ReportingGroupFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  filterable?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of ResetConfiguration */
export type ResetConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  configurationId: Scalars['String'];
};

/** Autogenerated return type of ResetConfiguration. */
export type ResetConfigurationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of ResetEmployeePassword */
export type ResetEmployeePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
};

/** Autogenerated input type of ResolveQaAppeal */
export type ResolveQaAppealInput = {
  calculateScore?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  qaAppealId: Scalars['ID'];
  reasons: Array<QaResolutionReasonInput>;
};

/** Contains information about tags selected in a survey response. */
export type ResponseTag = {
  caption: Scalars['String'];
  iconName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  imageUrl: Maybe<Scalars['String']>;
  type: ResponseTagTypeEnum;
};

/** The area of the survey the response tag belongs to. */
export enum ResponseTagTypeEnum {
  AreaOfExcellence = 'AREA_OF_EXCELLENCE',
  AreaOfImprovement = 'AREA_OF_IMPROVEMENT',
}

/** Reviewers sorting parameters */
export type ReviewerSortInput = {
  direction?: SortDirectionEnum;
  field?: ReviewersStatsSortFieldEnum;
};

/** A validation warning for the reviewer of a QA Assignment */
export type ReviewerValidation = {
  message: Scalars['String'];
  type: ValidationEnum;
};

/** Available Reviewers fields for sorting */
export enum ReviewersStatsSortFieldEnum {
  AuditAlignmentScore = 'AUDIT_ALIGNMENT_SCORE',
  AverageAuditScore = 'AVERAGE_AUDIT_SCORE',
  AverageQaScore = 'AVERAGE_QA_SCORE',
  ReviewerName = 'REVIEWER_NAME',
  ReviewsTotal = 'REVIEWS_TOTAL',
}

export type RewardConfiguration = {
  /** The value of the Snappy campaign selected */
  campaignId?: InputMaybe<Scalars['String']>;
  /** The selected reward ID */
  reward: Scalars['ID'];
  /** The value of the secondary Snappy campaign selected */
  secondaryCampaignId?: InputMaybe<Scalars['String']>;
  /** The value of the threshold for the low tier */
  threshold?: InputMaybe<Scalars['Int']>;
};

export type RewardTiersConfiguration = {
  highTier: RewardConfiguration;
  lowTier: RewardConfiguration;
  midTier: RewardConfiguration;
};

export type RewardTranslation = {
  caption: Scalars['String'];
  language: Scalars['String'];
};

export type RewardsTier = {
  caption: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  tier: TierEnum;
};

/** The company defined role for an employee. */
export type Role = {
  companyId: Scalars['ID'];
  /** The employees belonging to the current company. */
  employees: EmployeeConnection;
  id: Scalars['ID'];
  legacy: Scalars['Boolean'];
  name: Scalars['String'];
  roleTemplate: Scalars['String'];
};

/** The company defined role for an employee. */
export type RoleEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  between?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productArea?: InputMaybe<ProductArea>;
  search?: InputMaybe<Array<EmployeeSearchInput>>;
  sort?: InputMaybe<Array<EmployeeSortInput>>;
};

/** The connection type for Role. */
export type RoleConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RoleEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Role>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RoleEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Role>;
};

/** Available filters when listing roles. */
export type RoleFilterInput = {
  excludeEmpty?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  reportingGroups?: InputMaybe<Array<Scalars['ID']>>;
  teams?: InputMaybe<Array<Scalars['ID']>>;
};

/** Available fields to search roles. */
export enum RoleSearchFieldEnum {
  Name = 'NAME',
}

/** Search roles using a combination of `value` and `on` arguments. */
export type RoleSearchInput = {
  /** The fields you want to match on. */
  on: Array<RoleSearchFieldEnum>;
  /** The value you want to match. Can't be blank. */
  value: Scalars['String'];
};

/** The possible fields to sort on. */
export enum RoleSortFieldEnum {
  Name = 'NAME',
}

/** Sort the list of roles. */
export type RoleSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: RoleSortFieldEnum;
};

export type RolesEmployeeCount = {
  totalEmployeeCount: Scalars['Int'];
};

/** The number of decimal places to round the score to */
export type ScoreDecimals = {
  options: Array<DecimalOption>;
  selected: Scalars['String'];
};

/** Available fields to search interactions */
export enum SearchFieldEnum {
  ExtInteractionId = 'EXT_INTERACTION_ID',
}

export enum Section {
  Customer = 'CUSTOMER',
  CustomProperties = 'CUSTOM_PROPERTIES',
  Employee = 'EMPLOYEE',
  Marketing = 'MARKETING',
  ServiceRecoveryRequest = 'SERVICE_RECOVERY_REQUEST',
  ServiceRecoveryResponse = 'SERVICE_RECOVERY_RESPONSE',
  SurveyRequest = 'SURVEY_REQUEST',
  SurveyResponse = 'SURVEY_RESPONSE',
  TeamLeader = 'TEAM_LEADER',
}

/** Autogenerated input type of SendTestEmail */
export type SendTestEmailInput = {
  attributes: SolicitationPreviewAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SendTestEmail. */
export type SendTestEmailPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Attributes for creating or updating a SessionInteractionAttachment */
export type SessionInteractionAttachmentInput = {
  followUpId?: InputMaybe<Scalars['ID']>;
  interactionId: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
  summary?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of SetSnappyApiKey */
export type SetSnappyApiKeyInput = {
  apiKey: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** QA Assignment skipped solicitation data */
export type SkippedSolicitation = {
  channel: Scalars['String'];
  /** @deprecated Use solicitation.interaction.ext_interaction_id */
  extInteractionId: Maybe<Scalars['String']>;
  member: Person;
  qaAllocation: Maybe<QaAllocation>;
  reviewed: Scalars['Boolean'];
  reviewer: Person;
  skipReason: Scalars['String'];
  skipReasonDetail: Maybe<Scalars['String']>;
  skippedDate: Scalars['ISO8601DateTime'];
  solicitation: Solicitation;
};

/** Available filters when listing QA Assignment skipped solicitations. */
export type SkippedSolicitationFilterInput = {
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  /** @deprecated Please use channel_ids */
  channels?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  excludeTags?: InputMaybe<Array<Scalars['String']>>;
  includeTags?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['ID']>>;
  skipReasonIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  teamMemberIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** The possible fields to sort on. */
export enum SkippedSolicitationSortFieldEnum {
  Member = 'MEMBER',
  Reviewer = 'REVIEWER',
  SkippedDate = 'SKIPPED_DATE',
  SkipReason = 'SKIP_REASON',
}

/** Sort input for SkippedSolicitations. */
export type SkippedSolicitationSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: SkippedSolicitationSortFieldEnum;
};

/** QA Assignment skipped solicitations data */
export type SkippedSolicitationsCollection = {
  collection: Array<SkippedSolicitation>;
  metadata: CollectionMetadata;
};

export type Snappy = {
  /** Part of the API Key used to integrate Snappy */
  apiKey: Maybe<Scalars['String']>;
  /** The current status of the Snappy integration */
  enabled: Scalars['Boolean'];
};

export type SnappyApiKey = {
  companyId: Scalars['ID'];
  enabled: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Snappy integration campaign */
export type SnappyCampaign = {
  extSnappyCampaignId: Scalars['String'];
  name: Scalars['String'];
};

/** Feedback request related data */
export type Solicitation = {
  createdAt: Scalars['ISO8601DateTime'];
  employee: Employee;
  finishedAt: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  interaction: Maybe<Interaction>;
  recovered: Maybe<Scalars['Boolean']>;
  recoveryFeedback: Maybe<Solicitation>;
  respondedAt: Maybe<Scalars['ISO8601DateTime']>;
  surveyAnswers: Maybe<SurveyAnswerConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['ID'];
};

/** Feedback request related data */
export type SolicitationSurveyAnswersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Solicitation. */
export type SolicitationConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SolicitationEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Solicitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SolicitationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Solicitation>;
};

/** Input for sending a test email for a survey configuration */
export type SolicitationPreviewAttributes = {
  /** Brand for preview */
  brand?: InputMaybe<Scalars['String']>;
  /** Channel for preview */
  channel?: InputMaybe<Scalars['String']>;
  /** UUID of the survey configuration */
  configurationId: Scalars['String'];
  /** Email address to send test to */
  customerEmailAddress: Scalars['String'];
  /** Employee ID for preview context */
  employeeId?: InputMaybe<Scalars['String']>;
  /** Language for preview */
  language?: InputMaybe<Scalars['String']>;
};

/** Filter responses and metrics by created-at or responded-at timestamps */
export enum SolicitationReportingTimestampEnum {
  CreatedAt = 'CREATED_AT',
  RespondedAt = 'RESPONDED_AT',
}

/** The available sort directions. */
export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Available fields for sorting */
export enum SortFieldEnum {
  CompletedAt = 'COMPLETED_AT',
  Id = 'ID',
  StartedAt = 'STARTED_AT',
}

/** Sort the list of QA Calibrations. */
export type SortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field?: InputMaybe<QaCalibrationSortFieldEnum>;
};

/** Specifies start of Q1 to calculate quarterly time frames */
export type StartOfQuarter = {
  day: Maybe<Scalars['Int']>;
  month: Maybe<Scalars['Int']>;
};

/** Specifies start of Q1 to calculate quarterly time frames */
export type StartOfQuarterInput = {
  day: Scalars['Int'];
  month: Scalars['Int'];
};

/** The account status of the employee. */
export enum StatusEnum {
  Active = 'ACTIVE',
  Confirmed = 'CONFIRMED',
  Created = 'CREATED',
  Deactivated = 'DEACTIVATED',
  PendingReview = 'PENDING_REVIEW',
  Unapproved = 'UNAPPROVED',
}

/** The available subscriptions. */
export type Subscription = {
  /** Fires when an employee earns a new badge */
  employeeBadgeEarned: EmployeeBadgeEarnedPayload;
};

/** Coaching Session Summary Feedback type */
export type SummaryFeedback = {
  employee: Employee;
  userFeedback: Maybe<UserFeedbackEnum>;
};

/** The team leader for an employee. */
export type Supervisor = {
  fullName: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  primaryTeam: Team;
};

/** The connection type for Supervisor. */
export type SupervisorConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupervisorEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Supervisor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SupervisorEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Supervisor>;
};

export enum Survey {
  Feedback = 'FEEDBACK',
  Recovery = 'RECOVERY',
}

/** SurveyAnswer object */
export type SurveyAnswer = {
  answeredAt: Maybe<Scalars['ISO8601DateTime']>;
  comment: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  fromEmail: Scalars['Boolean'];
  id: Scalars['ID'];
  solicitation: Solicitation;
  surveyOptions: Maybe<Array<SurveyOption>>;
  surveyQuestionId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for SurveyAnswer. */
export type SurveyAnswerConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SurveyAnswerEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<SurveyAnswer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SurveyAnswerEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<SurveyAnswer>;
};

/** SurveyConfiguration object */
export type SurveyConfiguration = {
  availableQuestions: Maybe<Array<SurveyQuestion>>;
  configuration: Scalars['JSON'];
  configurationHash: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  features: Maybe<Scalars['JSON']>;
  filterOptions: Maybe<Scalars['JSON']>;
  globalMarketingSettings: Maybe<Scalars['JSON']>;
  publishedConfiguration: Maybe<Scalars['JSON']>;
  publishedHash: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['String'];
};

/** SurveyOption object */
export type SurveyOption = {
  active: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  identifier: Maybe<Scalars['String']>;
  integerValue: Maybe<Scalars['Int']>;
  position: Scalars['Int'];
  surveyQuestionId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** SurveyQuestion object */
export type SurveyQuestion = {
  companyId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  identifier: Scalars['String'];
  metadata: Scalars['JSON'];
  nickname: Maybe<Scalars['String']>;
  showComment: Scalars['Boolean'];
  showOnStream: Scalars['Boolean'];
  surveyNames: Maybe<Array<Scalars['String']>>;
  surveyOptions: Array<SurveyOption>;
  translations: Scalars['JSON'];
  type: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Available options for survey response */
export type SurveyResponseOption = {
  includeFutureQuestions: Scalars['Boolean'];
};

/** Available options for survey response */
export type SurveyResponseOptionInput = {
  includeFutureQuestions?: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the result of metrics by tag ranking. */
export type TagRankingResult = {
  metricResult: MetricResult;
  name: Scalars['String'];
};

/** The payload for the result of metrics by tag ranking. */
export type TagRankingsResult = {
  bottomRankings: Maybe<Array<TagRankingResult>>;
  topRankings: Maybe<Array<TagRankingResult>>;
};

/** Coaching Session Takeaway type */
export type Takeaway = {
  coachingSession: CoachingSession;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  completedBy: Maybe<Employee>;
  completedCoachingSessionId: Maybe<Scalars['ID']>;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Employee;
  dueDate: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  isPositive: Maybe<Scalars['Boolean']>;
  owner: Maybe<Employee>;
  permissions: Permissions;
  takeawayCategory: Maybe<CoachingSessionTakeawayCategory>;
  text: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type TakeawayCategoryStat = {
  count: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** The connection type for Takeaway. */
export type TakeawayConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TakeawayEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Takeaway>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum TakeawayDateFieldEnum {
  CoachingSessionCreatedAt = 'COACHING_SESSION__CREATED_AT',
  CoachingSessionSharedAt = 'COACHING_SESSION__SHARED_AT',
  CoachingSessionUpdatedAt = 'COACHING_SESSION__UPDATED_AT',
  CompletedAt = 'COMPLETED_AT',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/** An edge in a connection. */
export type TakeawayEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Takeaway>;
};

export type TakeawayFilterInput = {
  dateField?: InputMaybe<TakeawayDateFieldEnum>;
  dateRange?: InputMaybe<DateRangeInput>;
  dateRangeOption?: InputMaybe<FilterModeEnum>;
  employeeId?: InputMaybe<Scalars['ID']>;
  sessionIds?: InputMaybe<Array<Scalars['ID']>>;
  sessionIdsOption?: InputMaybe<FilterModeEnum>;
  status?: InputMaybe<TakeawayStatusEnum>;
  teamId?: InputMaybe<Scalars['ID']>;
};

/** Coaching Session Action Item History type */
export type TakeawayHistory = {
  actor: Maybe<Actor>;
  attributeName: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  event: Scalars['String'];
  valueAfter: Maybe<Scalars['String']>;
  valueBefore: Maybe<Scalars['String']>;
};

/** TakeawayHistoryCollection type */
export type TakeawayHistoryCollection = {
  /** A collection of paginated TakeawayHistoryCollection */
  collection: Array<TakeawayHistory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export enum TakeawaySortFieldEnum {
  Id = 'ID',
}

export type TakeawaySortInput = {
  direction?: SortDirectionEnum;
  field?: TakeawaySortFieldEnum;
};

export enum TakeawayStatusEnum {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

/** A team of employees. It has an owner and relatives in the team hierarchy. */
export type Team = {
  active: Maybe<Scalars['Boolean']>;
  /** @deprecated Use directMembersCount instead */
  agentsCount: Scalars['Int'];
  ancestors: Maybe<TeamConnection>;
  /** The immediate active children of this team. */
  children: Maybe<TeamConnection>;
  createdAt: Scalars['ISO8601DateTime'];
  /** All the active teams that have this team as an ancestor. */
  descendants: Maybe<TeamConnection>;
  directMembersCount: Scalars['Int'];
  /** The employees belonging to the current company. */
  employees: EmployeeConnection;
  id: Maybe<Scalars['ID']>;
  label: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner: Maybe<Employee>;
  parent: Maybe<Team>;
  permissions: Maybe<TeamPermissionsType>;
  subteamsCount: Scalars['Int'];
  totalMembersCount: Scalars['Int'];
};

/** A team of employees. It has an owner and relatives in the team hierarchy. */
export type TeamAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A team of employees. It has an owner and relatives in the team hierarchy. */
export type TeamChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A team of employees. It has an owner and relatives in the team hierarchy. */
export type TeamDescendantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A team of employees. It has an owner and relatives in the team hierarchy. */
export type TeamDirectMembersCountArgs = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};

/** A team of employees. It has an owner and relatives in the team hierarchy. */
export type TeamEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  between?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productArea?: InputMaybe<ProductArea>;
  search?: InputMaybe<Array<EmployeeSearchInput>>;
  sort?: InputMaybe<Array<EmployeeSortInput>>;
};

/** A team of employees. It has an owner and relatives in the team hierarchy. */
export type TeamSubteamsCountArgs = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};

/** A team of employees. It has an owner and relatives in the team hierarchy. */
export type TeamTotalMembersCountArgs = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for Team. */
export type TeamConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TeamEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Team>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TeamEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Team>;
};

/** Available filters when listing teams. */
export type TeamFilterInput = {
  excludeEmpty?: InputMaybe<Scalars['Boolean']>;
  goalCreatable?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  includeRoot?: InputMaybe<Scalars['Boolean']>;
  includeUnassigned?: InputMaybe<Scalars['Boolean']>;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<TeamStatusFilterEnum>;
};

/** Team permissions type */
export type TeamPermissionsType = {
  canCreateGoal: Scalars['Boolean'];
};

/** Available fields to search teams. */
export enum TeamSearchFieldEnum {
  Name = 'NAME',
}

/** Search teams using a combination of `value` and `on` arguments. */
export type TeamSearchInput = {
  /** The fields you want to match on. */
  on: Array<TeamSearchFieldEnum>;
  /** The value you want to match. Can't be blank */
  value: Scalars['String'];
};

export enum TeamSortFieldEnum {
  Name = 'NAME',
}

export type TeamSortInput = {
  direction?: SortDirectionEnum;
  field?: TeamSortFieldEnum;
};

/** The possible statuses to filter a team on. */
export enum TeamStatusFilterEnum {
  Active = 'ACTIVE',
  Any = 'ANY',
  Disabled = 'DISABLED',
}

export enum Template {
  Saved = 'SAVED',
  Scheduled = 'SCHEDULED',
}

/** Actors for CoachingTemplates */
export type TemplateActor = Company | Employee;

/** Represents the Terms & Conditions return type */
export type TermsAndConditions = {
  content: Scalars['String'];
  id: Scalars['ID'];
};

/** Contains information about a leaderboard metric's thresholds */
export type Threshold = {
  day: Maybe<Scalars['Int']>;
  month: Maybe<Scalars['Int']>;
  quarter: Maybe<Scalars['Int']>;
  week: Maybe<Scalars['Int']>;
  year: Maybe<Scalars['Int']>;
};

/** The input fields for updating the leaderboard's threshold settings */
export type ThresholdInput = {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  quarter?: InputMaybe<Scalars['Int']>;
  week?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** The type of the tier that you want to check */
export enum TierEnum {
  High = 'HIGH',
  Low = 'LOW',
  Mid = 'MID',
}

/** The possible time period values. */
export enum TimePeriodEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR',
}

/** The number of results and the calculated metric values for each date. */
export type TimeSeries = {
  displayPercentages: Maybe<Array<Maybe<Scalars['String']>>>;
  displayValues: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  targetAnswers: Maybe<Array<Scalars['String']>>;
  totalPercentages: Maybe<Array<Maybe<Scalars['Float']>>>;
  totalResults: Maybe<Array<Maybe<Scalars['Int']>>>;
  values: Maybe<Array<Maybe<Scalars['Float']>>>;
};

/** Autogenerated input type of ToggleAchievementCategory */
export type ToggleAchievementCategoryInput = {
  categoryId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enable: Scalars['Boolean'];
};

/** Autogenerated input type of ToggleCompanyAchievement */
export type ToggleCompanyAchievementInput = {
  achievementId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enable: Scalars['Boolean'];
};

/** Autogenerated input type of ToggleServiceRecovery */
export type ToggleServiceRecoveryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
};

/** Autogenerated return type of ToggleServiceRecovery. */
export type ToggleServiceRecoveryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
};

/** Top agent */
export type TopAgent = {
  count: Scalars['Int'];
  delta: Maybe<Scalars['Int']>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  prevRank: Maybe<Scalars['Int']>;
  rank: Scalars['Int'];
  rating: Scalars['String'];
};

/** Reference object containing details of a reference */
export type TopicReference = {
  /** Link derived from the reference */
  link: Maybe<Scalars['String']>;
  /** Parsed representation of the reference */
  parsed: Maybe<Scalars['JSON']>;
  /** The raw reference string */
  raw: Scalars['String'];
};

/** Input to move a set of employees to a manager */
export type TransferToManagerInput = {
  employeeIds: Array<Scalars['ID']>;
  managerId: Scalars['ID'];
};

/** Autogenerated input type of UnassignLesson */
export type UnassignLessonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  coachingSessionId: Scalars['ID'];
  lessonId: Scalars['ID'];
};

/** Autogenerated input type of UndoFreeformGoal */
export type UndoFreeformGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UndoFreeformGoal. */
export type UndoFreeformGoalPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  freeformGoal: Maybe<FreeformGoal>;
};

/** Autogenerated input type of UndoMetricGoal */
export type UndoMetricGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: MetricGoalTypeEnum;
};

/** Autogenerated return type of UndoMetricGoal. */
export type UndoMetricGoalPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  metricGoal: Maybe<MetricGoalItem>;
};

/** Autogenerated input type of UpdateActionItem */
export type UpdateActionItemInput = {
  action: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateActionItem. */
export type UpdateActionItemPayload = {
  actionItem: Maybe<ActionItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of UpdateAnswer */
export type UpdateAnswerInput = {
  answered?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  qaAnswerId: Scalars['ID'];
  qaOptionId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateAudit */
export type UpdateAuditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  countTowardScore?: InputMaybe<Scalars['Boolean']>;
  hideReviewer?: InputMaybe<Scalars['Boolean']>;
  qaReviewAuditId: Scalars['ID'];
};

/** Autogenerated input type of UpdateCalibration */
export type UpdateCalibrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCalibration. */
export type UpdateCalibrationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  qaCalibration: Maybe<QaCalibration>;
};

/** Autogenerated input type of UpdateCoachingIntelligenceSettings */
export type UpdateCoachingIntelligenceSettingsInput = {
  action?: InputMaybe<CoachingSettingsUpdateActionsEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCoachingIntelligenceSettings. */
export type UpdateCoachingIntelligenceSettingsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  coachingIntelligenceSettings: CoachingIntelligenceSettings;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of UpdateCoachingSessionActionItemAttributes */
export type UpdateCoachingSessionActionItemAttributesInput = {
  attributes: CoachingSessionActionItemUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateCoachingSessionActionItem */
export type UpdateCoachingSessionActionItemInput = {
  action: ActionEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  completedCoachingSessionId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateCoachingSessionInteractionAttachment */
export type UpdateCoachingSessionInteractionAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  coachingSessionId: Scalars['ID'];
  id: Scalars['ID'];
  notes: Scalars['String'];
};

/** Autogenerated return type of UpdateCoachingSessionInteractionAttachment. */
export type UpdateCoachingSessionInteractionAttachmentPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  interactionAttachment: Maybe<CoachingSessionInteractionAttachment>;
};

/** Autogenerated input type of UpdateCoachingSessionPublicNote */
export type UpdateCoachingSessionPublicNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  noteId: Scalars['ID'];
  notes: Scalars['String'];
};

/** Autogenerated return type of UpdateCoachingSessionPublicNote. */
export type UpdateCoachingSessionPublicNotePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  publicNote: Maybe<CoachingSessionNote>;
};

/** Autogenerated input type of UpdateCoachingSummaryFeedback */
export type UpdateCoachingSummaryFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  coachingSessionId: Scalars['ID'];
  userFeedback: UserFeedbackEnum;
};

/** Autogenerated return type of UpdateCoachingSummaryFeedback. */
export type UpdateCoachingSummaryFeedbackPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  summaryFeedback: Maybe<SummaryFeedback>;
};

/** Autogenerated input type of UpdateCoachingTemplate */
export type UpdateCoachingTemplateInput = {
  body?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCoachingTemplate. */
export type UpdateCoachingTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  coachingTemplate: Maybe<CoachingTemplate>;
  errors: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of UpdateConfiguration */
export type UpdateConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  configuration: Scalars['JSON'];
  configurationHash?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** Autogenerated return type of UpdateConfiguration. */
export type UpdateConfigurationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  surveyConfiguration: Maybe<SurveyConfiguration>;
};

/** Autogenerated input type of UpdateDateFilterConfig */
export type UpdateDateFilterConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  defaultDateRange: DateRangeEnum;
  selectedDateRanges: Array<DateRangeEnum>;
  solicitationReportingTimestamp?: InputMaybe<SolicitationReportingTimestampEnum>;
  startOfQuarter: StartOfQuarterInput;
  startOfWeek: WeekdayEnum;
};

/** Autogenerated input type of UpdateEmployee */
export type UpdateEmployeeInput = {
  attributes?: InputMaybe<EmployeeInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  employeeId: Scalars['ID'];
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  supervisorId?: InputMaybe<Scalars['ID']>;
  temporaryPassword?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateExportsLastReadAt */
export type UpdateExportsLastReadAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  exportType?: InputMaybe<ExportTypeEnum>;
  exportsLastReadAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of UpdateExportsLastReadAt. */
export type UpdateExportsLastReadAtPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  exportsLastReadAt: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of UpdateFeedbackExportTemplate */
export type UpdateFeedbackExportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldSectionOptions?: InputMaybe<FieldSectionOptionsInput>;
  fields?: InputMaybe<Array<FeedbackExportFieldInput>>;
  filters?: InputMaybe<FeedbackExportFilterInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  schedule?: InputMaybe<FeedbackExportScheduleInput>;
};

/** Autogenerated return type of UpdateFeedbackExportTemplate. */
export type UpdateFeedbackExportTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  template: Maybe<FeedbackExportTemplate>;
};

/** Autogenerated input type of UpdateIntegrations */
export type UpdateIntegrationsInput = {
  channelIntegrations: Array<ChannelIntegrationInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateLeaderboardSettings */
export type UpdateLeaderboardSettingsInput = {
  advancedSettings?: InputMaybe<LeaderboardSettingsInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  metric?: InputMaybe<MetricInput>;
};

/** Autogenerated input type of UpdateMetricSelection */
export type UpdateMetricSelectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  metric: MetricInput;
  order?: InputMaybe<Scalars['Int']>;
  type: MetricConfigTypeEnum;
};

/** Autogenerated input type of UpdateMetricSetOrder */
export type UpdateMetricSetOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateMetricSetOrder. */
export type UpdateMetricSetOrderPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Scalars['JSON']>;
  metricSets: Maybe<Array<MetricSet>>;
};

/** Autogenerated input type of UpdatePerformanceMetricSelections */
export type UpdatePerformanceMetricSelectionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  metrics: Array<MetricInput>;
};

/** Autogenerated input type of UpdateQaAssignment */
export type UpdateQaAssignmentInput = {
  allocateToTeamLeader?: InputMaybe<Scalars['Boolean']>;
  assignedEmployeeIds?: InputMaybe<Array<Scalars['ID']>>;
  assignedReviewerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  excludedEmployeeIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  reportingGroupScopeId?: InputMaybe<Scalars['ID']>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of UpdateQaAssignment. */
export type UpdateQaAssignmentPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  qaAssignment: Maybe<QaAssignment>;
};

/** Attributes for updating a reporting group criterion */
export type UpdateReportingGroupCriterionAttributes = {
  criterionType?: InputMaybe<ReportingGroupCriterionTypeEnum>;
  id?: InputMaybe<Scalars['ID']>;
  isDestroyed?: InputMaybe<Scalars['Boolean']>;
  operator?: InputMaybe<ReportingGroupCriterionOperatorEnum>;
  period?: InputMaybe<ReportingGroupCriterionPeriodEnum>;
  periodValue?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateReportingGroup */
export type UpdateReportingGroupInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  criteriaAttributes?: InputMaybe<Array<UpdateReportingGroupCriterionAttributes>>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  filterable?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['String']>;
  matchAll?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  permissionable?: InputMaybe<Scalars['Boolean']>;
  streamFooterDisplayable?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateReportingGroup. */
export type UpdateReportingGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<ValidationError>>;
  reportingGroup: Maybe<ReportingGroup>;
};

/** Autogenerated input type of UpdateTeamSettings */
export type UpdateTeamSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerVisibility?: InputMaybe<CompanyCustomerVisibilityEnum>;
  defaultProfilePictureUrl?: InputMaybe<Scalars['String']>;
  guidelineProfile?: InputMaybe<Scalars['String']>;
  profileImageSetting?: InputMaybe<CompanyProfileImageSetting>;
};

/** Feedback from the user on the coaching summary */
export enum UserFeedbackEnum {
  /** The feedback is helpful */
  Helpful = 'HELPFUL',
  /** The feedback is neutral, or none */
  Neutral = 'NEUTRAL',
  /** The feedback is not helpful */
  NotHelpful = 'NOT_HELPFUL',
}

/** Possible validations on a reviewer in a QA Assignment. */
export enum ValidationEnum {
  /** Reviewer is missing a permission to review assignments */
  Permission = 'PERMISSION',
  /** Reviewer does not have visibility to all reviewees it is assigned to */
  Scope = 'SCOPE',
}

/** A user-readable validation error */
export type ValidationError = {
  /** A description of the error */
  message: Scalars['String'];
  /** Which input field is cause of this error/message */
  path: Array<Scalars['String']>;
};

/** Deprecated type, should be replaced by [Types::ValidationError] */
export type ValidationErrors = {
  details: Scalars['String'];
  fullMessages: Array<Scalars['String']>;
};

/** Comparation type */
export type ValuesComparison = {
  current: Scalars['Int'];
  delta: Scalars['Int'];
  previous: Scalars['Int'];
};

/** A valid weekday */
export enum WeekdayEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type UpdateCoachingIntelligenceSettingsMutationVariables = Exact<{
  action?: InputMaybe<CoachingSettingsUpdateActionsEnum>;
}>;

export type UpdateCoachingIntelligenceSettingsMutation = {
  updateCoachingIntelligenceSettings: {
    coachingIntelligenceSettings: { enabled: boolean; termsAccepted: boolean };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type GetCoachingIntelligenceSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoachingIntelligenceSettingsQuery = {
  coachingIntelligenceSettings: {
    enabled: boolean;
    termsAcceptedAt: any;
    termsAccepted: boolean;
    termsExpiryAt: any;
    termsExpired: boolean;
    termsExpiry: boolean;
    termsRevisionMatches: boolean;
    termsAcceptedBy: { id: string; profile: { id: string; fullName: string } };
  };
};

export type GetCoachingIntelligenceTcQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoachingIntelligenceTcQuery = {
  coachingIntelligenceTc: { id: string; content: string };
};

export type LeaderboardSettingsFieldsFragment = {
  __typename: 'LeaderboardMetrics';
  id: string;
  type: MetricConfigTypeEnum;
  selected: Array<string>;
  options: Array<{ label: string; value: string }>;
  thresholds: { day: number; week: number; month: number; quarter: number; year: number };
  decimals: { selected: string; options: Array<{ label: string; value: string }> };
  boardSizes: { selected: string; options: Array<{ label: string; value: string }> };
  intervals: { selected: string; options: Array<{ label: string; value: string }> };
};

type MetricSelectionFields_GeneralMetric_Fragment = {
  __typename: 'GeneralMetric';
  id: string;
  type: MetricConfigTypeEnum;
  selected: Array<string>;
  options: Array<{ label: string; value: string }>;
};

type MetricSelectionFields_LeaderboardMetrics_Fragment = {
  __typename: 'LeaderboardMetrics';
  id: string;
  type: MetricConfigTypeEnum;
  selected: Array<string>;
  options: Array<{ label: string; value: string }>;
};

export type MetricSelectionFieldsFragment =
  | MetricSelectionFields_GeneralMetric_Fragment
  | MetricSelectionFields_LeaderboardMetrics_Fragment;

export type CreateMetricSetMutationVariables = Exact<{
  name: Scalars['String'];
  metrics: Array<MetricInput> | MetricInput;
  groupIds: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type CreateMetricSetMutation = {
  createMetricSet: {
    metricSet: {
      id: string;
      name: string;
      order: number;
      metrics: Array<{ id: string; value: string; label: string }>;
      visibility: Array<{ value: string; label: string }>;
    };
  };
};

export type DeleteMetricSetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteMetricSetMutation = {
  deleteMetricSet: Array<{
    id: string;
    name: string;
    order: number;
    metrics: Array<{ id: string; value: string; label: string }>;
    visibility: Array<{ value: string; label: string }>;
  }>;
};

export type ModifyMetricSetMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  metrics?: InputMaybe<Array<MetricInput> | MetricInput>;
  groupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;

export type ModifyMetricSetMutation = {
  modifyMetricSet: {
    metricSet: {
      id: string;
      name: string;
      order: number;
      metrics: Array<{ id: string; value: string; label: string }>;
      visibility: Array<{ value: string; label: string }>;
    };
  };
};

export type UpdateDateFilterConfigMutationVariables = Exact<{
  selectedDateRanges: Array<DateRangeEnum> | DateRangeEnum;
  defaultDateRange: DateRangeEnum;
  startOfWeek: WeekdayEnum;
  startOfQuarter: StartOfQuarterInput;
  solicitationReportingTimestamp?: InputMaybe<SolicitationReportingTimestampEnum>;
}>;

export type UpdateDateFilterConfigMutation = {
  updateDateFilterConfig: {
    selectedDateRanges: Array<DateRangeEnum>;
    defaultDateRange: DateRangeEnum;
    startOfWeek: WeekdayEnum;
    solicitationReportingTimestamp: SolicitationReportingTimestampEnum;
    startOfQuarter: { month: number; day: number };
  };
};

export type UpdateLeaderboardSettingsMutationVariables = Exact<{
  metric?: InputMaybe<MetricInput>;
  advancedSettings?: InputMaybe<LeaderboardSettingsInput>;
}>;

export type UpdateLeaderboardSettingsMutation = {
  updateLeaderboardSettings: {
    __typename: 'LeaderboardMetrics';
    id: string;
    type: MetricConfigTypeEnum;
    selected: Array<string>;
    options: Array<{ label: string; value: string }>;
    thresholds: { day: number; week: number; month: number; quarter: number; year: number };
    decimals: { selected: string; options: Array<{ label: string; value: string }> };
    boardSizes: { selected: string; options: Array<{ label: string; value: string }> };
    intervals: { selected: string; options: Array<{ label: string; value: string }> };
  };
};

export type UpdateMetricSelectionMutationVariables = Exact<{
  metric: MetricInput;
  order: Scalars['Int'];
  type: MetricConfigTypeEnum;
}>;

export type UpdateMetricSelectionMutation = {
  updateMetricSelection: {
    __typename: 'GeneralMetric';
    id: string;
    type: MetricConfigTypeEnum;
    selected: Array<string>;
    options: Array<{ label: string; value: string }>;
  };
};

export type UpdateMetricSetsOrderMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type UpdateMetricSetsOrderMutation = {
  updateMetricSetOrder: {
    metricSets: Array<{
      id: string;
      name: string;
      order: number;
      metrics: Array<{ id: string; value: string; label: string }>;
      visibility: Array<{ value: string; label: string }>;
    }>;
  };
};

export type UpdatePerformanceMetricSelectionsMutationVariables = Exact<{
  metrics: Array<MetricInput> | MetricInput;
}>;

export type UpdatePerformanceMetricSelectionsMutation = {
  updatePerformanceMetricSelections: {
    __typename: 'GeneralMetric';
    id: string;
    type: MetricConfigTypeEnum;
    selected: Array<string>;
    options: Array<{ label: string; value: string }>;
  };
};

export type GetDateFilterConfigurationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDateFilterConfigurationsQuery = {
  dateFilterConfig: {
    availableDateRanges: Array<DateRangeEnum>;
    defaultDateRange: DateRangeEnum;
    defaultDateRangeSelections: Array<DateRangeEnum>;
    selectedDateRanges: Array<DateRangeEnum>;
    startOfWeek: WeekdayEnum;
    solicitationReportingTimestamp: SolicitationReportingTimestampEnum;
    startOfQuarter: { month: number; day: number };
  };
};

export type GetMetricConfigurationOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMetricConfigurationOptionsQuery = {
  metricSelectionOptions: Array<
    | {
        __typename: 'GeneralMetric';
        id: string;
        type: MetricConfigTypeEnum;
        selected: Array<string>;
        options: Array<{ label: string; value: string }>;
      }
    | {
        __typename: 'LeaderboardMetrics';
        id: string;
        type: MetricConfigTypeEnum;
        selected: Array<string>;
        options: Array<{ label: string; value: string }>;
        thresholds: { day: number; week: number; month: number; quarter: number; year: number };
        decimals: { selected: string; options: Array<{ label: string; value: string }> };
        boardSizes: { selected: string; options: Array<{ label: string; value: string }> };
        intervals: { selected: string; options: Array<{ label: string; value: string }> };
      }
  >;
};

export type GetMetricSetsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMetricSetsQuery = {
  metricSets: Array<{
    id: string;
    name: string;
    order: number;
    default: boolean;
    metrics: Array<{ id: string; value: string; label: string }>;
    visibility: Array<{ value: string; label: string; owner: { id: string } }>;
  }>;
};

export type GetCoachingSessionSummaryQueryVariables = Exact<{
  coachingSessionId: Scalars['ID'];
}>;

export type GetCoachingSessionSummaryQuery = {
  coachingSessionSummary: {
    status: string;
    summary: string;
    summaryFeedback: { userFeedback: UserFeedbackEnum };
  };
};

export type UpdateCoachingSummaryFeedbackMutationVariables = Exact<{
  coachingSessionId: Scalars['ID'];
  userFeedback: UserFeedbackEnum;
}>;

export type UpdateCoachingSummaryFeedbackMutation = {
  updateCoachingSummaryFeedback: {
    summaryFeedback: { userFeedback: UserFeedbackEnum };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type GetMetricGraphDataQueryVariables = Exact<{
  filters: MetricFilterInput;
  metric: MetricInput;
  interval?: InputMaybe<TimePeriodEnum>;
}>;

export type GetMetricGraphDataQuery = {
  calculateMetricTrend: {
    dates: Array<any>;
    title: string;
    value: number;
    timeSeries: Array<{
      values: Array<number>;
      totalResults: Array<number>;
      displayValues: Array<string>;
    }>;
  };
};

export type GetAreasQueryVariables = Exact<{
  filters: MetricFilterInput;
  metric: MetricInput;
  fetchAoe: Scalars['Boolean'];
}>;

export type GetAreasQuery = {
  aoe: {
    edges: Array<{
      node: {
        groupValue: string;
        areaIdentifier: string;
        metricResult: {
          value: number;
          displayValue: string;
          totalResults: any;
          displayPercentage: string;
        };
      };
    }>;
  };
  aoi: {
    edges: Array<{
      node: {
        groupValue: string;
        areaIdentifier: string;
        metricResult: {
          value: number;
          displayValue: string;
          totalResults: any;
          displayPercentage: string;
        };
      };
    }>;
  };
};

export type CalculateMetricByCategoryQueryVariables = Exact<{
  filters: MetricFilterInput;
  identifier: IdentifierEnum;
  includeAreas?: InputMaybe<Scalars['Boolean']>;
}>;

export type CalculateMetricByCategoryQuery = {
  calculateMetricByCategory: {
    areasEnabled: boolean;
    categories?: Array<{
      category: string;
      categoryId: number;
      label: string;
      count: number;
      percent: number;
    }>;
  };
};

export type GetBehaviorQueryVariables = Exact<{
  filters: MetricFilterInput;
  metric: MetricInput;
  interval?: InputMaybe<TimePeriodEnum>;
  hasAoe?: InputMaybe<Scalars['Boolean']>;
  hasAoi?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetBehaviorQuery = {
  aoe: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          displayValue: string;
          higherIsBetter: boolean;
          totalResults: any;
          metricName: MetricNameEnum;
        };
      };
    }>;
  };
  aoi: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          displayValue: string;
          higherIsBetter: boolean;
          totalResults: any;
          metricName: MetricNameEnum;
        };
      };
    }>;
  };
  aoeTrends: {
    dates: Array<any>;
    timeSeries: Array<{
      name: string;
      values: Array<number>;
      totalResults: Array<number>;
      displayValues: Array<string>;
    }>;
  };
  aoiTrends: {
    dates: Array<any>;
    timeSeries: Array<{
      name: string;
      values: Array<number>;
      totalResults: Array<number>;
      displayValues: Array<string>;
    }>;
  };
};

export type TableMetricResultFragmentFragment = {
  value: number;
  title: string;
  displayValue: string;
  totalResults: any;
  higherIsBetter: boolean;
};

export type GetTableColumnQueryVariables = Exact<{
  metric: MetricInput;
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  previousStartDate: Scalars['ISO8601Date'];
  previousEndDate: Scalars['ISO8601Date'];
  employeeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  teamIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sortField?: InputMaybe<MetricSortFieldEnum>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  includeEmployees?: InputMaybe<Scalars['Boolean']>;
  channelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  brandingIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  languages?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  excludeTags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeTags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  customProperties?: InputMaybe<Array<CustomPropertyFilterInput> | CustomPropertyFilterInput>;
  solicitationReportingTimestamp?: InputMaybe<SolicitationReportingTimestampEnum>;
}>;

export type GetTableColumnQuery = {
  currentTeamMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  currentEmployeeMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  previousTeamMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  previousEmployeeMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
};

export type GetTableColumnWithGoalsQueryVariables = Exact<{
  metric: MetricInput;
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  previousStartDate: Scalars['ISO8601Date'];
  previousEndDate: Scalars['ISO8601Date'];
  employeeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  teamIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sortField?: InputMaybe<MetricSortFieldEnum>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  includeEmployees?: InputMaybe<Scalars['Boolean']>;
  channelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  brandingIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  languages?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  excludeTags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeTags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  customProperties?: InputMaybe<Array<CustomPropertyFilterInput> | CustomPropertyFilterInput>;
  solicitationReportingTimestamp?: InputMaybe<SolicitationReportingTimestampEnum>;
}>;

export type GetTableColumnWithGoalsQuery = {
  currentTeamMetricGoals: {
    edges: Array<{
      node:
        | {
            id: string;
            displayValue: string;
            goal: number;
            reachedCount: number;
            type: MetricGoalTypeEnum;
            group: { id: string; agentsCount: number };
            metricConfig: { id: string; metricName: MetricNameEnum; questionIdentifier: string };
          }
        | {};
    }>;
  };
  currentEmployeeMetricGoals: {
    edges: Array<{
      node:
        | {
            id: string;
            displayValue: string;
            goal: number;
            type: MetricGoalTypeEnum;
            employee: { id: string };
            metricConfig: { id: string; metricName: MetricNameEnum; questionIdentifier: string };
          }
        | {};
    }>;
  };
  currentTeamMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  currentEmployeeMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  previousTeamMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  previousEmployeeMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
};

export type GetEmployeeHierarchyQueryVariables = Exact<{
  employeeId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;

export type GetEmployeeHierarchyQuery = {
  employee: {
    id: string;
    primaryTeam: {
      id: string;
      owner: { id: string; profile: { id: string; fullName: string } };
      ancestors: {
        totalCount: number;
        nodes: Array<{
          id: string;
          owner: { id: string; profile: { id: string; fullName: string } };
        }>;
        pageInfo: { endCursor: string; hasNextPage: boolean };
      };
    };
  };
};

export type GetGroupsTableColumnQueryVariables = Exact<{
  metric: MetricInput;
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  previousStartDate: Scalars['ISO8601Date'];
  previousEndDate: Scalars['ISO8601Date'];
  employeeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  groupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sortField?: InputMaybe<MetricSortFieldEnum>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  includeEmployees?: InputMaybe<Scalars['Boolean']>;
  parentGroupId: Scalars['ID'];
  solicitationReportingTimestamp?: InputMaybe<SolicitationReportingTimestampEnum>;
  channelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  brandingIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  languages?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  excludeTags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeTags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  customProperties?: InputMaybe<Array<CustomPropertyFilterInput> | CustomPropertyFilterInput>;
}>;

export type GetGroupsTableColumnQuery = {
  currentGroupMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  currentEmployeeMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  previousGroupMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
  previousEmployeeMetrics: {
    edges: Array<{
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          title: string;
          displayValue: string;
          totalResults: any;
          higherIsBetter: boolean;
        };
      };
    }>;
  };
};

export type GetGroupHierarchyQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;

export type GetGroupHierarchyQuery = {
  reportingGroup: {
    id: string;
    name: string;
    ancestors: {
      totalCount: number;
      nodes: Array<{ id: string; name: string }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
    parent: { id: string; name: string };
  };
};

export type GetGroupMembersAndChildrenQueryVariables = Exact<{
  groupId: Scalars['ID'];
  afterEmployees?: InputMaybe<Scalars['String']>;
  firstEmployees?: InputMaybe<Scalars['Int']>;
  afterChildren?: InputMaybe<Scalars['String']>;
  firstChildren?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  employeeFilters?: InputMaybe<EmployeeFilterInput>;
  between?: InputMaybe<DateRangeInput>;
}>;

export type GetGroupMembersAndChildrenQuery = {
  reportingGroup: {
    id: string;
    name: string;
    color: string;
    emoji: string;
    image: string;
    members: {
      nodes: Array<{
        id: string;
        isActive: boolean;
        profile: {
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          imageUrl: string;
        };
      }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
    children: {
      nodes: Array<{ id: string; name: string; color: string; emoji: string; image: string }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
  };
};

export type GetMetricByQuestionOptionQueryVariables = Exact<{
  filters: MetricFilterInput;
  metric: MetricInput;
}>;

export type GetMetricByQuestionOptionQuery = {
  calculateMetricByGroup: {
    edges: Array<{
      node: {
        groupValue: string;
        groupValueId: string;
        groupValueIds: Array<string>;
        metricResult: {
          value: number;
          displayValue: string;
          higherIsBetter: boolean;
          totalResults: any;
          displayPercentage: string;
          totalPercentage: number;
        };
      };
    }>;
  };
};

export type GetMetricInvestigationGroupByQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  filters: MetricFilterInput;
  metric: MetricInput;
  groupBy: MetricGroupByEnum;
  interval?: InputMaybe<TimePeriodEnum>;
}>;

export type GetMetricInvestigationGroupByQuery = {
  company: {
    id: string;
    channels: Array<{ id: string; name: string; slug: string; active: boolean; enumId: string }>;
  };
  calculateMetricByGroup: {
    edges: Array<{
      node: {
        groupValue: string;
        groupValueId: string;
        metricResult: {
          value: number;
          displayValue: string;
          higherIsBetter: boolean;
          totalResults: any;
          displayPercentage: string;
          totalPercentage: number;
        };
      };
    }>;
    pageInfo: { hasNextPage: boolean; endCursor: string };
  };
  calculateMetricTrendByGroup: {
    dates: Array<any>;
    higherIsBetter: boolean;
    totalPercentage: number;
    displayPercentage: string;
    dateRanges: Array<{ endDate: any; startDate: any }>;
    timeSeries: Array<{
      displayValues: Array<string>;
      values: Array<number>;
      totalResults: Array<number>;
      name: string;
      totalPercentages: Array<number>;
      displayPercentages: Array<string>;
    }>;
  };
};

export type GetTagsByRankingQueryVariables = Exact<{
  filters: MetricFilterInput;
  metric: MetricInput;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type GetTagsByRankingQuery = {
  calculateMetricByTagRanking: {
    bottomRankings: Array<{
      name: string;
      metricResult: { displayValue: string; totalResults: any };
    }>;
    topRankings: Array<{ name: string; metricResult: { displayValue: string; totalResults: any } }>;
  };
};

export type GetTeamHierarchyQueryVariables = Exact<{
  teamId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;

export type GetTeamHierarchyQuery = {
  team: {
    id: string;
    ancestors: {
      totalCount: number;
      nodes: Array<{
        id: string;
        owner: { id: string; profile: { id: string; fullName: string } };
      }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
    parent: { id: string; owner: { id: string; profile: { id: string; fullName: string } } };
  };
};

export type GetTopLevelGroupsQueryVariables = Exact<{
  groupFilters?: InputMaybe<ReportingGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;

export type GetTopLevelGroupsQuery = {
  reportingGroups: {
    nodes: Array<{ id: string; name: string; color: string; emoji: string; image: string }>;
    pageInfo: { endCursor: string; hasNextPage: boolean };
  };
};

export type GetUnitSelectorEmployeesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchEmployee?: InputMaybe<Array<EmployeeSearchInput> | EmployeeSearchInput>;
  withSelectedEmployee?: InputMaybe<Scalars['Boolean']>;
  selectedEmployee?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<EmployeeFilterInput>;
}>;

export type GetUnitSelectorEmployeesQuery = {
  employees: {
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        isActive: boolean;
        profile: {
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          imageUrl: string;
        };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
  selectedEmployee: {
    id: string;
    isActive: boolean;
    profile: {
      id: string;
      firstName: string;
      lastName: string;
      fullName: string;
      imageUrl: string;
    };
  };
};

export type GetUnitSelectorGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  withSelectedGroup?: InputMaybe<Scalars['Boolean']>;
  selectedGroup?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ReportingGroupFilterInput>;
  between?: InputMaybe<DateRangeInput>;
}>;

export type GetUnitSelectorGroupsQuery = {
  reportingGroups: {
    totalCount: number;
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        name: string;
        color: string;
        emoji: string;
        image: string;
        members: { totalCount: number };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
  selectedGroup: { id: string; name: string };
};

export type GetUnitSelectorTeamsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchTeam?: InputMaybe<Array<TeamSearchInput> | TeamSearchInput>;
  withSelectedTeam?: InputMaybe<Scalars['Boolean']>;
  selectedTeam?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<TeamFilterInput>;
}>;

export type GetUnitSelectorTeamsQuery = {
  teams: {
    totalCount: number;
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        name: string;
        active: boolean;
        label: string;
        children: {
          nodes: Array<{
            id: string;
            name: string;
            active: boolean;
            label: string;
            owner: {
              id: string;
              isActive: boolean;
              profile: {
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                imageUrl: string;
              };
            };
          }>;
        };
        employees: {
          totalCount: number;
          nodes: Array<{
            id: string;
            isActive: boolean;
            profile: {
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              imageUrl: string;
            };
          }>;
        };
        owner: {
          id: string;
          isActive: boolean;
          profile: {
            id: string;
            firstName: string;
            lastName: string;
            fullName: string;
            imageUrl: string;
          };
        };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
  selectedTeam: {
    id: string;
    name: string;
    active: boolean;
    label: string;
    owner: {
      id: string;
      isActive: boolean;
      profile: {
        id: string;
        firstName: string;
        lastName: string;
        fullName: string;
        imageUrl: string;
      };
    };
  };
};

export type GetMetricTrendDataQueryVariables = Exact<{
  filters: MetricFilterInput;
  metric: MetricInput;
  interval?: InputMaybe<TimePeriodEnum>;
}>;

export type GetMetricTrendDataQuery = {
  calculateMetricTrend: {
    displayValue: string;
    title: string;
    value: number;
    questionIdentifier: string;
    dates: Array<any>;
    timeSeries: Array<{
      totalResults: Array<number>;
      values: Array<number>;
      displayValues: Array<string>;
      targetAnswers: Array<string>;
    }>;
    dateRanges: Array<{ endDate: any; startDate: any }>;
  };
};

export type GetPerformanceHighlightsQueryVariables = Exact<{
  highlights: Array<PerformanceHighlightsEnum> | PerformanceHighlightsEnum;
  filters: MetricFilterInput;
}>;

export type GetPerformanceHighlightsQuery = {
  performanceHighlights: Array<{ id: string; name: string; value: number }>;
};

export type AssignLessonMutationVariables = Exact<{
  input: AssignLessonInput;
}>;

export type AssignLessonMutation = { assignLesson: Array<{ id: string }> };

export type UnassignLessonMutationVariables = Exact<{
  input: UnassignLessonInput;
}>;

export type UnassignLessonMutation = { unassignLesson: Array<{ id: string }> };

export type GetLessonlyLessonsQueryVariables = Exact<{ [key: string]: never }>;

export type GetLessonlyLessonsQuery = {
  lessonly: {
    enabled: boolean;
    lessons: Array<{
      id: string;
      title: string;
      tags: Array<{ id: string; name: string }>;
      links: { shareable: string; overview: string };
    }>;
  };
};

export type GetLessonlyIntegratedQueryVariables = Exact<{ [key: string]: never }>;

export type GetLessonlyIntegratedQuery = { lessonly: { enabled: boolean } };

export type ActionItemsCollectionFieldsFragment = {
  totalCount: number;
  edges: Array<{
    node: {
      id: string;
      text: string;
      completedAt: any;
      createdAt: any;
      dueDate: any;
      createdBy: { id: string; profile: { id: string; fullName: string } };
      owner: { id: string; profile: { fullName: string; id: string; imageUrl: string } };
      takeawayCategory: { id: string; name: string };
      coachingSession: { id: string };
      permissions: { completable: boolean };
    };
  }>;
  pageInfo: { endCursor: string; hasNextPage: boolean };
};

export type PublicNoteFieldsFragment = {
  id: string;
  createdAt: any;
  updatedAt: any;
  notes: string;
  coachingSession: { id: string };
  createdBy: { id: string };
};

export type CoachingTopicFieldsFragment = {
  id: string;
  topic: string;
  order: number;
  addedToSessionAt: any;
  createdAt: any;
  updatedAt: any;
  references: Array<{ link: string; parsed: any }>;
  coachingSession: { id: string };
  negativeFeedback: { id: string; feedbackReason: string; comment: string; createdAt: any };
};

export type EmployeeFieldsFragment = {
  id: string;
  isActive: boolean;
  profile: { id: string; firstName: string; lastName: string; fullName: string; imageUrl: string };
};

export type InteractionFieldsFragment = {
  id: string;
  extInteractionId: string;
  resolvedAt: any;
  canShowSummary: boolean;
  reviews: {
    nodes: Array<
      | { __typename: 'QaReviewCalibration' }
      | { __typename: 'QaReviewRegular'; id: string; score: number; date: any }
    >;
  };
  solicitations: {
    nodes: Array<{
      __typename: 'Solicitation';
      id: string;
      uuid: string;
      recovered: boolean;
      date: any;
      surveyAnswers: {
        nodes: Array<{
          id: string;
          surveyQuestionId: string;
          surveyOptions: Array<{ id: string }>;
        }>;
      };
    }>;
  };
};

export type TeamFieldsFragment = {
  id: string;
  name: string;
  active: boolean;
  label: string;
  owner: {
    id: string;
    isActive: boolean;
    profile: {
      id: string;
      firstName: string;
      lastName: string;
      fullName: string;
      imageUrl: string;
    };
  };
};

export type AddCoachingTopicToSessionMutationVariables = Exact<{
  topicId: Scalars['ID'];
  sessionId: Scalars['ID'];
}>;

export type AddCoachingTopicToSessionMutation = {
  addCoachingTopicToSession: {
    errors: Array<{ message: string }>;
    publicNote: {
      id: string;
      createdAt: any;
      updatedAt: any;
      notes: string;
      coachingSession: { id: string };
      createdBy: { id: string };
    };
  };
};

export type AddMemberToGroupMutationVariables = Exact<{
  input: AddMemberReportingGroupInput;
}>;

export type AddMemberToGroupMutation = {
  reportingGroupAddMember: {
    id: string;
    name: string;
    members: { nodes: Array<{ id: string; email: string }> };
  };
};

export type AddNegativeFeedbackToCoachingTopicMutationVariables = Exact<{
  topicId: Scalars['ID'];
  feedbackReason?: InputMaybe<NegativeFeedbackReasonEnum>;
  feedbackComment?: InputMaybe<Scalars['String']>;
}>;

export type AddNegativeFeedbackToCoachingTopicMutation = {
  addNegativeFeedbackToCoachingTopic: {
    errors: Array<{ message: string }>;
    coachingTopic: {
      id: string;
      topic: string;
      order: number;
      addedToSessionAt: any;
      createdAt: any;
      updatedAt: any;
      references: Array<{ link: string; parsed: any }>;
      coachingSession: { id: string };
      negativeFeedback: { id: string; feedbackReason: string; comment: string; createdAt: any };
    };
  };
};

export type AppealReviewMutationVariables = Exact<{
  input: AppealQaReviewInput;
}>;

export type AppealReviewMutation = {
  appealQaReview: {
    id: string;
    createdAt: any;
    reasons: Array<{ note: string; qaAnswer: { id: string } }>;
    employee: { id: string; profile: { id: string; fullName: string } };
  };
};

export type ApplyCoachingTemplateMutationVariables = Exact<{
  noteId: Scalars['ID'];
  templateId: Scalars['ID'];
}>;

export type ApplyCoachingTemplateMutation = {
  applyCoachingTemplateToPublicNote: {
    publicNote: {
      id: string;
      createdAt: any;
      updatedAt: any;
      notes: string;
      coachingSession: { id: string };
      createdBy: { id: string };
    };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type ArchiveQaAssignmentMutationVariables = Exact<{
  assignmentId: Scalars['ID'];
}>;

export type ArchiveQaAssignmentMutation = { archiveQaAssignment: { id: string; archivedAt: any } };

export type ArchiveCoachingTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ArchiveCoachingTemplateMutation = {
  archiveCoachingTemplate: {
    coachingTemplate: { id: string; status: CoachingTemplateStatusEnum };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type ArchiveFreeformGoalMutationVariables = Exact<{
  freeformGoalId: Scalars['ID'];
}>;

export type ArchiveFreeformGoalMutation = { archiveFreeformGoal: { id: string; archivedAt: any } };

export type ArchiveGoalMutationVariables = Exact<{
  metricGoalId: Scalars['ID'];
  type: MetricGoalTypeEnum;
}>;

export type ArchiveGoalMutation = {
  archiveMetricGoal:
    | { id: string; archivedAt: any; type: MetricGoalTypeEnum }
    | { id: string; archivedAt: any; type: MetricGoalTypeEnum };
};

export type BulkDeactivateEmployeesMutationVariables = Exact<{
  input: BulkDeactivateEmployeesInput;
}>;

export type BulkDeactivateEmployeesMutation = {
  bulkDeactivateEmployees: {
    deactivatedTeamMembers: Array<{ id: string; profile: { id: string; fullName: string } }>;
    deactivatedTeamLeaders: Array<{
      id: string;
      profile: { id: string; fullName: string; imageUrl: string };
    }>;
    errors: Array<{ message: string }>;
  };
};

export type CompleteActionItemMutationVariables = Exact<{
  actionItemId: Scalars['ID'];
}>;

export type CompleteActionItemMutation = {
  completeActionItem: { action: string; completedAt: any; createdAt: any; id: string };
};

export type CompleteCalibrationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CompleteCalibrationMutation = {
  completeCalibration: {
    errors: Array<{ message: string; path: Array<string> }>;
    qaCalibration: {
      id: string;
      completedAt: any;
      status: QaCalibrationStatusEnum;
      alignmentScore: number;
    };
  };
};

export type CompleteFreeformGoalMutationVariables = Exact<{
  freeformGoalId: Scalars['ID'];
}>;

export type CompleteFreeformGoalMutation = {
  completeFreeformGoal: { id: string; completedAt: any };
};

export type CompleteGoalMutationVariables = Exact<{
  metricGoalId: Scalars['ID'];
  type: MetricGoalTypeEnum;
}>;

export type CompleteGoalMutation = {
  completeMetricGoal:
    | { id: string; completedAt: any; type: MetricGoalTypeEnum }
    | { id: string; completedAt: any; type: MetricGoalTypeEnum };
};

export type CreateAnswerMutationVariables = Exact<{
  input: CreateAnswerInput;
}>;

export type CreateAnswerMutation = {
  createAnswer: {
    id: string;
    answered: boolean;
    comments: string;
    createdAt: any;
    qaQuestion: { id: string };
    qaOption: { id: string };
  };
};

export type CreateNewAuditMutationVariables = Exact<{
  input: CreateAuditInput;
}>;

export type CreateNewAuditMutation = {
  createAudit: {
    id: string;
    qaReview: { id: string };
    auditable:
      | { __typename: 'QaReviewCalibrationAudit' }
      | { __typename: 'QaReviewRegularAudit'; id: string; qaForm: { id: string } };
    qaForm: { id: string };
  };
};

export type CreateCalibrationMutationVariables = Exact<{
  input: CreateCalibrationInput;
}>;

export type CreateCalibrationMutation = {
  createCalibration: {
    qaCalibration: { id: string; createdAt: any; ownerReviewId: string };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type CreateCalibtationsExportMutationVariables = Exact<{
  input: CreateCalibrationsExportInput;
}>;

export type CreateCalibtationsExportMutation = {
  createCalibtationsExport: { errors: { details: string }; export: { id: string; state: string } };
};

export type CreateNewCalibrationAuditMutationVariables = Exact<{
  input: CreateCalibrationAuditInput;
}>;

export type CreateNewCalibrationAuditMutation = {
  createCalibrationAudit: {
    id: string;
    qaReview: { id: string };
    auditable:
      | { __typename: 'QaReviewCalibrationAudit'; id: string }
      | { __typename: 'QaReviewRegularAudit' };
  };
};

export type CreateCoachingExportMutationVariables = Exact<{
  input: CreateCoachingExportInput;
}>;

export type CreateCoachingExportMutation = {
  createCoachingExport: { errors: { details: string }; export: { id: string; state: string } };
};

export type CreateCoachingSessionMutationVariables = Exact<{
  coacheeId: Scalars['ID'];
}>;

export type CreateCoachingSessionMutation = { createCoachingSession: { id: string } };

export type CreateCoachingSessionActionItemMutationVariables = Exact<{
  input: CreateCoachingSessionActionItemInput;
}>;

export type CreateCoachingSessionActionItemMutation = {
  createCoachingSessionActionItem: {
    actionItem: {
      id: string;
      createdAt: any;
      dueDate: any;
      text: string;
      owner: { id: string; profile: { id: string; imageUrl: string; fullName: string } };
    };
  };
};

export type CreatePublicNoteMutationVariables = Exact<{
  publicNoteInput: CreateCoachingSessionPublicNoteInput;
}>;

export type CreatePublicNoteMutation = {
  createCoachingSessionPublicNote: {
    publicNote: {
      id: string;
      createdAt: any;
      updatedAt: any;
      notes: string;
      coachingSession: { id: string };
      createdBy: { id: string };
    };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type CreateCoachingTemplateMutationVariables = Exact<{
  input: CreateCoachingTemplateInput;
}>;

export type CreateCoachingTemplateMutation = {
  createCoachingTemplate: {
    coachingTemplate: { id: string; name: string; body: string };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type CreateUserMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;

export type CreateUserMutation = {
  createEmployee: {
    channels: Array<ChannelTypeEnum>;
    customEmployeeId: string;
    email: string;
    employmentStatus: EmploymentStatusEnum;
    id: string;
    licenseType: LicenseTypeEnum;
    customRole: { id: string; name: string };
    employeeGroups: Array<{ id: string; name: string }>;
    primaryTeam: {
      id: string;
      owner: {
        id: string;
        profile: { id: string; fullName: string; firstName: string; lastName: string };
      };
    };
    profile: {
      id: string;
      countryCode: string;
      fullName: string;
      firstName: string;
      lastName: string;
    };
  };
};

export type CreateFeedbackExportMutationVariables = Exact<{
  input: CreateFeedbackExportInput;
}>;

export type CreateFeedbackExportMutation = {
  createFeedbackExport: {
    export: { id: string; state: string };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type CreateFeedbackExportTemplateMutationVariables = Exact<{
  input: CreateFeedbackExportTemplateInput;
}>;

export type CreateFeedbackExportTemplateMutation = {
  createFeedbackExportTemplate: {
    template: { id: string; name: string };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type CreateFeedbackExportFromTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CreateFeedbackExportFromTemplateMutation = {
  createFeedbackExportFromTemplate: {
    export: { id: string; state: string };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type CreateFollowUpMutationVariables = Exact<{
  input: CreateFollowUpInput;
}>;

export type CreateFollowUpMutation = {
  createFollowUp: {
    followUp: { id: string; followUpable: { __typename: 'Interaction'; id: string } | {} };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type CreateFreeformGoalMutationVariables = Exact<{
  input: CreateFreeformGoalInput;
}>;

export type CreateFreeformGoalMutation = {
  createFreeformGoal: {
    errors: Array<{ message: string; path: Array<string> }>;
    freeformGoal: { id: string; createdAt: any; completedAt: any; title: string };
  };
};

export type CreateInteractionAttachmentMutationVariables = Exact<{
  input: CreateCoachingSessionInteractionAttachmentInput;
}>;

export type CreateInteractionAttachmentMutation = {
  createCoachingSessionInteractionAttachment: {
    interactionAttachment: {
      id: string;
      coachingSession: { id: string };
      followUp: { id: string };
      interaction: { id: string };
    };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type CreateMetricGoalMutationVariables = Exact<{
  input: CreateMetricGoalInput;
}>;

export type CreateMetricGoalMutation = {
  createMetricGoal: {
    errors: Array<{ message: string; path: Array<string> }>;
    metricGoal: { id: string } | { id: string };
  };
};

export type CreateMetricsExportMutationVariables = Exact<{
  input: PerformanceMetricsInput;
}>;

export type CreateMetricsExportMutation = {
  createPerformanceMetricsExport: {
    errors: { details: string };
    export: { id: string; state: string };
  };
};

export type CreateReportingGroupMutationVariables = Exact<{
  input: CreateReportingGroupInput;
}>;

export type CreateReportingGroupMutation = {
  createReportingGroup: {
    reportingGroup: {
      active: boolean;
      color: string;
      createdAt: any;
      description: string;
      emoji: string;
      filterable: boolean;
      hidden: boolean;
      id: string;
      image: string;
      name: string;
      parentId: string;
      streamFooterDisplayable: boolean;
      updatedAt: any;
    };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type ResolveAppealMutationVariables = Exact<{
  input: ResolveQaAppealInput;
}>;

export type ResolveAppealMutation = {
  resolveQaAppeal: {
    id: string;
    createdAt: any;
    reasons: Array<{ note: string; qaAnswer: { id: string } }>;
  };
};

export type DeactivateEmployeeFromCompanyMutationVariables = Exact<{
  input: DeactivateEmployeeInput;
}>;

export type DeactivateEmployeeFromCompanyMutation = {
  deactivateEmployee: { id: string; status: StatusEnum; email: string };
};

export type DeleteAuditMutationVariables = Exact<{
  input: DeleteAuditInput;
}>;

export type DeleteAuditMutation = { deleteAudit: { deletedId: string } };

export type DeleteCalibrationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteCalibrationMutation = { deleteCalibration: { deletedId: string } };

export type DeleteCoachingSessionActionItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteCoachingSessionActionItemMutation = {
  deleteCoachingSessionActionItem: { id: string; message: string };
};

export type DeleteFeedbackExportTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteFeedbackExportTemplateMutation = {
  deleteFeedbackExportTemplate: { id: string; message: string };
};

export type DeleteFollowUpMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteFollowUpMutation = { deleteFollowUp: { id: string; message: string } };

export type DeleteCoachingSessionInteractionAttachmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteCoachingSessionInteractionAttachmentMutation = {
  deleteCoachingSessionInteractionAttachment: { id: string; message: string };
};

export type PublishSurveyConfigurationMutationVariables = Exact<{
  configurationId: Scalars['String'];
}>;

export type PublishSurveyConfigurationMutation = {
  publishSurveyConfiguration: { success: boolean; errors: Array<{ message: string }> };
};

export type RecapCoachingSessionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RecapCoachingSessionMutation = {
  recapCoachingSession: { resharedAt: any; sharedAt: any; id: string };
};

export type RecordCalibrationAnswerMutationVariables = Exact<{
  input: RecordCalibrationAnswerInput;
}>;

export type RecordCalibrationAnswerMutation = {
  recordCalibrationAnswer: {
    clientMutationId: string;
    errors: Array<{ message: string; path: Array<string> }>;
    qaCalibration: { id: string };
  };
};

export type RemoveMemberFromGroupMutationVariables = Exact<{
  input: RemoveMemberReportingGroupInput;
}>;

export type RemoveMemberFromGroupMutation = {
  reportingGroupRemoveMember: {
    id: string;
    name: string;
    members: { nodes: Array<{ id: string; email: string }> };
  };
};

export type RemoveNegativeFeedbackFromCoachingTopicMutationVariables = Exact<{
  topicId: Scalars['ID'];
}>;

export type RemoveNegativeFeedbackFromCoachingTopicMutation = {
  removeNegativeFeedbackFromCoachingTopic: {
    errors: Array<{ message: string }>;
    coachingTopic: {
      id: string;
      topic: string;
      order: number;
      addedToSessionAt: any;
      createdAt: any;
      updatedAt: any;
      references: Array<{ link: string; parsed: any }>;
      coachingSession: { id: string };
      negativeFeedback: { id: string; feedbackReason: string; comment: string; createdAt: any };
    };
  };
};

export type ResetSurveyConfigurationMutationVariables = Exact<{
  configurationId: Scalars['String'];
}>;

export type ResetSurveyConfigurationMutation = {
  resetSurveyConfiguration: { success: boolean; errors: Array<{ message: string }> };
};

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetEmployeePasswordInput;
}>;

export type ResetUserPasswordMutation = {
  resetEmployeePassword: { id: string; profile: { id: string; fullName: string } };
};

export type SendTestsSurveyMutationVariables = Exact<{
  input: SendTestEmailInput;
}>;

export type SendTestsSurveyMutation = { sendTestEmail: { success: boolean } };

export type ToggleAchievementCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID'];
  enable: Scalars['Boolean'];
}>;

export type ToggleAchievementCategoryMutation = {
  toggleAchievementCategory: {
    id: string;
    enabled: boolean;
    name: string;
    description: string;
    identifier: string;
  };
};

export type ToggleServiceRecoveryMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
}>;

export type ToggleServiceRecoveryMutation = { toggleServiceRecovery: { enabled: boolean } };

export type UndoFreeformGoalMutationVariables = Exact<{
  freeformGoalId: Scalars['ID'];
}>;

export type UndoFreeformGoalMutation = {
  undoFreeformGoal: { freeformGoal: { id: string; completedAt: any; createdAt: any } };
};

export type UndoGoalMutationVariables = Exact<{
  metricGoalId: Scalars['ID'];
  type: MetricGoalTypeEnum;
}>;

export type UndoGoalMutation = { undoMetricGoal: { metricGoal: { id: string } | { id: string } } };

export type UpdateActionItemMutationVariables = Exact<{
  input: UpdateActionItemInput;
}>;

export type UpdateActionItemMutation = {
  updateActionItem: { actionItem: { action: string; id: string; updatedAt: any } };
};

export type UpdateActionItemAttributesMutationVariables = Exact<{
  input: UpdateCoachingSessionActionItemAttributesInput;
}>;

export type UpdateActionItemAttributesMutation = {
  updateCoachingSessionActionItemAttributes: {
    dueDate: any;
    id: string;
    text: string;
    updatedAt: any;
    owner: { id: string; profile: { fullName: string; id: string; imageUrl: string } };
    takeawayCategory: { name: string; id: string };
  };
};

export type UpdateAnswerMutationVariables = Exact<{
  input: UpdateAnswerInput;
}>;

export type UpdateAnswerMutation = {
  updateAnswer: {
    id: string;
    answered: boolean;
    comments: string;
    createdAt: any;
    qaQuestion: { id: string };
    qaOption: { id: string };
  };
};

export type UpdateAuditMutationVariables = Exact<{
  input: UpdateAuditInput;
}>;

export type UpdateAuditMutation = {
  updateAudit: { id: string; completedAt: any; qaReview: { id: string }; qaForm: { id: string } };
};

export type UpdateCalibrationMutationVariables = Exact<{
  input: UpdateCalibrationInput;
}>;

export type UpdateCalibrationMutation = {
  updateCalibration: {
    errors: Array<{ message: string; path: Array<string> }>;
    qaCalibration: { id: string; notes: string };
  };
};

export type UpdateCoachingSessionActionItemMutationVariables = Exact<{
  id: Scalars['ID'];
  action: ActionEnum;
  completedCoachingSessionId?: InputMaybe<Scalars['ID']>;
}>;

export type UpdateCoachingSessionActionItemMutation = {
  updateCoachingSessionActionItem: { id: string; completedAt: any };
};

export type UpdatePublicNoteMutationVariables = Exact<{
  noteId: Scalars['ID'];
  notes: Scalars['String'];
}>;

export type UpdatePublicNoteMutation = {
  updateCoachingSessionPublicNote: {
    publicNote: {
      id: string;
      createdAt: any;
      updatedAt: any;
      notes: string;
      coachingSession: { id: string };
      createdBy: { id: string };
    };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type UpdateCoachingTemplateMutationVariables = Exact<{
  input: UpdateCoachingTemplateInput;
}>;

export type UpdateCoachingTemplateMutation = {
  updateCoachingTemplate: {
    coachingTemplate: { body: string; id: string; name: string };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateEmployeeInput;
}>;

export type UpdateUserMutation = {
  updateEmployee: {
    channels: Array<ChannelTypeEnum>;
    email: string;
    id: string;
    licenseType: LicenseTypeEnum;
    employmentStatus: EmploymentStatusEnum;
    startDate: any;
    status: StatusEnum;
    customRole: { id: string; name: string };
    employeeGroups: Array<{ id: string; name: string }>;
    primaryTeam: {
      id: string;
      owner: {
        id: string;
        profile: { id: string; fullName: string; firstName: string; lastName: string };
      };
    };
    profile: {
      id: string;
      countryCode: string;
      fullName: string;
      firstName: string;
      lastName: string;
      hometown: string;
    };
    reportingGroups: Array<{ id: string; name: string }>;
    supervisor: { id: string; fullName: string };
  };
};

export type UpdateExportsLastReadAtMutationVariables = Exact<{
  input: UpdateExportsLastReadAtInput;
}>;

export type UpdateExportsLastReadAtMutation = {
  updateExportsLastReadAt: { exportsLastReadAt: any };
};

export type UpdateFeedbackExportTemplateMutationVariables = Exact<{
  input: UpdateFeedbackExportTemplateInput;
}>;

export type UpdateFeedbackExportTemplateMutation = {
  updateFeedbackExportTemplate: {
    template: { id: string };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type UpdateInteractionAttachmentMutationVariables = Exact<{
  input: UpdateCoachingSessionInteractionAttachmentInput;
}>;

export type UpdateInteractionAttachmentMutation = {
  updateCoachingSessionInteractionAttachment: {
    interactionAttachment: { id: string; notes: string };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type UpdateQaAssignmentMutationVariables = Exact<{
  input: UpdateQaAssignmentInput;
}>;

export type UpdateQaAssignmentMutation = {
  updateQaAssignment: { qaAssignment: { id: string }; errors: Array<{ message: string }> };
};

export type UpdateReportingGroupMutationVariables = Exact<{
  input: UpdateReportingGroupInput;
}>;

export type UpdateReportingGroupMutation = {
  updateReportingGroup: {
    reportingGroup: {
      active: boolean;
      color: string;
      createdAt: any;
      description: string;
      emoji: string;
      filterable: boolean;
      hidden: boolean;
      id: string;
      image: string;
      name: string;
      parentId: string;
      streamFooterDisplayable: boolean;
      updatedAt: any;
    };
    errors: Array<{ message: string; path: Array<string> }>;
  };
};

export type UpdateSurveyConfigurationMutationVariables = Exact<{
  uuid: Scalars['String'];
  configuration: Scalars['JSON'];
  configurationHash: Scalars['String'];
}>;

export type UpdateSurveyConfigurationMutation = {
  updateSurveyConfiguration: {
    surveyConfiguration: {
      uuid: string;
      configuration: any;
      configurationHash: string;
      publishedHash: string;
      updatedAt: any;
    };
    errors: Array<{ path: Array<string>; message: string }>;
  };
};

export type UpdateTeamSettingsMutationVariables = Exact<{
  input?: InputMaybe<UpdateTeamSettingsInput>;
}>;

export type UpdateTeamSettingsMutation = {
  updateTeamSettings: {
    id: string;
    customerVisibility: CompanyCustomerVisibilityEnum;
    defaultProfilePictureUrl: string;
    guidelineProfile: string;
    profileImageSetting: CompanyProfileImageSetting;
  };
};

export type GetAchievementCategoryBadgesQueryVariables = Exact<{
  status?: InputMaybe<AchievementStatus>;
}>;

export type GetAchievementCategoryBadgesQuery = {
  achievementCategories: Array<{
    id: string;
    identifier: string;
    name: string;
    description: string;
    enabled: boolean;
    companyAchievements: Array<{
      id: string;
      pathName: string;
      badges: Array<{
        key: string;
        achievementKey: string;
        name: string;
        iconSettings: any;
        description: string;
        imageUrl: string;
        badgeType: string;
        surprise: boolean;
        threshold: number;
      }>;
    }>;
  }>;
};

export type GetAchievementCategoryEmployeeBadgesQueryVariables = Exact<{
  status?: InputMaybe<AchievementStatus>;
  employeeId?: InputMaybe<Scalars['ID']>;
}>;

export type GetAchievementCategoryEmployeeBadgesQuery = {
  achievementCategories: Array<{
    id: string;
    identifier: string;
    name: string;
    description: string;
    enabled: boolean;
    companyAchievements: Array<{
      id: string;
      pathName: string;
      pathDescription: string;
      employeeBadges: Array<
        | {
            id: string;
            name: string;
            description: string;
            iconSettings: any;
            badgeKey: string;
            badgeType: string;
            imageUrl: string;
            count: number;
            status: string;
            earnedAt: any;
            employee: { id: string; email: string };
          }
        | {
            name: string;
            description: string;
            instruction: string;
            iconSettings: any;
            badgeKey: string;
            badgeType: string;
            imageUrl: string;
            status: string;
            surprise: boolean;
            threshold: number;
            employee: { email: string; id: string };
          }
      >;
    }>;
  }>;
};

export type GetAchievementCategoryStatusesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAchievementCategoryStatusesQuery = {
  achievementCategories: Array<{ id: string; enabled: boolean }>;
};

export type GetActionItemsQueryVariables = Exact<{
  actionableId: Scalars['ID'];
  actionableType: ActionableTypeEnum;
  status?: InputMaybe<GoalStatusEnum>;
}>;

export type GetActionItemsQuery = {
  actionItems: {
    edges: Array<{
      node: { action: string; completedAt: any; createdAt: any; id: string; updatedAt: any };
    }>;
  };
};

export type GetActionItemHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetActionItemHistoryQuery = {
  coachingSessionActionItemHistory: {
    collection: Array<{
      attributeName: string;
      createdAt: any;
      valueBefore: string;
      valueAfter: string;
      event: string;
      actor:
        | { __typename: 'Company'; name: string; logoUrl: string }
        | {
            __typename: 'Employee';
            id: string;
            email: string;
            profile: { id: string; fullName: string; imageUrl: string };
          };
    }>;
  };
};

export type GetAllReportingGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllReportingGroupsQuery = { reportingGroups: { nodes: Array<{ id: string }> } };

export type GetReviewAppealQueryVariables = Exact<{
  reviewId: Scalars['ID'];
}>;

export type GetReviewAppealQuery = {
  qaAppeal: {
    id: string;
    createdAt: any;
    reasons: Array<{ note: string; qaAnswer: { id: string } }>;
    employee: { id: string; profile: { id: string; fullName: string } };
    resolution: {
      id: string;
      createdAt: any;
      reasons: Array<{ note: string; qaAnswer: { id: string } }>;
      employee: { id: string; profile: { id: string; fullName: string } };
    };
  };
};

export type GetAssignmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAssignmentQuery = {
  qaAssignment: {
    allocateToTeamLeader: boolean;
    archivedAt: any;
    assigned: number;
    cadence: string;
    completed: number;
    endDate: any;
    id: string;
    initialStartDate: any;
    name: string;
    numberOfDays: number;
    progress: number;
    qaFormId: string;
    qaReviewType: string;
    skipped: number;
    startDate: any;
    totalActiveReviewees: number;
    totalActiveReviewers: number;
    totalCycles: number;
    totalReportingGroups: number;
    totalReviewees: number;
    totalReviewers: number;
    totalReviewsPerAgent: number;
    totalReviewsPerReviewer: number;
    totalTeams: number;
    reviewers: Array<{ id: string }>;
    skipReasonStats: Array<{
      id: string;
      reason: string;
      reasonDetails: Array<string>;
      totalSkipped: number;
    }>;
  };
};

export type GetQaAssignmentsQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']>;
  reviewerId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<QaAssignmentSortInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type GetQaAssignmentsQuery = {
  qaAssignments: {
    collection: Array<{
      id: string;
      name: string;
      cadence: string;
      numberOfDays: number;
      progress: number;
      assigned: number;
      completed: number;
      skipped: number;
      totalReviewers: number;
      totalReviewees: number;
      initialStartDate: any;
      startDate: any;
      qaReviewType: string;
      endDate: any;
      archivedAt: any;
      effectiveAt: any;
      createdAt: any;
      updatedAt: any;
    }>;
    metadata: { currentPage: number; limitValue: number; totalCount: number; totalPages: number };
  };
};

export type GetAssignmentNextReviewQueryVariables = Exact<{
  assignmentId: Scalars['ID'];
  employeeId?: InputMaybe<Scalars['ID']>;
  partialMatching?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAssignmentNextReviewQuery = {
  qaAssignmentNextReview: {
    uuid: string;
    qaAssignmentId: string;
    blind: boolean;
    partiallyMatched: boolean;
    qaReviewType: string;
    qaReviewId: string;
    qaAllocation: { id: string };
  };
};

export type GetAssignmentPeriodsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type GetAssignmentPeriodsQuery = {
  qaAssignment: { id: string; archivedAt: any; initialStartDate: any; cadence: string };
  qaAssignmentPeriods: {
    collection: Array<{
      id: string;
      startDate: any;
      endDate: any;
      averageQaScore: number;
      assigned: number;
      completed: number;
      progress: number;
      totalReviewees: number;
      totalReviewers: number;
      interactionsCount: number;
      eligibleInteractionsCount: number;
      skipped: number;
      revieweesStats: { added: number; allPeriod: number; removed: number; total: number };
      reviewersStats: { added: number; allPeriod: number; removed: number; total: number };
      skipReasonStats: Array<{
        id: string;
        reason: string;
        reasonDetails: Array<string>;
        totalSkipped: number;
      }>;
    }>;
    metadata: { totalPages: number; totalCount: number; currentPage: number; limitValue: number };
  };
};

export type GetAssignmentPeriodsRevieweesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  periodIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  activity?: InputMaybe<QaAssignmentRevieweeActivityEnum>;
  sort?: InputMaybe<QaAssignmentPeriodRevieweesSortInput>;
  onlyStats?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAssignmentPeriodsRevieweesQuery = {
  qaAssignmentPeriods: {
    collection: Array<{
      id: string;
      revieweesStats: { added: number; allPeriod: number; removed: number; total: number };
      reviewees?: {
        pageInfo: {
          hasNextPage: boolean;
          endCursor: string;
          hasPreviousPage: boolean;
          startCursor: string;
        };
        edges: Array<{
          cursor: string;
          node: {
            fullName: string;
            id: string;
            isReviewable: boolean;
            activity: QaAssignmentRevieweeActivityEnum;
            imageUrl: string;
            joinedAt: any;
            leftAt: any;
            leftReason: string;
            progress: number;
            averageQaScore: number;
            completed: number;
          };
        }>;
      };
    }>;
    metadata: { totalPages: number; totalCount: number; currentPage: number; limitValue: number };
  };
};

export type GetAssignmentPeriodsReviewersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  periodIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  activity?: InputMaybe<QaAssignmentReviewerActivityEnum>;
  sort?: InputMaybe<QaAssignmentPeriodReviewersSortInput>;
  onlyStats?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetAssignmentPeriodsReviewersQuery = {
  qaAssignmentPeriods: {
    collection: Array<{
      id: string;
      reviewersStats: { added: number; allPeriod: number; removed: number; total: number };
      reviewers?: {
        pageInfo: {
          hasNextPage: boolean;
          endCursor: string;
          hasPreviousPage: boolean;
          startCursor: string;
        };
        edges: Array<{
          cursor: string;
          node: {
            assigned: number;
            fullName: string;
            id: string;
            activity: QaAssignmentReviewerActivityEnum;
            imageUrl: string;
            joinedAt: any;
            leftAt: any;
            leftReason: string;
            progress: number;
            completed: number;
            skipped: number;
          };
        }>;
      };
    }>;
    metadata: { totalPages: number; totalCount: number; currentPage: number; limitValue: number };
  };
};

export type GetQaAssignmentPreviewQueryVariables = Exact<{
  assignment: QaAssignmentInput;
}>;

export type GetQaAssignmentPreviewQuery = {
  previewQaAssignment: {
    id: string;
    assigned: number;
    totalReviewees: number;
    totalReviewers: number;
    totalReviewsPerAgent: number;
    totalReviewsPerReviewer: number;
    allocateToTeamLeader: boolean;
    qaReviewType: string;
    reviewers: Array<{
      id: string;
      assigned: number;
      fullName: string;
      imageUrl: string;
      validationErrors: Array<{ message: string; type: ValidationEnum }>;
    }>;
  };
};

export type GetAssignmentRevieweesQueryVariables = Exact<{
  id: Scalars['ID'];
  filters?: InputMaybe<QaAssignmentRevieweesFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type GetAssignmentRevieweesQuery = {
  qaAssignment: {
    id: string;
    reviewees: {
      collection: Array<{
        id: string;
        fullName: string;
        imageUrl: string;
        averageQaScore: number;
        completed: number;
        progress: number;
      }>;
      metadata: { totalPages: number; totalCount: number; currentPage: number; limitValue: number };
    };
  };
};

export type GetAssignmentReviewersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAssignmentReviewersQuery = {
  qaAssignment: {
    id: string;
    reviewers: Array<{ fullName: string; id: string; imageUrl: string; completed: number }>;
  };
};

export type GetQaAssignmentSkipReasonsQueryVariables = Exact<{ [key: string]: never }>;

export type GetQaAssignmentSkipReasonsQuery = {
  qaAssignmentSkipReasons: Array<{
    default: boolean;
    description: string;
    id: string;
    label: string;
  }>;
};

export type GetAuditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAuditQuery = {
  audit: {
    id: string;
    autofailed: boolean;
    hideReviewer: boolean;
    hideEmployee: boolean;
    deletedAt: any;
    createdAt: any;
    completedAt: any;
    score: number;
    scoreDisplayValue: number;
    qaAssignmentId: string;
    auditable:
      | { __typename: 'QaReviewCalibrationAudit'; id: string }
      | { __typename: 'QaReviewRegularAudit'; id: string };
    reviewer: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
    qaReview: { id: string };
    qaAnswers: Array<{
      answerableId: string;
      answerableType: string;
      answered: boolean;
      comments: string;
      createdAt: any;
      id: string;
      qaOption: { id: string; qaQuestion: { id: string } };
      qaQuestion: { id: string };
    }>;
    qaForm: {
      id: string;
      qaReviewsCount: number;
      questionCount: number;
      sectionCount: number;
      type: QaFormTypeEnum;
      weightedSections: boolean;
      name: string;
      qaFormSections: Array<{
        id: string;
        title: string;
        qaQuestions: Array<{
          id: string;
          instructions: string;
          naOption: boolean;
          position: number;
          text: string;
          qaOptions: Array<{
            id: string;
            createdAt: any;
            autofail: boolean;
            position: number;
            score: number;
            text: string;
            updatedAt: any;
          }>;
        }>;
      }>;
    };
  };
};

export type GetAuditsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  filters: AuditFilterInput;
  sort?: InputMaybe<AuditSortInput>;
}>;

export type GetAuditsQuery = {
  audits: {
    metadata: { currentPage: number; limitValue: number; totalCount: number; totalPages: number };
    collection: Array<{
      auditorFullName: string;
      autofailed: boolean;
      completedAt: any;
      id: string;
      interactionId: string;
      reviewerFullName: string;
      reviewerImageUrl: string;
      score: number;
      scorecard: string;
      startedAt: any;
      originalScorecardName: string;
      revised: boolean;
      auditable:
        | { __typename: 'QaReviewCalibrationAudit'; id: string }
        | { __typename: 'QaReviewRegularAudit'; id: string };
    }>;
  };
};

export type GetAReportingGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAReportingGroupQuery = { reportingGroup: { id: string; name: string } };

export type ResultFragmentFragment = {
  displayValue: string;
  higherIsBetter: boolean;
  max: number;
  metricName: MetricNameEnum;
  min: number;
  questionIdentifier: string;
  title: string;
  totalResults: any;
  value: number;
};

export type GetCalculatedMetricsQueryVariables = Exact<{
  dateRange: DateRangeInput;
  prevDateRange: DateRangeInput;
  solicitationReportingTimestamp?: InputMaybe<SolicitationReportingTimestampEnum>;
  employeeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  teamIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  metrics: Array<MetricInput> | MetricInput;
}>;

export type GetCalculatedMetricsQuery = {
  calculateMetrics: Array<{
    displayValue: string;
    higherIsBetter: boolean;
    max: number;
    metricName: MetricNameEnum;
    min: number;
    questionIdentifier: string;
    title: string;
    totalResults: any;
    value: number;
  }>;
  prevPeriod: Array<{
    displayValue: string;
    higherIsBetter: boolean;
    max: number;
    metricName: MetricNameEnum;
    min: number;
    questionIdentifier: string;
    title: string;
    totalResults: any;
    value: number;
  }>;
};

export type GetCalibrationQuestionsQueryVariables = Exact<{
  qaFormId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QaCalibrationFormQuestionSortInput>;
}>;

export type GetCalibrationQuestionsQuery = {
  qaCalibrationFormQuestions: {
    totalCount: number;
    edges: Array<{
      node: {
        id: string;
        sectionTitle: string;
        text: string;
        sectionId: string;
        sectionPosition: number;
        position: number;
        alignmentScore: { current: number; previous: number };
      };
    }>;
    pageInfo: {
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
    };
  };
};

export type GetCalibrationQuestionBreakdownQueryVariables = Exact<{
  qaCalibrationId: Scalars['ID'];
}>;

export type GetCalibrationQuestionBreakdownQuery = {
  qaCalibrationQuestionBreakdown: Array<{
    qaFormSection: { defaultSection: boolean; id: string; position: number; title: string };
    questions: Array<{
      selectedOptionId: string;
      selectedNaOption: boolean;
      qaQuestion: {
        id: string;
        instructions: string;
        text: string;
        naOption: boolean;
        position: number;
        qaOptions: Array<{ id: string; text: string }>;
      };
      qaAnswersWithReviewers: Array<{
        qaAnswer: {
          id: string;
          answered: boolean;
          comments: string;
          qaQuestion: { id: string; naOption: boolean };
          qaOption: { id: string };
        };
        reviewer: { id: string; profile: { id: string; imageUrl: string; fullName: string } };
      }>;
    }>;
  }>;
};

export type GetCalibrationScoresQueryVariables = Exact<{
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;

export type GetCalibrationScoresQuery = {
  qaCalibrationScores: {
    alignedAnswersCount: number;
    alignmentScore: number;
    answersCount: number;
    calibrationsCount: number;
    qaFormCalibrationScores: Array<{
      alignedAnswersCount: number;
      alignmentScore: number;
      answersCount: number;
      calibrationsCount: number;
      dates: Array<any>;
      qaForm: { id: string; name: string };
      trend: { alignmentScores: Array<number> };
    }>;
  };
};

export type GetCalibrationScoresForScorecardQueryVariables = Exact<{
  qaFormId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  previousStartDate: Scalars['ISO8601Date'];
  previousEndDate: Scalars['ISO8601Date'];
}>;

export type GetCalibrationScoresForScorecardQuery = {
  qaFormCalibrationScores: {
    alignmentScore: number;
    calibrationsCount: number;
    qaForm: { id: string; name: string };
    qaFormSectionCalibrationScores: Array<{
      dates: Array<any>;
      alignmentScore: number;
      answersCount: number;
      trend: { alignmentScores: Array<number> };
      qaFormSection: { id: string; title: string };
      qaQuestionCalibrationScores: Array<{
        alignmentScore: number;
        qaQuestion: { id: string; text: string; position: number };
        qaCalibrations: Array<{ id: string }>;
      }>;
    }>;
  };
  previousQaFormCalibrationScores: {
    qaFormSectionCalibrationScores: Array<{
      qaQuestionCalibrationScores: Array<{ alignmentScore: number; qaQuestion: { id: string } }>;
    }>;
  };
};

export type GetCalibrationScoresTrendsQueryVariables = Exact<{
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
}>;

export type GetCalibrationScoresTrendsQuery = {
  qaFormCalibrationScores: {
    alignedAnswersCount: number;
    alignmentScore: number;
    answersCount: number;
    calibrationsCount: number;
    dates: Array<any>;
    qaForm: { id: string; name: string };
    qaFormSectionCalibrationScores: Array<{
      alignedAnswersCount: number;
      alignmentScore: number;
      answersCount: number;
      calibrationsCount: number;
      dates: Array<any>;
      qaFormSection: { id: string; title: string };
      qaQuestionCalibrationScores: Array<{
        alignedAnswersCount: number;
        alignmentScore: number;
        answersCount: number;
        calibrationsCount: number;
        qaCalibrations: Array<{ id: string }>;
        qaQuestion: { id: string; text: string };
      }>;
      trend: { alignmentScores: Array<number> };
    }>;
    trend: { alignmentScores: Array<number> };
  };
};

export type GetCoacheesDataQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filters: CoacheesDataFilterInput;
  search?: InputMaybe<Array<CoacheesDataSearchInput> | CoacheesDataSearchInput>;
  sort?: InputMaybe<Array<CoacheesDataSortInput> | CoacheesDataSortInput>;
}>;

export type GetCoacheesDataQuery = {
  coacheesData: {
    totalCount: number;
    edges: Array<{
      node: {
        entityId: number;
        entityType: string;
        name: string;
        imageUrl: string;
        closedActionItemsCount: number;
        sessionsCount: number;
        lastSession: any;
        lastSessionId: number;
        openActionItemsCount: number;
        draftCoachingSessionId: number;
        parentName: string;
      };
    }>;
    pageInfo: {
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
    };
  };
};

export type GetCoachingSessionsQueryVariables = Exact<{
  employeeId: Scalars['ID'];
  dateRange?: InputMaybe<DateRangeInput>;
  sort?: InputMaybe<Array<CoachingSessionSortInput> | CoachingSessionSortInput>;
  after?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CoachingSessionStatusEnum>;
  first?: InputMaybe<Scalars['Int']>;
}>;

export type GetCoachingSessionsQuery = {
  employee: {
    id: string;
    coachingSessions: {
      totalCount: number;
      edges: Array<{
        node: {
          id: string;
          title: string;
          createdAt: any;
          updatedAt: any;
          sharedAt: any;
          coach: {
            id: string;
            isActive: boolean;
            profile: {
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              imageUrl: string;
            };
          };
        };
      }>;
      pageInfo: {
        endCursor: string;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string;
      };
    };
  };
};

export type GetCoachingSessionActionItemsQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
  dateRange: DateRangeInput;
  sort?: InputMaybe<Array<TakeawaySortInput> | TakeawaySortInput>;
  openInDateRangeFirst?: InputMaybe<Scalars['Int']>;
  openInDateRangeAfter?: InputMaybe<Scalars['String']>;
  openOutsideDateRangeFirst?: InputMaybe<Scalars['Int']>;
  openOutsideDateRangeAfter?: InputMaybe<Scalars['String']>;
  closedInDateRangeFirst?: InputMaybe<Scalars['Int']>;
  closedInDateRangeAfter?: InputMaybe<Scalars['String']>;
  includeClosedItems?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCoachingSessionActionItemsQuery = {
  openInDateRange: {
    categories: Array<{ id: string; name: string; count: number }>;
    collection: {
      totalCount: number;
      edges: Array<{
        node: {
          id: string;
          text: string;
          completedAt: any;
          createdAt: any;
          dueDate: any;
          createdBy: { id: string; profile: { id: string; fullName: string } };
          owner: { id: string; profile: { fullName: string; id: string; imageUrl: string } };
          takeawayCategory: { id: string; name: string };
          coachingSession: { id: string };
          permissions: { completable: boolean };
        };
      }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
  };
  openOutsideDateRange: {
    collection: {
      totalCount: number;
      edges: Array<{
        node: {
          id: string;
          text: string;
          completedAt: any;
          createdAt: any;
          dueDate: any;
          createdBy: { id: string; profile: { id: string; fullName: string } };
          owner: { id: string; profile: { fullName: string; id: string; imageUrl: string } };
          takeawayCategory: { id: string; name: string };
          coachingSession: { id: string };
          permissions: { completable: boolean };
        };
      }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
  };
  closedInDateRange: {
    collection: {
      totalCount: number;
      edges: Array<{
        node: {
          id: string;
          text: string;
          completedAt: any;
          createdAt: any;
          dueDate: any;
          createdBy: { id: string; profile: { id: string; fullName: string } };
          owner: { id: string; profile: { fullName: string; id: string; imageUrl: string } };
          takeawayCategory: { id: string; name: string };
          coachingSession: { id: string };
          permissions: { completable: boolean };
        };
      }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
  };
};

export type GetcoachingSessionInteractionAttachmentsQueryVariables = Exact<{
  id: Scalars['ID'];
  employeeId: Scalars['ID'];
}>;

export type GetcoachingSessionInteractionAttachmentsQuery = {
  coachingSession: {
    id: string;
    interactionAttachments: {
      nodes: Array<{
        id: string;
        notes: string;
        summary: string;
        followUp: {
          id: string;
          note: string;
          employee: { id: string };
          createdBy: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
          followUpable:
            | {
                __typename: 'Interaction';
                id: string;
                extInteractionId: string;
                resolvedAt: any;
                canShowSummary: boolean;
                reviews: {
                  nodes: Array<
                    | { __typename: 'QaReviewCalibration' }
                    | { __typename: 'QaReviewRegular'; id: string; score: number; date: any }
                  >;
                };
                solicitations: {
                  nodes: Array<{
                    __typename: 'Solicitation';
                    id: string;
                    uuid: string;
                    recovered: boolean;
                    date: any;
                    surveyAnswers: {
                      nodes: Array<{
                        id: string;
                        surveyQuestionId: string;
                        surveyOptions: Array<{ id: string }>;
                      }>;
                    };
                  }>;
                };
              }
            | { __typename: 'QaReviewRegular' }
            | { __typename: 'Solicitation' };
        };
      }>;
    };
  };
};

export type GetCoachingTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetCoachingTemplateQuery = {
  coachingTemplate: { body: string; id: string; name: string };
};

export type GetCoachingTemplatesQueryVariables = Exact<{
  includeArchived?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCoachingTemplatesQuery = {
  coachingTemplates: {
    nodes: Array<{
      body: string;
      createdAt: any;
      id: string;
      name: string;
      status: CoachingTemplateStatusEnum;
      updatedAt: any;
      usageCount: number;
      creator:
        | { __typename: 'Company'; name: string; logoUrl: string }
        | {
            __typename: 'Employee';
            id: string;
            profile: { fullName: string; id: string; imageUrl: string };
          };
      lastUpdatedBy: { id: string; profile: { id: string; fullName: string } };
    }>;
  };
};

export type GetCoachingTemplateHistoryQueryVariables = Exact<{
  templateId: Scalars['ID'];
}>;

export type GetCoachingTemplateHistoryQuery = {
  coachingTemplate: { id: string; name: string };
  coachingTemplateHistory: {
    collection: Array<{
      attributeName: string;
      createdAt: any;
      event: string;
      valueAfter: string;
      valueBefore: string;
      actor:
        | { __typename: 'Company'; name: string; logoUrl: string }
        | {
            __typename: 'Employee';
            id: string;
            profile: { fullName: string; id: string; imageUrl: string };
          };
    }>;
  };
};

export type GetCoachingTopicsQueryVariables = Exact<{
  sessionId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type GetCoachingTopicsQuery = {
  coachingTopics: {
    collection: Array<{
      id: string;
      topic: string;
      order: number;
      addedToSessionAt: any;
      createdAt: any;
      updatedAt: any;
      references: Array<{ link: string; parsed: any }>;
      coachingSession: { id: string };
      negativeFeedback: { id: string; feedbackReason: string; comment: string; createdAt: any };
    }>;
    metadata: {
      totalPages: number;
      totalCount: number;
      limitValue: number;
      fetchingStatus: string;
      currentPage: number;
    };
  };
};

export type GetCompanySettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanySettingsQuery = {
  company: {
    id: string;
    profileImageSetting: CompanyProfileImageSetting;
    customerVisibility: CompanyCustomerVisibilityEnum;
    defaultProfilePictureUrl: string;
    guidelineProfile: string;
    brands: Array<{ name: string; id: string }>;
  };
};

export type GetCondensedAssignmentPeriodsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type GetCondensedAssignmentPeriodsQuery = {
  qaAssignmentPeriods: {
    collection: Array<{ id: string; startDate: any; endDate: any }>;
    metadata: { totalPages: number; totalCount: number; currentPage: number; limitValue: number };
  };
};

export type GetCountriesListQueryVariables = Exact<{ [key: string]: never }>;

export type GetCountriesListQuery = { countries: Array<{ code: string; name: string }> };

export type GetCriteriaListQueryVariables = Exact<{ [key: string]: never }>;

export type GetCriteriaListQuery = {
  reportingGroupCriterionTypeObjects: Array<{
    operators: Array<ReportingGroupCriterionOperatorEnum>;
    periods: Array<ReportingGroupCriterionPeriodEnum>;
    criterionType: ReportingGroupCriterionTypeEnum;
  }>;
};

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetEmployeeQuery = {
  employee: {
    id: string;
    demotable: boolean;
    status: StatusEnum;
    deactivated: boolean;
    startDate: any;
    licenseType: LicenseTypeEnum;
    lastActive: any;
    email: string;
    customEmployeeId: string;
    employmentStatus: EmploymentStatusEnum;
    channels: Array<ChannelTypeEnum>;
    profile: {
      id: string;
      fullName: string;
      firstName: string;
      hometown: string;
      imageUrl: string;
      location: string;
      lastName: string;
      stateOrCountry: string;
      text: string;
    };
    supervisor: { id: string; fullName: string };
    primaryTeam: { id: string; owner: { id: string; profile: { id: string; fullName: string } } };
    customRole: { id: string; name: string };
    employeeGroups: Array<{ id: string; name: string }>;
    reportingGroups: Array<{ id: string; name: string }>;
  };
};

export type GetEmployeesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Array<EmployeeSearchInput> | EmployeeSearchInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  includePrimaryTeam?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetEmployeesQuery = {
  employees: {
    totalCount: number;
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        canManageTeams: boolean;
        profile: {
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          imageUrl: string;
        };
        primaryTeam?: { id: string; agentsCount: number };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetEmployeesAndChildTeamsQueryVariables = Exact<{
  teamFilters?: InputMaybe<TeamFilterInput>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  afterEmployees?: InputMaybe<Scalars['String']>;
  firstEmployees?: InputMaybe<Scalars['Int']>;
  afterChildren?: InputMaybe<Scalars['String']>;
  firstChildren?: InputMaybe<Scalars['Int']>;
  employeeFilters?: InputMaybe<EmployeeFilterInput>;
  productArea?: InputMaybe<ProductArea>;
  between?: InputMaybe<DateRangeInput>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetEmployeesAndChildTeamsQuery = {
  teams: {
    nodes: Array<{
      id: string;
      name: string;
      active: boolean;
      label: string;
      employees: {
        nodes: Array<{
          id: string;
          isActive: boolean;
          profile: {
            id: string;
            firstName: string;
            lastName: string;
            fullName: string;
            imageUrl: string;
          };
        }>;
        pageInfo: { endCursor: string; hasNextPage: boolean };
      };
      children: {
        nodes: Array<{
          id: string;
          name: string;
          active: boolean;
          label: string;
          owner: {
            id: string;
            isActive: boolean;
            profile: {
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              imageUrl: string;
            };
          };
        }>;
        pageInfo: { endCursor: string; hasNextPage: boolean };
      };
      owner: {
        id: string;
        isActive: boolean;
        profile: {
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          imageUrl: string;
        };
      };
    }>;
  };
};

export type GetEmployeesFilterDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Array<EmployeeSearchInput> | EmployeeSearchInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  sort?: InputMaybe<Array<EmployeeSortInput> | EmployeeSortInput>;
  productArea?: InputMaybe<ProductArea>;
}>;

export type GetEmployeesFilterDataQuery = {
  employees: {
    totalCount: number;
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        profile: { id: string; fullName: string; imageUrl: string };
        primaryTeam: { id: string; name: string };
        reportingGroups: Array<{ id: string; name: string }>;
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetEmployeeBadgesQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']>;
  badgeType?: InputMaybe<AchievementBadgeType>;
  badgeKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;

export type GetEmployeeBadgesQuery = {
  employeeBadges: {
    nodes: Array<{
      badgeKey: string;
      count: number;
      description: string;
      earnedAt: any;
      id: string;
      imageUrl: string;
      name: string;
      iconSettings: any;
      status: string;
      threshold: number;
      companyAchievement: {
        id: string;
        pathName: string;
        achievementCategory: { id: string; identifier: string; imageUrl: string };
      };
    }>;
  };
};

export type GetEmployeeCoachingSessionActionItemsQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<TakeawayStatusEnum>;
  sort?: InputMaybe<Array<TakeawaySortInput> | TakeawaySortInput>;
  sessionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  otherSessionItemsFirst?: InputMaybe<Scalars['Int']>;
  otherSessionItemsAfter?: InputMaybe<Scalars['String']>;
  includeCategories?: InputMaybe<Scalars['Boolean']>;
  includeOtherSessionItems?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetEmployeeCoachingSessionActionItemsQuery = {
  coachingSessionActionItems: {
    categories?: Array<{ id: string; name: string; count: number }>;
    collection: {
      totalCount: number;
      edges: Array<{
        node: {
          id: string;
          text: string;
          completedAt: any;
          createdAt: any;
          dueDate: any;
          createdBy: { id: string; profile: { id: string; fullName: string } };
          owner: { id: string; profile: { fullName: string; id: string; imageUrl: string } };
          takeawayCategory: { id: string; name: string };
          coachingSession: { id: string };
          permissions: { completable: boolean };
        };
      }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
  };
  otherSessionActionItems: {
    collection: {
      totalCount: number;
      edges: Array<{
        node: {
          id: string;
          text: string;
          completedAt: any;
          createdAt: any;
          dueDate: any;
          createdBy: { id: string; profile: { id: string; fullName: string } };
          owner: { id: string; profile: { fullName: string; id: string; imageUrl: string } };
          takeawayCategory: { id: string; name: string };
          coachingSession: { id: string };
          permissions: { completable: boolean };
        };
      }>;
      pageInfo: { endCursor: string; hasNextPage: boolean };
    };
  };
};

export type GetEmployeeForEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetEmployeeForEditQuery = {
  employee: {
    id: string;
    demotable: boolean;
    status: StatusEnum;
    deactivated: boolean;
    startDate: any;
    licenseType: LicenseTypeEnum;
    lastActive: any;
    email: string;
    canManageTeams: boolean;
    customEmployeeId: string;
    employmentStatus: EmploymentStatusEnum;
    channels: Array<ChannelTypeEnum>;
    profileForEdit: {
      id: string;
      countryCode: string;
      fullName: string;
      firstName: string;
      hometown: string;
      imageUrl: string;
      location: string;
      lastName: string;
      stateOrCountry: string;
      text: string;
    };
    supervisor: { id: string; fullName: string; primaryTeam: { id: string; name: string } };
    primaryTeam: {
      id: string;
      name: string;
      owner: { id: string; profile: { id: string; fullName: string } };
    };
    customRole: { id: string; name: string; legacy: boolean; roleTemplate: string };
    employeeGroups: Array<{ id: string; name: string }>;
    reportingGroups: Array<{ id: string; name: string; active: boolean }>;
  };
};

export type GetEmployeeForFilterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetEmployeeForFilterQuery = {
  employee: {
    id: string;
    deactivated: boolean;
    email: string;
    customEmployeeId: string;
    profile: { id: string; firstName: string; imageUrl: string; lastName: string };
    primaryTeam: { id: string };
  };
};

export type GetEmployeeLifetimeCountersQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']>;
  badgeKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;

export type GetEmployeeLifetimeCountersQuery = {
  lifetimeBadges: {
    nodes: Array<{
      badgeKey: string;
      count: number;
      id: string;
      name: string;
      companyAchievement: { id: string; achievementCategory: { id: string; identifier: string } };
    }>;
  };
};

export type GetEmployeeReportingGropsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetEmployeeReportingGropsQuery = {
  employee: { id: string; reportingGroups: Array<{ id: string; name: string }> };
};

export type GetExportsQueryVariables = Exact<{
  exportType: ExportTypeEnum;
}>;

export type GetExportsQuery = {
  exports: Array<{
    id: string;
    expired: boolean;
    state: string;
    createdAt: any;
    updatedAt: any;
    exportType: string;
    s3Url: string;
  }>;
};

export type GetExportsPaginatedQueryVariables = Exact<{
  exportType?: InputMaybe<ExportTypeEnum>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;

export type GetExportsPaginatedQuery = {
  exportsWithCursor: {
    nodes: Array<{
      createdAt: any;
      expired: boolean;
      exportType: string;
      fieldsCount: number;
      id: string;
      options: any;
      s3Url: string;
      state: string;
      updatedAt: any;
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean };
  };
};

export type GetExportsStateQueryVariables = Exact<{
  exportType: ExportTypeEnum;
}>;

export type GetExportsStateQuery = { exportsState: { inProgress: boolean; unread: boolean } };

export type GetFeedbackExportFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFeedbackExportFieldsQuery = {
  CUSTOM_PROPERTIES: Array<{ id: string; label: string }>;
  SURVEY_RESPONSE: Array<{ id: string; label: string }>;
};

export type GetFeedbackExportSectionsQueryVariables = Exact<{
  includeFields?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetFeedbackExportSectionsQuery = {
  feedbackExportSections: {
    nodes: Array<{
      id: ExportSectionId;
      includeFutureQuestionField: string;
      label: string;
      order: number;
      parentSectionLabel: string;
      surveyType: Survey;
      fields?: Array<{ id: string; order: number; label: string; usedIn: Array<string> }>;
    }>;
  };
};

export type GetFeedbackExportTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetFeedbackExportTemplateQuery = {
  feedbackExportTemplate: {
    id: string;
    name: string;
    preselectedDateRange: FeedbackExportDateRangeEnum;
    includeArchived: boolean;
    withResponses: boolean;
    surveyType: Array<Survey>;
    startOfWeek: string;
    startDate: any;
    endDate: any;
    fieldSectionOptions: { surveyResponse: { includeFutureQuestions: boolean } };
    startOfQuarter: { month: number; day: number };
    fields: Array<{
      id: string;
      selected: boolean;
      type: Field;
      label: string;
      status: FieldStatus;
      section: Section;
      usedIn: Array<string>;
    }>;
    schedule: {
      month: number;
      week: number;
      dayOfWeek: WeekdayEnum;
      dayOfMonth: number;
      day: number;
      hour: number;
    };
  };
};

export type GetFeedbackExportTemplatesQueryVariables = Exact<{
  templateType?: InputMaybe<Template>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type GetFeedbackExportTemplatesQuery = {
  feedbackExportTemplates: {
    nodes: Array<{
      id: string;
      name: string;
      fieldsCount: number;
      startDate: any;
      endDate: any;
      preselectedDateRange: FeedbackExportDateRangeEnum;
      createdAt: any;
      includeArchived: boolean;
      withResponses: boolean;
      surveyType: Array<Survey>;
      startOfWeek: string;
      startOfQuarter: { month: number; day: number };
      fields: Array<{ id: string; selected: boolean; type: Field }>;
      schedule: {
        month: number;
        week: number;
        dayOfWeek: WeekdayEnum;
        dayOfMonth: number;
        day: number;
        hour: number;
      };
    }>;
    pageInfo: {
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
    };
  };
};

export type GetFollowUpsQueryVariables = Exact<{
  filters?: InputMaybe<FollowUpFilterInput>;
  employeeId: Scalars['ID'];
}>;

export type GetFollowUpsQuery = {
  followUps: {
    nodes: Array<{
      id: string;
      note: string;
      employee: { id: string };
      createdBy: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
      followUpable:
        | {
            __typename: 'Interaction';
            id: string;
            extInteractionId: string;
            resolvedAt: any;
            canShowSummary: boolean;
            reviews: {
              nodes: Array<
                | { __typename: 'QaReviewCalibration' }
                | { __typename: 'QaReviewRegular'; id: string; score: number; date: any }
              >;
            };
            solicitations: {
              nodes: Array<{
                __typename: 'Solicitation';
                id: string;
                uuid: string;
                recovered: boolean;
                date: any;
                surveyAnswers: {
                  nodes: Array<{
                    id: string;
                    surveyQuestionId: string;
                    surveyOptions: Array<{ id: string }>;
                  }>;
                };
              }>;
            };
          }
        | { __typename: 'QaReviewRegular' }
        | { __typename: 'Solicitation' };
    }>;
  };
};

export type GetGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EmployeeGroupStatusEnum>;
}>;

export type GetGroupsQuery = {
  employeeGroups: {
    edges: Array<{
      node: {
        id: string;
        name: string;
        status: EmployeeGroupStatusEnum;
        members: Array<{ id: string }>;
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetReportingGroupPreviewQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  criteriaAttributes?: InputMaybe<
    Array<CreateReportingGroupCriterionAttributes> | CreateReportingGroupCriterionAttributes
  >;
  first?: InputMaybe<Scalars['Int']>;
  matchAll?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetReportingGroupPreviewQuery = {
  reportingGroupParticipantsPreview: {
    totalCount: number;
    edges: Array<{
      node: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
    }>;
    pageInfo: {
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
    };
  };
};

export type GetInteractionsQueryVariables = Exact<{
  filters: InteractionFilterInput;
  sort?: InputMaybe<Array<InteractionSortInput> | InteractionSortInput>;
  search?: InputMaybe<Array<InteractionSearchInput> | InteractionSearchInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  includeSummary?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['ID']>;
}>;

export type GetInteractionsQuery = {
  interactions: {
    nodes: Array<{
      id: string;
      extInteractionId: string;
      resolvedAt: any;
      summary?: string;
      solicitations: {
        nodes: Array<{
          id: string;
          recovered: boolean;
          respondedAt: any;
          surveyAnswers: {
            nodes: Array<{
              id: string;
              surveyQuestionId: string;
              surveyOptions: Array<{ id: string }>;
            }>;
          };
        }>;
      };
      reviews: { nodes: Array<{ id: string } | {}> };
      followUps: { nodes: Array<{ id: string; createdBy: { id: string } }> };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean };
  };
};

export type GetInteractionSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetInteractionSummaryQuery = { interaction: { id: string; summary: string } };

export type GetLeaderboardQueryVariables = Exact<{
  interval?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  reportingGroupIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetLeaderboardQuery = {
  leaderboard: {
    topAgents: Array<{
      count: number;
      delta: number;
      fullName: string;
      id: string;
      image: string;
      prevRank: number;
      rank: number;
      rating: string;
    }>;
    intervals: Array<{ label: string; value: string }>;
    config: {
      intervals: Array<string>;
      activeInterval: string;
      showStar: boolean;
      metricTitle: string;
      thresholds: { day: number; week: number; month: number; quarter: number; year: number };
    };
  };
  channels: Array<{ id: string; active: boolean; name: string; slug: string }>;
};

export type GetLeaderboardTeamsAndGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  afterTeams?: InputMaybe<Scalars['String']>;
  searchTeam?: InputMaybe<Array<TeamSearchInput> | TeamSearchInput>;
  afterReportingGroups?: InputMaybe<Scalars['String']>;
  searchGroup?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TeamFilterInput>;
}>;

export type GetLeaderboardTeamsAndGroupsQuery = {
  teams: {
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        owner: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
        parent: { id: string };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
  reportingGroups: {
    edges: Array<{ cursor: string; node: { id: string; name: string } }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetMentionableEmployeesQueryVariables = Exact<{
  filters?: InputMaybe<EmployeeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Array<EmployeeSearchInput> | EmployeeSearchInput>;
}>;

export type GetMentionableEmployeesQuery = {
  employeesMentionable: {
    collection: Array<{
      id: string;
      canManageTeams: boolean;
      profile: { id: string; fullName: string; imageUrl: string };
      primaryTeam: { id: string; name: string };
    }>;
    metadata: { totalPages: number; totalCount: number; currentPage: number; limitValue: number };
  };
};

export type GetMetricsDataQueryVariables = Exact<{
  filters: MetricFilterInput;
  metrics: Array<MetricInput> | MetricInput;
}>;

export type GetMetricsDataQuery = {
  calculateMetrics: Array<{
    max: number;
    min: number;
    title: string;
    customTitle: string;
    value: number;
    metricName: MetricNameEnum;
    displayValue: string;
    totalResults: any;
    higherIsBetter: boolean;
    questionIdentifier: string;
  }>;
};

export type GetMetricByGroupQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  filters: MetricFilterInput;
  metric: MetricInput;
  groupBy: MetricGroupByEnum;
}>;

export type GetMetricByGroupQuery = {
  company: {
    id: string;
    channels: Array<{ id: string; name: string; slug: string; active: boolean }>;
    qaForms: Array<{ id: string; name: string; slug: string; active: boolean }>;
  };
  calculateMetricByGroup: {
    edges: Array<{
      cursor: string;
      node: {
        groupValue: string;
        metricResult: {
          value: number;
          displayValue: string;
          higherIsBetter: boolean;
          totalResults: any;
        };
      };
    }>;
    pageInfo: { hasNextPage: boolean; hasPreviousPage: boolean; endCursor: string };
  };
};

export type GetMetricConfigsQueryVariables = Exact<{
  metricConfigType?: InputMaybe<Array<MetricConfigTypeEnum> | MetricConfigTypeEnum>;
}>;

export type GetMetricConfigsQuery = {
  metricConfigs: Array<{
    higherIsBetter: boolean;
    availableFilters: Array<string>;
    availableGroupBy: Array<MetricGroupByEnum>;
    defaultGroupBy: MetricGroupByEnum;
    id: string;
    metricName: MetricNameEnum;
    order: number;
    questionIdentifier: string;
    title: string;
    customTitle: string;
    type: MetricConfigTypeEnum;
    min: number;
    max: number;
    targetAnswers: Array<string>;
    denominator: string;
    nickname: string;
    questionText: string;
    questionType: string;
  }>;
};

export type GetMetricDataQueryVariables = Exact<{
  filters: MetricFilterInput;
  metric: MetricInput;
}>;

export type GetMetricDataQuery = {
  calculateMetricTrend: {
    displayValue: string;
    higherIsBetter: boolean;
    max: number;
    min: number;
    title: string;
    totalResults: any;
    value: number;
  };
};

export type GetMetricGoalsQueryVariables = Exact<{
  dateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<GoalStatusEnum>;
  employeeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  teamIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  skipTeams: Scalars['Boolean'];
  skipEmployees: Scalars['Boolean'];
}>;

export type GetMetricGoalsQuery = {
  teamMetricGoals: {
    pageInfo: { endCursor: string; startCursor: string; hasNextPage: boolean };
    edges: Array<{
      node:
        | {
            id: string;
            archivedAt: any;
            completedAt: any;
            createdAt: any;
            displayValue: string;
            goal: number;
            title: string;
            threshold: number;
            startedAt: any;
            endedAt: any;
            reachedCount: number;
            creator: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
            group: { id: string; agentsCount: number };
            metricConfig: {
              metricName: MetricNameEnum;
              title: string;
              id: string;
              min: number;
              max: number;
            };
            permissions: { canCompleteActionItems: boolean; canManageGoal: boolean };
          }
        | {};
    }>;
  };
  employeeMetricGoals: {
    pageInfo: { endCursor: string; startCursor: string; hasNextPage: boolean };
    edges: Array<{
      node:
        | {
            id: string;
            archivedAt: any;
            completedAt: any;
            createdAt: any;
            displayValue: string;
            goal: number;
            title: string;
            threshold: number;
            startedAt: any;
            endedAt: any;
            reachedCount: number;
            actionItems: Array<{
              action: string;
              completedAt: any;
              createdAt: any;
              id: string;
              actionable: { id: string } | {};
            }>;
            creator: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
            metricConfig: {
              metricName: MetricNameEnum;
              title: string;
              id: string;
              min: number;
              max: number;
            };
            permissions: { canCompleteActionItems: boolean; canManageGoal: boolean };
          }
        | {};
    }>;
  };
  freeformGoals: {
    pageInfo: { endCursor: string; startCursor: string; hasNextPage: boolean };
    edges: Array<{
      node: {
        archivedAt: any;
        completedAt: any;
        createdAt: any;
        startedAt: any;
        endedAt: any;
        id: string;
        displayValue: string;
        actionItems: Array<{
          action: string;
          completedAt: any;
          createdAt: any;
          id: string;
          actionable: { id: string } | {};
        }>;
        creator: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
        permissions: { canCompleteActionItems: boolean; canManageGoal: boolean };
      };
    }>;
  };
};

export type GetMetricTrendByGroupQueryVariables = Exact<{
  filters: MetricFilterInput;
  metric: MetricInput;
  groupBy: MetricGroupByEnum;
  interval?: InputMaybe<TimePeriodEnum>;
}>;

export type GetMetricTrendByGroupQuery = {
  calculateMetricTrendByGroup: {
    dates: Array<any>;
    totalPercentage: number;
    displayPercentage: string;
    title: string;
    totalResults: any;
    nickname: string;
    questionIdentifier: string;
    dateRanges: Array<{ endDate: any; startDate: any }>;
    timeSeries: Array<{
      displayValues: Array<string>;
      values: Array<number>;
      totalResults: Array<number>;
      name: string;
      displayPercentages: Array<string>;
      totalPercentages: Array<number>;
      targetAnswers: Array<string>;
    }>;
  };
};

export type GetMyQaAssignmentsQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<MyQaAssignmentSortInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type GetMyQaAssignmentsQuery = {
  myQaAssignments: {
    collection: Array<{
      id: string;
      name: string;
      cadence: string;
      numberOfDays: number;
      progress: number;
      assigned: number;
      assignedBefore: number;
      completed: number;
      skipped: number;
      totalReviewers: number;
      totalReviewees: number;
      initialStartDate: any;
      startDate: any;
      endDate: any;
      archivedAt: any;
      effectiveAt: any;
      createdAt: any;
      updatedAt: any;
      qaFormId: string;
      qaReviewType: string;
      revieweesStats: { added: number; removed: number };
      reviewersStats: { added: number; removed: number };
    }>;
    metadata: { currentPage: number; limitValue: number; totalCount: number; totalPages: number };
  };
};

export type GetMyQaAssignmentsStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyQaAssignmentsStatusQuery = { myQaAssignmentsStatus: { isChanged: boolean } };

export type GetMyQaAssignmentsStatusDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyQaAssignmentsStatusDetailsQuery = {
  myQaAssignmentsStatus: {
    isChanged: boolean;
    assigned: number;
    assignedBefore: number;
    totalAssignmentsAffected: number;
    revieweesStats: { added: number; allPeriod: number; removed: number; total: number };
    reviewersStats: { added: number; allPeriod: number; removed: number; total: number };
  };
};

export type GetPaginatedUsersDataQueryVariables = Exact<{
  filters?: InputMaybe<EmployeeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<EmployeeSortInput> | EmployeeSortInput>;
}>;

export type GetPaginatedUsersDataQuery = {
  employeesPaginated: {
    collection: Array<{
      id: string;
      canManageTeams: boolean;
      demotable: boolean;
      status: StatusEnum;
      lastActive: any;
      email: string;
      profile: { id: string; fullName: string; imageUrl: string };
      primaryTeam: {
        id: string;
        agentsCount: number;
        owner: { id: string; profile: { id: string; fullName: string } };
      };
      supervisor: { id: string; fullName: string };
      customRole: { id: string; name: string; legacy: boolean; roleTemplate: string };
    }>;
    metadata: { currentPage: number; limitValue: number; totalCount: number; totalPages: number };
  };
};

export type GetPastGoalsQueryVariables = Exact<{
  filters: PastGoalFilterInput;
}>;

export type GetPastGoalsQuery = {
  pastGoals: {
    pageInfo: { endCursor: string; startCursor: string; hasNextPage: boolean };
    edges: Array<{
      node: {
        id: string;
        archivedAt: any;
        completedAt: any;
        createdAt: any;
        title: string;
        startedAt: any;
        endedAt: any;
        creator: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
      };
    }>;
  };
};

export type GetPropertiesFilterDataQueryVariables = Exact<{
  propertyKeyId?: InputMaybe<Scalars['ID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  filterValues?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;

export type GetPropertiesFilterDataQuery = {
  properties: {
    edges: Array<{ cursor: string; node: { value: string; id: string } }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetQaCalibrationQueryVariables = Exact<{
  id: Scalars['ID'];
  currentPersonId: Scalars['ID'];
}>;

export type GetQaCalibrationQuery = {
  qaCalibration: {
    id: string;
    completedAt: any;
    alignmentScore: number;
    meetingAt: any;
    notes: string;
    status: QaCalibrationStatusEnum;
    interactionId: string;
    participants: { totalCount: number };
    employee: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
    currentPersonReview: {
      nodes: Array<{
        id: string;
        completedAt: any;
        interaction: { id: string; interactionEvents: Array<{ id: string }> };
      }>;
    };
    firstReview: {
      nodes: Array<{
        id: string;
        interaction: { id: string; interactionEvents: Array<{ id: string }> };
      }>;
    };
    completedReviews: { totalCount: number };
  };
};

export type GetQaCalibrationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<QaCalibrationsFilterInput>;
  sort?: InputMaybe<SortInput>;
  currentPersonId?: InputMaybe<Scalars['ID']>;
  includeCurrentPersonReview?: Scalars['Boolean'];
}>;

export type GetQaCalibrationsQuery = {
  qaCalibrations: {
    metadata: { currentPage: number; limitValue: number; totalCount: number; totalPages: number };
    collection: Array<{
      id: string;
      meetingAt: any;
      status: QaCalibrationStatusEnum;
      alignmentScore: number;
      completedAt: any;
      createdAt: any;
      interactionId: string;
      participants: {
        totalCount: number;
        edges: Array<{
          node: { id: string; profile: { id: string; imageUrl: string; fullName: string } };
        }>;
      };
      employee: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
      completedReviews: { totalCount: number };
      currentPersonReview: { nodes: Array<{ id: string; completedAt: any }> };
    }>;
  };
};

export type GetQaCalibrationReviewsQueryVariables = Exact<{
  id: Scalars['ID'];
  status?: InputMaybe<QaCalibrationReviewStatusEnum>;
  search?: InputMaybe<Array<QaCalibrationReviewSearchInput> | QaCalibrationReviewSearchInput>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;

export type GetQaCalibrationReviewsQuery = {
  qaCalibration: {
    id: string;
    qaReviews: {
      totalCount: number;
      edges: Array<{
        node: {
          id: string;
          completedAt: any;
          startedAt: any;
          reviewer: { id: string; profile: { id: string; fullName: string; imageUrl: string } };
        };
      }>;
      pageInfo: { hasNextPage: boolean; endCursor: string };
    };
  };
};

export type GetQaFormsQueryVariables = Exact<{
  type?: InputMaybe<QaFormTypeEnum>;
  archived?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
}>;

export type GetQaFormsQuery = {
  qaForms: {
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        name: string;
        type: QaFormTypeEnum;
        editable: boolean;
        archived: boolean;
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetQaFormDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetQaFormDetailsQuery = { qaForm: { id: string; name: string } };

export type GetQaReviewHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetQaReviewHistoryQuery = {
  qaHistory: {
    collection: Array<{
      attributeName: string;
      createdAt: any;
      event: string;
      valueAfter: string;
      valueBefore: string;
      item:
        | {
            __typename: 'QaAnswer';
            id: string;
            updatedAt: any;
            qaQuestion: {
              id: string;
              text: string;
              position: number;
              qaFormSection: { id: string; title: string; position: number };
              qaOptions: Array<{ id: string; text: string }>;
            };
            qaOption: { id: string; text: string };
          }
        | { __typename: 'QaReviewRegular'; id: string };
      employee: { id: string; profile: { fullName: string; id: string; imageUrl: string } };
    }>;
  };
};

export type GetRecentlyCoachedEmployeesQueryVariables = Exact<{
  dateRange: DateRangeInput;
  isRoot?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;

export type GetRecentlyCoachedEmployeesQuery = {
  coacheesData: {
    edges: Array<{
      node: { entityId: number; entityType: string; name: string; imageUrl: string };
    }>;
  };
};

export type GetReportingGroupWithCriteriaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetReportingGroupWithCriteriaQuery = {
  reportingGroup: {
    active: boolean;
    color: string;
    createdAt: any;
    description: string;
    emoji: string;
    hidden: boolean;
    filterable: boolean;
    id: string;
    image: string;
    matchAll: boolean;
    name: string;
    parentId: string;
    streamFooterDisplayable: boolean;
    updatedAt: any;
    criteria: Array<{
      criterionType: ReportingGroupCriterionTypeEnum;
      id: string;
      operator: ReportingGroupCriterionOperatorEnum;
      period: ReportingGroupCriterionPeriodEnum;
      periodValue: string;
      value: string;
    }>;
  };
};

export type GetReportingGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ReportingGroupFilterInput>;
  employeeFilters?: InputMaybe<EmployeeFilterInput>;
  productArea?: InputMaybe<ProductArea>;
  between?: InputMaybe<DateRangeInput>;
}>;

export type GetReportingGroupsQuery = {
  reportingGroups: {
    edges: Array<{
      node: {
        id: string;
        name: string;
        color: string;
        emoji: string;
        image: string;
        members: { totalCount: number; nodes: Array<{ id: string }> };
        children: {
          totalCount: number;
          nodes: Array<{ id: string; name: string; members: { totalCount: number } }>;
        };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetReportingTimestampConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetReportingTimestampConfigQuery = {
  dateFilterConfig: { solicitationReportingTimestamp: SolicitationReportingTimestampEnum };
};

export type GetResponseTagsQueryVariables = Exact<{
  responseTag?: InputMaybe<Array<ResponseTagTypeEnum> | ResponseTagTypeEnum>;
}>;

export type GetResponseTagsQuery = {
  responseTags: Array<{
    caption: string;
    id: string;
    iconName: string;
    imageUrl: string;
    identifier: string;
  }>;
};

export type GetReviewerStatsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  filters: QaReviewFilterInput;
  sort?: InputMaybe<ReviewerSortInput>;
}>;

export type GetReviewerStatsQuery = {
  reviewerStats: {
    collection: Array<{
      id: string;
      firstName: string;
      fullName: string;
      imageUrl: string;
      reviewsTotal: { current: number; previous: number };
      averageAuditAlignmentScore: { current: number; delta: number; previous: number };
      averageAuditScore: { current: number; delta: number; previous: number };
      averageQaScore: { delta: number; previous: number; current: number };
    }>;
    metadata: { currentPage: number; totalCount: number; totalPages: number; limitValue: number };
  };
};

export type GetReviewStatsQueryVariables = Exact<{
  filters: QaReviewFilterInput;
  skipCalibrationAudit?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetReviewStatsQuery = {
  calibrationStats: {
    averageAlignmentScore: number;
    calibrationsTotal: number;
    calibrationsTotalByRanges: Array<number>;
  };
  auditStats: {
    auditsTotal: number;
    auditorsTotal: number;
    averageAuditScoreByRanges: Array<number>;
    averageAuditScore: { current: number; delta: number; previous: number };
  };
  calibrationAuditStats: {
    auditsTotal: number;
    auditorsTotal: number;
    averageAuditScoreByRanges: Array<number>;
    averageAuditScore: { current: number; delta: number; previous: number };
  };
  reviewStats: {
    qaScoreStandardDeviation: number;
    qaAssignmentsAssigned: number;
    averageQaScoreByRanges: Array<number>;
    reviewsTotalByRanges: Array<number>;
    reviewsTotal: { current: number; delta: number; previous: number };
    averageQaScore: { current: number; delta: number; previous: number };
    appealStats: { appealed: number; resolved: number; reviewsAcknowledged: number };
    reviewsOrigin: { assignment: number; initial: number; stream: number };
    teamMemberStats: {
      agentsTotal: number;
      teamMembersTotal: number;
      reviewedTeamMembersTotal: number;
      reviewedTeamMembersTotalPrior: number;
    };
  };
};

export type GetRolesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Array<RoleSearchInput> | RoleSearchInput>;
  filters?: InputMaybe<RoleFilterInput>;
  employeeFilters?: InputMaybe<EmployeeFilterInput>;
}>;

export type GetRolesQuery = {
  roles: {
    totalCount: number;
    nodes: Array<{ name: string; id: string; employees: { totalCount: number } }>;
    pageInfo: { endCursor: string; hasNextPage: boolean };
  };
};

export type GetRolesEmployeeCountQueryVariables = Exact<{
  search?: InputMaybe<Array<RoleSearchInput> | RoleSearchInput>;
  filters?: InputMaybe<RoleFilterInput>;
  employeeFilters?: InputMaybe<EmployeeFilterInput>;
  productArea?: InputMaybe<ProductArea>;
}>;

export type GetRolesEmployeeCountQuery = { rolesEmployeeCount: { totalEmployeeCount: number } };

export type GetSkippedInteractionsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<SkippedSolicitationFilterInput>;
  sort?: InputMaybe<Array<SkippedSolicitationSortInput> | SkippedSolicitationSortInput>;
}>;

export type GetSkippedInteractionsQuery = {
  qaAssignment: { id: string; archivedAt: any; qaFormId: string; blind: boolean };
  qaAssignmentSkippedSolicitations: {
    collection: Array<{
      channel: string;
      reviewed: boolean;
      skipReason: string;
      skipReasonDetail: string;
      skippedDate: any;
      qaAllocation: { id: string };
      solicitation: {
        id: string;
        uuid: string;
        interaction: { id: string; extInteractionId: string };
      };
      member: { fullName: string; id: string; imageUrl: string };
      reviewer: { id: string; fullName: string; imageUrl: string };
    }>;
    metadata: { limitValue: number; currentPage: number; totalCount: number; totalPages: number };
  };
};

export type GetSkipReasonDetailsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type GetSkipReasonDetailsQuery = { skipReasonDetails: Array<string> };

export type GetSupervisorsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Array<EmployeeSearchInput> | EmployeeSearchInput>;
}>;

export type GetSupervisorsQuery = {
  supervisors: {
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        fullName: string;
        imageUrl: string;
        primaryTeam: { id: string; name: string };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetSurveyConfigurationQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetSurveyConfigurationQuery = {
  surveyConfiguration: {
    configuration: any;
    configurationHash: string;
    createdAt: any;
    features: any;
    filterOptions: any;
    globalMarketingSettings: any;
    publishedConfiguration: any;
    publishedHash: string;
    updatedAt: any;
    uuid: string;
    availableQuestions: Array<{
      id: string;
      identifier: string;
      metadata: any;
      nickname: string;
      translations: any;
      type: string;
      company_id: string;
      created_at: any;
      show_comment: boolean;
      show_on_stream: boolean;
      survey_names: Array<string>;
      updated_at: any;
      options: Array<{
        active: boolean;
        id: string;
        identifier: string;
        position: number;
        created_at: any;
        integer_value: number;
        survey_question_id: string;
        updated_at: any;
      }>;
    }>;
  };
};

export type GetSurveyConfigurationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSurveyConfigurationsQuery = {
  surveyConfigurations: Array<{
    configuration: any;
    configurationHash: string;
    createdAt: any;
    updatedAt: any;
    uuid: string;
    publishedHash: string;
  }>;
};

export type GetTeamQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetTeamQuery = {
  team: {
    id: string;
    label: string;
    name: string;
    owner: {
      customEmployeeId: string;
      email: string;
      id: string;
      isActive: boolean;
      profile: {
        id: string;
        imageUrl: string;
        firstName: string;
        lastName: string;
        fullName: string;
      };
    };
    employees: { totalCount: number };
  };
};

export type GetTeamsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Array<TeamSearchInput> | TeamSearchInput>;
  filters?: InputMaybe<TeamFilterInput>;
  productArea?: InputMaybe<ProductArea>;
}>;

export type GetTeamsQuery = {
  teams: {
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        name: string;
        owner: { id: string; profile: { id: string; imageUrl: string } };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetTeamsFilterDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Array<TeamSearchInput> | TeamSearchInput>;
  filters?: InputMaybe<TeamFilterInput>;
  employeeFilters?: InputMaybe<EmployeeFilterInput>;
  productArea?: InputMaybe<ProductArea>;
}>;

export type GetTeamsFilterDataQuery = {
  teams: {
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        name: string;
        owner: { id: string; profile: { id: string; imageUrl: string } };
        employees: { totalCount: number; nodes: Array<{ id: string }> };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean; hasPreviousPage: boolean };
  };
};

export type GetTeamBadgesQueryVariables = Exact<{
  teamIds: Array<Scalars['ID']> | Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
}>;

export type GetTeamBadgesQuery = {
  teamEmployeeBadges: {
    nodes: Array<{
      id: string;
      name: string;
      earnedAt: any;
      description: string;
      iconSettings: any;
      imageUrl: string;
      badgeType: string;
      badgeKey: string;
      companyAchievement: { id: string; pathName: string };
      employee: {
        id: string;
        profile: { firstName: string; fullName: string; imageUrl: string; id: string };
      };
    }>;
    pageInfo: { endCursor: string; hasNextPage: boolean };
  };
};

export type GetTeamLeaderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetTeamLeaderQuery = {
  employee: { id: string; primaryTeam: { id: string; owner: { id: string } } };
};

export type GetUsersTableDataQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Array<EmployeeSearchInput> | EmployeeSearchInput>;
  filters?: InputMaybe<EmployeeFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type GetUsersTableDataQuery = {
  employees: {
    totalCount: number;
    edges: Array<{
      node: {
        id: string;
        canManageTeams: boolean;
        demotable: boolean;
        status: StatusEnum;
        lastActive: any;
        email: string;
        profile: { id: string; fullName: string; imageUrl: string };
        primaryTeam: {
          id: string;
          agentsCount: number;
          owner: { id: string; profile: { id: string; fullName: string } };
        };
        supervisor: { id: string; fullName: string };
        customRole: { id: string; name: string; legacy: boolean; roleTemplate: string };
      };
    }>;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor: string;
      startCursor: string;
    };
  };
};

export type GetWeekAndQuarterConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type GetWeekAndQuarterConfigurationQuery = {
  dateFilterConfig: { startOfWeek: WeekdayEnum; startOfQuarter: { month: number; day: number } };
};

export type ExportQaScorecardsMutationVariables = Exact<{
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  teamIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  reportingGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  employeeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  reviewerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  autofailed: Scalars['Boolean'];
  languages?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  channelEnumIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  propertyIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;

export type ExportQaScorecardsMutation = {
  createQaFormOverviewsExport: { errors: { details: string }; export: { id: string } };
};

export type ConfigureAreasOfExcellenceMutationVariables = Exact<{
  aoe: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type ConfigureAreasOfExcellenceMutation = {
  configureAreasOfExcellence: Array<{ id: number; caption: string }>;
};

export type ConfigureRewardsMutationVariables = Exact<{
  rewardConfiguration: RewardTiersConfiguration;
  thresholdsEnabled: Scalars['Boolean'];
  fiveStarRewards: Scalars['Boolean'];
}>;

export type ConfigureRewardsMutation = { configureRewards: boolean };

export type ConnectSnappyMutationVariables = Exact<{
  apiKey: Scalars['String'];
}>;

export type ConnectSnappyMutation = {
  setSnappyApiKey: { id: string; name: string; enabled: boolean };
};

export type DisconnectSnappyMutationVariables = Exact<{ [key: string]: never }>;

export type DisconnectSnappyMutation = {
  disconnectSnappyIntegration: { id: string; name: string; enabled: boolean };
};

export type GetAreasOfExcellenceQueryVariables = Exact<{ [key: string]: never }>;

export type GetAreasOfExcellenceQuery = {
  company: {
    id: string;
    allAoe: Array<{ id: number; caption: string }>;
    activeAoe: Array<{ id: number; caption: string }>;
  };
};

export type GetChannelableIntegrationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetChannelableIntegrationsQuery = {
  channelableIntegrations: Array<{ id: string; name: string; enabled: boolean }>;
};

export type GetChannelsQueryVariables = Exact<{ [key: string]: never }>;

export type GetChannelsQuery = {
  channels: Array<{
    id: string;
    name: string;
    slug: string;
    active: boolean;
    integrated: boolean;
    integration: { id: string; name: string; enabled: boolean };
  }>;
};

export type GetCompanyPositiveFeedbackComponentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanyPositiveFeedbackComponentsQuery = {
  company: { id: string; positiveFeedbackComponents: CompanyPositiveFeedbackComponentEnum };
};

export type GetCompanyRewardsConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanyRewardsConfigurationQuery = {
  company: {
    id: string;
    thresholdsEnabled: boolean;
    fiveStarRewards: boolean;
    rewards: Array<{
      id: string;
      tier: TierEnum;
      caption: string;
      imageUrl: string;
      threshold: number;
      campaignId: string;
      secondaryCampaignId: string;
      displayName: string;
    }>;
    clearedAtByTier: { low: string; mid: string; high: string };
  };
  snappy: { apiKey: string; enabled: boolean };
};

export type GetRewardsByTierQueryVariables = Exact<{
  tier: TierEnum;
}>;

export type GetRewardsByTierQuery = {
  rewardsByTier: Array<{ id: string; caption: string; imageUrl: string; tier: TierEnum }>;
};

export type GetSnappyCampaignsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSnappyCampaignsQuery = {
  snappyCampaigns: Array<{ name: string; extSnappyCampaignId: string }>;
};

export type UpdateChannelIntegrationsMutationVariables = Exact<{
  channelIntegrations: Array<ChannelIntegrationInput> | ChannelIntegrationInput;
}>;

export type UpdateChannelIntegrationsMutation = {
  updateChannelIntegrations: Array<{ id: string; integration: { id: string } }>;
};

export const LeaderboardSettingsFieldsFragmentDoc = gql`
  fragment leaderboardSettingsFields on LeaderboardMetrics {
    __typename
    id
    type
    options {
      label
      value
    }
    selected
    thresholds {
      day
      week
      month
      quarter
      year
    }
    decimals {
      options {
        label
        value
      }
      selected
    }
    boardSizes {
      options {
        label
        value
      }
      selected
    }
    intervals {
      options {
        label
        value
      }
      selected
    }
  }
`;
export const MetricSelectionFieldsFragmentDoc = gql`
  fragment metricSelectionFields on MetricSelections {
    __typename
    id
    type
    options {
      label
      value
    }
    selected
  }
`;
export const TableMetricResultFragmentFragmentDoc = gql`
  fragment tableMetricResultFragment on MetricResult {
    value
    title
    displayValue
    totalResults
    higherIsBetter
  }
`;
export const ActionItemsCollectionFieldsFragmentDoc = gql`
  fragment actionItemsCollectionFields on TakeawayConnection {
    totalCount
    edges {
      node {
        id
        text
        completedAt
        createdAt
        createdBy {
          id
          profile {
            id
            fullName
          }
        }
        dueDate
        owner {
          id
          profile {
            fullName
            id
            imageUrl
          }
        }
        takeawayCategory {
          id
          name
        }
        coachingSession {
          id
        }
        permissions {
          completable
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
`;
export const PublicNoteFieldsFragmentDoc = gql`
  fragment publicNoteFields on CoachingSessionNote {
    id
    coachingSession {
      id
    }
    createdAt
    updatedAt
    createdBy {
      id
    }
    notes
  }
`;
export const CoachingTopicFieldsFragmentDoc = gql`
  fragment coachingTopicFields on CoachingTopic {
    id
    topic
    references {
      link
      parsed
    }
    order
    addedToSessionAt
    createdAt
    updatedAt
    coachingSession {
      id
    }
    negativeFeedback {
      id
      feedbackReason
      comment
      createdAt
    }
  }
`;
export const InteractionFieldsFragmentDoc = gql`
  fragment interactionFields on Interaction {
    id
    extInteractionId
    resolvedAt
    canShowSummary
    reviews(filters: { employeeId: $employeeId }) {
      nodes {
        ... on QaReviewRegular {
          id
          score
          date: completedAt
        }
        __typename
      }
    }
    solicitations(filters: { employeeId: $employeeId }) {
      nodes {
        id
        uuid
        date: respondedAt
        recovered
        surveyAnswers {
          nodes {
            id
            surveyQuestionId
            surveyOptions {
              id
            }
          }
        }
        __typename
      }
    }
  }
`;
export const EmployeeFieldsFragmentDoc = gql`
  fragment employeeFields on Employee {
    id
    isActive
    profile {
      id
      firstName
      lastName
      fullName
      imageUrl
    }
  }
`;
export const TeamFieldsFragmentDoc = gql`
  fragment teamFields on Team {
    id
    name
    active
    label
    owner {
      id
      ...employeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
`;
export const ResultFragmentFragmentDoc = gql`
  fragment resultFragment on MetricResult {
    displayValue
    higherIsBetter
    max
    metricName
    min
    questionIdentifier
    title
    totalResults
    value
  }
`;
export const UpdateCoachingIntelligenceSettingsDocument = gql`
  mutation updateCoachingIntelligenceSettings($action: CoachingSettingsUpdateActionsEnum) {
    updateCoachingIntelligenceSettings(input: { action: $action }) {
      coachingIntelligenceSettings {
        enabled
        termsAccepted
      }
      errors {
        message
        path
      }
    }
  }
`;
export type UpdateCoachingIntelligenceSettingsMutationFn = Apollo.MutationFunction<
  UpdateCoachingIntelligenceSettingsMutation,
  UpdateCoachingIntelligenceSettingsMutationVariables
>;

/**
 * __useUpdateCoachingIntelligenceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCoachingIntelligenceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachingIntelligenceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachingIntelligenceSettingsMutation, { data, loading, error }] = useUpdateCoachingIntelligenceSettingsMutation({
 *   variables: {
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateCoachingIntelligenceSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoachingIntelligenceSettingsMutation,
    UpdateCoachingIntelligenceSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCoachingIntelligenceSettingsMutation,
    UpdateCoachingIntelligenceSettingsMutationVariables
  >(UpdateCoachingIntelligenceSettingsDocument, options);
}
export type UpdateCoachingIntelligenceSettingsMutationHookResult = ReturnType<
  typeof useUpdateCoachingIntelligenceSettingsMutation
>;
export type UpdateCoachingIntelligenceSettingsMutationResult =
  Apollo.MutationResult<UpdateCoachingIntelligenceSettingsMutation>;
export type UpdateCoachingIntelligenceSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoachingIntelligenceSettingsMutation,
  UpdateCoachingIntelligenceSettingsMutationVariables
>;
export const GetCoachingIntelligenceSettingsDocument = gql`
  query getCoachingIntelligenceSettings {
    coachingIntelligenceSettings {
      enabled
      termsAcceptedAt
      termsAcceptedBy {
        id
        profile {
          id
          fullName
        }
      }
      termsAccepted
      termsExpiryAt
      termsExpired
      termsExpiry
      termsRevisionMatches
    }
  }
`;

/**
 * __useGetCoachingIntelligenceSettingsQuery__
 *
 * To run a query within a React component, call `useGetCoachingIntelligenceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingIntelligenceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingIntelligenceSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoachingIntelligenceSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCoachingIntelligenceSettingsQuery,
    GetCoachingIntelligenceSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCoachingIntelligenceSettingsQuery,
    GetCoachingIntelligenceSettingsQueryVariables
  >(GetCoachingIntelligenceSettingsDocument, options);
}
export function useGetCoachingIntelligenceSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoachingIntelligenceSettingsQuery,
    GetCoachingIntelligenceSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCoachingIntelligenceSettingsQuery,
    GetCoachingIntelligenceSettingsQueryVariables
  >(GetCoachingIntelligenceSettingsDocument, options);
}
export type GetCoachingIntelligenceSettingsQueryHookResult = ReturnType<
  typeof useGetCoachingIntelligenceSettingsQuery
>;
export type GetCoachingIntelligenceSettingsLazyQueryHookResult = ReturnType<
  typeof useGetCoachingIntelligenceSettingsLazyQuery
>;
export type GetCoachingIntelligenceSettingsQueryResult = Apollo.QueryResult<
  GetCoachingIntelligenceSettingsQuery,
  GetCoachingIntelligenceSettingsQueryVariables
>;
export const GetCoachingIntelligenceTcDocument = gql`
  query getCoachingIntelligenceTc {
    coachingIntelligenceTc {
      id
      content
    }
  }
`;

/**
 * __useGetCoachingIntelligenceTcQuery__
 *
 * To run a query within a React component, call `useGetCoachingIntelligenceTcQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingIntelligenceTcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingIntelligenceTcQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoachingIntelligenceTcQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCoachingIntelligenceTcQuery,
    GetCoachingIntelligenceTcQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoachingIntelligenceTcQuery, GetCoachingIntelligenceTcQueryVariables>(
    GetCoachingIntelligenceTcDocument,
    options
  );
}
export function useGetCoachingIntelligenceTcLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoachingIntelligenceTcQuery,
    GetCoachingIntelligenceTcQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCoachingIntelligenceTcQuery,
    GetCoachingIntelligenceTcQueryVariables
  >(GetCoachingIntelligenceTcDocument, options);
}
export type GetCoachingIntelligenceTcQueryHookResult = ReturnType<
  typeof useGetCoachingIntelligenceTcQuery
>;
export type GetCoachingIntelligenceTcLazyQueryHookResult = ReturnType<
  typeof useGetCoachingIntelligenceTcLazyQuery
>;
export type GetCoachingIntelligenceTcQueryResult = Apollo.QueryResult<
  GetCoachingIntelligenceTcQuery,
  GetCoachingIntelligenceTcQueryVariables
>;
export const CreateMetricSetDocument = gql`
  mutation createMetricSet($name: String!, $metrics: [MetricInput!]!, $groupIds: [ID!]!) {
    createMetricSet(input: { name: $name, metrics: $metrics, groupIds: $groupIds }) {
      metricSet {
        id
        name
        order
        metrics {
          id
          value
          label
        }
        visibility {
          value: id
          label: name
        }
      }
    }
  }
`;
export type CreateMetricSetMutationFn = Apollo.MutationFunction<
  CreateMetricSetMutation,
  CreateMetricSetMutationVariables
>;

/**
 * __useCreateMetricSetMutation__
 *
 * To run a mutation, you first call `useCreateMetricSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricSetMutation, { data, loading, error }] = useCreateMetricSetMutation({
 *   variables: {
 *      name: // value for 'name'
 *      metrics: // value for 'metrics'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useCreateMetricSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMetricSetMutation,
    CreateMetricSetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateMetricSetMutation, CreateMetricSetMutationVariables>(
    CreateMetricSetDocument,
    options
  );
}
export type CreateMetricSetMutationHookResult = ReturnType<typeof useCreateMetricSetMutation>;
export type CreateMetricSetMutationResult = Apollo.MutationResult<CreateMetricSetMutation>;
export type CreateMetricSetMutationOptions = Apollo.BaseMutationOptions<
  CreateMetricSetMutation,
  CreateMetricSetMutationVariables
>;
export const DeleteMetricSetDocument = gql`
  mutation deleteMetricSet($id: ID!) {
    deleteMetricSet(input: { id: $id }) {
      id
      name
      order
      metrics {
        id
        value
        label
      }
      visibility {
        value: id
        label: name
      }
    }
  }
`;
export type DeleteMetricSetMutationFn = Apollo.MutationFunction<
  DeleteMetricSetMutation,
  DeleteMetricSetMutationVariables
>;

/**
 * __useDeleteMetricSetMutation__
 *
 * To run a mutation, you first call `useDeleteMetricSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricSetMutation, { data, loading, error }] = useDeleteMetricSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMetricSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMetricSetMutation,
    DeleteMetricSetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteMetricSetMutation, DeleteMetricSetMutationVariables>(
    DeleteMetricSetDocument,
    options
  );
}
export type DeleteMetricSetMutationHookResult = ReturnType<typeof useDeleteMetricSetMutation>;
export type DeleteMetricSetMutationResult = Apollo.MutationResult<DeleteMetricSetMutation>;
export type DeleteMetricSetMutationOptions = Apollo.BaseMutationOptions<
  DeleteMetricSetMutation,
  DeleteMetricSetMutationVariables
>;
export const ModifyMetricSetDocument = gql`
  mutation modifyMetricSet($id: ID!, $name: String, $metrics: [MetricInput!], $groupIds: [ID!]) {
    modifyMetricSet(input: { id: $id, name: $name, metrics: $metrics, groupIds: $groupIds }) {
      metricSet {
        id
        name
        order
        metrics {
          id
          value
          label
        }
        visibility {
          value: id
          label: name
        }
      }
    }
  }
`;
export type ModifyMetricSetMutationFn = Apollo.MutationFunction<
  ModifyMetricSetMutation,
  ModifyMetricSetMutationVariables
>;

/**
 * __useModifyMetricSetMutation__
 *
 * To run a mutation, you first call `useModifyMetricSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyMetricSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyMetricSetMutation, { data, loading, error }] = useModifyMetricSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      metrics: // value for 'metrics'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useModifyMetricSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ModifyMetricSetMutation,
    ModifyMetricSetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ModifyMetricSetMutation, ModifyMetricSetMutationVariables>(
    ModifyMetricSetDocument,
    options
  );
}
export type ModifyMetricSetMutationHookResult = ReturnType<typeof useModifyMetricSetMutation>;
export type ModifyMetricSetMutationResult = Apollo.MutationResult<ModifyMetricSetMutation>;
export type ModifyMetricSetMutationOptions = Apollo.BaseMutationOptions<
  ModifyMetricSetMutation,
  ModifyMetricSetMutationVariables
>;
export const UpdateDateFilterConfigDocument = gql`
  mutation updateDateFilterConfig(
    $selectedDateRanges: [DateRangeEnum!]!
    $defaultDateRange: DateRangeEnum!
    $startOfWeek: WeekdayEnum!
    $startOfQuarter: StartOfQuarterInput!
    $solicitationReportingTimestamp: SolicitationReportingTimestampEnum
  ) {
    updateDateFilterConfig(
      input: {
        selectedDateRanges: $selectedDateRanges
        defaultDateRange: $defaultDateRange
        startOfWeek: $startOfWeek
        startOfQuarter: $startOfQuarter
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
    ) {
      selectedDateRanges
      defaultDateRange
      startOfWeek
      startOfQuarter {
        month
        day
      }
      solicitationReportingTimestamp
    }
  }
`;
export type UpdateDateFilterConfigMutationFn = Apollo.MutationFunction<
  UpdateDateFilterConfigMutation,
  UpdateDateFilterConfigMutationVariables
>;

/**
 * __useUpdateDateFilterConfigMutation__
 *
 * To run a mutation, you first call `useUpdateDateFilterConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDateFilterConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDateFilterConfigMutation, { data, loading, error }] = useUpdateDateFilterConfigMutation({
 *   variables: {
 *      selectedDateRanges: // value for 'selectedDateRanges'
 *      defaultDateRange: // value for 'defaultDateRange'
 *      startOfWeek: // value for 'startOfWeek'
 *      startOfQuarter: // value for 'startOfQuarter'
 *      solicitationReportingTimestamp: // value for 'solicitationReportingTimestamp'
 *   },
 * });
 */
export function useUpdateDateFilterConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDateFilterConfigMutation,
    UpdateDateFilterConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDateFilterConfigMutation,
    UpdateDateFilterConfigMutationVariables
  >(UpdateDateFilterConfigDocument, options);
}
export type UpdateDateFilterConfigMutationHookResult = ReturnType<
  typeof useUpdateDateFilterConfigMutation
>;
export type UpdateDateFilterConfigMutationResult =
  Apollo.MutationResult<UpdateDateFilterConfigMutation>;
export type UpdateDateFilterConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateDateFilterConfigMutation,
  UpdateDateFilterConfigMutationVariables
>;
export const UpdateLeaderboardSettingsDocument = gql`
  mutation updateLeaderboardSettings(
    $metric: MetricInput
    $advancedSettings: LeaderboardSettingsInput
  ) {
    updateLeaderboardSettings(input: { metric: $metric, advancedSettings: $advancedSettings }) {
      id
      ...leaderboardSettingsFields
    }
  }
  ${LeaderboardSettingsFieldsFragmentDoc}
`;
export type UpdateLeaderboardSettingsMutationFn = Apollo.MutationFunction<
  UpdateLeaderboardSettingsMutation,
  UpdateLeaderboardSettingsMutationVariables
>;

/**
 * __useUpdateLeaderboardSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateLeaderboardSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaderboardSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaderboardSettingsMutation, { data, loading, error }] = useUpdateLeaderboardSettingsMutation({
 *   variables: {
 *      metric: // value for 'metric'
 *      advancedSettings: // value for 'advancedSettings'
 *   },
 * });
 */
export function useUpdateLeaderboardSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLeaderboardSettingsMutation,
    UpdateLeaderboardSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLeaderboardSettingsMutation,
    UpdateLeaderboardSettingsMutationVariables
  >(UpdateLeaderboardSettingsDocument, options);
}
export type UpdateLeaderboardSettingsMutationHookResult = ReturnType<
  typeof useUpdateLeaderboardSettingsMutation
>;
export type UpdateLeaderboardSettingsMutationResult =
  Apollo.MutationResult<UpdateLeaderboardSettingsMutation>;
export type UpdateLeaderboardSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateLeaderboardSettingsMutation,
  UpdateLeaderboardSettingsMutationVariables
>;
export const UpdateMetricSelectionDocument = gql`
  mutation updateMetricSelection(
    $metric: MetricInput!
    $order: Int!
    $type: MetricConfigTypeEnum!
  ) {
    updateMetricSelection(input: { metric: $metric, order: $order, type: $type }) {
      id
      ...metricSelectionFields
    }
  }
  ${MetricSelectionFieldsFragmentDoc}
`;
export type UpdateMetricSelectionMutationFn = Apollo.MutationFunction<
  UpdateMetricSelectionMutation,
  UpdateMetricSelectionMutationVariables
>;

/**
 * __useUpdateMetricSelectionMutation__
 *
 * To run a mutation, you first call `useUpdateMetricSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricSelectionMutation, { data, loading, error }] = useUpdateMetricSelectionMutation({
 *   variables: {
 *      metric: // value for 'metric'
 *      order: // value for 'order'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateMetricSelectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMetricSelectionMutation,
    UpdateMetricSelectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateMetricSelectionMutation, UpdateMetricSelectionMutationVariables>(
    UpdateMetricSelectionDocument,
    options
  );
}
export type UpdateMetricSelectionMutationHookResult = ReturnType<
  typeof useUpdateMetricSelectionMutation
>;
export type UpdateMetricSelectionMutationResult =
  Apollo.MutationResult<UpdateMetricSelectionMutation>;
export type UpdateMetricSelectionMutationOptions = Apollo.BaseMutationOptions<
  UpdateMetricSelectionMutation,
  UpdateMetricSelectionMutationVariables
>;
export const UpdateMetricSetsOrderDocument = gql`
  mutation updateMetricSetsOrder($ids: [ID!]!) {
    updateMetricSetOrder(input: { ids: $ids }) {
      metricSets {
        id
        name
        order
        metrics {
          id
          value
          label
        }
        visibility {
          value: id
          label: name
        }
      }
    }
  }
`;
export type UpdateMetricSetsOrderMutationFn = Apollo.MutationFunction<
  UpdateMetricSetsOrderMutation,
  UpdateMetricSetsOrderMutationVariables
>;

/**
 * __useUpdateMetricSetsOrderMutation__
 *
 * To run a mutation, you first call `useUpdateMetricSetsOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricSetsOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricSetsOrderMutation, { data, loading, error }] = useUpdateMetricSetsOrderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpdateMetricSetsOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMetricSetsOrderMutation,
    UpdateMetricSetsOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateMetricSetsOrderMutation, UpdateMetricSetsOrderMutationVariables>(
    UpdateMetricSetsOrderDocument,
    options
  );
}
export type UpdateMetricSetsOrderMutationHookResult = ReturnType<
  typeof useUpdateMetricSetsOrderMutation
>;
export type UpdateMetricSetsOrderMutationResult =
  Apollo.MutationResult<UpdateMetricSetsOrderMutation>;
export type UpdateMetricSetsOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateMetricSetsOrderMutation,
  UpdateMetricSetsOrderMutationVariables
>;
export const UpdatePerformanceMetricSelectionsDocument = gql`
  mutation updatePerformanceMetricSelections($metrics: [MetricInput!]!) {
    updatePerformanceMetricSelections(input: { metrics: $metrics }) {
      id
      ...metricSelectionFields
    }
  }
  ${MetricSelectionFieldsFragmentDoc}
`;
export type UpdatePerformanceMetricSelectionsMutationFn = Apollo.MutationFunction<
  UpdatePerformanceMetricSelectionsMutation,
  UpdatePerformanceMetricSelectionsMutationVariables
>;

/**
 * __useUpdatePerformanceMetricSelectionsMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceMetricSelectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceMetricSelectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceMetricSelectionsMutation, { data, loading, error }] = useUpdatePerformanceMetricSelectionsMutation({
 *   variables: {
 *      metrics: // value for 'metrics'
 *   },
 * });
 */
export function useUpdatePerformanceMetricSelectionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePerformanceMetricSelectionsMutation,
    UpdatePerformanceMetricSelectionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePerformanceMetricSelectionsMutation,
    UpdatePerformanceMetricSelectionsMutationVariables
  >(UpdatePerformanceMetricSelectionsDocument, options);
}
export type UpdatePerformanceMetricSelectionsMutationHookResult = ReturnType<
  typeof useUpdatePerformanceMetricSelectionsMutation
>;
export type UpdatePerformanceMetricSelectionsMutationResult =
  Apollo.MutationResult<UpdatePerformanceMetricSelectionsMutation>;
export type UpdatePerformanceMetricSelectionsMutationOptions = Apollo.BaseMutationOptions<
  UpdatePerformanceMetricSelectionsMutation,
  UpdatePerformanceMetricSelectionsMutationVariables
>;
export const GetDateFilterConfigurationsDocument = gql`
  query getDateFilterConfigurations {
    dateFilterConfig {
      availableDateRanges
      defaultDateRange
      defaultDateRangeSelections
      selectedDateRanges
      startOfWeek
      startOfQuarter {
        month
        day
      }
      solicitationReportingTimestamp
    }
  }
`;

/**
 * __useGetDateFilterConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetDateFilterConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDateFilterConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDateFilterConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDateFilterConfigurationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDateFilterConfigurationsQuery,
    GetDateFilterConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDateFilterConfigurationsQuery,
    GetDateFilterConfigurationsQueryVariables
  >(GetDateFilterConfigurationsDocument, options);
}
export function useGetDateFilterConfigurationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDateFilterConfigurationsQuery,
    GetDateFilterConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDateFilterConfigurationsQuery,
    GetDateFilterConfigurationsQueryVariables
  >(GetDateFilterConfigurationsDocument, options);
}
export type GetDateFilterConfigurationsQueryHookResult = ReturnType<
  typeof useGetDateFilterConfigurationsQuery
>;
export type GetDateFilterConfigurationsLazyQueryHookResult = ReturnType<
  typeof useGetDateFilterConfigurationsLazyQuery
>;
export type GetDateFilterConfigurationsQueryResult = Apollo.QueryResult<
  GetDateFilterConfigurationsQuery,
  GetDateFilterConfigurationsQueryVariables
>;
export const GetMetricConfigurationOptionsDocument = gql`
  query getMetricConfigurationOptions {
    metricSelectionOptions(type: [LEADERBOARD, STREAM, ONE_ON_ONE, TREND]) {
      ...metricSelectionFields
      ...leaderboardSettingsFields
    }
  }
  ${MetricSelectionFieldsFragmentDoc}
  ${LeaderboardSettingsFieldsFragmentDoc}
`;

/**
 * __useGetMetricConfigurationOptionsQuery__
 *
 * To run a query within a React component, call `useGetMetricConfigurationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricConfigurationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricConfigurationOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMetricConfigurationOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMetricConfigurationOptionsQuery,
    GetMetricConfigurationOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMetricConfigurationOptionsQuery,
    GetMetricConfigurationOptionsQueryVariables
  >(GetMetricConfigurationOptionsDocument, options);
}
export function useGetMetricConfigurationOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricConfigurationOptionsQuery,
    GetMetricConfigurationOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMetricConfigurationOptionsQuery,
    GetMetricConfigurationOptionsQueryVariables
  >(GetMetricConfigurationOptionsDocument, options);
}
export type GetMetricConfigurationOptionsQueryHookResult = ReturnType<
  typeof useGetMetricConfigurationOptionsQuery
>;
export type GetMetricConfigurationOptionsLazyQueryHookResult = ReturnType<
  typeof useGetMetricConfigurationOptionsLazyQuery
>;
export type GetMetricConfigurationOptionsQueryResult = Apollo.QueryResult<
  GetMetricConfigurationOptionsQuery,
  GetMetricConfigurationOptionsQueryVariables
>;
export const GetMetricSetsDocument = gql`
  query getMetricSets {
    metricSets {
      id
      name
      order
      default
      metrics {
        id
        value
        label
      }
      visibility {
        value: id
        label: name
        owner {
          id
        }
      }
    }
  }
`;

/**
 * __useGetMetricSetsQuery__
 *
 * To run a query within a React component, call `useGetMetricSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMetricSetsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMetricSetsQuery, GetMetricSetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricSetsQuery, GetMetricSetsQueryVariables>(
    GetMetricSetsDocument,
    options
  );
}
export function useGetMetricSetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMetricSetsQuery, GetMetricSetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricSetsQuery, GetMetricSetsQueryVariables>(
    GetMetricSetsDocument,
    options
  );
}
export type GetMetricSetsQueryHookResult = ReturnType<typeof useGetMetricSetsQuery>;
export type GetMetricSetsLazyQueryHookResult = ReturnType<typeof useGetMetricSetsLazyQuery>;
export type GetMetricSetsQueryResult = Apollo.QueryResult<
  GetMetricSetsQuery,
  GetMetricSetsQueryVariables
>;
export const GetCoachingSessionSummaryDocument = gql`
  query getCoachingSessionSummary($coachingSessionId: ID!) {
    coachingSessionSummary(sessionId: $coachingSessionId) {
      status
      summary
      summaryFeedback {
        userFeedback
      }
    }
  }
`;

/**
 * __useGetCoachingSessionSummaryQuery__
 *
 * To run a query within a React component, call `useGetCoachingSessionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingSessionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingSessionSummaryQuery({
 *   variables: {
 *      coachingSessionId: // value for 'coachingSessionId'
 *   },
 * });
 */
export function useGetCoachingSessionSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCoachingSessionSummaryQuery,
    GetCoachingSessionSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoachingSessionSummaryQuery, GetCoachingSessionSummaryQueryVariables>(
    GetCoachingSessionSummaryDocument,
    options
  );
}
export function useGetCoachingSessionSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoachingSessionSummaryQuery,
    GetCoachingSessionSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCoachingSessionSummaryQuery,
    GetCoachingSessionSummaryQueryVariables
  >(GetCoachingSessionSummaryDocument, options);
}
export type GetCoachingSessionSummaryQueryHookResult = ReturnType<
  typeof useGetCoachingSessionSummaryQuery
>;
export type GetCoachingSessionSummaryLazyQueryHookResult = ReturnType<
  typeof useGetCoachingSessionSummaryLazyQuery
>;
export type GetCoachingSessionSummaryQueryResult = Apollo.QueryResult<
  GetCoachingSessionSummaryQuery,
  GetCoachingSessionSummaryQueryVariables
>;
export const UpdateCoachingSummaryFeedbackDocument = gql`
  mutation updateCoachingSummaryFeedback(
    $coachingSessionId: ID!
    $userFeedback: UserFeedbackEnum!
  ) {
    updateCoachingSummaryFeedback(
      input: { coachingSessionId: $coachingSessionId, userFeedback: $userFeedback }
    ) {
      summaryFeedback {
        userFeedback
      }
      errors {
        message
        path
      }
    }
  }
`;
export type UpdateCoachingSummaryFeedbackMutationFn = Apollo.MutationFunction<
  UpdateCoachingSummaryFeedbackMutation,
  UpdateCoachingSummaryFeedbackMutationVariables
>;

/**
 * __useUpdateCoachingSummaryFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateCoachingSummaryFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachingSummaryFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachingSummaryFeedbackMutation, { data, loading, error }] = useUpdateCoachingSummaryFeedbackMutation({
 *   variables: {
 *      coachingSessionId: // value for 'coachingSessionId'
 *      userFeedback: // value for 'userFeedback'
 *   },
 * });
 */
export function useUpdateCoachingSummaryFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoachingSummaryFeedbackMutation,
    UpdateCoachingSummaryFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCoachingSummaryFeedbackMutation,
    UpdateCoachingSummaryFeedbackMutationVariables
  >(UpdateCoachingSummaryFeedbackDocument, options);
}
export type UpdateCoachingSummaryFeedbackMutationHookResult = ReturnType<
  typeof useUpdateCoachingSummaryFeedbackMutation
>;
export type UpdateCoachingSummaryFeedbackMutationResult =
  Apollo.MutationResult<UpdateCoachingSummaryFeedbackMutation>;
export type UpdateCoachingSummaryFeedbackMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoachingSummaryFeedbackMutation,
  UpdateCoachingSummaryFeedbackMutationVariables
>;
export const GetMetricGraphDataDocument = gql`
  query getMetricGraphData(
    $filters: MetricFilterInput!
    $metric: MetricInput!
    $interval: TimePeriodEnum = WEEK
  ) {
    calculateMetricTrend(filters: $filters, metric: $metric, interval: $interval) {
      dates
      timeSeries {
        values
        totalResults
        displayValues
      }
      title
      value
    }
  }
`;

/**
 * __useGetMetricGraphDataQuery__
 *
 * To run a query within a React component, call `useGetMetricGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricGraphDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useGetMetricGraphDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetMetricGraphDataQuery, GetMetricGraphDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricGraphDataQuery, GetMetricGraphDataQueryVariables>(
    GetMetricGraphDataDocument,
    options
  );
}
export function useGetMetricGraphDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricGraphDataQuery,
    GetMetricGraphDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricGraphDataQuery, GetMetricGraphDataQueryVariables>(
    GetMetricGraphDataDocument,
    options
  );
}
export type GetMetricGraphDataQueryHookResult = ReturnType<typeof useGetMetricGraphDataQuery>;
export type GetMetricGraphDataLazyQueryHookResult = ReturnType<
  typeof useGetMetricGraphDataLazyQuery
>;
export type GetMetricGraphDataQueryResult = Apollo.QueryResult<
  GetMetricGraphDataQuery,
  GetMetricGraphDataQueryVariables
>;
export const GetAreasDocument = gql`
  query getAreas($filters: MetricFilterInput!, $metric: MetricInput!, $fetchAoe: Boolean!) {
    aoe: calculateMetricByGroup(groupBy: AREAS_OF_EXCELLENCE, filters: $filters, metric: $metric)
      @include(if: $fetchAoe) {
      edges {
        node {
          groupValue
          areaIdentifier
          metricResult {
            value
            displayValue
            totalResults
            displayPercentage
          }
        }
      }
    }
    aoi: calculateMetricByGroup(groupBy: AREAS_OF_IMPROVEMENT, filters: $filters, metric: $metric) {
      edges {
        node {
          groupValue
          areaIdentifier
          metricResult {
            value
            displayValue
            totalResults
            displayPercentage
          }
        }
      }
    }
  }
`;

/**
 * __useGetAreasQuery__
 *
 * To run a query within a React component, call `useGetAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreasQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *      fetchAoe: // value for 'fetchAoe'
 *   },
 * });
 */
export function useGetAreasQuery(
  baseOptions: Apollo.QueryHookOptions<GetAreasQuery, GetAreasQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAreasQuery, GetAreasQueryVariables>(GetAreasDocument, options);
}
export function useGetAreasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAreasQuery, GetAreasQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAreasQuery, GetAreasQueryVariables>(GetAreasDocument, options);
}
export type GetAreasQueryHookResult = ReturnType<typeof useGetAreasQuery>;
export type GetAreasLazyQueryHookResult = ReturnType<typeof useGetAreasLazyQuery>;
export type GetAreasQueryResult = Apollo.QueryResult<GetAreasQuery, GetAreasQueryVariables>;
export const CalculateMetricByCategoryDocument = gql`
  query calculateMetricByCategory(
    $filters: MetricFilterInput!
    $identifier: IdentifierEnum!
    $includeAreas: Boolean = true
  ) {
    calculateMetricByCategory(filters: $filters, identifier: $identifier) {
      areasEnabled
      categories @include(if: $includeAreas) {
        category
        categoryId
        label
        count
        percent
      }
    }
  }
`;

/**
 * __useCalculateMetricByCategoryQuery__
 *
 * To run a query within a React component, call `useCalculateMetricByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateMetricByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateMetricByCategoryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      identifier: // value for 'identifier'
 *      includeAreas: // value for 'includeAreas'
 *   },
 * });
 */
export function useCalculateMetricByCategoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    CalculateMetricByCategoryQuery,
    CalculateMetricByCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CalculateMetricByCategoryQuery, CalculateMetricByCategoryQueryVariables>(
    CalculateMetricByCategoryDocument,
    options
  );
}
export function useCalculateMetricByCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CalculateMetricByCategoryQuery,
    CalculateMetricByCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CalculateMetricByCategoryQuery,
    CalculateMetricByCategoryQueryVariables
  >(CalculateMetricByCategoryDocument, options);
}
export type CalculateMetricByCategoryQueryHookResult = ReturnType<
  typeof useCalculateMetricByCategoryQuery
>;
export type CalculateMetricByCategoryLazyQueryHookResult = ReturnType<
  typeof useCalculateMetricByCategoryLazyQuery
>;
export type CalculateMetricByCategoryQueryResult = Apollo.QueryResult<
  CalculateMetricByCategoryQuery,
  CalculateMetricByCategoryQueryVariables
>;
export const GetBehaviorDocument = gql`
  query getBehavior(
    $filters: MetricFilterInput!
    $metric: MetricInput!
    $interval: TimePeriodEnum = WEEK
    $hasAoe: Boolean = true
    $hasAoi: Boolean = true
  ) {
    aoe: calculateMetricByGroup(groupBy: AREAS_OF_EXCELLENCE, filters: $filters, metric: $metric)
      @include(if: $hasAoe) {
      edges {
        node {
          groupValue
          metricResult {
            value
            displayValue
            higherIsBetter
            totalResults
            metricName
          }
        }
      }
    }
    aoi: calculateMetricByGroup(groupBy: AREAS_OF_IMPROVEMENT, filters: $filters, metric: $metric)
      @include(if: $hasAoi) {
      edges {
        node {
          groupValue
          metricResult {
            value
            displayValue
            higherIsBetter
            totalResults
            metricName
          }
        }
      }
    }
    aoeTrends: calculateMetricTrendByGroup(
      groupBy: AREAS_OF_EXCELLENCE
      filters: $filters
      metric: $metric
      interval: $interval
    ) @include(if: $hasAoe) {
      dates
      timeSeries {
        name
        values
        totalResults
        displayValues
      }
    }
    aoiTrends: calculateMetricTrendByGroup(
      groupBy: AREAS_OF_IMPROVEMENT
      filters: $filters
      metric: $metric
      interval: $interval
    ) @include(if: $hasAoi) {
      dates
      timeSeries {
        name
        values
        totalResults
        displayValues
      }
    }
  }
`;

/**
 * __useGetBehaviorQuery__
 *
 * To run a query within a React component, call `useGetBehaviorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBehaviorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBehaviorQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *      interval: // value for 'interval'
 *      hasAoe: // value for 'hasAoe'
 *      hasAoi: // value for 'hasAoi'
 *   },
 * });
 */
export function useGetBehaviorQuery(
  baseOptions: Apollo.QueryHookOptions<GetBehaviorQuery, GetBehaviorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBehaviorQuery, GetBehaviorQueryVariables>(GetBehaviorDocument, options);
}
export function useGetBehaviorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBehaviorQuery, GetBehaviorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBehaviorQuery, GetBehaviorQueryVariables>(
    GetBehaviorDocument,
    options
  );
}
export type GetBehaviorQueryHookResult = ReturnType<typeof useGetBehaviorQuery>;
export type GetBehaviorLazyQueryHookResult = ReturnType<typeof useGetBehaviorLazyQuery>;
export type GetBehaviorQueryResult = Apollo.QueryResult<
  GetBehaviorQuery,
  GetBehaviorQueryVariables
>;
export const GetTableColumnDocument = gql`
  query getTableColumn(
    $metric: MetricInput!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $previousStartDate: ISO8601Date!
    $previousEndDate: ISO8601Date!
    $employeeIds: [ID!]
    $teamIds: [ID!]
    $sortField: MetricSortFieldEnum = GROUP_VALUE
    $sortDirection: SortDirectionEnum = DESC
    $includeEmployees: Boolean = false
    $channelIds: [ID!]
    $brandingIds: [ID!]
    $languages: [String!]
    $excludeTags: [String!]
    $includeTags: [String!]
    $customProperties: [CustomPropertyFilterInput!]
    $solicitationReportingTimestamp: SolicitationReportingTimestampEnum
  ) {
    currentTeamMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        teamIds: $teamIds
        dateRange: { startDate: $startDate, endDate: $endDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: TEAM_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    currentEmployeeMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        employeeIds: $employeeIds
        dateRange: { startDate: $startDate, endDate: $endDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: EMPLOYEE_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) @include(if: $includeEmployees) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    previousTeamMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        teamIds: $teamIds
        dateRange: { startDate: $previousStartDate, endDate: $previousEndDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: TEAM_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    previousEmployeeMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        employeeIds: $employeeIds
        dateRange: { startDate: $previousStartDate, endDate: $previousEndDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: EMPLOYEE_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) @include(if: $includeEmployees) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
  }
  ${TableMetricResultFragmentFragmentDoc}
`;

/**
 * __useGetTableColumnQuery__
 *
 * To run a query within a React component, call `useGetTableColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableColumnQuery({
 *   variables: {
 *      metric: // value for 'metric'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *      employeeIds: // value for 'employeeIds'
 *      teamIds: // value for 'teamIds'
 *      sortField: // value for 'sortField'
 *      sortDirection: // value for 'sortDirection'
 *      includeEmployees: // value for 'includeEmployees'
 *      channelIds: // value for 'channelIds'
 *      brandingIds: // value for 'brandingIds'
 *      languages: // value for 'languages'
 *      excludeTags: // value for 'excludeTags'
 *      includeTags: // value for 'includeTags'
 *      customProperties: // value for 'customProperties'
 *      solicitationReportingTimestamp: // value for 'solicitationReportingTimestamp'
 *   },
 * });
 */
export function useGetTableColumnQuery(
  baseOptions: Apollo.QueryHookOptions<GetTableColumnQuery, GetTableColumnQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTableColumnQuery, GetTableColumnQueryVariables>(
    GetTableColumnDocument,
    options
  );
}
export function useGetTableColumnLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTableColumnQuery, GetTableColumnQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTableColumnQuery, GetTableColumnQueryVariables>(
    GetTableColumnDocument,
    options
  );
}
export type GetTableColumnQueryHookResult = ReturnType<typeof useGetTableColumnQuery>;
export type GetTableColumnLazyQueryHookResult = ReturnType<typeof useGetTableColumnLazyQuery>;
export type GetTableColumnQueryResult = Apollo.QueryResult<
  GetTableColumnQuery,
  GetTableColumnQueryVariables
>;
export const GetTableColumnWithGoalsDocument = gql`
  query getTableColumnWithGoals(
    $metric: MetricInput!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $previousStartDate: ISO8601Date!
    $previousEndDate: ISO8601Date!
    $employeeIds: [ID!]
    $teamIds: [ID!]
    $sortField: MetricSortFieldEnum = GROUP_VALUE
    $sortDirection: SortDirectionEnum = DESC
    $includeEmployees: Boolean = false
    $channelIds: [ID!]
    $brandingIds: [ID!]
    $languages: [String!]
    $excludeTags: [String!]
    $includeTags: [String!]
    $customProperties: [CustomPropertyFilterInput!]
    $solicitationReportingTimestamp: SolicitationReportingTimestampEnum
  ) {
    currentTeamMetricGoals: metricGoals(
      type: GROUP
      filters: {
        dateRange: { startDate: $startDate, endDate: $endDate }
        entityIds: $teamIds
        status: ACTIVE
      }
    ) {
      edges {
        node {
          ... on MetricGoalGroup {
            id
            displayValue
            goal
            group {
              id
              agentsCount
            }
            metricConfig {
              id
              metricName
              questionIdentifier
            }
            reachedCount
            type
          }
        }
      }
    }
    currentEmployeeMetricGoals: metricGoals(
      type: EMPLOYEE
      filters: {
        dateRange: { startDate: $startDate, endDate: $endDate }
        entityIds: $employeeIds
        status: ACTIVE
      }
    ) {
      edges {
        node {
          ... on MetricGoalEmployee {
            id
            displayValue
            employee {
              id
            }
            goal
            metricConfig {
              id
              metricName
              questionIdentifier
            }
            type
          }
        }
      }
    }
    currentTeamMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        teamIds: $teamIds
        dateRange: { startDate: $startDate, endDate: $endDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: TEAM_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    currentEmployeeMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        employeeIds: $employeeIds
        dateRange: { startDate: $startDate, endDate: $endDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: EMPLOYEE_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) @include(if: $includeEmployees) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    previousTeamMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        teamIds: $teamIds
        dateRange: { startDate: $previousStartDate, endDate: $previousEndDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: TEAM_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    previousEmployeeMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        employeeIds: $employeeIds
        dateRange: { startDate: $previousStartDate, endDate: $previousEndDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: EMPLOYEE_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) @include(if: $includeEmployees) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
  }
  ${TableMetricResultFragmentFragmentDoc}
`;

/**
 * __useGetTableColumnWithGoalsQuery__
 *
 * To run a query within a React component, call `useGetTableColumnWithGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableColumnWithGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableColumnWithGoalsQuery({
 *   variables: {
 *      metric: // value for 'metric'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *      employeeIds: // value for 'employeeIds'
 *      teamIds: // value for 'teamIds'
 *      sortField: // value for 'sortField'
 *      sortDirection: // value for 'sortDirection'
 *      includeEmployees: // value for 'includeEmployees'
 *      channelIds: // value for 'channelIds'
 *      brandingIds: // value for 'brandingIds'
 *      languages: // value for 'languages'
 *      excludeTags: // value for 'excludeTags'
 *      includeTags: // value for 'includeTags'
 *      customProperties: // value for 'customProperties'
 *      solicitationReportingTimestamp: // value for 'solicitationReportingTimestamp'
 *   },
 * });
 */
export function useGetTableColumnWithGoalsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableColumnWithGoalsQuery,
    GetTableColumnWithGoalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTableColumnWithGoalsQuery, GetTableColumnWithGoalsQueryVariables>(
    GetTableColumnWithGoalsDocument,
    options
  );
}
export function useGetTableColumnWithGoalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableColumnWithGoalsQuery,
    GetTableColumnWithGoalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTableColumnWithGoalsQuery, GetTableColumnWithGoalsQueryVariables>(
    GetTableColumnWithGoalsDocument,
    options
  );
}
export type GetTableColumnWithGoalsQueryHookResult = ReturnType<
  typeof useGetTableColumnWithGoalsQuery
>;
export type GetTableColumnWithGoalsLazyQueryHookResult = ReturnType<
  typeof useGetTableColumnWithGoalsLazyQuery
>;
export type GetTableColumnWithGoalsQueryResult = Apollo.QueryResult<
  GetTableColumnWithGoalsQuery,
  GetTableColumnWithGoalsQueryVariables
>;
export const GetEmployeeHierarchyDocument = gql`
  query getEmployeeHierarchy($employeeId: ID!, $first: Int = 25, $after: String) {
    employee(id: $employeeId) {
      id
      primaryTeam {
        id
        owner {
          id
          profile {
            id
            fullName
          }
        }
        ancestors(first: $first, after: $after) {
          totalCount
          nodes {
            id
            owner {
              id
              profile {
                id
                fullName
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeHierarchyQuery__
 *
 * To run a query within a React component, call `useGetEmployeeHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeHierarchyQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetEmployeeHierarchyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeHierarchyQuery,
    GetEmployeeHierarchyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeHierarchyQuery, GetEmployeeHierarchyQueryVariables>(
    GetEmployeeHierarchyDocument,
    options
  );
}
export function useGetEmployeeHierarchyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeHierarchyQuery,
    GetEmployeeHierarchyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeHierarchyQuery, GetEmployeeHierarchyQueryVariables>(
    GetEmployeeHierarchyDocument,
    options
  );
}
export type GetEmployeeHierarchyQueryHookResult = ReturnType<typeof useGetEmployeeHierarchyQuery>;
export type GetEmployeeHierarchyLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeHierarchyLazyQuery
>;
export type GetEmployeeHierarchyQueryResult = Apollo.QueryResult<
  GetEmployeeHierarchyQuery,
  GetEmployeeHierarchyQueryVariables
>;
export const GetGroupsTableColumnDocument = gql`
  query getGroupsTableColumn(
    $metric: MetricInput!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $previousStartDate: ISO8601Date!
    $previousEndDate: ISO8601Date!
    $employeeIds: [ID!]
    $groupIds: [ID!]
    $sortField: MetricSortFieldEnum = GROUP_VALUE
    $sortDirection: SortDirectionEnum = DESC
    $includeEmployees: Boolean = false
    $parentGroupId: ID!
    $solicitationReportingTimestamp: SolicitationReportingTimestampEnum
    $channelIds: [ID!]
    $brandingIds: [ID!]
    $languages: [String!]
    $excludeTags: [String!]
    $includeTags: [String!]
    $customProperties: [CustomPropertyFilterInput!]
  ) {
    currentGroupMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        reportingGroupIds: $groupIds
        dateRange: { startDate: $startDate, endDate: $endDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: REPORTING_GROUP_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    currentEmployeeMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        employeeIds: $employeeIds
        reportingGroupIds: [$parentGroupId]
        dateRange: { startDate: $startDate, endDate: $endDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: EMPLOYEE_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) @include(if: $includeEmployees) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    previousGroupMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        reportingGroupIds: $groupIds
        dateRange: { startDate: $previousStartDate, endDate: $previousEndDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: REPORTING_GROUP_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
    previousEmployeeMetrics: calculateMetricByGroup(
      metric: $metric
      filters: {
        employeeIds: $employeeIds
        reportingGroupIds: [$parentGroupId]
        dateRange: { startDate: $previousStartDate, endDate: $previousEndDate }
        customProperties: $customProperties
        channelIds: $channelIds
        brandingIds: $brandingIds
        languages: $languages
        excludeTags: $excludeTags
        includeTags: $includeTags
        solicitationReportingTimestamp: $solicitationReportingTimestamp
      }
      groupBy: EMPLOYEE_ID
      sort: { field: $sortField, direction: $sortDirection }
    ) @include(if: $includeEmployees) {
      edges {
        node {
          groupValue
          metricResult {
            ...tableMetricResultFragment
          }
        }
      }
    }
  }
  ${TableMetricResultFragmentFragmentDoc}
`;

/**
 * __useGetGroupsTableColumnQuery__
 *
 * To run a query within a React component, call `useGetGroupsTableColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsTableColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsTableColumnQuery({
 *   variables: {
 *      metric: // value for 'metric'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *      employeeIds: // value for 'employeeIds'
 *      groupIds: // value for 'groupIds'
 *      sortField: // value for 'sortField'
 *      sortDirection: // value for 'sortDirection'
 *      includeEmployees: // value for 'includeEmployees'
 *      parentGroupId: // value for 'parentGroupId'
 *      solicitationReportingTimestamp: // value for 'solicitationReportingTimestamp'
 *      channelIds: // value for 'channelIds'
 *      brandingIds: // value for 'brandingIds'
 *      languages: // value for 'languages'
 *      excludeTags: // value for 'excludeTags'
 *      includeTags: // value for 'includeTags'
 *      customProperties: // value for 'customProperties'
 *   },
 * });
 */
export function useGetGroupsTableColumnQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGroupsTableColumnQuery,
    GetGroupsTableColumnQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupsTableColumnQuery, GetGroupsTableColumnQueryVariables>(
    GetGroupsTableColumnDocument,
    options
  );
}
export function useGetGroupsTableColumnLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupsTableColumnQuery,
    GetGroupsTableColumnQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupsTableColumnQuery, GetGroupsTableColumnQueryVariables>(
    GetGroupsTableColumnDocument,
    options
  );
}
export type GetGroupsTableColumnQueryHookResult = ReturnType<typeof useGetGroupsTableColumnQuery>;
export type GetGroupsTableColumnLazyQueryHookResult = ReturnType<
  typeof useGetGroupsTableColumnLazyQuery
>;
export type GetGroupsTableColumnQueryResult = Apollo.QueryResult<
  GetGroupsTableColumnQuery,
  GetGroupsTableColumnQueryVariables
>;
export const GetGroupHierarchyDocument = gql`
  query getGroupHierarchy($id: ID!, $first: Int = 25, $after: String) {
    reportingGroup(id: $id) {
      id
      name
      ancestors(first: $first, after: $after) {
        totalCount
        nodes {
          id
          name
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      parent {
        id
        name
      }
    }
  }
`;

/**
 * __useGetGroupHierarchyQuery__
 *
 * To run a query within a React component, call `useGetGroupHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupHierarchyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetGroupHierarchyQuery(
  baseOptions: Apollo.QueryHookOptions<GetGroupHierarchyQuery, GetGroupHierarchyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupHierarchyQuery, GetGroupHierarchyQueryVariables>(
    GetGroupHierarchyDocument,
    options
  );
}
export function useGetGroupHierarchyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGroupHierarchyQuery, GetGroupHierarchyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupHierarchyQuery, GetGroupHierarchyQueryVariables>(
    GetGroupHierarchyDocument,
    options
  );
}
export type GetGroupHierarchyQueryHookResult = ReturnType<typeof useGetGroupHierarchyQuery>;
export type GetGroupHierarchyLazyQueryHookResult = ReturnType<typeof useGetGroupHierarchyLazyQuery>;
export type GetGroupHierarchyQueryResult = Apollo.QueryResult<
  GetGroupHierarchyQuery,
  GetGroupHierarchyQueryVariables
>;
export const GetGroupMembersAndChildrenDocument = gql`
  query getGroupMembersAndChildren(
    $groupId: ID!
    $afterEmployees: String
    $firstEmployees: Int = 25
    $afterChildren: String
    $firstChildren: Int = 25
    $sortDirection: SortDirectionEnum
    $employeeFilters: EmployeeFilterInput = { status: ACTIVE }
    $between: DateRangeInput
  ) {
    reportingGroup(id: $groupId) {
      id
      name
      color
      emoji
      image
      members(
        between: $between
        first: $firstEmployees
        after: $afterEmployees
        filters: $employeeFilters
        sort: [{ field: FIRST_NAME, direction: $sortDirection }]
      ) {
        nodes {
          id
          ...employeeFields
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      children(first: $firstChildren, after: $afterChildren) {
        nodes {
          id
          name
          color
          emoji
          image
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  ${EmployeeFieldsFragmentDoc}
`;

/**
 * __useGetGroupMembersAndChildrenQuery__
 *
 * To run a query within a React component, call `useGetGroupMembersAndChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupMembersAndChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupMembersAndChildrenQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      afterEmployees: // value for 'afterEmployees'
 *      firstEmployees: // value for 'firstEmployees'
 *      afterChildren: // value for 'afterChildren'
 *      firstChildren: // value for 'firstChildren'
 *      sortDirection: // value for 'sortDirection'
 *      employeeFilters: // value for 'employeeFilters'
 *      between: // value for 'between'
 *   },
 * });
 */
export function useGetGroupMembersAndChildrenQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGroupMembersAndChildrenQuery,
    GetGroupMembersAndChildrenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupMembersAndChildrenQuery, GetGroupMembersAndChildrenQueryVariables>(
    GetGroupMembersAndChildrenDocument,
    options
  );
}
export function useGetGroupMembersAndChildrenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupMembersAndChildrenQuery,
    GetGroupMembersAndChildrenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupMembersAndChildrenQuery,
    GetGroupMembersAndChildrenQueryVariables
  >(GetGroupMembersAndChildrenDocument, options);
}
export type GetGroupMembersAndChildrenQueryHookResult = ReturnType<
  typeof useGetGroupMembersAndChildrenQuery
>;
export type GetGroupMembersAndChildrenLazyQueryHookResult = ReturnType<
  typeof useGetGroupMembersAndChildrenLazyQuery
>;
export type GetGroupMembersAndChildrenQueryResult = Apollo.QueryResult<
  GetGroupMembersAndChildrenQuery,
  GetGroupMembersAndChildrenQueryVariables
>;
export const GetMetricByQuestionOptionDocument = gql`
  query getMetricByQuestionOption($filters: MetricFilterInput!, $metric: MetricInput!) {
    calculateMetricByGroup(groupBy: OPTION, filters: $filters, metric: $metric) {
      edges {
        node {
          groupValue
          groupValueId
          groupValueIds
          metricResult {
            value
            displayValue
            higherIsBetter
            totalResults
            displayPercentage
            totalPercentage
          }
        }
      }
    }
  }
`;

/**
 * __useGetMetricByQuestionOptionQuery__
 *
 * To run a query within a React component, call `useGetMetricByQuestionOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricByQuestionOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricByQuestionOptionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *   },
 * });
 */
export function useGetMetricByQuestionOptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMetricByQuestionOptionQuery,
    GetMetricByQuestionOptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricByQuestionOptionQuery, GetMetricByQuestionOptionQueryVariables>(
    GetMetricByQuestionOptionDocument,
    options
  );
}
export function useGetMetricByQuestionOptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricByQuestionOptionQuery,
    GetMetricByQuestionOptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMetricByQuestionOptionQuery,
    GetMetricByQuestionOptionQueryVariables
  >(GetMetricByQuestionOptionDocument, options);
}
export type GetMetricByQuestionOptionQueryHookResult = ReturnType<
  typeof useGetMetricByQuestionOptionQuery
>;
export type GetMetricByQuestionOptionLazyQueryHookResult = ReturnType<
  typeof useGetMetricByQuestionOptionLazyQuery
>;
export type GetMetricByQuestionOptionQueryResult = Apollo.QueryResult<
  GetMetricByQuestionOptionQuery,
  GetMetricByQuestionOptionQueryVariables
>;
export const GetMetricInvestigationGroupByDocument = gql`
  query getMetricInvestigationGroupBy(
    $after: String = ""
    $filters: MetricFilterInput!
    $metric: MetricInput!
    $groupBy: MetricGroupByEnum!
    $interval: TimePeriodEnum = WEEK
  ) {
    company {
      id
      channels {
        id
        name
        slug
        active
        enumId
      }
    }
    calculateMetricByGroup(after: $after, groupBy: $groupBy, filters: $filters, metric: $metric) {
      edges {
        node {
          groupValue
          groupValueId
          metricResult {
            value
            displayValue
            higherIsBetter
            totalResults
            displayPercentage
            totalPercentage
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    calculateMetricTrendByGroup(
      metric: $metric
      filters: $filters
      groupBy: $groupBy
      interval: $interval
    ) {
      dates
      dateRanges {
        endDate
        startDate
      }
      higherIsBetter
      totalPercentage
      displayPercentage
      timeSeries {
        displayValues
        values
        totalResults
        name
        totalPercentages
        displayPercentages
      }
    }
  }
`;

/**
 * __useGetMetricInvestigationGroupByQuery__
 *
 * To run a query within a React component, call `useGetMetricInvestigationGroupByQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricInvestigationGroupByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricInvestigationGroupByQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *      groupBy: // value for 'groupBy'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useGetMetricInvestigationGroupByQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMetricInvestigationGroupByQuery,
    GetMetricInvestigationGroupByQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMetricInvestigationGroupByQuery,
    GetMetricInvestigationGroupByQueryVariables
  >(GetMetricInvestigationGroupByDocument, options);
}
export function useGetMetricInvestigationGroupByLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricInvestigationGroupByQuery,
    GetMetricInvestigationGroupByQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMetricInvestigationGroupByQuery,
    GetMetricInvestigationGroupByQueryVariables
  >(GetMetricInvestigationGroupByDocument, options);
}
export type GetMetricInvestigationGroupByQueryHookResult = ReturnType<
  typeof useGetMetricInvestigationGroupByQuery
>;
export type GetMetricInvestigationGroupByLazyQueryHookResult = ReturnType<
  typeof useGetMetricInvestigationGroupByLazyQuery
>;
export type GetMetricInvestigationGroupByQueryResult = Apollo.QueryResult<
  GetMetricInvestigationGroupByQuery,
  GetMetricInvestigationGroupByQueryVariables
>;
export const GetTagsByRankingDocument = gql`
  query getTagsByRanking($filters: MetricFilterInput!, $metric: MetricInput!, $limit: Int = 25) {
    calculateMetricByTagRanking(filters: $filters, metric: $metric, limit: $limit) {
      bottomRankings {
        name
        metricResult {
          displayValue
          totalResults
        }
      }
      topRankings {
        name
        metricResult {
          displayValue
          totalResults
        }
      }
    }
  }
`;

/**
 * __useGetTagsByRankingQuery__
 *
 * To run a query within a React component, call `useGetTagsByRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsByRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsByRankingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTagsByRankingQuery(
  baseOptions: Apollo.QueryHookOptions<GetTagsByRankingQuery, GetTagsByRankingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTagsByRankingQuery, GetTagsByRankingQueryVariables>(
    GetTagsByRankingDocument,
    options
  );
}
export function useGetTagsByRankingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTagsByRankingQuery, GetTagsByRankingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTagsByRankingQuery, GetTagsByRankingQueryVariables>(
    GetTagsByRankingDocument,
    options
  );
}
export type GetTagsByRankingQueryHookResult = ReturnType<typeof useGetTagsByRankingQuery>;
export type GetTagsByRankingLazyQueryHookResult = ReturnType<typeof useGetTagsByRankingLazyQuery>;
export type GetTagsByRankingQueryResult = Apollo.QueryResult<
  GetTagsByRankingQuery,
  GetTagsByRankingQueryVariables
>;
export const GetTeamHierarchyDocument = gql`
  query getTeamHierarchy($teamId: ID!, $first: Int = 25, $after: String) {
    team(id: $teamId) {
      id
      ancestors(first: $first, after: $after) {
        totalCount
        nodes {
          id
          owner {
            id
            profile {
              id
              fullName
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      parent {
        id
        owner {
          id
          profile {
            id
            fullName
          }
        }
      }
    }
  }
`;

/**
 * __useGetTeamHierarchyQuery__
 *
 * To run a query within a React component, call `useGetTeamHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamHierarchyQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetTeamHierarchyQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>(
    GetTeamHierarchyDocument,
    options
  );
}
export function useGetTeamHierarchyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamHierarchyQuery, GetTeamHierarchyQueryVariables>(
    GetTeamHierarchyDocument,
    options
  );
}
export type GetTeamHierarchyQueryHookResult = ReturnType<typeof useGetTeamHierarchyQuery>;
export type GetTeamHierarchyLazyQueryHookResult = ReturnType<typeof useGetTeamHierarchyLazyQuery>;
export type GetTeamHierarchyQueryResult = Apollo.QueryResult<
  GetTeamHierarchyQuery,
  GetTeamHierarchyQueryVariables
>;
export const GetTopLevelGroupsDocument = gql`
  query getTopLevelGroups(
    $groupFilters: ReportingGroupFilterInput = { isRoot: true }
    $first: Int = 50
    $after: String
  ) {
    reportingGroups(filters: $groupFilters, first: $first, after: $after) {
      nodes {
        id
        name
        color
        emoji
        image
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useGetTopLevelGroupsQuery__
 *
 * To run a query within a React component, call `useGetTopLevelGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopLevelGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopLevelGroupsQuery({
 *   variables: {
 *      groupFilters: // value for 'groupFilters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetTopLevelGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTopLevelGroupsQuery, GetTopLevelGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTopLevelGroupsQuery, GetTopLevelGroupsQueryVariables>(
    GetTopLevelGroupsDocument,
    options
  );
}
export function useGetTopLevelGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTopLevelGroupsQuery, GetTopLevelGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTopLevelGroupsQuery, GetTopLevelGroupsQueryVariables>(
    GetTopLevelGroupsDocument,
    options
  );
}
export type GetTopLevelGroupsQueryHookResult = ReturnType<typeof useGetTopLevelGroupsQuery>;
export type GetTopLevelGroupsLazyQueryHookResult = ReturnType<typeof useGetTopLevelGroupsLazyQuery>;
export type GetTopLevelGroupsQueryResult = Apollo.QueryResult<
  GetTopLevelGroupsQuery,
  GetTopLevelGroupsQueryVariables
>;
export const GetUnitSelectorEmployeesDocument = gql`
  query getUnitSelectorEmployees(
    $first: Int = 50
    $after: String
    $searchEmployee: [EmployeeSearchInput!]
    $withSelectedEmployee: Boolean = false
    $selectedEmployee: ID = ""
    $filters: EmployeeFilterInput = { includeDeactivated: false }
  ) {
    employees(
      first: $first
      after: $after
      sort: [{ field: FIRST_NAME, direction: ASC }, { field: LAST_NAME, direction: ASC }]
      search: $searchEmployee
      filters: $filters
      productArea: COACHING
    ) {
      edges {
        node {
          id
          ...employeeFields
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
    selectedEmployee: employee(id: $selectedEmployee) @include(if: $withSelectedEmployee) {
      id
      ...employeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
`;

/**
 * __useGetUnitSelectorEmployeesQuery__
 *
 * To run a query within a React component, call `useGetUnitSelectorEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitSelectorEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitSelectorEmployeesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchEmployee: // value for 'searchEmployee'
 *      withSelectedEmployee: // value for 'withSelectedEmployee'
 *      selectedEmployee: // value for 'selectedEmployee'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUnitSelectorEmployeesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnitSelectorEmployeesQuery,
    GetUnitSelectorEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnitSelectorEmployeesQuery, GetUnitSelectorEmployeesQueryVariables>(
    GetUnitSelectorEmployeesDocument,
    options
  );
}
export function useGetUnitSelectorEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnitSelectorEmployeesQuery,
    GetUnitSelectorEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUnitSelectorEmployeesQuery, GetUnitSelectorEmployeesQueryVariables>(
    GetUnitSelectorEmployeesDocument,
    options
  );
}
export type GetUnitSelectorEmployeesQueryHookResult = ReturnType<
  typeof useGetUnitSelectorEmployeesQuery
>;
export type GetUnitSelectorEmployeesLazyQueryHookResult = ReturnType<
  typeof useGetUnitSelectorEmployeesLazyQuery
>;
export type GetUnitSelectorEmployeesQueryResult = Apollo.QueryResult<
  GetUnitSelectorEmployeesQuery,
  GetUnitSelectorEmployeesQueryVariables
>;
export const GetUnitSelectorGroupsDocument = gql`
  query getUnitSelectorGroups(
    $first: Int = 50
    $after: String
    $name: String
    $withSelectedGroup: Boolean = false
    $selectedGroup: ID = ""
    $filters: ReportingGroupFilterInput = { active: true }
    $between: DateRangeInput
  ) {
    reportingGroups(first: $first, after: $after, name: $name, filters: $filters) {
      edges {
        node {
          id
          name
          color
          emoji
          image
          members(between: $between) {
            totalCount
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
    selectedGroup: reportingGroup(id: $selectedGroup) @include(if: $withSelectedGroup) {
      id
      name
    }
  }
`;

/**
 * __useGetUnitSelectorGroupsQuery__
 *
 * To run a query within a React component, call `useGetUnitSelectorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitSelectorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitSelectorGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      withSelectedGroup: // value for 'withSelectedGroup'
 *      selectedGroup: // value for 'selectedGroup'
 *      filters: // value for 'filters'
 *      between: // value for 'between'
 *   },
 * });
 */
export function useGetUnitSelectorGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnitSelectorGroupsQuery,
    GetUnitSelectorGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnitSelectorGroupsQuery, GetUnitSelectorGroupsQueryVariables>(
    GetUnitSelectorGroupsDocument,
    options
  );
}
export function useGetUnitSelectorGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnitSelectorGroupsQuery,
    GetUnitSelectorGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUnitSelectorGroupsQuery, GetUnitSelectorGroupsQueryVariables>(
    GetUnitSelectorGroupsDocument,
    options
  );
}
export type GetUnitSelectorGroupsQueryHookResult = ReturnType<typeof useGetUnitSelectorGroupsQuery>;
export type GetUnitSelectorGroupsLazyQueryHookResult = ReturnType<
  typeof useGetUnitSelectorGroupsLazyQuery
>;
export type GetUnitSelectorGroupsQueryResult = Apollo.QueryResult<
  GetUnitSelectorGroupsQuery,
  GetUnitSelectorGroupsQueryVariables
>;
export const GetUnitSelectorTeamsDocument = gql`
  query getUnitSelectorTeams(
    $first: Int = 50
    $after: String
    $searchTeam: [TeamSearchInput!]
    $withSelectedTeam: Boolean = false
    $selectedTeam: ID = ""
    $filters: TeamFilterInput
  ) {
    teams(
      first: $first
      after: $after
      search: $searchTeam
      productArea: COACHING
      filters: $filters
    ) {
      edges {
        node {
          id
          ...teamFields
          children {
            nodes {
              ...teamFields
            }
          }
          employees {
            nodes {
              ...employeeFields
            }
            totalCount
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
    selectedTeam: team(id: $selectedTeam) @include(if: $withSelectedTeam) {
      id
      ...teamFields
    }
  }
  ${TeamFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
`;

/**
 * __useGetUnitSelectorTeamsQuery__
 *
 * To run a query within a React component, call `useGetUnitSelectorTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitSelectorTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitSelectorTeamsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchTeam: // value for 'searchTeam'
 *      withSelectedTeam: // value for 'withSelectedTeam'
 *      selectedTeam: // value for 'selectedTeam'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUnitSelectorTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnitSelectorTeamsQuery,
    GetUnitSelectorTeamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnitSelectorTeamsQuery, GetUnitSelectorTeamsQueryVariables>(
    GetUnitSelectorTeamsDocument,
    options
  );
}
export function useGetUnitSelectorTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnitSelectorTeamsQuery,
    GetUnitSelectorTeamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUnitSelectorTeamsQuery, GetUnitSelectorTeamsQueryVariables>(
    GetUnitSelectorTeamsDocument,
    options
  );
}
export type GetUnitSelectorTeamsQueryHookResult = ReturnType<typeof useGetUnitSelectorTeamsQuery>;
export type GetUnitSelectorTeamsLazyQueryHookResult = ReturnType<
  typeof useGetUnitSelectorTeamsLazyQuery
>;
export type GetUnitSelectorTeamsQueryResult = Apollo.QueryResult<
  GetUnitSelectorTeamsQuery,
  GetUnitSelectorTeamsQueryVariables
>;
export const GetMetricTrendDataDocument = gql`
  query getMetricTrendData(
    $filters: MetricFilterInput!
    $metric: MetricInput!
    $interval: TimePeriodEnum
  ) {
    calculateMetricTrend(filters: $filters, metric: $metric, interval: $interval) {
      displayValue
      title
      value
      questionIdentifier
      timeSeries {
        totalResults
        values
        displayValues
        targetAnswers
      }
      dates
      dateRanges {
        endDate
        startDate
      }
    }
  }
`;

/**
 * __useGetMetricTrendDataQuery__
 *
 * To run a query within a React component, call `useGetMetricTrendDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricTrendDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricTrendDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useGetMetricTrendDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetMetricTrendDataQuery, GetMetricTrendDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricTrendDataQuery, GetMetricTrendDataQueryVariables>(
    GetMetricTrendDataDocument,
    options
  );
}
export function useGetMetricTrendDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricTrendDataQuery,
    GetMetricTrendDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricTrendDataQuery, GetMetricTrendDataQueryVariables>(
    GetMetricTrendDataDocument,
    options
  );
}
export type GetMetricTrendDataQueryHookResult = ReturnType<typeof useGetMetricTrendDataQuery>;
export type GetMetricTrendDataLazyQueryHookResult = ReturnType<
  typeof useGetMetricTrendDataLazyQuery
>;
export type GetMetricTrendDataQueryResult = Apollo.QueryResult<
  GetMetricTrendDataQuery,
  GetMetricTrendDataQueryVariables
>;
export const GetPerformanceHighlightsDocument = gql`
  query getPerformanceHighlights(
    $highlights: [PerformanceHighlightsEnum!]!
    $filters: MetricFilterInput!
  ) {
    performanceHighlights(highlights: $highlights, filters: $filters) {
      id
      name
      value
    }
  }
`;

/**
 * __useGetPerformanceHighlightsQuery__
 *
 * To run a query within a React component, call `useGetPerformanceHighlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformanceHighlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformanceHighlightsQuery({
 *   variables: {
 *      highlights: // value for 'highlights'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPerformanceHighlightsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPerformanceHighlightsQuery,
    GetPerformanceHighlightsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPerformanceHighlightsQuery, GetPerformanceHighlightsQueryVariables>(
    GetPerformanceHighlightsDocument,
    options
  );
}
export function useGetPerformanceHighlightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPerformanceHighlightsQuery,
    GetPerformanceHighlightsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPerformanceHighlightsQuery, GetPerformanceHighlightsQueryVariables>(
    GetPerformanceHighlightsDocument,
    options
  );
}
export type GetPerformanceHighlightsQueryHookResult = ReturnType<
  typeof useGetPerformanceHighlightsQuery
>;
export type GetPerformanceHighlightsLazyQueryHookResult = ReturnType<
  typeof useGetPerformanceHighlightsLazyQuery
>;
export type GetPerformanceHighlightsQueryResult = Apollo.QueryResult<
  GetPerformanceHighlightsQuery,
  GetPerformanceHighlightsQueryVariables
>;
export const AssignLessonDocument = gql`
  mutation assignLesson($input: AssignLessonInput!) {
    assignLesson(input: $input) {
      id
    }
  }
`;
export type AssignLessonMutationFn = Apollo.MutationFunction<
  AssignLessonMutation,
  AssignLessonMutationVariables
>;

/**
 * __useAssignLessonMutation__
 *
 * To run a mutation, you first call `useAssignLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignLessonMutation, { data, loading, error }] = useAssignLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignLessonMutation(
  baseOptions?: Apollo.MutationHookOptions<AssignLessonMutation, AssignLessonMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignLessonMutation, AssignLessonMutationVariables>(
    AssignLessonDocument,
    options
  );
}
export type AssignLessonMutationHookResult = ReturnType<typeof useAssignLessonMutation>;
export type AssignLessonMutationResult = Apollo.MutationResult<AssignLessonMutation>;
export type AssignLessonMutationOptions = Apollo.BaseMutationOptions<
  AssignLessonMutation,
  AssignLessonMutationVariables
>;
export const UnassignLessonDocument = gql`
  mutation unassignLesson($input: UnassignLessonInput!) {
    unassignLesson(input: $input) {
      id
    }
  }
`;
export type UnassignLessonMutationFn = Apollo.MutationFunction<
  UnassignLessonMutation,
  UnassignLessonMutationVariables
>;

/**
 * __useUnassignLessonMutation__
 *
 * To run a mutation, you first call `useUnassignLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignLessonMutation, { data, loading, error }] = useUnassignLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignLessonMutation(
  baseOptions?: Apollo.MutationHookOptions<UnassignLessonMutation, UnassignLessonMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnassignLessonMutation, UnassignLessonMutationVariables>(
    UnassignLessonDocument,
    options
  );
}
export type UnassignLessonMutationHookResult = ReturnType<typeof useUnassignLessonMutation>;
export type UnassignLessonMutationResult = Apollo.MutationResult<UnassignLessonMutation>;
export type UnassignLessonMutationOptions = Apollo.BaseMutationOptions<
  UnassignLessonMutation,
  UnassignLessonMutationVariables
>;
export const GetLessonlyLessonsDocument = gql`
  query getLessonlyLessons {
    lessonly {
      enabled
      lessons {
        id
        title
        tags {
          id
          name
        }
        links {
          shareable
          overview
        }
      }
    }
  }
`;

/**
 * __useGetLessonlyLessonsQuery__
 *
 * To run a query within a React component, call `useGetLessonlyLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonlyLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonlyLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLessonlyLessonsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLessonlyLessonsQuery, GetLessonlyLessonsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLessonlyLessonsQuery, GetLessonlyLessonsQueryVariables>(
    GetLessonlyLessonsDocument,
    options
  );
}
export function useGetLessonlyLessonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLessonlyLessonsQuery,
    GetLessonlyLessonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLessonlyLessonsQuery, GetLessonlyLessonsQueryVariables>(
    GetLessonlyLessonsDocument,
    options
  );
}
export type GetLessonlyLessonsQueryHookResult = ReturnType<typeof useGetLessonlyLessonsQuery>;
export type GetLessonlyLessonsLazyQueryHookResult = ReturnType<
  typeof useGetLessonlyLessonsLazyQuery
>;
export type GetLessonlyLessonsQueryResult = Apollo.QueryResult<
  GetLessonlyLessonsQuery,
  GetLessonlyLessonsQueryVariables
>;
export const GetLessonlyIntegratedDocument = gql`
  query getLessonlyIntegrated {
    lessonly {
      enabled
    }
  }
`;

/**
 * __useGetLessonlyIntegratedQuery__
 *
 * To run a query within a React component, call `useGetLessonlyIntegratedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonlyIntegratedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonlyIntegratedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLessonlyIntegratedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLessonlyIntegratedQuery,
    GetLessonlyIntegratedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLessonlyIntegratedQuery, GetLessonlyIntegratedQueryVariables>(
    GetLessonlyIntegratedDocument,
    options
  );
}
export function useGetLessonlyIntegratedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLessonlyIntegratedQuery,
    GetLessonlyIntegratedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLessonlyIntegratedQuery, GetLessonlyIntegratedQueryVariables>(
    GetLessonlyIntegratedDocument,
    options
  );
}
export type GetLessonlyIntegratedQueryHookResult = ReturnType<typeof useGetLessonlyIntegratedQuery>;
export type GetLessonlyIntegratedLazyQueryHookResult = ReturnType<
  typeof useGetLessonlyIntegratedLazyQuery
>;
export type GetLessonlyIntegratedQueryResult = Apollo.QueryResult<
  GetLessonlyIntegratedQuery,
  GetLessonlyIntegratedQueryVariables
>;
export const AddCoachingTopicToSessionDocument = gql`
  mutation addCoachingTopicToSession($topicId: ID!, $sessionId: ID!) {
    addCoachingTopicToSession(input: { topicId: $topicId, sessionId: $sessionId }) {
      errors {
        message
      }
      publicNote {
        ...publicNoteFields
      }
    }
  }
  ${PublicNoteFieldsFragmentDoc}
`;
export type AddCoachingTopicToSessionMutationFn = Apollo.MutationFunction<
  AddCoachingTopicToSessionMutation,
  AddCoachingTopicToSessionMutationVariables
>;

/**
 * __useAddCoachingTopicToSessionMutation__
 *
 * To run a mutation, you first call `useAddCoachingTopicToSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoachingTopicToSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoachingTopicToSessionMutation, { data, loading, error }] = useAddCoachingTopicToSessionMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useAddCoachingTopicToSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCoachingTopicToSessionMutation,
    AddCoachingTopicToSessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddCoachingTopicToSessionMutation,
    AddCoachingTopicToSessionMutationVariables
  >(AddCoachingTopicToSessionDocument, options);
}
export type AddCoachingTopicToSessionMutationHookResult = ReturnType<
  typeof useAddCoachingTopicToSessionMutation
>;
export type AddCoachingTopicToSessionMutationResult =
  Apollo.MutationResult<AddCoachingTopicToSessionMutation>;
export type AddCoachingTopicToSessionMutationOptions = Apollo.BaseMutationOptions<
  AddCoachingTopicToSessionMutation,
  AddCoachingTopicToSessionMutationVariables
>;
export const AddMemberToGroupDocument = gql`
  mutation addMemberToGroup($input: AddMemberReportingGroupInput!) {
    reportingGroupAddMember(input: $input) {
      id
      name
      members {
        nodes {
          id
          email
        }
      }
    }
  }
`;
export type AddMemberToGroupMutationFn = Apollo.MutationFunction<
  AddMemberToGroupMutation,
  AddMemberToGroupMutationVariables
>;

/**
 * __useAddMemberToGroupMutation__
 *
 * To run a mutation, you first call `useAddMemberToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberToGroupMutation, { data, loading, error }] = useAddMemberToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberToGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddMemberToGroupMutation,
    AddMemberToGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddMemberToGroupMutation, AddMemberToGroupMutationVariables>(
    AddMemberToGroupDocument,
    options
  );
}
export type AddMemberToGroupMutationHookResult = ReturnType<typeof useAddMemberToGroupMutation>;
export type AddMemberToGroupMutationResult = Apollo.MutationResult<AddMemberToGroupMutation>;
export type AddMemberToGroupMutationOptions = Apollo.BaseMutationOptions<
  AddMemberToGroupMutation,
  AddMemberToGroupMutationVariables
>;
export const AddNegativeFeedbackToCoachingTopicDocument = gql`
  mutation addNegativeFeedbackToCoachingTopic(
    $topicId: ID!
    $feedbackReason: NegativeFeedbackReasonEnum
    $feedbackComment: String
  ) {
    addNegativeFeedbackToCoachingTopic(
      input: {
        topicId: $topicId
        feedbackReason: $feedbackReason
        feedbackComment: $feedbackComment
      }
    ) {
      errors {
        message
      }
      coachingTopic {
        ...coachingTopicFields
      }
    }
  }
  ${CoachingTopicFieldsFragmentDoc}
`;
export type AddNegativeFeedbackToCoachingTopicMutationFn = Apollo.MutationFunction<
  AddNegativeFeedbackToCoachingTopicMutation,
  AddNegativeFeedbackToCoachingTopicMutationVariables
>;

/**
 * __useAddNegativeFeedbackToCoachingTopicMutation__
 *
 * To run a mutation, you first call `useAddNegativeFeedbackToCoachingTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNegativeFeedbackToCoachingTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNegativeFeedbackToCoachingTopicMutation, { data, loading, error }] = useAddNegativeFeedbackToCoachingTopicMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      feedbackReason: // value for 'feedbackReason'
 *      feedbackComment: // value for 'feedbackComment'
 *   },
 * });
 */
export function useAddNegativeFeedbackToCoachingTopicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddNegativeFeedbackToCoachingTopicMutation,
    AddNegativeFeedbackToCoachingTopicMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddNegativeFeedbackToCoachingTopicMutation,
    AddNegativeFeedbackToCoachingTopicMutationVariables
  >(AddNegativeFeedbackToCoachingTopicDocument, options);
}
export type AddNegativeFeedbackToCoachingTopicMutationHookResult = ReturnType<
  typeof useAddNegativeFeedbackToCoachingTopicMutation
>;
export type AddNegativeFeedbackToCoachingTopicMutationResult =
  Apollo.MutationResult<AddNegativeFeedbackToCoachingTopicMutation>;
export type AddNegativeFeedbackToCoachingTopicMutationOptions = Apollo.BaseMutationOptions<
  AddNegativeFeedbackToCoachingTopicMutation,
  AddNegativeFeedbackToCoachingTopicMutationVariables
>;
export const AppealReviewDocument = gql`
  mutation appealReview($input: AppealQaReviewInput!) {
    appealQaReview(input: $input) {
      id
      createdAt
      reasons {
        note
        qaAnswer {
          id
        }
      }
      employee {
        id
        profile {
          id
          fullName
        }
      }
    }
  }
`;
export type AppealReviewMutationFn = Apollo.MutationFunction<
  AppealReviewMutation,
  AppealReviewMutationVariables
>;

/**
 * __useAppealReviewMutation__
 *
 * To run a mutation, you first call `useAppealReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppealReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appealReviewMutation, { data, loading, error }] = useAppealReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppealReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<AppealReviewMutation, AppealReviewMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AppealReviewMutation, AppealReviewMutationVariables>(
    AppealReviewDocument,
    options
  );
}
export type AppealReviewMutationHookResult = ReturnType<typeof useAppealReviewMutation>;
export type AppealReviewMutationResult = Apollo.MutationResult<AppealReviewMutation>;
export type AppealReviewMutationOptions = Apollo.BaseMutationOptions<
  AppealReviewMutation,
  AppealReviewMutationVariables
>;
export const ApplyCoachingTemplateDocument = gql`
  mutation applyCoachingTemplate($noteId: ID!, $templateId: ID!) {
    applyCoachingTemplateToPublicNote(input: { noteId: $noteId, templateId: $templateId }) {
      publicNote {
        ...publicNoteFields
      }
      errors {
        message
        path
      }
    }
  }
  ${PublicNoteFieldsFragmentDoc}
`;
export type ApplyCoachingTemplateMutationFn = Apollo.MutationFunction<
  ApplyCoachingTemplateMutation,
  ApplyCoachingTemplateMutationVariables
>;

/**
 * __useApplyCoachingTemplateMutation__
 *
 * To run a mutation, you first call `useApplyCoachingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCoachingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCoachingTemplateMutation, { data, loading, error }] = useApplyCoachingTemplateMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useApplyCoachingTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyCoachingTemplateMutation,
    ApplyCoachingTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApplyCoachingTemplateMutation, ApplyCoachingTemplateMutationVariables>(
    ApplyCoachingTemplateDocument,
    options
  );
}
export type ApplyCoachingTemplateMutationHookResult = ReturnType<
  typeof useApplyCoachingTemplateMutation
>;
export type ApplyCoachingTemplateMutationResult =
  Apollo.MutationResult<ApplyCoachingTemplateMutation>;
export type ApplyCoachingTemplateMutationOptions = Apollo.BaseMutationOptions<
  ApplyCoachingTemplateMutation,
  ApplyCoachingTemplateMutationVariables
>;
export const ArchiveQaAssignmentDocument = gql`
  mutation archiveQaAssignment($assignmentId: ID!) {
    archiveQaAssignment(input: { id: $assignmentId }) {
      id
      archivedAt
    }
  }
`;
export type ArchiveQaAssignmentMutationFn = Apollo.MutationFunction<
  ArchiveQaAssignmentMutation,
  ArchiveQaAssignmentMutationVariables
>;

/**
 * __useArchiveQaAssignmentMutation__
 *
 * To run a mutation, you first call `useArchiveQaAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveQaAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveQaAssignmentMutation, { data, loading, error }] = useArchiveQaAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useArchiveQaAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveQaAssignmentMutation,
    ArchiveQaAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveQaAssignmentMutation, ArchiveQaAssignmentMutationVariables>(
    ArchiveQaAssignmentDocument,
    options
  );
}
export type ArchiveQaAssignmentMutationHookResult = ReturnType<
  typeof useArchiveQaAssignmentMutation
>;
export type ArchiveQaAssignmentMutationResult = Apollo.MutationResult<ArchiveQaAssignmentMutation>;
export type ArchiveQaAssignmentMutationOptions = Apollo.BaseMutationOptions<
  ArchiveQaAssignmentMutation,
  ArchiveQaAssignmentMutationVariables
>;
export const ArchiveCoachingTemplateDocument = gql`
  mutation archiveCoachingTemplate($id: ID!) {
    archiveCoachingTemplate(input: { id: $id }) {
      coachingTemplate {
        id
        status
      }
      errors {
        message
        path
      }
    }
  }
`;
export type ArchiveCoachingTemplateMutationFn = Apollo.MutationFunction<
  ArchiveCoachingTemplateMutation,
  ArchiveCoachingTemplateMutationVariables
>;

/**
 * __useArchiveCoachingTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveCoachingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCoachingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCoachingTemplateMutation, { data, loading, error }] = useArchiveCoachingTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveCoachingTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveCoachingTemplateMutation,
    ArchiveCoachingTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveCoachingTemplateMutation,
    ArchiveCoachingTemplateMutationVariables
  >(ArchiveCoachingTemplateDocument, options);
}
export type ArchiveCoachingTemplateMutationHookResult = ReturnType<
  typeof useArchiveCoachingTemplateMutation
>;
export type ArchiveCoachingTemplateMutationResult =
  Apollo.MutationResult<ArchiveCoachingTemplateMutation>;
export type ArchiveCoachingTemplateMutationOptions = Apollo.BaseMutationOptions<
  ArchiveCoachingTemplateMutation,
  ArchiveCoachingTemplateMutationVariables
>;
export const ArchiveFreeformGoalDocument = gql`
  mutation archiveFreeformGoal($freeformGoalId: ID!) {
    archiveFreeformGoal(input: { id: $freeformGoalId }) {
      id
      archivedAt
    }
  }
`;
export type ArchiveFreeformGoalMutationFn = Apollo.MutationFunction<
  ArchiveFreeformGoalMutation,
  ArchiveFreeformGoalMutationVariables
>;

/**
 * __useArchiveFreeformGoalMutation__
 *
 * To run a mutation, you first call `useArchiveFreeformGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFreeformGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFreeformGoalMutation, { data, loading, error }] = useArchiveFreeformGoalMutation({
 *   variables: {
 *      freeformGoalId: // value for 'freeformGoalId'
 *   },
 * });
 */
export function useArchiveFreeformGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveFreeformGoalMutation,
    ArchiveFreeformGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveFreeformGoalMutation, ArchiveFreeformGoalMutationVariables>(
    ArchiveFreeformGoalDocument,
    options
  );
}
export type ArchiveFreeformGoalMutationHookResult = ReturnType<
  typeof useArchiveFreeformGoalMutation
>;
export type ArchiveFreeformGoalMutationResult = Apollo.MutationResult<ArchiveFreeformGoalMutation>;
export type ArchiveFreeformGoalMutationOptions = Apollo.BaseMutationOptions<
  ArchiveFreeformGoalMutation,
  ArchiveFreeformGoalMutationVariables
>;
export const ArchiveGoalDocument = gql`
  mutation archiveGoal($metricGoalId: ID!, $type: MetricGoalTypeEnum!) {
    archiveMetricGoal(input: { id: $metricGoalId, type: $type }) {
      ... on MetricGoalGroup {
        id
        archivedAt
        type
      }
      ... on MetricGoalEmployee {
        id
        archivedAt
        type
      }
    }
  }
`;
export type ArchiveGoalMutationFn = Apollo.MutationFunction<
  ArchiveGoalMutation,
  ArchiveGoalMutationVariables
>;

/**
 * __useArchiveGoalMutation__
 *
 * To run a mutation, you first call `useArchiveGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveGoalMutation, { data, loading, error }] = useArchiveGoalMutation({
 *   variables: {
 *      metricGoalId: // value for 'metricGoalId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useArchiveGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveGoalMutation, ArchiveGoalMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ArchiveGoalMutation, ArchiveGoalMutationVariables>(
    ArchiveGoalDocument,
    options
  );
}
export type ArchiveGoalMutationHookResult = ReturnType<typeof useArchiveGoalMutation>;
export type ArchiveGoalMutationResult = Apollo.MutationResult<ArchiveGoalMutation>;
export type ArchiveGoalMutationOptions = Apollo.BaseMutationOptions<
  ArchiveGoalMutation,
  ArchiveGoalMutationVariables
>;
export const BulkDeactivateEmployeesDocument = gql`
  mutation bulkDeactivateEmployees($input: BulkDeactivateEmployeesInput!) {
    bulkDeactivateEmployees(input: $input) {
      deactivatedTeamMembers {
        id
        profile {
          id
          fullName
        }
      }
      deactivatedTeamLeaders {
        id
        profile {
          id
          fullName
          imageUrl
        }
      }
      errors {
        message
      }
    }
  }
`;
export type BulkDeactivateEmployeesMutationFn = Apollo.MutationFunction<
  BulkDeactivateEmployeesMutation,
  BulkDeactivateEmployeesMutationVariables
>;

/**
 * __useBulkDeactivateEmployeesMutation__
 *
 * To run a mutation, you first call `useBulkDeactivateEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeactivateEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeactivateEmployeesMutation, { data, loading, error }] = useBulkDeactivateEmployeesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkDeactivateEmployeesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkDeactivateEmployeesMutation,
    BulkDeactivateEmployeesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkDeactivateEmployeesMutation,
    BulkDeactivateEmployeesMutationVariables
  >(BulkDeactivateEmployeesDocument, options);
}
export type BulkDeactivateEmployeesMutationHookResult = ReturnType<
  typeof useBulkDeactivateEmployeesMutation
>;
export type BulkDeactivateEmployeesMutationResult =
  Apollo.MutationResult<BulkDeactivateEmployeesMutation>;
export type BulkDeactivateEmployeesMutationOptions = Apollo.BaseMutationOptions<
  BulkDeactivateEmployeesMutation,
  BulkDeactivateEmployeesMutationVariables
>;
export const CompleteActionItemDocument = gql`
  mutation completeActionItem($actionItemId: ID!) {
    completeActionItem(input: { id: $actionItemId }) {
      action
      completedAt
      createdAt
      id
    }
  }
`;
export type CompleteActionItemMutationFn = Apollo.MutationFunction<
  CompleteActionItemMutation,
  CompleteActionItemMutationVariables
>;

/**
 * __useCompleteActionItemMutation__
 *
 * To run a mutation, you first call `useCompleteActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeActionItemMutation, { data, loading, error }] = useCompleteActionItemMutation({
 *   variables: {
 *      actionItemId: // value for 'actionItemId'
 *   },
 * });
 */
export function useCompleteActionItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteActionItemMutation,
    CompleteActionItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteActionItemMutation, CompleteActionItemMutationVariables>(
    CompleteActionItemDocument,
    options
  );
}
export type CompleteActionItemMutationHookResult = ReturnType<typeof useCompleteActionItemMutation>;
export type CompleteActionItemMutationResult = Apollo.MutationResult<CompleteActionItemMutation>;
export type CompleteActionItemMutationOptions = Apollo.BaseMutationOptions<
  CompleteActionItemMutation,
  CompleteActionItemMutationVariables
>;
export const CompleteCalibrationDocument = gql`
  mutation completeCalibration($id: ID!) {
    completeCalibration(input: { id: $id }) {
      errors {
        message
        path
      }
      qaCalibration {
        id
        completedAt
        status
        alignmentScore
      }
    }
  }
`;
export type CompleteCalibrationMutationFn = Apollo.MutationFunction<
  CompleteCalibrationMutation,
  CompleteCalibrationMutationVariables
>;

/**
 * __useCompleteCalibrationMutation__
 *
 * To run a mutation, you first call `useCompleteCalibrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCalibrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCalibrationMutation, { data, loading, error }] = useCompleteCalibrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteCalibrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteCalibrationMutation,
    CompleteCalibrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteCalibrationMutation, CompleteCalibrationMutationVariables>(
    CompleteCalibrationDocument,
    options
  );
}
export type CompleteCalibrationMutationHookResult = ReturnType<
  typeof useCompleteCalibrationMutation
>;
export type CompleteCalibrationMutationResult = Apollo.MutationResult<CompleteCalibrationMutation>;
export type CompleteCalibrationMutationOptions = Apollo.BaseMutationOptions<
  CompleteCalibrationMutation,
  CompleteCalibrationMutationVariables
>;
export const CompleteFreeformGoalDocument = gql`
  mutation completeFreeformGoal($freeformGoalId: ID!) {
    completeFreeformGoal(input: { id: $freeformGoalId }) {
      id
      completedAt
    }
  }
`;
export type CompleteFreeformGoalMutationFn = Apollo.MutationFunction<
  CompleteFreeformGoalMutation,
  CompleteFreeformGoalMutationVariables
>;

/**
 * __useCompleteFreeformGoalMutation__
 *
 * To run a mutation, you first call `useCompleteFreeformGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteFreeformGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeFreeformGoalMutation, { data, loading, error }] = useCompleteFreeformGoalMutation({
 *   variables: {
 *      freeformGoalId: // value for 'freeformGoalId'
 *   },
 * });
 */
export function useCompleteFreeformGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteFreeformGoalMutation,
    CompleteFreeformGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteFreeformGoalMutation, CompleteFreeformGoalMutationVariables>(
    CompleteFreeformGoalDocument,
    options
  );
}
export type CompleteFreeformGoalMutationHookResult = ReturnType<
  typeof useCompleteFreeformGoalMutation
>;
export type CompleteFreeformGoalMutationResult =
  Apollo.MutationResult<CompleteFreeformGoalMutation>;
export type CompleteFreeformGoalMutationOptions = Apollo.BaseMutationOptions<
  CompleteFreeformGoalMutation,
  CompleteFreeformGoalMutationVariables
>;
export const CompleteGoalDocument = gql`
  mutation completeGoal($metricGoalId: ID!, $type: MetricGoalTypeEnum!) {
    completeMetricGoal(input: { id: $metricGoalId, type: $type }) {
      ... on MetricGoalGroup {
        id
        completedAt
        type
      }
      ... on MetricGoalEmployee {
        id
        completedAt
        type
      }
    }
  }
`;
export type CompleteGoalMutationFn = Apollo.MutationFunction<
  CompleteGoalMutation,
  CompleteGoalMutationVariables
>;

/**
 * __useCompleteGoalMutation__
 *
 * To run a mutation, you first call `useCompleteGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeGoalMutation, { data, loading, error }] = useCompleteGoalMutation({
 *   variables: {
 *      metricGoalId: // value for 'metricGoalId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCompleteGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<CompleteGoalMutation, CompleteGoalMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteGoalMutation, CompleteGoalMutationVariables>(
    CompleteGoalDocument,
    options
  );
}
export type CompleteGoalMutationHookResult = ReturnType<typeof useCompleteGoalMutation>;
export type CompleteGoalMutationResult = Apollo.MutationResult<CompleteGoalMutation>;
export type CompleteGoalMutationOptions = Apollo.BaseMutationOptions<
  CompleteGoalMutation,
  CompleteGoalMutationVariables
>;
export const CreateAnswerDocument = gql`
  mutation createAnswer($input: CreateAnswerInput!) {
    createAnswer(input: $input) {
      id
      answered
      comments
      createdAt
      qaQuestion {
        id
      }
      qaOption {
        id
      }
    }
  }
`;
export type CreateAnswerMutationFn = Apollo.MutationFunction<
  CreateAnswerMutation,
  CreateAnswerMutationVariables
>;

/**
 * __useCreateAnswerMutation__
 *
 * To run a mutation, you first call `useCreateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerMutation, { data, loading, error }] = useCreateAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAnswerMutation, CreateAnswerMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAnswerMutation, CreateAnswerMutationVariables>(
    CreateAnswerDocument,
    options
  );
}
export type CreateAnswerMutationHookResult = ReturnType<typeof useCreateAnswerMutation>;
export type CreateAnswerMutationResult = Apollo.MutationResult<CreateAnswerMutation>;
export type CreateAnswerMutationOptions = Apollo.BaseMutationOptions<
  CreateAnswerMutation,
  CreateAnswerMutationVariables
>;
export const CreateNewAuditDocument = gql`
  mutation createNewAudit($input: CreateAuditInput!) {
    createAudit(input: $input) {
      id
      qaReview {
        id
      }
      auditable {
        __typename
        ... on QaReviewRegularAudit {
          id
          qaForm {
            id
          }
        }
      }
      qaForm {
        id
      }
    }
  }
`;
export type CreateNewAuditMutationFn = Apollo.MutationFunction<
  CreateNewAuditMutation,
  CreateNewAuditMutationVariables
>;

/**
 * __useCreateNewAuditMutation__
 *
 * To run a mutation, you first call `useCreateNewAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewAuditMutation, { data, loading, error }] = useCreateNewAuditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewAuditMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateNewAuditMutation, CreateNewAuditMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateNewAuditMutation, CreateNewAuditMutationVariables>(
    CreateNewAuditDocument,
    options
  );
}
export type CreateNewAuditMutationHookResult = ReturnType<typeof useCreateNewAuditMutation>;
export type CreateNewAuditMutationResult = Apollo.MutationResult<CreateNewAuditMutation>;
export type CreateNewAuditMutationOptions = Apollo.BaseMutationOptions<
  CreateNewAuditMutation,
  CreateNewAuditMutationVariables
>;
export const CreateCalibrationDocument = gql`
  mutation createCalibration($input: CreateCalibrationInput!) {
    createCalibration(input: $input) {
      qaCalibration {
        id
        createdAt
        ownerReviewId
      }
      errors {
        message
        path
      }
    }
  }
`;
export type CreateCalibrationMutationFn = Apollo.MutationFunction<
  CreateCalibrationMutation,
  CreateCalibrationMutationVariables
>;

/**
 * __useCreateCalibrationMutation__
 *
 * To run a mutation, you first call `useCreateCalibrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalibrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalibrationMutation, { data, loading, error }] = useCreateCalibrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalibrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCalibrationMutation,
    CreateCalibrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCalibrationMutation, CreateCalibrationMutationVariables>(
    CreateCalibrationDocument,
    options
  );
}
export type CreateCalibrationMutationHookResult = ReturnType<typeof useCreateCalibrationMutation>;
export type CreateCalibrationMutationResult = Apollo.MutationResult<CreateCalibrationMutation>;
export type CreateCalibrationMutationOptions = Apollo.BaseMutationOptions<
  CreateCalibrationMutation,
  CreateCalibrationMutationVariables
>;
export const CreateCalibtationsExportDocument = gql`
  mutation createCalibtationsExport($input: CreateCalibrationsExportInput!) {
    createCalibtationsExport(input: $input) {
      errors {
        details
      }
      export {
        id
        state
      }
    }
  }
`;
export type CreateCalibtationsExportMutationFn = Apollo.MutationFunction<
  CreateCalibtationsExportMutation,
  CreateCalibtationsExportMutationVariables
>;

/**
 * __useCreateCalibtationsExportMutation__
 *
 * To run a mutation, you first call `useCreateCalibtationsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalibtationsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalibtationsExportMutation, { data, loading, error }] = useCreateCalibtationsExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalibtationsExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCalibtationsExportMutation,
    CreateCalibtationsExportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCalibtationsExportMutation,
    CreateCalibtationsExportMutationVariables
  >(CreateCalibtationsExportDocument, options);
}
export type CreateCalibtationsExportMutationHookResult = ReturnType<
  typeof useCreateCalibtationsExportMutation
>;
export type CreateCalibtationsExportMutationResult =
  Apollo.MutationResult<CreateCalibtationsExportMutation>;
export type CreateCalibtationsExportMutationOptions = Apollo.BaseMutationOptions<
  CreateCalibtationsExportMutation,
  CreateCalibtationsExportMutationVariables
>;
export const CreateNewCalibrationAuditDocument = gql`
  mutation createNewCalibrationAudit($input: CreateCalibrationAuditInput!) {
    createCalibrationAudit(input: $input) {
      id
      qaReview {
        id
      }
      auditable {
        __typename
        ... on QaReviewCalibrationAudit {
          id
        }
      }
    }
  }
`;
export type CreateNewCalibrationAuditMutationFn = Apollo.MutationFunction<
  CreateNewCalibrationAuditMutation,
  CreateNewCalibrationAuditMutationVariables
>;

/**
 * __useCreateNewCalibrationAuditMutation__
 *
 * To run a mutation, you first call `useCreateNewCalibrationAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewCalibrationAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewCalibrationAuditMutation, { data, loading, error }] = useCreateNewCalibrationAuditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewCalibrationAuditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNewCalibrationAuditMutation,
    CreateNewCalibrationAuditMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateNewCalibrationAuditMutation,
    CreateNewCalibrationAuditMutationVariables
  >(CreateNewCalibrationAuditDocument, options);
}
export type CreateNewCalibrationAuditMutationHookResult = ReturnType<
  typeof useCreateNewCalibrationAuditMutation
>;
export type CreateNewCalibrationAuditMutationResult =
  Apollo.MutationResult<CreateNewCalibrationAuditMutation>;
export type CreateNewCalibrationAuditMutationOptions = Apollo.BaseMutationOptions<
  CreateNewCalibrationAuditMutation,
  CreateNewCalibrationAuditMutationVariables
>;
export const CreateCoachingExportDocument = gql`
  mutation createCoachingExport($input: CreateCoachingExportInput!) {
    createCoachingExport(input: $input) {
      errors {
        details
      }
      export {
        id
        state
      }
    }
  }
`;
export type CreateCoachingExportMutationFn = Apollo.MutationFunction<
  CreateCoachingExportMutation,
  CreateCoachingExportMutationVariables
>;

/**
 * __useCreateCoachingExportMutation__
 *
 * To run a mutation, you first call `useCreateCoachingExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachingExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachingExportMutation, { data, loading, error }] = useCreateCoachingExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoachingExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCoachingExportMutation,
    CreateCoachingExportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCoachingExportMutation, CreateCoachingExportMutationVariables>(
    CreateCoachingExportDocument,
    options
  );
}
export type CreateCoachingExportMutationHookResult = ReturnType<
  typeof useCreateCoachingExportMutation
>;
export type CreateCoachingExportMutationResult =
  Apollo.MutationResult<CreateCoachingExportMutation>;
export type CreateCoachingExportMutationOptions = Apollo.BaseMutationOptions<
  CreateCoachingExportMutation,
  CreateCoachingExportMutationVariables
>;
export const CreateCoachingSessionDocument = gql`
  mutation createCoachingSession($coacheeId: ID!) {
    createCoachingSession(input: { employeeId: $coacheeId }) {
      id
    }
  }
`;
export type CreateCoachingSessionMutationFn = Apollo.MutationFunction<
  CreateCoachingSessionMutation,
  CreateCoachingSessionMutationVariables
>;

/**
 * __useCreateCoachingSessionMutation__
 *
 * To run a mutation, you first call `useCreateCoachingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachingSessionMutation, { data, loading, error }] = useCreateCoachingSessionMutation({
 *   variables: {
 *      coacheeId: // value for 'coacheeId'
 *   },
 * });
 */
export function useCreateCoachingSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCoachingSessionMutation,
    CreateCoachingSessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCoachingSessionMutation, CreateCoachingSessionMutationVariables>(
    CreateCoachingSessionDocument,
    options
  );
}
export type CreateCoachingSessionMutationHookResult = ReturnType<
  typeof useCreateCoachingSessionMutation
>;
export type CreateCoachingSessionMutationResult =
  Apollo.MutationResult<CreateCoachingSessionMutation>;
export type CreateCoachingSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateCoachingSessionMutation,
  CreateCoachingSessionMutationVariables
>;
export const CreateCoachingSessionActionItemDocument = gql`
  mutation createCoachingSessionActionItem($input: CreateCoachingSessionActionItemInput!) {
    createCoachingSessionActionItem(input: $input) {
      actionItem {
        id
        owner {
          id
          profile {
            id
            imageUrl
            fullName
          }
        }
        createdAt
        dueDate
        text
      }
    }
  }
`;
export type CreateCoachingSessionActionItemMutationFn = Apollo.MutationFunction<
  CreateCoachingSessionActionItemMutation,
  CreateCoachingSessionActionItemMutationVariables
>;

/**
 * __useCreateCoachingSessionActionItemMutation__
 *
 * To run a mutation, you first call `useCreateCoachingSessionActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachingSessionActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachingSessionActionItemMutation, { data, loading, error }] = useCreateCoachingSessionActionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoachingSessionActionItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCoachingSessionActionItemMutation,
    CreateCoachingSessionActionItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCoachingSessionActionItemMutation,
    CreateCoachingSessionActionItemMutationVariables
  >(CreateCoachingSessionActionItemDocument, options);
}
export type CreateCoachingSessionActionItemMutationHookResult = ReturnType<
  typeof useCreateCoachingSessionActionItemMutation
>;
export type CreateCoachingSessionActionItemMutationResult =
  Apollo.MutationResult<CreateCoachingSessionActionItemMutation>;
export type CreateCoachingSessionActionItemMutationOptions = Apollo.BaseMutationOptions<
  CreateCoachingSessionActionItemMutation,
  CreateCoachingSessionActionItemMutationVariables
>;
export const CreatePublicNoteDocument = gql`
  mutation createPublicNote($publicNoteInput: CreateCoachingSessionPublicNoteInput!) {
    createCoachingSessionPublicNote(input: $publicNoteInput) {
      publicNote {
        ...publicNoteFields
      }
      errors {
        message
        path
      }
    }
  }
  ${PublicNoteFieldsFragmentDoc}
`;
export type CreatePublicNoteMutationFn = Apollo.MutationFunction<
  CreatePublicNoteMutation,
  CreatePublicNoteMutationVariables
>;

/**
 * __useCreatePublicNoteMutation__
 *
 * To run a mutation, you first call `useCreatePublicNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicNoteMutation, { data, loading, error }] = useCreatePublicNoteMutation({
 *   variables: {
 *      publicNoteInput: // value for 'publicNoteInput'
 *   },
 * });
 */
export function useCreatePublicNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePublicNoteMutation,
    CreatePublicNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePublicNoteMutation, CreatePublicNoteMutationVariables>(
    CreatePublicNoteDocument,
    options
  );
}
export type CreatePublicNoteMutationHookResult = ReturnType<typeof useCreatePublicNoteMutation>;
export type CreatePublicNoteMutationResult = Apollo.MutationResult<CreatePublicNoteMutation>;
export type CreatePublicNoteMutationOptions = Apollo.BaseMutationOptions<
  CreatePublicNoteMutation,
  CreatePublicNoteMutationVariables
>;
export const CreateCoachingTemplateDocument = gql`
  mutation createCoachingTemplate($input: CreateCoachingTemplateInput!) {
    createCoachingTemplate(input: $input) {
      coachingTemplate {
        id
        name
        body
      }
      errors {
        message
        path
      }
    }
  }
`;
export type CreateCoachingTemplateMutationFn = Apollo.MutationFunction<
  CreateCoachingTemplateMutation,
  CreateCoachingTemplateMutationVariables
>;

/**
 * __useCreateCoachingTemplateMutation__
 *
 * To run a mutation, you first call `useCreateCoachingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachingTemplateMutation, { data, loading, error }] = useCreateCoachingTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoachingTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCoachingTemplateMutation,
    CreateCoachingTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCoachingTemplateMutation,
    CreateCoachingTemplateMutationVariables
  >(CreateCoachingTemplateDocument, options);
}
export type CreateCoachingTemplateMutationHookResult = ReturnType<
  typeof useCreateCoachingTemplateMutation
>;
export type CreateCoachingTemplateMutationResult =
  Apollo.MutationResult<CreateCoachingTemplateMutation>;
export type CreateCoachingTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateCoachingTemplateMutation,
  CreateCoachingTemplateMutationVariables
>;
export const CreateUserDocument = gql`
  mutation createUser($input: CreateEmployeeInput!) {
    createEmployee(input: $input) {
      channels
      customEmployeeId
      customRole {
        id
        name
      }
      email
      employeeGroups {
        id
        name
      }
      employmentStatus
      id
      licenseType
      primaryTeam {
        id
        owner {
          id
          profile {
            id
            fullName
            firstName
            lastName
          }
        }
      }
      profile {
        id
        countryCode
        fullName
        firstName
        lastName
      }
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options
  );
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const CreateFeedbackExportDocument = gql`
  mutation createFeedbackExport($input: CreateFeedbackExportInput!) {
    createFeedbackExport(input: $input) {
      export {
        id
        state
      }
      errors {
        message
        path
      }
    }
  }
`;
export type CreateFeedbackExportMutationFn = Apollo.MutationFunction<
  CreateFeedbackExportMutation,
  CreateFeedbackExportMutationVariables
>;

/**
 * __useCreateFeedbackExportMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackExportMutation, { data, loading, error }] = useCreateFeedbackExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFeedbackExportMutation,
    CreateFeedbackExportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFeedbackExportMutation, CreateFeedbackExportMutationVariables>(
    CreateFeedbackExportDocument,
    options
  );
}
export type CreateFeedbackExportMutationHookResult = ReturnType<
  typeof useCreateFeedbackExportMutation
>;
export type CreateFeedbackExportMutationResult =
  Apollo.MutationResult<CreateFeedbackExportMutation>;
export type CreateFeedbackExportMutationOptions = Apollo.BaseMutationOptions<
  CreateFeedbackExportMutation,
  CreateFeedbackExportMutationVariables
>;
export const CreateFeedbackExportTemplateDocument = gql`
  mutation createFeedbackExportTemplate($input: CreateFeedbackExportTemplateInput!) {
    createFeedbackExportTemplate(input: $input) {
      template {
        id
        name
      }
      errors {
        message
        path
      }
    }
  }
`;
export type CreateFeedbackExportTemplateMutationFn = Apollo.MutationFunction<
  CreateFeedbackExportTemplateMutation,
  CreateFeedbackExportTemplateMutationVariables
>;

/**
 * __useCreateFeedbackExportTemplateMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackExportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackExportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackExportTemplateMutation, { data, loading, error }] = useCreateFeedbackExportTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackExportTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFeedbackExportTemplateMutation,
    CreateFeedbackExportTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFeedbackExportTemplateMutation,
    CreateFeedbackExportTemplateMutationVariables
  >(CreateFeedbackExportTemplateDocument, options);
}
export type CreateFeedbackExportTemplateMutationHookResult = ReturnType<
  typeof useCreateFeedbackExportTemplateMutation
>;
export type CreateFeedbackExportTemplateMutationResult =
  Apollo.MutationResult<CreateFeedbackExportTemplateMutation>;
export type CreateFeedbackExportTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateFeedbackExportTemplateMutation,
  CreateFeedbackExportTemplateMutationVariables
>;
export const CreateFeedbackExportFromTemplateDocument = gql`
  mutation createFeedbackExportFromTemplate($id: ID!) {
    createFeedbackExportFromTemplate(input: { id: $id }) {
      export {
        id
        state
      }
      errors {
        message
        path
      }
    }
  }
`;
export type CreateFeedbackExportFromTemplateMutationFn = Apollo.MutationFunction<
  CreateFeedbackExportFromTemplateMutation,
  CreateFeedbackExportFromTemplateMutationVariables
>;

/**
 * __useCreateFeedbackExportFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackExportFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackExportFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackExportFromTemplateMutation, { data, loading, error }] = useCreateFeedbackExportFromTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateFeedbackExportFromTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFeedbackExportFromTemplateMutation,
    CreateFeedbackExportFromTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFeedbackExportFromTemplateMutation,
    CreateFeedbackExportFromTemplateMutationVariables
  >(CreateFeedbackExportFromTemplateDocument, options);
}
export type CreateFeedbackExportFromTemplateMutationHookResult = ReturnType<
  typeof useCreateFeedbackExportFromTemplateMutation
>;
export type CreateFeedbackExportFromTemplateMutationResult =
  Apollo.MutationResult<CreateFeedbackExportFromTemplateMutation>;
export type CreateFeedbackExportFromTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateFeedbackExportFromTemplateMutation,
  CreateFeedbackExportFromTemplateMutationVariables
>;
export const CreateFollowUpDocument = gql`
  mutation createFollowUp($input: CreateFollowUpInput!) {
    createFollowUp(input: $input) {
      followUp {
        id
        followUpable {
          ... on Interaction {
            id
            __typename
          }
        }
      }
      errors {
        message
        path
      }
    }
  }
`;
export type CreateFollowUpMutationFn = Apollo.MutationFunction<
  CreateFollowUpMutation,
  CreateFollowUpMutationVariables
>;

/**
 * __useCreateFollowUpMutation__
 *
 * To run a mutation, you first call `useCreateFollowUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFollowUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFollowUpMutation, { data, loading, error }] = useCreateFollowUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFollowUpMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFollowUpMutation, CreateFollowUpMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFollowUpMutation, CreateFollowUpMutationVariables>(
    CreateFollowUpDocument,
    options
  );
}
export type CreateFollowUpMutationHookResult = ReturnType<typeof useCreateFollowUpMutation>;
export type CreateFollowUpMutationResult = Apollo.MutationResult<CreateFollowUpMutation>;
export type CreateFollowUpMutationOptions = Apollo.BaseMutationOptions<
  CreateFollowUpMutation,
  CreateFollowUpMutationVariables
>;
export const CreateFreeformGoalDocument = gql`
  mutation createFreeformGoal($input: CreateFreeformGoalInput!) {
    createFreeformGoal(input: $input) {
      errors {
        message
        path
      }
      freeformGoal {
        id
        createdAt
        completedAt
        title
      }
    }
  }
`;
export type CreateFreeformGoalMutationFn = Apollo.MutationFunction<
  CreateFreeformGoalMutation,
  CreateFreeformGoalMutationVariables
>;

/**
 * __useCreateFreeformGoalMutation__
 *
 * To run a mutation, you first call `useCreateFreeformGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFreeformGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFreeformGoalMutation, { data, loading, error }] = useCreateFreeformGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFreeformGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFreeformGoalMutation,
    CreateFreeformGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFreeformGoalMutation, CreateFreeformGoalMutationVariables>(
    CreateFreeformGoalDocument,
    options
  );
}
export type CreateFreeformGoalMutationHookResult = ReturnType<typeof useCreateFreeformGoalMutation>;
export type CreateFreeformGoalMutationResult = Apollo.MutationResult<CreateFreeformGoalMutation>;
export type CreateFreeformGoalMutationOptions = Apollo.BaseMutationOptions<
  CreateFreeformGoalMutation,
  CreateFreeformGoalMutationVariables
>;
export const CreateInteractionAttachmentDocument = gql`
  mutation createInteractionAttachment($input: CreateCoachingSessionInteractionAttachmentInput!) {
    createCoachingSessionInteractionAttachment(input: $input) {
      interactionAttachment {
        id
        coachingSession {
          id
        }
        followUp {
          id
        }
        interaction {
          id
        }
      }
      errors {
        message
        path
      }
    }
  }
`;
export type CreateInteractionAttachmentMutationFn = Apollo.MutationFunction<
  CreateInteractionAttachmentMutation,
  CreateInteractionAttachmentMutationVariables
>;

/**
 * __useCreateInteractionAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateInteractionAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInteractionAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInteractionAttachmentMutation, { data, loading, error }] = useCreateInteractionAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInteractionAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInteractionAttachmentMutation,
    CreateInteractionAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInteractionAttachmentMutation,
    CreateInteractionAttachmentMutationVariables
  >(CreateInteractionAttachmentDocument, options);
}
export type CreateInteractionAttachmentMutationHookResult = ReturnType<
  typeof useCreateInteractionAttachmentMutation
>;
export type CreateInteractionAttachmentMutationResult =
  Apollo.MutationResult<CreateInteractionAttachmentMutation>;
export type CreateInteractionAttachmentMutationOptions = Apollo.BaseMutationOptions<
  CreateInteractionAttachmentMutation,
  CreateInteractionAttachmentMutationVariables
>;
export const CreateMetricGoalDocument = gql`
  mutation createMetricGoal($input: CreateMetricGoalInput!) {
    createMetricGoal(input: $input) {
      errors {
        message
        path
      }
      metricGoal {
        ... on MetricGoalEmployee {
          id
        }
        ... on MetricGoalGroup {
          id
        }
      }
    }
  }
`;
export type CreateMetricGoalMutationFn = Apollo.MutationFunction<
  CreateMetricGoalMutation,
  CreateMetricGoalMutationVariables
>;

/**
 * __useCreateMetricGoalMutation__
 *
 * To run a mutation, you first call `useCreateMetricGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricGoalMutation, { data, loading, error }] = useCreateMetricGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMetricGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMetricGoalMutation,
    CreateMetricGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateMetricGoalMutation, CreateMetricGoalMutationVariables>(
    CreateMetricGoalDocument,
    options
  );
}
export type CreateMetricGoalMutationHookResult = ReturnType<typeof useCreateMetricGoalMutation>;
export type CreateMetricGoalMutationResult = Apollo.MutationResult<CreateMetricGoalMutation>;
export type CreateMetricGoalMutationOptions = Apollo.BaseMutationOptions<
  CreateMetricGoalMutation,
  CreateMetricGoalMutationVariables
>;
export const CreateMetricsExportDocument = gql`
  mutation createMetricsExport($input: PerformanceMetricsInput!) {
    createPerformanceMetricsExport(input: $input) {
      errors {
        details
      }
      export {
        id
        state
      }
    }
  }
`;
export type CreateMetricsExportMutationFn = Apollo.MutationFunction<
  CreateMetricsExportMutation,
  CreateMetricsExportMutationVariables
>;

/**
 * __useCreateMetricsExportMutation__
 *
 * To run a mutation, you first call `useCreateMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetricsExportMutation, { data, loading, error }] = useCreateMetricsExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMetricsExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMetricsExportMutation,
    CreateMetricsExportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateMetricsExportMutation, CreateMetricsExportMutationVariables>(
    CreateMetricsExportDocument,
    options
  );
}
export type CreateMetricsExportMutationHookResult = ReturnType<
  typeof useCreateMetricsExportMutation
>;
export type CreateMetricsExportMutationResult = Apollo.MutationResult<CreateMetricsExportMutation>;
export type CreateMetricsExportMutationOptions = Apollo.BaseMutationOptions<
  CreateMetricsExportMutation,
  CreateMetricsExportMutationVariables
>;
export const CreateReportingGroupDocument = gql`
  mutation createReportingGroup($input: CreateReportingGroupInput!) {
    createReportingGroup(input: $input) {
      reportingGroup {
        active
        color
        createdAt
        description
        emoji
        filterable
        hidden
        id
        image
        name
        parentId
        streamFooterDisplayable
        updatedAt
      }
      errors {
        message
        path
      }
    }
  }
`;
export type CreateReportingGroupMutationFn = Apollo.MutationFunction<
  CreateReportingGroupMutation,
  CreateReportingGroupMutationVariables
>;

/**
 * __useCreateReportingGroupMutation__
 *
 * To run a mutation, you first call `useCreateReportingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportingGroupMutation, { data, loading, error }] = useCreateReportingGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportingGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReportingGroupMutation,
    CreateReportingGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateReportingGroupMutation, CreateReportingGroupMutationVariables>(
    CreateReportingGroupDocument,
    options
  );
}
export type CreateReportingGroupMutationHookResult = ReturnType<
  typeof useCreateReportingGroupMutation
>;
export type CreateReportingGroupMutationResult =
  Apollo.MutationResult<CreateReportingGroupMutation>;
export type CreateReportingGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateReportingGroupMutation,
  CreateReportingGroupMutationVariables
>;
export const ResolveAppealDocument = gql`
  mutation resolveAppeal($input: ResolveQaAppealInput!) {
    resolveQaAppeal(input: $input) {
      id
      createdAt
      reasons {
        note
        qaAnswer {
          id
        }
      }
    }
  }
`;
export type ResolveAppealMutationFn = Apollo.MutationFunction<
  ResolveAppealMutation,
  ResolveAppealMutationVariables
>;

/**
 * __useResolveAppealMutation__
 *
 * To run a mutation, you first call `useResolveAppealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveAppealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveAppealMutation, { data, loading, error }] = useResolveAppealMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveAppealMutation(
  baseOptions?: Apollo.MutationHookOptions<ResolveAppealMutation, ResolveAppealMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResolveAppealMutation, ResolveAppealMutationVariables>(
    ResolveAppealDocument,
    options
  );
}
export type ResolveAppealMutationHookResult = ReturnType<typeof useResolveAppealMutation>;
export type ResolveAppealMutationResult = Apollo.MutationResult<ResolveAppealMutation>;
export type ResolveAppealMutationOptions = Apollo.BaseMutationOptions<
  ResolveAppealMutation,
  ResolveAppealMutationVariables
>;
export const DeactivateEmployeeFromCompanyDocument = gql`
  mutation deactivateEmployeeFromCompany($input: DeactivateEmployeeInput!) {
    deactivateEmployee(input: $input) {
      id
      status
      email
    }
  }
`;
export type DeactivateEmployeeFromCompanyMutationFn = Apollo.MutationFunction<
  DeactivateEmployeeFromCompanyMutation,
  DeactivateEmployeeFromCompanyMutationVariables
>;

/**
 * __useDeactivateEmployeeFromCompanyMutation__
 *
 * To run a mutation, you first call `useDeactivateEmployeeFromCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateEmployeeFromCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateEmployeeFromCompanyMutation, { data, loading, error }] = useDeactivateEmployeeFromCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateEmployeeFromCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateEmployeeFromCompanyMutation,
    DeactivateEmployeeFromCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeactivateEmployeeFromCompanyMutation,
    DeactivateEmployeeFromCompanyMutationVariables
  >(DeactivateEmployeeFromCompanyDocument, options);
}
export type DeactivateEmployeeFromCompanyMutationHookResult = ReturnType<
  typeof useDeactivateEmployeeFromCompanyMutation
>;
export type DeactivateEmployeeFromCompanyMutationResult =
  Apollo.MutationResult<DeactivateEmployeeFromCompanyMutation>;
export type DeactivateEmployeeFromCompanyMutationOptions = Apollo.BaseMutationOptions<
  DeactivateEmployeeFromCompanyMutation,
  DeactivateEmployeeFromCompanyMutationVariables
>;
export const DeleteAuditDocument = gql`
  mutation deleteAudit($input: DeleteAuditInput!) {
    deleteAudit(input: $input) {
      deletedId
    }
  }
`;
export type DeleteAuditMutationFn = Apollo.MutationFunction<
  DeleteAuditMutation,
  DeleteAuditMutationVariables
>;

/**
 * __useDeleteAuditMutation__
 *
 * To run a mutation, you first call `useDeleteAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuditMutation, { data, loading, error }] = useDeleteAuditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAuditMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAuditMutation, DeleteAuditMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAuditMutation, DeleteAuditMutationVariables>(
    DeleteAuditDocument,
    options
  );
}
export type DeleteAuditMutationHookResult = ReturnType<typeof useDeleteAuditMutation>;
export type DeleteAuditMutationResult = Apollo.MutationResult<DeleteAuditMutation>;
export type DeleteAuditMutationOptions = Apollo.BaseMutationOptions<
  DeleteAuditMutation,
  DeleteAuditMutationVariables
>;
export const DeleteCalibrationDocument = gql`
  mutation deleteCalibration($id: ID!) {
    deleteCalibration(input: { id: $id }) {
      deletedId
    }
  }
`;
export type DeleteCalibrationMutationFn = Apollo.MutationFunction<
  DeleteCalibrationMutation,
  DeleteCalibrationMutationVariables
>;

/**
 * __useDeleteCalibrationMutation__
 *
 * To run a mutation, you first call `useDeleteCalibrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalibrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalibrationMutation, { data, loading, error }] = useDeleteCalibrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalibrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCalibrationMutation,
    DeleteCalibrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCalibrationMutation, DeleteCalibrationMutationVariables>(
    DeleteCalibrationDocument,
    options
  );
}
export type DeleteCalibrationMutationHookResult = ReturnType<typeof useDeleteCalibrationMutation>;
export type DeleteCalibrationMutationResult = Apollo.MutationResult<DeleteCalibrationMutation>;
export type DeleteCalibrationMutationOptions = Apollo.BaseMutationOptions<
  DeleteCalibrationMutation,
  DeleteCalibrationMutationVariables
>;
export const DeleteCoachingSessionActionItemDocument = gql`
  mutation deleteCoachingSessionActionItem($id: ID!) {
    deleteCoachingSessionActionItem(input: { id: $id }) {
      id
      message
    }
  }
`;
export type DeleteCoachingSessionActionItemMutationFn = Apollo.MutationFunction<
  DeleteCoachingSessionActionItemMutation,
  DeleteCoachingSessionActionItemMutationVariables
>;

/**
 * __useDeleteCoachingSessionActionItemMutation__
 *
 * To run a mutation, you first call `useDeleteCoachingSessionActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoachingSessionActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoachingSessionActionItemMutation, { data, loading, error }] = useDeleteCoachingSessionActionItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCoachingSessionActionItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCoachingSessionActionItemMutation,
    DeleteCoachingSessionActionItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCoachingSessionActionItemMutation,
    DeleteCoachingSessionActionItemMutationVariables
  >(DeleteCoachingSessionActionItemDocument, options);
}
export type DeleteCoachingSessionActionItemMutationHookResult = ReturnType<
  typeof useDeleteCoachingSessionActionItemMutation
>;
export type DeleteCoachingSessionActionItemMutationResult =
  Apollo.MutationResult<DeleteCoachingSessionActionItemMutation>;
export type DeleteCoachingSessionActionItemMutationOptions = Apollo.BaseMutationOptions<
  DeleteCoachingSessionActionItemMutation,
  DeleteCoachingSessionActionItemMutationVariables
>;
export const DeleteFeedbackExportTemplateDocument = gql`
  mutation deleteFeedbackExportTemplate($id: ID!) {
    deleteFeedbackExportTemplate(input: { id: $id }) {
      id
      message
    }
  }
`;
export type DeleteFeedbackExportTemplateMutationFn = Apollo.MutationFunction<
  DeleteFeedbackExportTemplateMutation,
  DeleteFeedbackExportTemplateMutationVariables
>;

/**
 * __useDeleteFeedbackExportTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackExportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackExportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackExportTemplateMutation, { data, loading, error }] = useDeleteFeedbackExportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackExportTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFeedbackExportTemplateMutation,
    DeleteFeedbackExportTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFeedbackExportTemplateMutation,
    DeleteFeedbackExportTemplateMutationVariables
  >(DeleteFeedbackExportTemplateDocument, options);
}
export type DeleteFeedbackExportTemplateMutationHookResult = ReturnType<
  typeof useDeleteFeedbackExportTemplateMutation
>;
export type DeleteFeedbackExportTemplateMutationResult =
  Apollo.MutationResult<DeleteFeedbackExportTemplateMutation>;
export type DeleteFeedbackExportTemplateMutationOptions = Apollo.BaseMutationOptions<
  DeleteFeedbackExportTemplateMutation,
  DeleteFeedbackExportTemplateMutationVariables
>;
export const DeleteFollowUpDocument = gql`
  mutation deleteFollowUp($id: ID!) {
    deleteFollowUp(input: { id: $id }) {
      id
      message
    }
  }
`;
export type DeleteFollowUpMutationFn = Apollo.MutationFunction<
  DeleteFollowUpMutation,
  DeleteFollowUpMutationVariables
>;

/**
 * __useDeleteFollowUpMutation__
 *
 * To run a mutation, you first call `useDeleteFollowUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFollowUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFollowUpMutation, { data, loading, error }] = useDeleteFollowUpMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFollowUpMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFollowUpMutation, DeleteFollowUpMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteFollowUpMutation, DeleteFollowUpMutationVariables>(
    DeleteFollowUpDocument,
    options
  );
}
export type DeleteFollowUpMutationHookResult = ReturnType<typeof useDeleteFollowUpMutation>;
export type DeleteFollowUpMutationResult = Apollo.MutationResult<DeleteFollowUpMutation>;
export type DeleteFollowUpMutationOptions = Apollo.BaseMutationOptions<
  DeleteFollowUpMutation,
  DeleteFollowUpMutationVariables
>;
export const DeleteCoachingSessionInteractionAttachmentDocument = gql`
  mutation deleteCoachingSessionInteractionAttachment($id: ID!) {
    deleteCoachingSessionInteractionAttachment(input: { id: $id }) {
      id
      message
    }
  }
`;
export type DeleteCoachingSessionInteractionAttachmentMutationFn = Apollo.MutationFunction<
  DeleteCoachingSessionInteractionAttachmentMutation,
  DeleteCoachingSessionInteractionAttachmentMutationVariables
>;

/**
 * __useDeleteCoachingSessionInteractionAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteCoachingSessionInteractionAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoachingSessionInteractionAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoachingSessionInteractionAttachmentMutation, { data, loading, error }] = useDeleteCoachingSessionInteractionAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCoachingSessionInteractionAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCoachingSessionInteractionAttachmentMutation,
    DeleteCoachingSessionInteractionAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCoachingSessionInteractionAttachmentMutation,
    DeleteCoachingSessionInteractionAttachmentMutationVariables
  >(DeleteCoachingSessionInteractionAttachmentDocument, options);
}
export type DeleteCoachingSessionInteractionAttachmentMutationHookResult = ReturnType<
  typeof useDeleteCoachingSessionInteractionAttachmentMutation
>;
export type DeleteCoachingSessionInteractionAttachmentMutationResult =
  Apollo.MutationResult<DeleteCoachingSessionInteractionAttachmentMutation>;
export type DeleteCoachingSessionInteractionAttachmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCoachingSessionInteractionAttachmentMutation,
  DeleteCoachingSessionInteractionAttachmentMutationVariables
>;
export const PublishSurveyConfigurationDocument = gql`
  mutation publishSurveyConfiguration($configurationId: String!) {
    publishSurveyConfiguration(input: { configurationId: $configurationId }) {
      success
      errors {
        message
      }
    }
  }
`;
export type PublishSurveyConfigurationMutationFn = Apollo.MutationFunction<
  PublishSurveyConfigurationMutation,
  PublishSurveyConfigurationMutationVariables
>;

/**
 * __usePublishSurveyConfigurationMutation__
 *
 * To run a mutation, you first call `usePublishSurveyConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSurveyConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSurveyConfigurationMutation, { data, loading, error }] = usePublishSurveyConfigurationMutation({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *   },
 * });
 */
export function usePublishSurveyConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishSurveyConfigurationMutation,
    PublishSurveyConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishSurveyConfigurationMutation,
    PublishSurveyConfigurationMutationVariables
  >(PublishSurveyConfigurationDocument, options);
}
export type PublishSurveyConfigurationMutationHookResult = ReturnType<
  typeof usePublishSurveyConfigurationMutation
>;
export type PublishSurveyConfigurationMutationResult =
  Apollo.MutationResult<PublishSurveyConfigurationMutation>;
export type PublishSurveyConfigurationMutationOptions = Apollo.BaseMutationOptions<
  PublishSurveyConfigurationMutation,
  PublishSurveyConfigurationMutationVariables
>;
export const RecapCoachingSessionDocument = gql`
  mutation recapCoachingSession($id: ID!) {
    recapCoachingSession(input: { id: $id }) {
      resharedAt
      sharedAt
      id
    }
  }
`;
export type RecapCoachingSessionMutationFn = Apollo.MutationFunction<
  RecapCoachingSessionMutation,
  RecapCoachingSessionMutationVariables
>;

/**
 * __useRecapCoachingSessionMutation__
 *
 * To run a mutation, you first call `useRecapCoachingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecapCoachingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recapCoachingSessionMutation, { data, loading, error }] = useRecapCoachingSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecapCoachingSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecapCoachingSessionMutation,
    RecapCoachingSessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RecapCoachingSessionMutation, RecapCoachingSessionMutationVariables>(
    RecapCoachingSessionDocument,
    options
  );
}
export type RecapCoachingSessionMutationHookResult = ReturnType<
  typeof useRecapCoachingSessionMutation
>;
export type RecapCoachingSessionMutationResult =
  Apollo.MutationResult<RecapCoachingSessionMutation>;
export type RecapCoachingSessionMutationOptions = Apollo.BaseMutationOptions<
  RecapCoachingSessionMutation,
  RecapCoachingSessionMutationVariables
>;
export const RecordCalibrationAnswerDocument = gql`
  mutation recordCalibrationAnswer($input: RecordCalibrationAnswerInput!) {
    recordCalibrationAnswer(input: $input) {
      clientMutationId
      errors {
        message
        path
      }
      qaCalibration {
        id
      }
    }
  }
`;
export type RecordCalibrationAnswerMutationFn = Apollo.MutationFunction<
  RecordCalibrationAnswerMutation,
  RecordCalibrationAnswerMutationVariables
>;

/**
 * __useRecordCalibrationAnswerMutation__
 *
 * To run a mutation, you first call `useRecordCalibrationAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCalibrationAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCalibrationAnswerMutation, { data, loading, error }] = useRecordCalibrationAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordCalibrationAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordCalibrationAnswerMutation,
    RecordCalibrationAnswerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordCalibrationAnswerMutation,
    RecordCalibrationAnswerMutationVariables
  >(RecordCalibrationAnswerDocument, options);
}
export type RecordCalibrationAnswerMutationHookResult = ReturnType<
  typeof useRecordCalibrationAnswerMutation
>;
export type RecordCalibrationAnswerMutationResult =
  Apollo.MutationResult<RecordCalibrationAnswerMutation>;
export type RecordCalibrationAnswerMutationOptions = Apollo.BaseMutationOptions<
  RecordCalibrationAnswerMutation,
  RecordCalibrationAnswerMutationVariables
>;
export const RemoveMemberFromGroupDocument = gql`
  mutation removeMemberFromGroup($input: RemoveMemberReportingGroupInput!) {
    reportingGroupRemoveMember(input: $input) {
      id
      name
      members {
        nodes {
          id
          email
        }
      }
    }
  }
`;
export type RemoveMemberFromGroupMutationFn = Apollo.MutationFunction<
  RemoveMemberFromGroupMutation,
  RemoveMemberFromGroupMutationVariables
>;

/**
 * __useRemoveMemberFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveMemberFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberFromGroupMutation, { data, loading, error }] = useRemoveMemberFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMemberFromGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveMemberFromGroupMutation,
    RemoveMemberFromGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>(
    RemoveMemberFromGroupDocument,
    options
  );
}
export type RemoveMemberFromGroupMutationHookResult = ReturnType<
  typeof useRemoveMemberFromGroupMutation
>;
export type RemoveMemberFromGroupMutationResult =
  Apollo.MutationResult<RemoveMemberFromGroupMutation>;
export type RemoveMemberFromGroupMutationOptions = Apollo.BaseMutationOptions<
  RemoveMemberFromGroupMutation,
  RemoveMemberFromGroupMutationVariables
>;
export const RemoveNegativeFeedbackFromCoachingTopicDocument = gql`
  mutation removeNegativeFeedbackFromCoachingTopic($topicId: ID!) {
    removeNegativeFeedbackFromCoachingTopic(input: { topicId: $topicId }) {
      errors {
        message
      }
      coachingTopic {
        ...coachingTopicFields
      }
    }
  }
  ${CoachingTopicFieldsFragmentDoc}
`;
export type RemoveNegativeFeedbackFromCoachingTopicMutationFn = Apollo.MutationFunction<
  RemoveNegativeFeedbackFromCoachingTopicMutation,
  RemoveNegativeFeedbackFromCoachingTopicMutationVariables
>;

/**
 * __useRemoveNegativeFeedbackFromCoachingTopicMutation__
 *
 * To run a mutation, you first call `useRemoveNegativeFeedbackFromCoachingTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNegativeFeedbackFromCoachingTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNegativeFeedbackFromCoachingTopicMutation, { data, loading, error }] = useRemoveNegativeFeedbackFromCoachingTopicMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useRemoveNegativeFeedbackFromCoachingTopicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveNegativeFeedbackFromCoachingTopicMutation,
    RemoveNegativeFeedbackFromCoachingTopicMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveNegativeFeedbackFromCoachingTopicMutation,
    RemoveNegativeFeedbackFromCoachingTopicMutationVariables
  >(RemoveNegativeFeedbackFromCoachingTopicDocument, options);
}
export type RemoveNegativeFeedbackFromCoachingTopicMutationHookResult = ReturnType<
  typeof useRemoveNegativeFeedbackFromCoachingTopicMutation
>;
export type RemoveNegativeFeedbackFromCoachingTopicMutationResult =
  Apollo.MutationResult<RemoveNegativeFeedbackFromCoachingTopicMutation>;
export type RemoveNegativeFeedbackFromCoachingTopicMutationOptions = Apollo.BaseMutationOptions<
  RemoveNegativeFeedbackFromCoachingTopicMutation,
  RemoveNegativeFeedbackFromCoachingTopicMutationVariables
>;
export const ResetSurveyConfigurationDocument = gql`
  mutation resetSurveyConfiguration($configurationId: String!) {
    resetSurveyConfiguration(input: { configurationId: $configurationId }) {
      success
      errors {
        message
      }
    }
  }
`;
export type ResetSurveyConfigurationMutationFn = Apollo.MutationFunction<
  ResetSurveyConfigurationMutation,
  ResetSurveyConfigurationMutationVariables
>;

/**
 * __useResetSurveyConfigurationMutation__
 *
 * To run a mutation, you first call `useResetSurveyConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSurveyConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSurveyConfigurationMutation, { data, loading, error }] = useResetSurveyConfigurationMutation({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *   },
 * });
 */
export function useResetSurveyConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetSurveyConfigurationMutation,
    ResetSurveyConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetSurveyConfigurationMutation,
    ResetSurveyConfigurationMutationVariables
  >(ResetSurveyConfigurationDocument, options);
}
export type ResetSurveyConfigurationMutationHookResult = ReturnType<
  typeof useResetSurveyConfigurationMutation
>;
export type ResetSurveyConfigurationMutationResult =
  Apollo.MutationResult<ResetSurveyConfigurationMutation>;
export type ResetSurveyConfigurationMutationOptions = Apollo.BaseMutationOptions<
  ResetSurveyConfigurationMutation,
  ResetSurveyConfigurationMutationVariables
>;
export const ResetUserPasswordDocument = gql`
  mutation resetUserPassword($input: ResetEmployeePasswordInput!) {
    resetEmployeePassword(input: $input) {
      id
      profile {
        id
        fullName
      }
    }
  }
`;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(
    ResetUserPasswordDocument,
    options
  );
}
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;
export const SendTestsSurveyDocument = gql`
  mutation sendTestsSurvey($input: SendTestEmailInput!) {
    sendTestEmail(input: $input) {
      success
    }
  }
`;
export type SendTestsSurveyMutationFn = Apollo.MutationFunction<
  SendTestsSurveyMutation,
  SendTestsSurveyMutationVariables
>;

/**
 * __useSendTestsSurveyMutation__
 *
 * To run a mutation, you first call `useSendTestsSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestsSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestsSurveyMutation, { data, loading, error }] = useSendTestsSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTestsSurveyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendTestsSurveyMutation,
    SendTestsSurveyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendTestsSurveyMutation, SendTestsSurveyMutationVariables>(
    SendTestsSurveyDocument,
    options
  );
}
export type SendTestsSurveyMutationHookResult = ReturnType<typeof useSendTestsSurveyMutation>;
export type SendTestsSurveyMutationResult = Apollo.MutationResult<SendTestsSurveyMutation>;
export type SendTestsSurveyMutationOptions = Apollo.BaseMutationOptions<
  SendTestsSurveyMutation,
  SendTestsSurveyMutationVariables
>;
export const ToggleAchievementCategoryDocument = gql`
  mutation toggleAchievementCategory($categoryId: ID!, $enable: Boolean!) {
    toggleAchievementCategory(input: { categoryId: $categoryId, enable: $enable }) {
      id
      enabled
      name
      description
      identifier
    }
  }
`;
export type ToggleAchievementCategoryMutationFn = Apollo.MutationFunction<
  ToggleAchievementCategoryMutation,
  ToggleAchievementCategoryMutationVariables
>;

/**
 * __useToggleAchievementCategoryMutation__
 *
 * To run a mutation, you first call `useToggleAchievementCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAchievementCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAchievementCategoryMutation, { data, loading, error }] = useToggleAchievementCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useToggleAchievementCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleAchievementCategoryMutation,
    ToggleAchievementCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleAchievementCategoryMutation,
    ToggleAchievementCategoryMutationVariables
  >(ToggleAchievementCategoryDocument, options);
}
export type ToggleAchievementCategoryMutationHookResult = ReturnType<
  typeof useToggleAchievementCategoryMutation
>;
export type ToggleAchievementCategoryMutationResult =
  Apollo.MutationResult<ToggleAchievementCategoryMutation>;
export type ToggleAchievementCategoryMutationOptions = Apollo.BaseMutationOptions<
  ToggleAchievementCategoryMutation,
  ToggleAchievementCategoryMutationVariables
>;
export const ToggleServiceRecoveryDocument = gql`
  mutation toggleServiceRecovery($enabled: Boolean!) {
    toggleServiceRecovery(input: { enabled: $enabled }) {
      enabled
    }
  }
`;
export type ToggleServiceRecoveryMutationFn = Apollo.MutationFunction<
  ToggleServiceRecoveryMutation,
  ToggleServiceRecoveryMutationVariables
>;

/**
 * __useToggleServiceRecoveryMutation__
 *
 * To run a mutation, you first call `useToggleServiceRecoveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleServiceRecoveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleServiceRecoveryMutation, { data, loading, error }] = useToggleServiceRecoveryMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleServiceRecoveryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleServiceRecoveryMutation,
    ToggleServiceRecoveryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ToggleServiceRecoveryMutation, ToggleServiceRecoveryMutationVariables>(
    ToggleServiceRecoveryDocument,
    options
  );
}
export type ToggleServiceRecoveryMutationHookResult = ReturnType<
  typeof useToggleServiceRecoveryMutation
>;
export type ToggleServiceRecoveryMutationResult =
  Apollo.MutationResult<ToggleServiceRecoveryMutation>;
export type ToggleServiceRecoveryMutationOptions = Apollo.BaseMutationOptions<
  ToggleServiceRecoveryMutation,
  ToggleServiceRecoveryMutationVariables
>;
export const UndoFreeformGoalDocument = gql`
  mutation undoFreeformGoal($freeformGoalId: ID!) {
    undoFreeformGoal(input: { id: $freeformGoalId }) {
      freeformGoal {
        id
        completedAt
        createdAt
      }
    }
  }
`;
export type UndoFreeformGoalMutationFn = Apollo.MutationFunction<
  UndoFreeformGoalMutation,
  UndoFreeformGoalMutationVariables
>;

/**
 * __useUndoFreeformGoalMutation__
 *
 * To run a mutation, you first call `useUndoFreeformGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoFreeformGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoFreeformGoalMutation, { data, loading, error }] = useUndoFreeformGoalMutation({
 *   variables: {
 *      freeformGoalId: // value for 'freeformGoalId'
 *   },
 * });
 */
export function useUndoFreeformGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UndoFreeformGoalMutation,
    UndoFreeformGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UndoFreeformGoalMutation, UndoFreeformGoalMutationVariables>(
    UndoFreeformGoalDocument,
    options
  );
}
export type UndoFreeformGoalMutationHookResult = ReturnType<typeof useUndoFreeformGoalMutation>;
export type UndoFreeformGoalMutationResult = Apollo.MutationResult<UndoFreeformGoalMutation>;
export type UndoFreeformGoalMutationOptions = Apollo.BaseMutationOptions<
  UndoFreeformGoalMutation,
  UndoFreeformGoalMutationVariables
>;
export const UndoGoalDocument = gql`
  mutation undoGoal($metricGoalId: ID!, $type: MetricGoalTypeEnum!) {
    undoMetricGoal(input: { id: $metricGoalId, type: $type }) {
      metricGoal {
        ... on MetricGoalEmployee {
          id
        }
        ... on MetricGoalGroup {
          id
        }
      }
    }
  }
`;
export type UndoGoalMutationFn = Apollo.MutationFunction<
  UndoGoalMutation,
  UndoGoalMutationVariables
>;

/**
 * __useUndoGoalMutation__
 *
 * To run a mutation, you first call `useUndoGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoGoalMutation, { data, loading, error }] = useUndoGoalMutation({
 *   variables: {
 *      metricGoalId: // value for 'metricGoalId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUndoGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<UndoGoalMutation, UndoGoalMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UndoGoalMutation, UndoGoalMutationVariables>(UndoGoalDocument, options);
}
export type UndoGoalMutationHookResult = ReturnType<typeof useUndoGoalMutation>;
export type UndoGoalMutationResult = Apollo.MutationResult<UndoGoalMutation>;
export type UndoGoalMutationOptions = Apollo.BaseMutationOptions<
  UndoGoalMutation,
  UndoGoalMutationVariables
>;
export const UpdateActionItemDocument = gql`
  mutation updateActionItem($input: UpdateActionItemInput!) {
    updateActionItem(input: $input) {
      actionItem {
        action
        id
        updatedAt
      }
    }
  }
`;
export type UpdateActionItemMutationFn = Apollo.MutationFunction<
  UpdateActionItemMutation,
  UpdateActionItemMutationVariables
>;

/**
 * __useUpdateActionItemMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemMutation, { data, loading, error }] = useUpdateActionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActionItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateActionItemMutation,
    UpdateActionItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateActionItemMutation, UpdateActionItemMutationVariables>(
    UpdateActionItemDocument,
    options
  );
}
export type UpdateActionItemMutationHookResult = ReturnType<typeof useUpdateActionItemMutation>;
export type UpdateActionItemMutationResult = Apollo.MutationResult<UpdateActionItemMutation>;
export type UpdateActionItemMutationOptions = Apollo.BaseMutationOptions<
  UpdateActionItemMutation,
  UpdateActionItemMutationVariables
>;
export const UpdateActionItemAttributesDocument = gql`
  mutation updateActionItemAttributes($input: UpdateCoachingSessionActionItemAttributesInput!) {
    updateCoachingSessionActionItemAttributes(input: $input) {
      dueDate
      id
      owner {
        id
        profile {
          fullName
          id
          imageUrl
        }
      }
      takeawayCategory {
        name
        id
      }
      text
      updatedAt
    }
  }
`;
export type UpdateActionItemAttributesMutationFn = Apollo.MutationFunction<
  UpdateActionItemAttributesMutation,
  UpdateActionItemAttributesMutationVariables
>;

/**
 * __useUpdateActionItemAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemAttributesMutation, { data, loading, error }] = useUpdateActionItemAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActionItemAttributesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateActionItemAttributesMutation,
    UpdateActionItemAttributesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateActionItemAttributesMutation,
    UpdateActionItemAttributesMutationVariables
  >(UpdateActionItemAttributesDocument, options);
}
export type UpdateActionItemAttributesMutationHookResult = ReturnType<
  typeof useUpdateActionItemAttributesMutation
>;
export type UpdateActionItemAttributesMutationResult =
  Apollo.MutationResult<UpdateActionItemAttributesMutation>;
export type UpdateActionItemAttributesMutationOptions = Apollo.BaseMutationOptions<
  UpdateActionItemAttributesMutation,
  UpdateActionItemAttributesMutationVariables
>;
export const UpdateAnswerDocument = gql`
  mutation updateAnswer($input: UpdateAnswerInput!) {
    updateAnswer(input: $input) {
      id
      answered
      comments
      createdAt
      qaQuestion {
        id
      }
      qaOption {
        id
      }
    }
  }
`;
export type UpdateAnswerMutationFn = Apollo.MutationFunction<
  UpdateAnswerMutation,
  UpdateAnswerMutationVariables
>;

/**
 * __useUpdateAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerMutation, { data, loading, error }] = useUpdateAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAnswerMutation, UpdateAnswerMutationVariables>(
    UpdateAnswerDocument,
    options
  );
}
export type UpdateAnswerMutationHookResult = ReturnType<typeof useUpdateAnswerMutation>;
export type UpdateAnswerMutationResult = Apollo.MutationResult<UpdateAnswerMutation>;
export type UpdateAnswerMutationOptions = Apollo.BaseMutationOptions<
  UpdateAnswerMutation,
  UpdateAnswerMutationVariables
>;
export const UpdateAuditDocument = gql`
  mutation updateAudit($input: UpdateAuditInput!) {
    updateAudit(input: $input) {
      id
      completedAt
      qaReview {
        id
      }
      qaForm {
        id
      }
    }
  }
`;
export type UpdateAuditMutationFn = Apollo.MutationFunction<
  UpdateAuditMutation,
  UpdateAuditMutationVariables
>;

/**
 * __useUpdateAuditMutation__
 *
 * To run a mutation, you first call `useUpdateAuditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuditMutation, { data, loading, error }] = useUpdateAuditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuditMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAuditMutation, UpdateAuditMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAuditMutation, UpdateAuditMutationVariables>(
    UpdateAuditDocument,
    options
  );
}
export type UpdateAuditMutationHookResult = ReturnType<typeof useUpdateAuditMutation>;
export type UpdateAuditMutationResult = Apollo.MutationResult<UpdateAuditMutation>;
export type UpdateAuditMutationOptions = Apollo.BaseMutationOptions<
  UpdateAuditMutation,
  UpdateAuditMutationVariables
>;
export const UpdateCalibrationDocument = gql`
  mutation updateCalibration($input: UpdateCalibrationInput!) {
    updateCalibration(input: $input) {
      errors {
        message
        path
      }
      qaCalibration {
        id
        notes
      }
    }
  }
`;
export type UpdateCalibrationMutationFn = Apollo.MutationFunction<
  UpdateCalibrationMutation,
  UpdateCalibrationMutationVariables
>;

/**
 * __useUpdateCalibrationMutation__
 *
 * To run a mutation, you first call `useUpdateCalibrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalibrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalibrationMutation, { data, loading, error }] = useUpdateCalibrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalibrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCalibrationMutation,
    UpdateCalibrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCalibrationMutation, UpdateCalibrationMutationVariables>(
    UpdateCalibrationDocument,
    options
  );
}
export type UpdateCalibrationMutationHookResult = ReturnType<typeof useUpdateCalibrationMutation>;
export type UpdateCalibrationMutationResult = Apollo.MutationResult<UpdateCalibrationMutation>;
export type UpdateCalibrationMutationOptions = Apollo.BaseMutationOptions<
  UpdateCalibrationMutation,
  UpdateCalibrationMutationVariables
>;
export const UpdateCoachingSessionActionItemDocument = gql`
  mutation updateCoachingSessionActionItem(
    $id: ID!
    $action: ActionEnum!
    $completedCoachingSessionId: ID
  ) {
    updateCoachingSessionActionItem(
      input: { id: $id, action: $action, completedCoachingSessionId: $completedCoachingSessionId }
    ) {
      id
      completedAt
    }
  }
`;
export type UpdateCoachingSessionActionItemMutationFn = Apollo.MutationFunction<
  UpdateCoachingSessionActionItemMutation,
  UpdateCoachingSessionActionItemMutationVariables
>;

/**
 * __useUpdateCoachingSessionActionItemMutation__
 *
 * To run a mutation, you first call `useUpdateCoachingSessionActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachingSessionActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachingSessionActionItemMutation, { data, loading, error }] = useUpdateCoachingSessionActionItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      action: // value for 'action'
 *      completedCoachingSessionId: // value for 'completedCoachingSessionId'
 *   },
 * });
 */
export function useUpdateCoachingSessionActionItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoachingSessionActionItemMutation,
    UpdateCoachingSessionActionItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCoachingSessionActionItemMutation,
    UpdateCoachingSessionActionItemMutationVariables
  >(UpdateCoachingSessionActionItemDocument, options);
}
export type UpdateCoachingSessionActionItemMutationHookResult = ReturnType<
  typeof useUpdateCoachingSessionActionItemMutation
>;
export type UpdateCoachingSessionActionItemMutationResult =
  Apollo.MutationResult<UpdateCoachingSessionActionItemMutation>;
export type UpdateCoachingSessionActionItemMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoachingSessionActionItemMutation,
  UpdateCoachingSessionActionItemMutationVariables
>;
export const UpdatePublicNoteDocument = gql`
  mutation updatePublicNote($noteId: ID!, $notes: String!) {
    updateCoachingSessionPublicNote(input: { noteId: $noteId, notes: $notes }) {
      publicNote {
        ...publicNoteFields
      }
      errors {
        message
        path
      }
    }
  }
  ${PublicNoteFieldsFragmentDoc}
`;
export type UpdatePublicNoteMutationFn = Apollo.MutationFunction<
  UpdatePublicNoteMutation,
  UpdatePublicNoteMutationVariables
>;

/**
 * __useUpdatePublicNoteMutation__
 *
 * To run a mutation, you first call `useUpdatePublicNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicNoteMutation, { data, loading, error }] = useUpdatePublicNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdatePublicNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePublicNoteMutation,
    UpdatePublicNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePublicNoteMutation, UpdatePublicNoteMutationVariables>(
    UpdatePublicNoteDocument,
    options
  );
}
export type UpdatePublicNoteMutationHookResult = ReturnType<typeof useUpdatePublicNoteMutation>;
export type UpdatePublicNoteMutationResult = Apollo.MutationResult<UpdatePublicNoteMutation>;
export type UpdatePublicNoteMutationOptions = Apollo.BaseMutationOptions<
  UpdatePublicNoteMutation,
  UpdatePublicNoteMutationVariables
>;
export const UpdateCoachingTemplateDocument = gql`
  mutation updateCoachingTemplate($input: UpdateCoachingTemplateInput!) {
    updateCoachingTemplate(input: $input) {
      coachingTemplate {
        body
        id
        name
      }
      errors {
        message
        path
      }
    }
  }
`;
export type UpdateCoachingTemplateMutationFn = Apollo.MutationFunction<
  UpdateCoachingTemplateMutation,
  UpdateCoachingTemplateMutationVariables
>;

/**
 * __useUpdateCoachingTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateCoachingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachingTemplateMutation, { data, loading, error }] = useUpdateCoachingTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoachingTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoachingTemplateMutation,
    UpdateCoachingTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCoachingTemplateMutation,
    UpdateCoachingTemplateMutationVariables
  >(UpdateCoachingTemplateDocument, options);
}
export type UpdateCoachingTemplateMutationHookResult = ReturnType<
  typeof useUpdateCoachingTemplateMutation
>;
export type UpdateCoachingTemplateMutationResult =
  Apollo.MutationResult<UpdateCoachingTemplateMutation>;
export type UpdateCoachingTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoachingTemplateMutation,
  UpdateCoachingTemplateMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation updateUser($input: UpdateEmployeeInput!) {
    updateEmployee(input: $input) {
      channels
      customRole {
        id
        name
      }
      email
      employeeGroups {
        id
        name
      }
      id
      licenseType
      employmentStatus
      primaryTeam {
        id
        owner {
          id
          profile {
            id
            fullName
            firstName
            lastName
          }
        }
      }
      profile {
        id
        countryCode
        fullName
        firstName
        lastName
        hometown
      }
      reportingGroups {
        id
        name
      }
      startDate
      status
      supervisor {
        id
        fullName
      }
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  );
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const UpdateExportsLastReadAtDocument = gql`
  mutation updateExportsLastReadAt($input: UpdateExportsLastReadAtInput!) {
    updateExportsLastReadAt(input: $input) {
      exportsLastReadAt
    }
  }
`;
export type UpdateExportsLastReadAtMutationFn = Apollo.MutationFunction<
  UpdateExportsLastReadAtMutation,
  UpdateExportsLastReadAtMutationVariables
>;

/**
 * __useUpdateExportsLastReadAtMutation__
 *
 * To run a mutation, you first call `useUpdateExportsLastReadAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExportsLastReadAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExportsLastReadAtMutation, { data, loading, error }] = useUpdateExportsLastReadAtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExportsLastReadAtMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateExportsLastReadAtMutation,
    UpdateExportsLastReadAtMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateExportsLastReadAtMutation,
    UpdateExportsLastReadAtMutationVariables
  >(UpdateExportsLastReadAtDocument, options);
}
export type UpdateExportsLastReadAtMutationHookResult = ReturnType<
  typeof useUpdateExportsLastReadAtMutation
>;
export type UpdateExportsLastReadAtMutationResult =
  Apollo.MutationResult<UpdateExportsLastReadAtMutation>;
export type UpdateExportsLastReadAtMutationOptions = Apollo.BaseMutationOptions<
  UpdateExportsLastReadAtMutation,
  UpdateExportsLastReadAtMutationVariables
>;
export const UpdateFeedbackExportTemplateDocument = gql`
  mutation updateFeedbackExportTemplate($input: UpdateFeedbackExportTemplateInput!) {
    updateFeedbackExportTemplate(input: $input) {
      template {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
export type UpdateFeedbackExportTemplateMutationFn = Apollo.MutationFunction<
  UpdateFeedbackExportTemplateMutation,
  UpdateFeedbackExportTemplateMutationVariables
>;

/**
 * __useUpdateFeedbackExportTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackExportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackExportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackExportTemplateMutation, { data, loading, error }] = useUpdateFeedbackExportTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackExportTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFeedbackExportTemplateMutation,
    UpdateFeedbackExportTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFeedbackExportTemplateMutation,
    UpdateFeedbackExportTemplateMutationVariables
  >(UpdateFeedbackExportTemplateDocument, options);
}
export type UpdateFeedbackExportTemplateMutationHookResult = ReturnType<
  typeof useUpdateFeedbackExportTemplateMutation
>;
export type UpdateFeedbackExportTemplateMutationResult =
  Apollo.MutationResult<UpdateFeedbackExportTemplateMutation>;
export type UpdateFeedbackExportTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateFeedbackExportTemplateMutation,
  UpdateFeedbackExportTemplateMutationVariables
>;
export const UpdateInteractionAttachmentDocument = gql`
  mutation updateInteractionAttachment($input: UpdateCoachingSessionInteractionAttachmentInput!) {
    updateCoachingSessionInteractionAttachment(input: $input) {
      interactionAttachment {
        id
        notes
      }
      errors {
        message
        path
      }
    }
  }
`;
export type UpdateInteractionAttachmentMutationFn = Apollo.MutationFunction<
  UpdateInteractionAttachmentMutation,
  UpdateInteractionAttachmentMutationVariables
>;

/**
 * __useUpdateInteractionAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateInteractionAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInteractionAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInteractionAttachmentMutation, { data, loading, error }] = useUpdateInteractionAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInteractionAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateInteractionAttachmentMutation,
    UpdateInteractionAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateInteractionAttachmentMutation,
    UpdateInteractionAttachmentMutationVariables
  >(UpdateInteractionAttachmentDocument, options);
}
export type UpdateInteractionAttachmentMutationHookResult = ReturnType<
  typeof useUpdateInteractionAttachmentMutation
>;
export type UpdateInteractionAttachmentMutationResult =
  Apollo.MutationResult<UpdateInteractionAttachmentMutation>;
export type UpdateInteractionAttachmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateInteractionAttachmentMutation,
  UpdateInteractionAttachmentMutationVariables
>;
export const UpdateQaAssignmentDocument = gql`
  mutation updateQaAssignment($input: UpdateQaAssignmentInput!) {
    updateQaAssignment(input: $input) {
      qaAssignment {
        id
      }
      errors {
        message
      }
    }
  }
`;
export type UpdateQaAssignmentMutationFn = Apollo.MutationFunction<
  UpdateQaAssignmentMutation,
  UpdateQaAssignmentMutationVariables
>;

/**
 * __useUpdateQaAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateQaAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQaAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQaAssignmentMutation, { data, loading, error }] = useUpdateQaAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQaAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateQaAssignmentMutation,
    UpdateQaAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateQaAssignmentMutation, UpdateQaAssignmentMutationVariables>(
    UpdateQaAssignmentDocument,
    options
  );
}
export type UpdateQaAssignmentMutationHookResult = ReturnType<typeof useUpdateQaAssignmentMutation>;
export type UpdateQaAssignmentMutationResult = Apollo.MutationResult<UpdateQaAssignmentMutation>;
export type UpdateQaAssignmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateQaAssignmentMutation,
  UpdateQaAssignmentMutationVariables
>;
export const UpdateReportingGroupDocument = gql`
  mutation updateReportingGroup($input: UpdateReportingGroupInput!) {
    updateReportingGroup(input: $input) {
      reportingGroup {
        active
        color
        createdAt
        description
        emoji
        filterable
        hidden
        id
        image
        name
        parentId
        streamFooterDisplayable
        updatedAt
      }
      errors {
        message
        path
      }
    }
  }
`;
export type UpdateReportingGroupMutationFn = Apollo.MutationFunction<
  UpdateReportingGroupMutation,
  UpdateReportingGroupMutationVariables
>;

/**
 * __useUpdateReportingGroupMutation__
 *
 * To run a mutation, you first call `useUpdateReportingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportingGroupMutation, { data, loading, error }] = useUpdateReportingGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportingGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateReportingGroupMutation,
    UpdateReportingGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateReportingGroupMutation, UpdateReportingGroupMutationVariables>(
    UpdateReportingGroupDocument,
    options
  );
}
export type UpdateReportingGroupMutationHookResult = ReturnType<
  typeof useUpdateReportingGroupMutation
>;
export type UpdateReportingGroupMutationResult =
  Apollo.MutationResult<UpdateReportingGroupMutation>;
export type UpdateReportingGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateReportingGroupMutation,
  UpdateReportingGroupMutationVariables
>;
export const UpdateSurveyConfigurationDocument = gql`
  mutation updateSurveyConfiguration(
    $uuid: String!
    $configuration: JSON!
    $configurationHash: String!
  ) {
    updateSurveyConfiguration(
      input: { uuid: $uuid, configuration: $configuration, configurationHash: $configurationHash }
    ) {
      surveyConfiguration {
        uuid
        configuration
        configurationHash
        publishedHash
        updatedAt
      }
      errors {
        path
        message
      }
    }
  }
`;
export type UpdateSurveyConfigurationMutationFn = Apollo.MutationFunction<
  UpdateSurveyConfigurationMutation,
  UpdateSurveyConfigurationMutationVariables
>;

/**
 * __useUpdateSurveyConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyConfigurationMutation, { data, loading, error }] = useUpdateSurveyConfigurationMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      configuration: // value for 'configuration'
 *      configurationHash: // value for 'configurationHash'
 *   },
 * });
 */
export function useUpdateSurveyConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSurveyConfigurationMutation,
    UpdateSurveyConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSurveyConfigurationMutation,
    UpdateSurveyConfigurationMutationVariables
  >(UpdateSurveyConfigurationDocument, options);
}
export type UpdateSurveyConfigurationMutationHookResult = ReturnType<
  typeof useUpdateSurveyConfigurationMutation
>;
export type UpdateSurveyConfigurationMutationResult =
  Apollo.MutationResult<UpdateSurveyConfigurationMutation>;
export type UpdateSurveyConfigurationMutationOptions = Apollo.BaseMutationOptions<
  UpdateSurveyConfigurationMutation,
  UpdateSurveyConfigurationMutationVariables
>;
export const UpdateTeamSettingsDocument = gql`
  mutation updateTeamSettings($input: UpdateTeamSettingsInput = {}) {
    updateTeamSettings(input: $input) {
      id
      customerVisibility
      defaultProfilePictureUrl
      guidelineProfile
      profileImageSetting
    }
  }
`;
export type UpdateTeamSettingsMutationFn = Apollo.MutationFunction<
  UpdateTeamSettingsMutation,
  UpdateTeamSettingsMutationVariables
>;

/**
 * __useUpdateTeamSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamSettingsMutation, { data, loading, error }] = useUpdateTeamSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamSettingsMutation,
    UpdateTeamSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTeamSettingsMutation, UpdateTeamSettingsMutationVariables>(
    UpdateTeamSettingsDocument,
    options
  );
}
export type UpdateTeamSettingsMutationHookResult = ReturnType<typeof useUpdateTeamSettingsMutation>;
export type UpdateTeamSettingsMutationResult = Apollo.MutationResult<UpdateTeamSettingsMutation>;
export type UpdateTeamSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamSettingsMutation,
  UpdateTeamSettingsMutationVariables
>;
export const GetAchievementCategoryBadgesDocument = gql`
  query getAchievementCategoryBadges($status: AchievementStatus = ENABLED) {
    achievementCategories(status: $status) {
      id
      identifier
      name
      description
      enabled
      companyAchievements {
        id
        pathName
        badges {
          key
          achievementKey
          name
          iconSettings
          description
          imageUrl
          badgeType
          surprise
          threshold
        }
      }
    }
  }
`;

/**
 * __useGetAchievementCategoryBadgesQuery__
 *
 * To run a query within a React component, call `useGetAchievementCategoryBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementCategoryBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementCategoryBadgesQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAchievementCategoryBadgesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAchievementCategoryBadgesQuery,
    GetAchievementCategoryBadgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAchievementCategoryBadgesQuery,
    GetAchievementCategoryBadgesQueryVariables
  >(GetAchievementCategoryBadgesDocument, options);
}
export function useGetAchievementCategoryBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAchievementCategoryBadgesQuery,
    GetAchievementCategoryBadgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAchievementCategoryBadgesQuery,
    GetAchievementCategoryBadgesQueryVariables
  >(GetAchievementCategoryBadgesDocument, options);
}
export type GetAchievementCategoryBadgesQueryHookResult = ReturnType<
  typeof useGetAchievementCategoryBadgesQuery
>;
export type GetAchievementCategoryBadgesLazyQueryHookResult = ReturnType<
  typeof useGetAchievementCategoryBadgesLazyQuery
>;
export type GetAchievementCategoryBadgesQueryResult = Apollo.QueryResult<
  GetAchievementCategoryBadgesQuery,
  GetAchievementCategoryBadgesQueryVariables
>;
export const GetAchievementCategoryEmployeeBadgesDocument = gql`
  query getAchievementCategoryEmployeeBadges(
    $status: AchievementStatus = ENABLED
    $employeeId: ID
  ) {
    achievementCategories(status: $status) {
      id
      identifier
      name
      description
      enabled
      companyAchievements {
        id
        pathName
        pathDescription
        employeeBadges(employeeId: $employeeId) {
          ... on EmployeeBadge {
            id
            name
            description
            iconSettings
            badgeKey
            badgeType
            imageUrl
            count
            status
            earnedAt
            employee {
              id
              email
            }
          }
          ... on NonPersistedEmployeeBadge {
            name
            description
            instruction
            iconSettings
            badgeKey
            badgeType
            imageUrl
            status
            surprise
            threshold
            employee {
              email
              id
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetAchievementCategoryEmployeeBadgesQuery__
 *
 * To run a query within a React component, call `useGetAchievementCategoryEmployeeBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementCategoryEmployeeBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementCategoryEmployeeBadgesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetAchievementCategoryEmployeeBadgesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAchievementCategoryEmployeeBadgesQuery,
    GetAchievementCategoryEmployeeBadgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAchievementCategoryEmployeeBadgesQuery,
    GetAchievementCategoryEmployeeBadgesQueryVariables
  >(GetAchievementCategoryEmployeeBadgesDocument, options);
}
export function useGetAchievementCategoryEmployeeBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAchievementCategoryEmployeeBadgesQuery,
    GetAchievementCategoryEmployeeBadgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAchievementCategoryEmployeeBadgesQuery,
    GetAchievementCategoryEmployeeBadgesQueryVariables
  >(GetAchievementCategoryEmployeeBadgesDocument, options);
}
export type GetAchievementCategoryEmployeeBadgesQueryHookResult = ReturnType<
  typeof useGetAchievementCategoryEmployeeBadgesQuery
>;
export type GetAchievementCategoryEmployeeBadgesLazyQueryHookResult = ReturnType<
  typeof useGetAchievementCategoryEmployeeBadgesLazyQuery
>;
export type GetAchievementCategoryEmployeeBadgesQueryResult = Apollo.QueryResult<
  GetAchievementCategoryEmployeeBadgesQuery,
  GetAchievementCategoryEmployeeBadgesQueryVariables
>;
export const GetAchievementCategoryStatusesDocument = gql`
  query getAchievementCategoryStatuses {
    achievementCategories(status: ALL) {
      id
      enabled
    }
  }
`;

/**
 * __useGetAchievementCategoryStatusesQuery__
 *
 * To run a query within a React component, call `useGetAchievementCategoryStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementCategoryStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementCategoryStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAchievementCategoryStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAchievementCategoryStatusesQuery,
    GetAchievementCategoryStatusesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAchievementCategoryStatusesQuery,
    GetAchievementCategoryStatusesQueryVariables
  >(GetAchievementCategoryStatusesDocument, options);
}
export function useGetAchievementCategoryStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAchievementCategoryStatusesQuery,
    GetAchievementCategoryStatusesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAchievementCategoryStatusesQuery,
    GetAchievementCategoryStatusesQueryVariables
  >(GetAchievementCategoryStatusesDocument, options);
}
export type GetAchievementCategoryStatusesQueryHookResult = ReturnType<
  typeof useGetAchievementCategoryStatusesQuery
>;
export type GetAchievementCategoryStatusesLazyQueryHookResult = ReturnType<
  typeof useGetAchievementCategoryStatusesLazyQuery
>;
export type GetAchievementCategoryStatusesQueryResult = Apollo.QueryResult<
  GetAchievementCategoryStatusesQuery,
  GetAchievementCategoryStatusesQueryVariables
>;
export const GetActionItemsDocument = gql`
  query getActionItems(
    $actionableId: ID!
    $actionableType: ActionableTypeEnum!
    $status: GoalStatusEnum = ALL
  ) {
    actionItems(actionableId: $actionableId, actionableType: $actionableType, status: $status) {
      edges {
        node {
          action
          completedAt
          createdAt
          id
          updatedAt
        }
      }
    }
  }
`;

/**
 * __useGetActionItemsQuery__
 *
 * To run a query within a React component, call `useGetActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionItemsQuery({
 *   variables: {
 *      actionableId: // value for 'actionableId'
 *      actionableType: // value for 'actionableType'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetActionItemsQuery(
  baseOptions: Apollo.QueryHookOptions<GetActionItemsQuery, GetActionItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActionItemsQuery, GetActionItemsQueryVariables>(
    GetActionItemsDocument,
    options
  );
}
export function useGetActionItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActionItemsQuery, GetActionItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActionItemsQuery, GetActionItemsQueryVariables>(
    GetActionItemsDocument,
    options
  );
}
export type GetActionItemsQueryHookResult = ReturnType<typeof useGetActionItemsQuery>;
export type GetActionItemsLazyQueryHookResult = ReturnType<typeof useGetActionItemsLazyQuery>;
export type GetActionItemsQueryResult = Apollo.QueryResult<
  GetActionItemsQuery,
  GetActionItemsQueryVariables
>;
export const GetActionItemHistoryDocument = gql`
  query getActionItemHistory($id: ID!) {
    coachingSessionActionItemHistory(id: $id) {
      collection {
        attributeName
        actor {
          ... on Employee {
            id
            email
            profile {
              id
              fullName
              imageUrl
            }
            __typename
          }
          ... on Company {
            name
            logoUrl
            __typename
          }
        }
        createdAt
        valueBefore
        valueAfter
        event
      }
    }
  }
`;

/**
 * __useGetActionItemHistoryQuery__
 *
 * To run a query within a React component, call `useGetActionItemHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionItemHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionItemHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActionItemHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActionItemHistoryQuery,
    GetActionItemHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActionItemHistoryQuery, GetActionItemHistoryQueryVariables>(
    GetActionItemHistoryDocument,
    options
  );
}
export function useGetActionItemHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActionItemHistoryQuery,
    GetActionItemHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActionItemHistoryQuery, GetActionItemHistoryQueryVariables>(
    GetActionItemHistoryDocument,
    options
  );
}
export type GetActionItemHistoryQueryHookResult = ReturnType<typeof useGetActionItemHistoryQuery>;
export type GetActionItemHistoryLazyQueryHookResult = ReturnType<
  typeof useGetActionItemHistoryLazyQuery
>;
export type GetActionItemHistoryQueryResult = Apollo.QueryResult<
  GetActionItemHistoryQuery,
  GetActionItemHistoryQueryVariables
>;
export const GetAllReportingGroupsDocument = gql`
  query getAllReportingGroups {
    reportingGroups {
      nodes {
        id
      }
    }
  }
`;

/**
 * __useGetAllReportingGroupsQuery__
 *
 * To run a query within a React component, call `useGetAllReportingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReportingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReportingGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllReportingGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllReportingGroupsQuery,
    GetAllReportingGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllReportingGroupsQuery, GetAllReportingGroupsQueryVariables>(
    GetAllReportingGroupsDocument,
    options
  );
}
export function useGetAllReportingGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllReportingGroupsQuery,
    GetAllReportingGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllReportingGroupsQuery, GetAllReportingGroupsQueryVariables>(
    GetAllReportingGroupsDocument,
    options
  );
}
export type GetAllReportingGroupsQueryHookResult = ReturnType<typeof useGetAllReportingGroupsQuery>;
export type GetAllReportingGroupsLazyQueryHookResult = ReturnType<
  typeof useGetAllReportingGroupsLazyQuery
>;
export type GetAllReportingGroupsQueryResult = Apollo.QueryResult<
  GetAllReportingGroupsQuery,
  GetAllReportingGroupsQueryVariables
>;
export const GetReviewAppealDocument = gql`
  query getReviewAppeal($reviewId: ID!) {
    qaAppeal(qaReviewId: $reviewId) {
      id
      createdAt
      reasons {
        note
        qaAnswer {
          id
        }
      }
      employee {
        id
        profile {
          id
          fullName
        }
      }
      resolution {
        id
        createdAt
        reasons {
          note
          qaAnswer {
            id
          }
        }
        employee {
          id
          profile {
            id
            fullName
          }
        }
      }
    }
  }
`;

/**
 * __useGetReviewAppealQuery__
 *
 * To run a query within a React component, call `useGetReviewAppealQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewAppealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewAppealQuery({
 *   variables: {
 *      reviewId: // value for 'reviewId'
 *   },
 * });
 */
export function useGetReviewAppealQuery(
  baseOptions: Apollo.QueryHookOptions<GetReviewAppealQuery, GetReviewAppealQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReviewAppealQuery, GetReviewAppealQueryVariables>(
    GetReviewAppealDocument,
    options
  );
}
export function useGetReviewAppealLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReviewAppealQuery, GetReviewAppealQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReviewAppealQuery, GetReviewAppealQueryVariables>(
    GetReviewAppealDocument,
    options
  );
}
export type GetReviewAppealQueryHookResult = ReturnType<typeof useGetReviewAppealQuery>;
export type GetReviewAppealLazyQueryHookResult = ReturnType<typeof useGetReviewAppealLazyQuery>;
export type GetReviewAppealQueryResult = Apollo.QueryResult<
  GetReviewAppealQuery,
  GetReviewAppealQueryVariables
>;
export const GetAssignmentDocument = gql`
  query getAssignment($id: ID!) {
    qaAssignment(id: $id) {
      allocateToTeamLeader
      archivedAt
      assigned
      cadence
      completed
      endDate
      id
      initialStartDate
      name
      numberOfDays
      progress
      qaFormId
      qaReviewType
      reviewers {
        id
      }
      skipped
      startDate
      totalActiveReviewees
      totalActiveReviewers
      totalCycles
      totalReportingGroups
      totalReviewees
      totalReviewers
      totalReviewsPerAgent
      totalReviewsPerReviewer
      totalTeams
      skipReasonStats {
        id
        reason
        reasonDetails
        totalSkipped
      }
    }
  }
`;

/**
 * __useGetAssignmentQuery__
 *
 * To run a query within a React component, call `useGetAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(
    GetAssignmentDocument,
    options
  );
}
export function useGetAssignmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(
    GetAssignmentDocument,
    options
  );
}
export type GetAssignmentQueryHookResult = ReturnType<typeof useGetAssignmentQuery>;
export type GetAssignmentLazyQueryHookResult = ReturnType<typeof useGetAssignmentLazyQuery>;
export type GetAssignmentQueryResult = Apollo.QueryResult<
  GetAssignmentQuery,
  GetAssignmentQueryVariables
>;
export const GetQaAssignmentsDocument = gql`
  query getQaAssignments(
    $archived: Boolean = false
    $reviewerId: ID = null
    $sort: QaAssignmentSortInput = { field: createdAt, direction: DESC }
    $limit: Int = 10
    $page: Int = 1
  ) {
    qaAssignments(
      archived: $archived
      reviewerId: $reviewerId
      sort: $sort
      limit: $limit
      page: $page
    ) {
      collection {
        id
        name
        cadence
        numberOfDays
        progress
        assigned
        completed
        skipped
        totalReviewers
        totalReviewees
        initialStartDate
        startDate
        qaReviewType
        endDate
        archivedAt
        effectiveAt
        createdAt
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

/**
 * __useGetQaAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetQaAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaAssignmentsQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *      reviewerId: // value for 'reviewerId'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetQaAssignmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetQaAssignmentsQuery, GetQaAssignmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaAssignmentsQuery, GetQaAssignmentsQueryVariables>(
    GetQaAssignmentsDocument,
    options
  );
}
export function useGetQaAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQaAssignmentsQuery, GetQaAssignmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQaAssignmentsQuery, GetQaAssignmentsQueryVariables>(
    GetQaAssignmentsDocument,
    options
  );
}
export type GetQaAssignmentsQueryHookResult = ReturnType<typeof useGetQaAssignmentsQuery>;
export type GetQaAssignmentsLazyQueryHookResult = ReturnType<typeof useGetQaAssignmentsLazyQuery>;
export type GetQaAssignmentsQueryResult = Apollo.QueryResult<
  GetQaAssignmentsQuery,
  GetQaAssignmentsQueryVariables
>;
export const GetAssignmentNextReviewDocument = gql`
  query getAssignmentNextReview($assignmentId: ID!, $employeeId: ID, $partialMatching: Boolean) {
    qaAssignmentNextReview(
      id: $assignmentId
      employeeId: $employeeId
      partialMatching: $partialMatching
    ) {
      uuid
      qaAssignmentId
      qaAllocation {
        id
      }
      blind
      partiallyMatched
      qaReviewType
      qaReviewId
    }
  }
`;

/**
 * __useGetAssignmentNextReviewQuery__
 *
 * To run a query within a React component, call `useGetAssignmentNextReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentNextReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentNextReviewQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      employeeId: // value for 'employeeId'
 *      partialMatching: // value for 'partialMatching'
 *   },
 * });
 */
export function useGetAssignmentNextReviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssignmentNextReviewQuery,
    GetAssignmentNextReviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssignmentNextReviewQuery, GetAssignmentNextReviewQueryVariables>(
    GetAssignmentNextReviewDocument,
    options
  );
}
export function useGetAssignmentNextReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssignmentNextReviewQuery,
    GetAssignmentNextReviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssignmentNextReviewQuery, GetAssignmentNextReviewQueryVariables>(
    GetAssignmentNextReviewDocument,
    options
  );
}
export type GetAssignmentNextReviewQueryHookResult = ReturnType<
  typeof useGetAssignmentNextReviewQuery
>;
export type GetAssignmentNextReviewLazyQueryHookResult = ReturnType<
  typeof useGetAssignmentNextReviewLazyQuery
>;
export type GetAssignmentNextReviewQueryResult = Apollo.QueryResult<
  GetAssignmentNextReviewQuery,
  GetAssignmentNextReviewQueryVariables
>;
export const GetAssignmentPeriodsDocument = gql`
  query getAssignmentPeriods($id: ID!, $page: Int = 1, $limit: Int = 10) {
    qaAssignment(id: $id) {
      id
      archivedAt
      initialStartDate
      cadence
    }
    qaAssignmentPeriods(id: $id, page: $page, limit: $limit) {
      collection {
        id
        startDate
        endDate
        averageQaScore
        assigned
        completed
        progress
        revieweesStats {
          added
          allPeriod
          removed
          total
        }
        reviewersStats {
          added
          allPeriod
          removed
          total
        }
        totalReviewees
        totalReviewers
        interactionsCount
        eligibleInteractionsCount
        skipped
        skipReasonStats {
          id
          reason
          reasonDetails
          totalSkipped
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`;

/**
 * __useGetAssignmentPeriodsQuery__
 *
 * To run a query within a React component, call `useGetAssignmentPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentPeriodsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAssignmentPeriodsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssignmentPeriodsQuery,
    GetAssignmentPeriodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssignmentPeriodsQuery, GetAssignmentPeriodsQueryVariables>(
    GetAssignmentPeriodsDocument,
    options
  );
}
export function useGetAssignmentPeriodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssignmentPeriodsQuery,
    GetAssignmentPeriodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssignmentPeriodsQuery, GetAssignmentPeriodsQueryVariables>(
    GetAssignmentPeriodsDocument,
    options
  );
}
export type GetAssignmentPeriodsQueryHookResult = ReturnType<typeof useGetAssignmentPeriodsQuery>;
export type GetAssignmentPeriodsLazyQueryHookResult = ReturnType<
  typeof useGetAssignmentPeriodsLazyQuery
>;
export type GetAssignmentPeriodsQueryResult = Apollo.QueryResult<
  GetAssignmentPeriodsQuery,
  GetAssignmentPeriodsQueryVariables
>;
export const GetAssignmentPeriodsRevieweesDocument = gql`
  query getAssignmentPeriodsReviewees(
    $after: String
    $id: ID!
    $periodIds: [ID!] = null
    $limit: Int = 1
    $search: String = null
    $activity: QaAssignmentRevieweeActivityEnum = null
    $sort: QaAssignmentPeriodRevieweesSortInput = { field: FULL_NAME, direction: ASC }
    $onlyStats: Boolean = false
  ) {
    qaAssignmentPeriods(id: $id, limit: $limit, periodIds: $periodIds) {
      collection {
        id
        revieweesStats {
          added
          allPeriod
          removed
          total
        }
        reviewees(activity: $activity, search: $search, sort: $sort, after: $after)
          @skip(if: $onlyStats) {
          pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
          }
          edges {
            cursor
            node {
              fullName
              id
              isReviewable
              activity
              imageUrl
              joinedAt
              leftAt
              leftReason
              progress
              averageQaScore
              completed
            }
          }
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`;

/**
 * __useGetAssignmentPeriodsRevieweesQuery__
 *
 * To run a query within a React component, call `useGetAssignmentPeriodsRevieweesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentPeriodsRevieweesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentPeriodsRevieweesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      id: // value for 'id'
 *      periodIds: // value for 'periodIds'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      activity: // value for 'activity'
 *      sort: // value for 'sort'
 *      onlyStats: // value for 'onlyStats'
 *   },
 * });
 */
export function useGetAssignmentPeriodsRevieweesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssignmentPeriodsRevieweesQuery,
    GetAssignmentPeriodsRevieweesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssignmentPeriodsRevieweesQuery,
    GetAssignmentPeriodsRevieweesQueryVariables
  >(GetAssignmentPeriodsRevieweesDocument, options);
}
export function useGetAssignmentPeriodsRevieweesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssignmentPeriodsRevieweesQuery,
    GetAssignmentPeriodsRevieweesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssignmentPeriodsRevieweesQuery,
    GetAssignmentPeriodsRevieweesQueryVariables
  >(GetAssignmentPeriodsRevieweesDocument, options);
}
export type GetAssignmentPeriodsRevieweesQueryHookResult = ReturnType<
  typeof useGetAssignmentPeriodsRevieweesQuery
>;
export type GetAssignmentPeriodsRevieweesLazyQueryHookResult = ReturnType<
  typeof useGetAssignmentPeriodsRevieweesLazyQuery
>;
export type GetAssignmentPeriodsRevieweesQueryResult = Apollo.QueryResult<
  GetAssignmentPeriodsRevieweesQuery,
  GetAssignmentPeriodsRevieweesQueryVariables
>;
export const GetAssignmentPeriodsReviewersDocument = gql`
  query getAssignmentPeriodsReviewers(
    $after: String
    $id: ID!
    $periodIds: [ID!] = null
    $limit: Int = 1
    $search: String = null
    $activity: QaAssignmentReviewerActivityEnum = null
    $sort: QaAssignmentPeriodReviewersSortInput = { field: FULL_NAME, direction: ASC }
    $onlyStats: Boolean = false
  ) {
    qaAssignmentPeriods(id: $id, limit: $limit, periodIds: $periodIds) {
      collection {
        id
        reviewersStats {
          added
          allPeriod
          removed
          total
        }
        reviewers(activity: $activity, search: $search, sort: $sort, after: $after)
          @skip(if: $onlyStats) {
          pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
          }
          edges {
            cursor
            node {
              assigned
              fullName
              id
              activity
              imageUrl
              joinedAt
              leftAt
              leftReason
              progress
              completed
              skipped
            }
          }
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`;

/**
 * __useGetAssignmentPeriodsReviewersQuery__
 *
 * To run a query within a React component, call `useGetAssignmentPeriodsReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentPeriodsReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentPeriodsReviewersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      id: // value for 'id'
 *      periodIds: // value for 'periodIds'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      activity: // value for 'activity'
 *      sort: // value for 'sort'
 *      onlyStats: // value for 'onlyStats'
 *   },
 * });
 */
export function useGetAssignmentPeriodsReviewersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssignmentPeriodsReviewersQuery,
    GetAssignmentPeriodsReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssignmentPeriodsReviewersQuery,
    GetAssignmentPeriodsReviewersQueryVariables
  >(GetAssignmentPeriodsReviewersDocument, options);
}
export function useGetAssignmentPeriodsReviewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssignmentPeriodsReviewersQuery,
    GetAssignmentPeriodsReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssignmentPeriodsReviewersQuery,
    GetAssignmentPeriodsReviewersQueryVariables
  >(GetAssignmentPeriodsReviewersDocument, options);
}
export type GetAssignmentPeriodsReviewersQueryHookResult = ReturnType<
  typeof useGetAssignmentPeriodsReviewersQuery
>;
export type GetAssignmentPeriodsReviewersLazyQueryHookResult = ReturnType<
  typeof useGetAssignmentPeriodsReviewersLazyQuery
>;
export type GetAssignmentPeriodsReviewersQueryResult = Apollo.QueryResult<
  GetAssignmentPeriodsReviewersQuery,
  GetAssignmentPeriodsReviewersQueryVariables
>;
export const GetQaAssignmentPreviewDocument = gql`
  query getQaAssignmentPreview($assignment: QaAssignmentInput!) {
    previewQaAssignment(qaAssignment: $assignment) {
      id
      assigned
      totalReviewees
      totalReviewers
      totalReviewsPerAgent
      totalReviewsPerReviewer
      allocateToTeamLeader
      qaReviewType
      reviewers {
        id
        assigned
        fullName
        imageUrl
        validationErrors {
          message
          type
        }
      }
    }
  }
`;

/**
 * __useGetQaAssignmentPreviewQuery__
 *
 * To run a query within a React component, call `useGetQaAssignmentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaAssignmentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaAssignmentPreviewQuery({
 *   variables: {
 *      assignment: // value for 'assignment'
 *   },
 * });
 */
export function useGetQaAssignmentPreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQaAssignmentPreviewQuery,
    GetQaAssignmentPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaAssignmentPreviewQuery, GetQaAssignmentPreviewQueryVariables>(
    GetQaAssignmentPreviewDocument,
    options
  );
}
export function useGetQaAssignmentPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQaAssignmentPreviewQuery,
    GetQaAssignmentPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQaAssignmentPreviewQuery, GetQaAssignmentPreviewQueryVariables>(
    GetQaAssignmentPreviewDocument,
    options
  );
}
export type GetQaAssignmentPreviewQueryHookResult = ReturnType<
  typeof useGetQaAssignmentPreviewQuery
>;
export type GetQaAssignmentPreviewLazyQueryHookResult = ReturnType<
  typeof useGetQaAssignmentPreviewLazyQuery
>;
export type GetQaAssignmentPreviewQueryResult = Apollo.QueryResult<
  GetQaAssignmentPreviewQuery,
  GetQaAssignmentPreviewQueryVariables
>;
export const GetAssignmentRevieweesDocument = gql`
  query getAssignmentReviewees(
    $id: ID!
    $filters: QaAssignmentRevieweesFiltersInput
    $limit: Int = 5
  ) {
    qaAssignment(id: $id) {
      id
      reviewees(filters: $filters, limit: $limit) {
        collection {
          id
          fullName
          imageUrl
          averageQaScore
          completed
          progress
        }
        metadata {
          totalPages
          totalCount
          currentPage
          limitValue
        }
      }
    }
  }
`;

/**
 * __useGetAssignmentRevieweesQuery__
 *
 * To run a query within a React component, call `useGetAssignmentRevieweesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentRevieweesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentRevieweesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAssignmentRevieweesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssignmentRevieweesQuery,
    GetAssignmentRevieweesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssignmentRevieweesQuery, GetAssignmentRevieweesQueryVariables>(
    GetAssignmentRevieweesDocument,
    options
  );
}
export function useGetAssignmentRevieweesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssignmentRevieweesQuery,
    GetAssignmentRevieweesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssignmentRevieweesQuery, GetAssignmentRevieweesQueryVariables>(
    GetAssignmentRevieweesDocument,
    options
  );
}
export type GetAssignmentRevieweesQueryHookResult = ReturnType<
  typeof useGetAssignmentRevieweesQuery
>;
export type GetAssignmentRevieweesLazyQueryHookResult = ReturnType<
  typeof useGetAssignmentRevieweesLazyQuery
>;
export type GetAssignmentRevieweesQueryResult = Apollo.QueryResult<
  GetAssignmentRevieweesQuery,
  GetAssignmentRevieweesQueryVariables
>;
export const GetAssignmentReviewersDocument = gql`
  query getAssignmentReviewers($id: ID!) {
    qaAssignment(id: $id) {
      id
      reviewers {
        fullName
        id
        imageUrl
        completed
      }
    }
  }
`;

/**
 * __useGetAssignmentReviewersQuery__
 *
 * To run a query within a React component, call `useGetAssignmentReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentReviewersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentReviewersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssignmentReviewersQuery,
    GetAssignmentReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssignmentReviewersQuery, GetAssignmentReviewersQueryVariables>(
    GetAssignmentReviewersDocument,
    options
  );
}
export function useGetAssignmentReviewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssignmentReviewersQuery,
    GetAssignmentReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssignmentReviewersQuery, GetAssignmentReviewersQueryVariables>(
    GetAssignmentReviewersDocument,
    options
  );
}
export type GetAssignmentReviewersQueryHookResult = ReturnType<
  typeof useGetAssignmentReviewersQuery
>;
export type GetAssignmentReviewersLazyQueryHookResult = ReturnType<
  typeof useGetAssignmentReviewersLazyQuery
>;
export type GetAssignmentReviewersQueryResult = Apollo.QueryResult<
  GetAssignmentReviewersQuery,
  GetAssignmentReviewersQueryVariables
>;
export const GetQaAssignmentSkipReasonsDocument = gql`
  query getQaAssignmentSkipReasons {
    qaAssignmentSkipReasons {
      default
      description
      id
      label
    }
  }
`;

/**
 * __useGetQaAssignmentSkipReasonsQuery__
 *
 * To run a query within a React component, call `useGetQaAssignmentSkipReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaAssignmentSkipReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaAssignmentSkipReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQaAssignmentSkipReasonsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetQaAssignmentSkipReasonsQuery,
    GetQaAssignmentSkipReasonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaAssignmentSkipReasonsQuery, GetQaAssignmentSkipReasonsQueryVariables>(
    GetQaAssignmentSkipReasonsDocument,
    options
  );
}
export function useGetQaAssignmentSkipReasonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQaAssignmentSkipReasonsQuery,
    GetQaAssignmentSkipReasonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQaAssignmentSkipReasonsQuery,
    GetQaAssignmentSkipReasonsQueryVariables
  >(GetQaAssignmentSkipReasonsDocument, options);
}
export type GetQaAssignmentSkipReasonsQueryHookResult = ReturnType<
  typeof useGetQaAssignmentSkipReasonsQuery
>;
export type GetQaAssignmentSkipReasonsLazyQueryHookResult = ReturnType<
  typeof useGetQaAssignmentSkipReasonsLazyQuery
>;
export type GetQaAssignmentSkipReasonsQueryResult = Apollo.QueryResult<
  GetQaAssignmentSkipReasonsQuery,
  GetQaAssignmentSkipReasonsQueryVariables
>;
export const GetAuditDocument = gql`
  query getAudit($id: ID!) {
    audit(id: $id) {
      id
      auditable {
        __typename
        ... on QaReviewRegularAudit {
          id
        }
        ... on QaReviewCalibrationAudit {
          id
        }
      }
      autofailed
      hideReviewer
      hideEmployee
      deletedAt
      createdAt
      completedAt
      score
      scoreDisplayValue
      qaAssignmentId
      reviewer {
        id
        profile {
          id
          fullName
          imageUrl
        }
      }
      qaReview {
        id
      }
      qaAnswers {
        answerableId
        answerableType
        answered
        comments
        createdAt
        id
        qaOption {
          id
          qaQuestion {
            id
          }
        }
        qaQuestion {
          id
        }
      }
      qaForm {
        id
        qaReviewsCount
        questionCount
        sectionCount
        type
        weightedSections
        qaFormSections {
          id
          title
          qaQuestions {
            id
            instructions
            naOption
            position
            text
            qaOptions {
              id
              createdAt
              autofail
              position
              score
              text
              updatedAt
            }
          }
        }
        name
      }
    }
  }
`;

/**
 * __useGetAuditQuery__
 *
 * To run a query within a React component, call `useGetAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAuditQuery(
  baseOptions: Apollo.QueryHookOptions<GetAuditQuery, GetAuditQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAuditQuery, GetAuditQueryVariables>(GetAuditDocument, options);
}
export function useGetAuditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAuditQuery, GetAuditQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAuditQuery, GetAuditQueryVariables>(GetAuditDocument, options);
}
export type GetAuditQueryHookResult = ReturnType<typeof useGetAuditQuery>;
export type GetAuditLazyQueryHookResult = ReturnType<typeof useGetAuditLazyQuery>;
export type GetAuditQueryResult = Apollo.QueryResult<GetAuditQuery, GetAuditQueryVariables>;
export const GetAuditsDocument = gql`
  query getAudits(
    $limit: Int = 10
    $page: Int = 1
    $filters: AuditFilterInput!
    $sort: AuditSortInput
  ) {
    audits(limit: $limit, page: $page, filters: $filters, sort: $sort) {
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
      collection {
        auditable {
          __typename
          ... on QaReviewRegularAudit {
            id
          }
          ... on QaReviewCalibrationAudit {
            id
          }
        }
        auditorFullName
        autofailed
        completedAt
        id
        interactionId
        reviewerFullName
        reviewerImageUrl
        score
        scorecard
        startedAt
        originalScorecardName
        revised
      }
    }
  }
`;

/**
 * __useGetAuditsQuery__
 *
 * To run a query within a React component, call `useGetAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAuditsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAuditsQuery, GetAuditsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAuditsQuery, GetAuditsQueryVariables>(GetAuditsDocument, options);
}
export function useGetAuditsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAuditsQuery, GetAuditsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAuditsQuery, GetAuditsQueryVariables>(GetAuditsDocument, options);
}
export type GetAuditsQueryHookResult = ReturnType<typeof useGetAuditsQuery>;
export type GetAuditsLazyQueryHookResult = ReturnType<typeof useGetAuditsLazyQuery>;
export type GetAuditsQueryResult = Apollo.QueryResult<GetAuditsQuery, GetAuditsQueryVariables>;
export const GetAReportingGroupDocument = gql`
  query getAReportingGroup($id: ID!) {
    reportingGroup(id: $id) {
      id
      name
    }
  }
`;

/**
 * __useGetAReportingGroupQuery__
 *
 * To run a query within a React component, call `useGetAReportingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAReportingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAReportingGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAReportingGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GetAReportingGroupQuery, GetAReportingGroupQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAReportingGroupQuery, GetAReportingGroupQueryVariables>(
    GetAReportingGroupDocument,
    options
  );
}
export function useGetAReportingGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAReportingGroupQuery,
    GetAReportingGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAReportingGroupQuery, GetAReportingGroupQueryVariables>(
    GetAReportingGroupDocument,
    options
  );
}
export type GetAReportingGroupQueryHookResult = ReturnType<typeof useGetAReportingGroupQuery>;
export type GetAReportingGroupLazyQueryHookResult = ReturnType<
  typeof useGetAReportingGroupLazyQuery
>;
export type GetAReportingGroupQueryResult = Apollo.QueryResult<
  GetAReportingGroupQuery,
  GetAReportingGroupQueryVariables
>;
export const GetCalculatedMetricsDocument = gql`
  query getCalculatedMetrics(
    $dateRange: DateRangeInput!
    $prevDateRange: DateRangeInput!
    $solicitationReportingTimestamp: SolicitationReportingTimestampEnum
    $employeeIds: [ID!]
    $teamIds: [ID!]
    $metrics: [MetricInput!]!
  ) {
    calculateMetrics(
      filters: {
        dateRange: $dateRange
        solicitationReportingTimestamp: $solicitationReportingTimestamp
        employeeIds: $employeeIds
        teamIds: $teamIds
      }
      metrics: $metrics
    ) {
      ...resultFragment
    }
    prevPeriod: calculateMetrics(
      filters: { dateRange: $prevDateRange, employeeIds: $employeeIds, teamIds: $teamIds }
      metrics: $metrics
    ) {
      ...resultFragment
    }
  }
  ${ResultFragmentFragmentDoc}
`;

/**
 * __useGetCalculatedMetricsQuery__
 *
 * To run a query within a React component, call `useGetCalculatedMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculatedMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalculatedMetricsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      prevDateRange: // value for 'prevDateRange'
 *      solicitationReportingTimestamp: // value for 'solicitationReportingTimestamp'
 *      employeeIds: // value for 'employeeIds'
 *      teamIds: // value for 'teamIds'
 *      metrics: // value for 'metrics'
 *   },
 * });
 */
export function useGetCalculatedMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalculatedMetricsQuery,
    GetCalculatedMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCalculatedMetricsQuery, GetCalculatedMetricsQueryVariables>(
    GetCalculatedMetricsDocument,
    options
  );
}
export function useGetCalculatedMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalculatedMetricsQuery,
    GetCalculatedMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCalculatedMetricsQuery, GetCalculatedMetricsQueryVariables>(
    GetCalculatedMetricsDocument,
    options
  );
}
export type GetCalculatedMetricsQueryHookResult = ReturnType<typeof useGetCalculatedMetricsQuery>;
export type GetCalculatedMetricsLazyQueryHookResult = ReturnType<
  typeof useGetCalculatedMetricsLazyQuery
>;
export type GetCalculatedMetricsQueryResult = Apollo.QueryResult<
  GetCalculatedMetricsQuery,
  GetCalculatedMetricsQueryVariables
>;
export const GetCalibrationQuestionsDocument = gql`
  query getCalibrationQuestions(
    $qaFormId: ID!
    $first: Int
    $after: String
    $dateRange: DateRangeInput
    $before: String
    $last: Int
    $sort: QaCalibrationFormQuestionSortInput = {}
  ) {
    qaCalibrationFormQuestions(
      qaFormId: $qaFormId
      first: $first
      after: $after
      dateRange: $dateRange
      before: $before
      last: $last
      sort: $sort
    ) {
      edges {
        node {
          id
          alignmentScore {
            current
            previous
          }
          sectionTitle
          text
          sectionId
          sectionPosition
          position
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

/**
 * __useGetCalibrationQuestionsQuery__
 *
 * To run a query within a React component, call `useGetCalibrationQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationQuestionsQuery({
 *   variables: {
 *      qaFormId: // value for 'qaFormId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      dateRange: // value for 'dateRange'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCalibrationQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalibrationQuestionsQuery,
    GetCalibrationQuestionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCalibrationQuestionsQuery, GetCalibrationQuestionsQueryVariables>(
    GetCalibrationQuestionsDocument,
    options
  );
}
export function useGetCalibrationQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalibrationQuestionsQuery,
    GetCalibrationQuestionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCalibrationQuestionsQuery, GetCalibrationQuestionsQueryVariables>(
    GetCalibrationQuestionsDocument,
    options
  );
}
export type GetCalibrationQuestionsQueryHookResult = ReturnType<
  typeof useGetCalibrationQuestionsQuery
>;
export type GetCalibrationQuestionsLazyQueryHookResult = ReturnType<
  typeof useGetCalibrationQuestionsLazyQuery
>;
export type GetCalibrationQuestionsQueryResult = Apollo.QueryResult<
  GetCalibrationQuestionsQuery,
  GetCalibrationQuestionsQueryVariables
>;
export const GetCalibrationQuestionBreakdownDocument = gql`
  query getCalibrationQuestionBreakdown($qaCalibrationId: ID!) {
    qaCalibrationQuestionBreakdown(qaCalibrationId: $qaCalibrationId) {
      qaFormSection {
        defaultSection
        id
        position
        title
      }
      questions {
        selectedOptionId
        selectedNaOption
        qaQuestion {
          id
          instructions
          text
          naOption
          qaOptions {
            id
            text
          }
          position
        }
        qaAnswersWithReviewers {
          qaAnswer {
            id
            answered
            comments
            qaQuestion {
              id
              naOption
            }
            qaOption {
              id
            }
          }
          reviewer {
            id
            profile {
              id
              imageUrl
              fullName
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCalibrationQuestionBreakdownQuery__
 *
 * To run a query within a React component, call `useGetCalibrationQuestionBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationQuestionBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationQuestionBreakdownQuery({
 *   variables: {
 *      qaCalibrationId: // value for 'qaCalibrationId'
 *   },
 * });
 */
export function useGetCalibrationQuestionBreakdownQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalibrationQuestionBreakdownQuery,
    GetCalibrationQuestionBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCalibrationQuestionBreakdownQuery,
    GetCalibrationQuestionBreakdownQueryVariables
  >(GetCalibrationQuestionBreakdownDocument, options);
}
export function useGetCalibrationQuestionBreakdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalibrationQuestionBreakdownQuery,
    GetCalibrationQuestionBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalibrationQuestionBreakdownQuery,
    GetCalibrationQuestionBreakdownQueryVariables
  >(GetCalibrationQuestionBreakdownDocument, options);
}
export type GetCalibrationQuestionBreakdownQueryHookResult = ReturnType<
  typeof useGetCalibrationQuestionBreakdownQuery
>;
export type GetCalibrationQuestionBreakdownLazyQueryHookResult = ReturnType<
  typeof useGetCalibrationQuestionBreakdownLazyQuery
>;
export type GetCalibrationQuestionBreakdownQueryResult = Apollo.QueryResult<
  GetCalibrationQuestionBreakdownQuery,
  GetCalibrationQuestionBreakdownQueryVariables
>;
export const GetCalibrationScoresDocument = gql`
  query getCalibrationScores($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
    qaCalibrationScores(dateRange: { startDate: $startDate, endDate: $endDate }) {
      qaFormCalibrationScores {
        alignedAnswersCount
        alignmentScore
        answersCount
        calibrationsCount
        dates
        qaForm {
          id
          name
        }
        trend {
          alignmentScores
        }
      }
      alignedAnswersCount
      alignmentScore
      answersCount
      calibrationsCount
    }
  }
`;

/**
 * __useGetCalibrationScoresQuery__
 *
 * To run a query within a React component, call `useGetCalibrationScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationScoresQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCalibrationScoresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalibrationScoresQuery,
    GetCalibrationScoresQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCalibrationScoresQuery, GetCalibrationScoresQueryVariables>(
    GetCalibrationScoresDocument,
    options
  );
}
export function useGetCalibrationScoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalibrationScoresQuery,
    GetCalibrationScoresQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCalibrationScoresQuery, GetCalibrationScoresQueryVariables>(
    GetCalibrationScoresDocument,
    options
  );
}
export type GetCalibrationScoresQueryHookResult = ReturnType<typeof useGetCalibrationScoresQuery>;
export type GetCalibrationScoresLazyQueryHookResult = ReturnType<
  typeof useGetCalibrationScoresLazyQuery
>;
export type GetCalibrationScoresQueryResult = Apollo.QueryResult<
  GetCalibrationScoresQuery,
  GetCalibrationScoresQueryVariables
>;
export const GetCalibrationScoresForScorecardDocument = gql`
  query getCalibrationScoresForScorecard(
    $qaFormId: ID!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $previousStartDate: ISO8601Date!
    $previousEndDate: ISO8601Date!
  ) {
    qaFormCalibrationScores(
      qaFormId: $qaFormId
      dateRange: { startDate: $startDate, endDate: $endDate }
    ) {
      alignmentScore
      calibrationsCount
      qaForm {
        id
        name
      }
      qaFormSectionCalibrationScores {
        trend {
          alignmentScores
        }
        qaFormSection {
          id
          title
        }
        dates
        alignmentScore
        answersCount
        qaQuestionCalibrationScores {
          alignmentScore
          qaQuestion {
            id
            text
            position
          }
          qaCalibrations {
            id
          }
        }
      }
    }
    previousQaFormCalibrationScores: qaFormCalibrationScores(
      qaFormId: $qaFormId
      dateRange: { startDate: $previousStartDate, endDate: $previousEndDate }
    ) {
      qaFormSectionCalibrationScores {
        qaQuestionCalibrationScores {
          alignmentScore
          qaQuestion {
            id
          }
        }
      }
    }
  }
`;

/**
 * __useGetCalibrationScoresForScorecardQuery__
 *
 * To run a query within a React component, call `useGetCalibrationScoresForScorecardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationScoresForScorecardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationScoresForScorecardQuery({
 *   variables: {
 *      qaFormId: // value for 'qaFormId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *   },
 * });
 */
export function useGetCalibrationScoresForScorecardQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalibrationScoresForScorecardQuery,
    GetCalibrationScoresForScorecardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCalibrationScoresForScorecardQuery,
    GetCalibrationScoresForScorecardQueryVariables
  >(GetCalibrationScoresForScorecardDocument, options);
}
export function useGetCalibrationScoresForScorecardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalibrationScoresForScorecardQuery,
    GetCalibrationScoresForScorecardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalibrationScoresForScorecardQuery,
    GetCalibrationScoresForScorecardQueryVariables
  >(GetCalibrationScoresForScorecardDocument, options);
}
export type GetCalibrationScoresForScorecardQueryHookResult = ReturnType<
  typeof useGetCalibrationScoresForScorecardQuery
>;
export type GetCalibrationScoresForScorecardLazyQueryHookResult = ReturnType<
  typeof useGetCalibrationScoresForScorecardLazyQuery
>;
export type GetCalibrationScoresForScorecardQueryResult = Apollo.QueryResult<
  GetCalibrationScoresForScorecardQuery,
  GetCalibrationScoresForScorecardQueryVariables
>;
export const GetCalibrationScoresTrendsDocument = gql`
  query getCalibrationScoresTrends($startDate: ISO8601Date!, $endDate: ISO8601Date!, $id: ID!) {
    qaFormCalibrationScores(
      dateRange: { startDate: $startDate, endDate: $endDate }
      qaFormId: $id
    ) {
      alignedAnswersCount
      alignmentScore
      answersCount
      calibrationsCount
      dates
      qaForm {
        id
        name
      }
      qaFormSectionCalibrationScores {
        alignedAnswersCount
        alignmentScore
        answersCount
        calibrationsCount
        dates
        qaFormSection {
          id
          title
        }
        qaQuestionCalibrationScores {
          alignedAnswersCount
          alignmentScore
          answersCount
          calibrationsCount
          qaCalibrations {
            id
          }
          qaQuestion {
            id
            text
          }
        }
        trend {
          alignmentScores
        }
      }
      trend {
        alignmentScores
      }
    }
  }
`;

/**
 * __useGetCalibrationScoresTrendsQuery__
 *
 * To run a query within a React component, call `useGetCalibrationScoresTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationScoresTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationScoresTrendsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCalibrationScoresTrendsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalibrationScoresTrendsQuery,
    GetCalibrationScoresTrendsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCalibrationScoresTrendsQuery, GetCalibrationScoresTrendsQueryVariables>(
    GetCalibrationScoresTrendsDocument,
    options
  );
}
export function useGetCalibrationScoresTrendsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalibrationScoresTrendsQuery,
    GetCalibrationScoresTrendsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalibrationScoresTrendsQuery,
    GetCalibrationScoresTrendsQueryVariables
  >(GetCalibrationScoresTrendsDocument, options);
}
export type GetCalibrationScoresTrendsQueryHookResult = ReturnType<
  typeof useGetCalibrationScoresTrendsQuery
>;
export type GetCalibrationScoresTrendsLazyQueryHookResult = ReturnType<
  typeof useGetCalibrationScoresTrendsLazyQuery
>;
export type GetCalibrationScoresTrendsQueryResult = Apollo.QueryResult<
  GetCalibrationScoresTrendsQuery,
  GetCalibrationScoresTrendsQueryVariables
>;
export const GetCoacheesDataDocument = gql`
  query getCoacheesData(
    $after: String
    $first: Int = 50
    $filters: CoacheesDataFilterInput!
    $search: [CoacheesDataSearchInput!] = []
    $sort: [CoacheesDataSortInput!] = { field: LAST_SESSION, direction: DESC }
  ) {
    coacheesData(filters: $filters, first: $first, after: $after, search: $search, sort: $sort) {
      totalCount
      edges {
        node {
          entityId
          entityType
          name
          imageUrl
          closedActionItemsCount
          sessionsCount
          lastSession
          lastSessionId
          openActionItemsCount
          draftCoachingSessionId
          parentName
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

/**
 * __useGetCoacheesDataQuery__
 *
 * To run a query within a React component, call `useGetCoacheesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoacheesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoacheesDataQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCoacheesDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetCoacheesDataQuery, GetCoacheesDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoacheesDataQuery, GetCoacheesDataQueryVariables>(
    GetCoacheesDataDocument,
    options
  );
}
export function useGetCoacheesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCoacheesDataQuery, GetCoacheesDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoacheesDataQuery, GetCoacheesDataQueryVariables>(
    GetCoacheesDataDocument,
    options
  );
}
export type GetCoacheesDataQueryHookResult = ReturnType<typeof useGetCoacheesDataQuery>;
export type GetCoacheesDataLazyQueryHookResult = ReturnType<typeof useGetCoacheesDataLazyQuery>;
export type GetCoacheesDataQueryResult = Apollo.QueryResult<
  GetCoacheesDataQuery,
  GetCoacheesDataQueryVariables
>;
export const GetCoachingSessionsDocument = gql`
  query getCoachingSessions(
    $employeeId: ID!
    $dateRange: DateRangeInput
    $sort: [CoachingSessionSortInput!]
    $after: String
    $status: CoachingSessionStatusEnum
    $first: Int = 25
  ) {
    employee(id: $employeeId) {
      id
      coachingSessions(
        filters: { dateField: UPDATED_AT, dateRange: $dateRange, status: $status }
        sort: $sort
        first: $first
        after: $after
      ) {
        edges {
          node {
            id
            title
            createdAt
            updatedAt
            sharedAt
            coach {
              id
              ...employeeFields
            }
          }
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
  ${EmployeeFieldsFragmentDoc}
`;

/**
 * __useGetCoachingSessionsQuery__
 *
 * To run a query within a React component, call `useGetCoachingSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingSessionsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      dateRange: // value for 'dateRange'
 *      sort: // value for 'sort'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetCoachingSessionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCoachingSessionsQuery, GetCoachingSessionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoachingSessionsQuery, GetCoachingSessionsQueryVariables>(
    GetCoachingSessionsDocument,
    options
  );
}
export function useGetCoachingSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoachingSessionsQuery,
    GetCoachingSessionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoachingSessionsQuery, GetCoachingSessionsQueryVariables>(
    GetCoachingSessionsDocument,
    options
  );
}
export type GetCoachingSessionsQueryHookResult = ReturnType<typeof useGetCoachingSessionsQuery>;
export type GetCoachingSessionsLazyQueryHookResult = ReturnType<
  typeof useGetCoachingSessionsLazyQuery
>;
export type GetCoachingSessionsQueryResult = Apollo.QueryResult<
  GetCoachingSessionsQuery,
  GetCoachingSessionsQueryVariables
>;
export const GetCoachingSessionActionItemsDocument = gql`
  query getCoachingSessionActionItems(
    $employeeId: ID
    $teamId: ID
    $dateRange: DateRangeInput!
    $sort: [TakeawaySortInput!] = []
    $openInDateRangeFirst: Int = 10
    $openInDateRangeAfter: String
    $openOutsideDateRangeFirst: Int = 3
    $openOutsideDateRangeAfter: String
    $closedInDateRangeFirst: Int = 3
    $closedInDateRangeAfter: String
    $includeClosedItems: Boolean = false
  ) {
    openInDateRange: coachingSessionActionItems(
      filters: {
        employeeId: $employeeId
        teamId: $teamId
        dateRange: $dateRange
        dateRangeOption: INCLUDE
        status: OPEN
      }
      sort: $sort
    ) {
      categories {
        id
        name
        count
      }
      collection(first: $openInDateRangeFirst, after: $openInDateRangeAfter) {
        ...actionItemsCollectionFields
      }
    }
    openOutsideDateRange: coachingSessionActionItems(
      filters: {
        employeeId: $employeeId
        teamId: $teamId
        dateRange: $dateRange
        dateRangeOption: EXCLUDE
        status: OPEN
      }
      sort: $sort
    ) {
      collection(first: $openOutsideDateRangeFirst, after: $openOutsideDateRangeAfter) {
        ...actionItemsCollectionFields
      }
    }
    closedInDateRange: coachingSessionActionItems(
      filters: {
        employeeId: $employeeId
        teamId: $teamId
        dateRange: $dateRange
        dateRangeOption: INCLUDE
        status: CLOSED
      }
      sort: $sort
    ) @include(if: $includeClosedItems) {
      collection(first: $closedInDateRangeFirst, after: $closedInDateRangeAfter) {
        ...actionItemsCollectionFields
      }
    }
  }
  ${ActionItemsCollectionFieldsFragmentDoc}
`;

/**
 * __useGetCoachingSessionActionItemsQuery__
 *
 * To run a query within a React component, call `useGetCoachingSessionActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingSessionActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingSessionActionItemsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      teamId: // value for 'teamId'
 *      dateRange: // value for 'dateRange'
 *      sort: // value for 'sort'
 *      openInDateRangeFirst: // value for 'openInDateRangeFirst'
 *      openInDateRangeAfter: // value for 'openInDateRangeAfter'
 *      openOutsideDateRangeFirst: // value for 'openOutsideDateRangeFirst'
 *      openOutsideDateRangeAfter: // value for 'openOutsideDateRangeAfter'
 *      closedInDateRangeFirst: // value for 'closedInDateRangeFirst'
 *      closedInDateRangeAfter: // value for 'closedInDateRangeAfter'
 *      includeClosedItems: // value for 'includeClosedItems'
 *   },
 * });
 */
export function useGetCoachingSessionActionItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCoachingSessionActionItemsQuery,
    GetCoachingSessionActionItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCoachingSessionActionItemsQuery,
    GetCoachingSessionActionItemsQueryVariables
  >(GetCoachingSessionActionItemsDocument, options);
}
export function useGetCoachingSessionActionItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoachingSessionActionItemsQuery,
    GetCoachingSessionActionItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCoachingSessionActionItemsQuery,
    GetCoachingSessionActionItemsQueryVariables
  >(GetCoachingSessionActionItemsDocument, options);
}
export type GetCoachingSessionActionItemsQueryHookResult = ReturnType<
  typeof useGetCoachingSessionActionItemsQuery
>;
export type GetCoachingSessionActionItemsLazyQueryHookResult = ReturnType<
  typeof useGetCoachingSessionActionItemsLazyQuery
>;
export type GetCoachingSessionActionItemsQueryResult = Apollo.QueryResult<
  GetCoachingSessionActionItemsQuery,
  GetCoachingSessionActionItemsQueryVariables
>;
export const GetcoachingSessionInteractionAttachmentsDocument = gql`
  query getcoachingSessionInteractionAttachments($id: ID!, $employeeId: ID!) {
    coachingSession(id: $id) {
      id
      interactionAttachments {
        nodes {
          id
          notes
          summary
          followUp {
            id
            note
            employee {
              id
            }
            createdBy {
              id
              profile {
                id
                fullName
                imageUrl
              }
            }
            followUpable {
              ... on Interaction {
                ...interactionFields
              }
              __typename
            }
          }
        }
      }
    }
  }
  ${InteractionFieldsFragmentDoc}
`;

/**
 * __useGetcoachingSessionInteractionAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetcoachingSessionInteractionAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetcoachingSessionInteractionAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetcoachingSessionInteractionAttachmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetcoachingSessionInteractionAttachmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetcoachingSessionInteractionAttachmentsQuery,
    GetcoachingSessionInteractionAttachmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetcoachingSessionInteractionAttachmentsQuery,
    GetcoachingSessionInteractionAttachmentsQueryVariables
  >(GetcoachingSessionInteractionAttachmentsDocument, options);
}
export function useGetcoachingSessionInteractionAttachmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetcoachingSessionInteractionAttachmentsQuery,
    GetcoachingSessionInteractionAttachmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetcoachingSessionInteractionAttachmentsQuery,
    GetcoachingSessionInteractionAttachmentsQueryVariables
  >(GetcoachingSessionInteractionAttachmentsDocument, options);
}
export type GetcoachingSessionInteractionAttachmentsQueryHookResult = ReturnType<
  typeof useGetcoachingSessionInteractionAttachmentsQuery
>;
export type GetcoachingSessionInteractionAttachmentsLazyQueryHookResult = ReturnType<
  typeof useGetcoachingSessionInteractionAttachmentsLazyQuery
>;
export type GetcoachingSessionInteractionAttachmentsQueryResult = Apollo.QueryResult<
  GetcoachingSessionInteractionAttachmentsQuery,
  GetcoachingSessionInteractionAttachmentsQueryVariables
>;
export const GetCoachingTemplateDocument = gql`
  query getCoachingTemplate($id: ID!) {
    coachingTemplate(id: $id) {
      body
      id
      name
    }
  }
`;

/**
 * __useGetCoachingTemplateQuery__
 *
 * To run a query within a React component, call `useGetCoachingTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCoachingTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<GetCoachingTemplateQuery, GetCoachingTemplateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoachingTemplateQuery, GetCoachingTemplateQueryVariables>(
    GetCoachingTemplateDocument,
    options
  );
}
export function useGetCoachingTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoachingTemplateQuery,
    GetCoachingTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoachingTemplateQuery, GetCoachingTemplateQueryVariables>(
    GetCoachingTemplateDocument,
    options
  );
}
export type GetCoachingTemplateQueryHookResult = ReturnType<typeof useGetCoachingTemplateQuery>;
export type GetCoachingTemplateLazyQueryHookResult = ReturnType<
  typeof useGetCoachingTemplateLazyQuery
>;
export type GetCoachingTemplateQueryResult = Apollo.QueryResult<
  GetCoachingTemplateQuery,
  GetCoachingTemplateQueryVariables
>;
export const GetCoachingTemplatesDocument = gql`
  query getCoachingTemplates($includeArchived: Boolean) {
    coachingTemplates(includeArchived: $includeArchived) {
      nodes {
        body
        createdAt
        creator {
          ... on Employee {
            id
            profile {
              fullName
              id
              imageUrl
            }
            __typename
          }
          ... on Company {
            name
            logoUrl
            __typename
          }
        }
        id
        lastUpdatedBy {
          id
          profile {
            id
            fullName
          }
        }
        name
        status
        updatedAt
        usageCount
      }
    }
  }
`;

/**
 * __useGetCoachingTemplatesQuery__
 *
 * To run a query within a React component, call `useGetCoachingTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingTemplatesQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetCoachingTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCoachingTemplatesQuery,
    GetCoachingTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoachingTemplatesQuery, GetCoachingTemplatesQueryVariables>(
    GetCoachingTemplatesDocument,
    options
  );
}
export function useGetCoachingTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoachingTemplatesQuery,
    GetCoachingTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoachingTemplatesQuery, GetCoachingTemplatesQueryVariables>(
    GetCoachingTemplatesDocument,
    options
  );
}
export type GetCoachingTemplatesQueryHookResult = ReturnType<typeof useGetCoachingTemplatesQuery>;
export type GetCoachingTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetCoachingTemplatesLazyQuery
>;
export type GetCoachingTemplatesQueryResult = Apollo.QueryResult<
  GetCoachingTemplatesQuery,
  GetCoachingTemplatesQueryVariables
>;
export const GetCoachingTemplateHistoryDocument = gql`
  query getCoachingTemplateHistory($templateId: ID!) {
    coachingTemplate(id: $templateId) {
      id
      name
    }
    coachingTemplateHistory(templateId: $templateId) {
      collection {
        attributeName
        createdAt
        actor {
          ... on Employee {
            id
            profile {
              fullName
              id
              imageUrl
            }
            __typename
          }
          ... on Company {
            name
            logoUrl
            __typename
          }
        }
        event
        valueAfter
        valueBefore
      }
    }
  }
`;

/**
 * __useGetCoachingTemplateHistoryQuery__
 *
 * To run a query within a React component, call `useGetCoachingTemplateHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingTemplateHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingTemplateHistoryQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetCoachingTemplateHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCoachingTemplateHistoryQuery,
    GetCoachingTemplateHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoachingTemplateHistoryQuery, GetCoachingTemplateHistoryQueryVariables>(
    GetCoachingTemplateHistoryDocument,
    options
  );
}
export function useGetCoachingTemplateHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoachingTemplateHistoryQuery,
    GetCoachingTemplateHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCoachingTemplateHistoryQuery,
    GetCoachingTemplateHistoryQueryVariables
  >(GetCoachingTemplateHistoryDocument, options);
}
export type GetCoachingTemplateHistoryQueryHookResult = ReturnType<
  typeof useGetCoachingTemplateHistoryQuery
>;
export type GetCoachingTemplateHistoryLazyQueryHookResult = ReturnType<
  typeof useGetCoachingTemplateHistoryLazyQuery
>;
export type GetCoachingTemplateHistoryQueryResult = Apollo.QueryResult<
  GetCoachingTemplateHistoryQuery,
  GetCoachingTemplateHistoryQueryVariables
>;
export const GetCoachingTopicsDocument = gql`
  query getCoachingTopics($sessionId: ID!, $page: Int = 1, $limit: Int = 5) {
    coachingTopics(sessionId: $sessionId, limit: $limit, page: $page) {
      collection {
        ...coachingTopicFields
      }
      metadata {
        totalPages
        totalCount
        limitValue
        fetchingStatus
        currentPage
      }
    }
  }
  ${CoachingTopicFieldsFragmentDoc}
`;

/**
 * __useGetCoachingTopicsQuery__
 *
 * To run a query within a React component, call `useGetCoachingTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachingTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachingTopicsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCoachingTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCoachingTopicsQuery, GetCoachingTopicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoachingTopicsQuery, GetCoachingTopicsQueryVariables>(
    GetCoachingTopicsDocument,
    options
  );
}
export function useGetCoachingTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCoachingTopicsQuery, GetCoachingTopicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoachingTopicsQuery, GetCoachingTopicsQueryVariables>(
    GetCoachingTopicsDocument,
    options
  );
}
export type GetCoachingTopicsQueryHookResult = ReturnType<typeof useGetCoachingTopicsQuery>;
export type GetCoachingTopicsLazyQueryHookResult = ReturnType<typeof useGetCoachingTopicsLazyQuery>;
export type GetCoachingTopicsQueryResult = Apollo.QueryResult<
  GetCoachingTopicsQuery,
  GetCoachingTopicsQueryVariables
>;
export const GetCompanySettingsDocument = gql`
  query getCompanySettings {
    company {
      id
      profileImageSetting
      customerVisibility
      defaultProfilePictureUrl
      guidelineProfile
      brands {
        name
        id
      }
    }
  }
`;

/**
 * __useGetCompanySettingsQuery__
 *
 * To run a query within a React component, call `useGetCompanySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanySettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(
    GetCompanySettingsDocument,
    options
  );
}
export function useGetCompanySettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanySettingsQuery,
    GetCompanySettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>(
    GetCompanySettingsDocument,
    options
  );
}
export type GetCompanySettingsQueryHookResult = ReturnType<typeof useGetCompanySettingsQuery>;
export type GetCompanySettingsLazyQueryHookResult = ReturnType<
  typeof useGetCompanySettingsLazyQuery
>;
export type GetCompanySettingsQueryResult = Apollo.QueryResult<
  GetCompanySettingsQuery,
  GetCompanySettingsQueryVariables
>;
export const GetCondensedAssignmentPeriodsDocument = gql`
  query getCondensedAssignmentPeriods($id: ID!, $page: Int = 1, $limit: Int = 10) {
    qaAssignmentPeriods(id: $id, page: $page, limit: $limit) {
      collection {
        id
        startDate
        endDate
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`;

/**
 * __useGetCondensedAssignmentPeriodsQuery__
 *
 * To run a query within a React component, call `useGetCondensedAssignmentPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCondensedAssignmentPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCondensedAssignmentPeriodsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCondensedAssignmentPeriodsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCondensedAssignmentPeriodsQuery,
    GetCondensedAssignmentPeriodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCondensedAssignmentPeriodsQuery,
    GetCondensedAssignmentPeriodsQueryVariables
  >(GetCondensedAssignmentPeriodsDocument, options);
}
export function useGetCondensedAssignmentPeriodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCondensedAssignmentPeriodsQuery,
    GetCondensedAssignmentPeriodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCondensedAssignmentPeriodsQuery,
    GetCondensedAssignmentPeriodsQueryVariables
  >(GetCondensedAssignmentPeriodsDocument, options);
}
export type GetCondensedAssignmentPeriodsQueryHookResult = ReturnType<
  typeof useGetCondensedAssignmentPeriodsQuery
>;
export type GetCondensedAssignmentPeriodsLazyQueryHookResult = ReturnType<
  typeof useGetCondensedAssignmentPeriodsLazyQuery
>;
export type GetCondensedAssignmentPeriodsQueryResult = Apollo.QueryResult<
  GetCondensedAssignmentPeriodsQuery,
  GetCondensedAssignmentPeriodsQueryVariables
>;
export const GetCountriesListDocument = gql`
  query getCountriesList {
    countries {
      code
      name
    }
  }
`;

/**
 * __useGetCountriesListQuery__
 *
 * To run a query within a React component, call `useGetCountriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesListQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCountriesListQuery, GetCountriesListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountriesListQuery, GetCountriesListQueryVariables>(
    GetCountriesListDocument,
    options
  );
}
export function useGetCountriesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesListQuery, GetCountriesListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountriesListQuery, GetCountriesListQueryVariables>(
    GetCountriesListDocument,
    options
  );
}
export type GetCountriesListQueryHookResult = ReturnType<typeof useGetCountriesListQuery>;
export type GetCountriesListLazyQueryHookResult = ReturnType<typeof useGetCountriesListLazyQuery>;
export type GetCountriesListQueryResult = Apollo.QueryResult<
  GetCountriesListQuery,
  GetCountriesListQueryVariables
>;
export const GetCriteriaListDocument = gql`
  query getCriteriaList {
    reportingGroupCriterionTypeObjects {
      operators
      periods
      criterionType
    }
  }
`;

/**
 * __useGetCriteriaListQuery__
 *
 * To run a query within a React component, call `useGetCriteriaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCriteriaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCriteriaListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCriteriaListQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCriteriaListQuery, GetCriteriaListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCriteriaListQuery, GetCriteriaListQueryVariables>(
    GetCriteriaListDocument,
    options
  );
}
export function useGetCriteriaListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCriteriaListQuery, GetCriteriaListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCriteriaListQuery, GetCriteriaListQueryVariables>(
    GetCriteriaListDocument,
    options
  );
}
export type GetCriteriaListQueryHookResult = ReturnType<typeof useGetCriteriaListQuery>;
export type GetCriteriaListLazyQueryHookResult = ReturnType<typeof useGetCriteriaListLazyQuery>;
export type GetCriteriaListQueryResult = Apollo.QueryResult<
  GetCriteriaListQuery,
  GetCriteriaListQueryVariables
>;
export const GetEmployeeDocument = gql`
  query getEmployee($id: ID!) {
    employee(id: $id) {
      id
      demotable
      profile {
        id
        fullName
        firstName
        hometown
        imageUrl
        location
        lastName
        stateOrCountry
        text
      }
      supervisor {
        id
        fullName
      }
      primaryTeam {
        id
        owner {
          id
          profile {
            id
            fullName
          }
        }
      }
      status
      deactivated
      startDate
      licenseType
      lastActive
      email
      customEmployeeId
      customRole {
        id
        name
      }
      employmentStatus
      channels
      employeeGroups {
        id
        name
      }
      reportingGroups {
        id
        name
      }
    }
  }
`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export function useGetEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(
    GetEmployeeDocument,
    options
  );
}
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<
  GetEmployeeQuery,
  GetEmployeeQueryVariables
>;
export const GetEmployeesDocument = gql`
  query getEmployees(
    $first: Int = 10
    $after: String = ""
    $search: [EmployeeSearchInput!]
    $filters: EmployeeFilterInput = { status: ACTIVE }
    $includePrimaryTeam: Boolean = false
  ) {
    employees(
      first: $first
      after: $after
      filters: $filters
      sort: [{ field: FIRST_NAME, direction: ASC }, { field: LAST_NAME, direction: ASC }]
      search: $search
    ) {
      edges {
        node {
          id
          canManageTeams
          profile {
            id
            firstName
            lastName
            fullName
            imageUrl
          }
          primaryTeam @include(if: $includePrimaryTeam) {
            id
            agentsCount
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      includePrimaryTeam: // value for 'includePrimaryTeam'
 *   },
 * });
 */
export function useGetEmployeesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(
    GetEmployeesDocument,
    options
  );
}
export function useGetEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(
    GetEmployeesDocument,
    options
  );
}
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<
  GetEmployeesQuery,
  GetEmployeesQueryVariables
>;
export const GetEmployeesAndChildTeamsDocument = gql`
  query getEmployeesAndChildTeams(
    $teamFilters: TeamFilterInput
    $sortDirection: SortDirectionEnum
    $afterEmployees: String
    $firstEmployees: Int = 25
    $afterChildren: String
    $firstChildren: Int = 25
    $employeeFilters: EmployeeFilterInput = { status: ACTIVE }
    $productArea: ProductArea = COACHING
    $between: DateRangeInput
    $includeDeactivated: Boolean
  ) {
    teams(filters: $teamFilters) {
      nodes {
        id
        ...teamFields
        employees(
          first: $firstEmployees
          after: $afterEmployees
          filters: $employeeFilters
          sort: [{ field: FIRST_NAME, direction: $sortDirection }]
          productArea: $productArea
          between: $between
        ) {
          nodes {
            id
            ...employeeFields
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        children(
          first: $firstChildren
          after: $afterChildren
          includeDeactivated: $includeDeactivated
        ) {
          nodes {
            id
            ...teamFields
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
  ${TeamFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
`;

/**
 * __useGetEmployeesAndChildTeamsQuery__
 *
 * To run a query within a React component, call `useGetEmployeesAndChildTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesAndChildTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesAndChildTeamsQuery({
 *   variables: {
 *      teamFilters: // value for 'teamFilters'
 *      sortDirection: // value for 'sortDirection'
 *      afterEmployees: // value for 'afterEmployees'
 *      firstEmployees: // value for 'firstEmployees'
 *      afterChildren: // value for 'afterChildren'
 *      firstChildren: // value for 'firstChildren'
 *      employeeFilters: // value for 'employeeFilters'
 *      productArea: // value for 'productArea'
 *      between: // value for 'between'
 *      includeDeactivated: // value for 'includeDeactivated'
 *   },
 * });
 */
export function useGetEmployeesAndChildTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployeesAndChildTeamsQuery,
    GetEmployeesAndChildTeamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeesAndChildTeamsQuery, GetEmployeesAndChildTeamsQueryVariables>(
    GetEmployeesAndChildTeamsDocument,
    options
  );
}
export function useGetEmployeesAndChildTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeesAndChildTeamsQuery,
    GetEmployeesAndChildTeamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeesAndChildTeamsQuery,
    GetEmployeesAndChildTeamsQueryVariables
  >(GetEmployeesAndChildTeamsDocument, options);
}
export type GetEmployeesAndChildTeamsQueryHookResult = ReturnType<
  typeof useGetEmployeesAndChildTeamsQuery
>;
export type GetEmployeesAndChildTeamsLazyQueryHookResult = ReturnType<
  typeof useGetEmployeesAndChildTeamsLazyQuery
>;
export type GetEmployeesAndChildTeamsQueryResult = Apollo.QueryResult<
  GetEmployeesAndChildTeamsQuery,
  GetEmployeesAndChildTeamsQueryVariables
>;
export const GetEmployeesFilterDataDocument = gql`
  query getEmployeesFilterData(
    $first: Int = 50
    $after: String = ""
    $search: [EmployeeSearchInput!]
    $filters: EmployeeFilterInput = {}
    $sort: [EmployeeSortInput!] = { field: LAST_NAME, direction: ASC }
    $productArea: ProductArea = QA
  ) {
    employees(
      first: $first
      after: $after
      search: $search
      filters: $filters
      sort: $sort
      productArea: $productArea
    ) {
      edges {
        node {
          id
          profile {
            id
            fullName
            imageUrl
          }
          primaryTeam {
            id
            name
          }
          reportingGroups {
            id
            name
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetEmployeesFilterDataQuery__
 *
 * To run a query within a React component, call `useGetEmployeesFilterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesFilterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesFilterDataQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      productArea: // value for 'productArea'
 *   },
 * });
 */
export function useGetEmployeesFilterDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployeesFilterDataQuery,
    GetEmployeesFilterDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeesFilterDataQuery, GetEmployeesFilterDataQueryVariables>(
    GetEmployeesFilterDataDocument,
    options
  );
}
export function useGetEmployeesFilterDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeesFilterDataQuery,
    GetEmployeesFilterDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeesFilterDataQuery, GetEmployeesFilterDataQueryVariables>(
    GetEmployeesFilterDataDocument,
    options
  );
}
export type GetEmployeesFilterDataQueryHookResult = ReturnType<
  typeof useGetEmployeesFilterDataQuery
>;
export type GetEmployeesFilterDataLazyQueryHookResult = ReturnType<
  typeof useGetEmployeesFilterDataLazyQuery
>;
export type GetEmployeesFilterDataQueryResult = Apollo.QueryResult<
  GetEmployeesFilterDataQuery,
  GetEmployeesFilterDataQueryVariables
>;
export const GetEmployeeBadgesDocument = gql`
  query getEmployeeBadges(
    $employeeId: ID
    $badgeType: AchievementBadgeType
    $badgeKeys: [String!]
    $first: Int = 10
  ) {
    employeeBadges(
      employeeId: $employeeId
      badgeType: $badgeType
      badgeKeys: $badgeKeys
      first: $first
    ) {
      nodes {
        badgeKey
        count
        description
        earnedAt
        id
        imageUrl
        name
        iconSettings
        status
        threshold
        companyAchievement {
          id
          pathName
          achievementCategory {
            id
            identifier
            imageUrl
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeBadgesQuery__
 *
 * To run a query within a React component, call `useGetEmployeeBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeBadgesQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      badgeType: // value for 'badgeType'
 *      badgeKeys: // value for 'badgeKeys'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetEmployeeBadgesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEmployeeBadgesQuery, GetEmployeeBadgesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeBadgesQuery, GetEmployeeBadgesQueryVariables>(
    GetEmployeeBadgesDocument,
    options
  );
}
export function useGetEmployeeBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeBadgesQuery, GetEmployeeBadgesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeBadgesQuery, GetEmployeeBadgesQueryVariables>(
    GetEmployeeBadgesDocument,
    options
  );
}
export type GetEmployeeBadgesQueryHookResult = ReturnType<typeof useGetEmployeeBadgesQuery>;
export type GetEmployeeBadgesLazyQueryHookResult = ReturnType<typeof useGetEmployeeBadgesLazyQuery>;
export type GetEmployeeBadgesQueryResult = Apollo.QueryResult<
  GetEmployeeBadgesQuery,
  GetEmployeeBadgesQueryVariables
>;
export const GetEmployeeCoachingSessionActionItemsDocument = gql`
  query getEmployeeCoachingSessionActionItems(
    $employeeId: ID
    $status: TakeawayStatusEnum
    $sort: [TakeawaySortInput!] = []
    $sessionIds: [ID!]
    $first: Int = 10
    $after: String
    $otherSessionItemsFirst: Int = 10
    $otherSessionItemsAfter: String
    $includeCategories: Boolean = false
    $includeOtherSessionItems: Boolean = false
  ) {
    coachingSessionActionItems(
      filters: { employeeId: $employeeId, status: $status, sessionIds: $sessionIds }
      sort: $sort
    ) {
      categories @include(if: $includeCategories) {
        id
        name
        count
      }
      collection(first: $first, after: $after) {
        ...actionItemsCollectionFields
      }
    }
    otherSessionActionItems: coachingSessionActionItems(
      filters: {
        employeeId: $employeeId
        status: $status
        sessionIds: $sessionIds
        sessionIdsOption: EXCLUDE
      }
      sort: $sort
    ) @include(if: $includeOtherSessionItems) {
      collection(first: $otherSessionItemsFirst, after: $otherSessionItemsAfter) {
        ...actionItemsCollectionFields
      }
    }
  }
  ${ActionItemsCollectionFieldsFragmentDoc}
`;

/**
 * __useGetEmployeeCoachingSessionActionItemsQuery__
 *
 * To run a query within a React component, call `useGetEmployeeCoachingSessionActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeCoachingSessionActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeCoachingSessionActionItemsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      sessionIds: // value for 'sessionIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      otherSessionItemsFirst: // value for 'otherSessionItemsFirst'
 *      otherSessionItemsAfter: // value for 'otherSessionItemsAfter'
 *      includeCategories: // value for 'includeCategories'
 *      includeOtherSessionItems: // value for 'includeOtherSessionItems'
 *   },
 * });
 */
export function useGetEmployeeCoachingSessionActionItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployeeCoachingSessionActionItemsQuery,
    GetEmployeeCoachingSessionActionItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeCoachingSessionActionItemsQuery,
    GetEmployeeCoachingSessionActionItemsQueryVariables
  >(GetEmployeeCoachingSessionActionItemsDocument, options);
}
export function useGetEmployeeCoachingSessionActionItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeCoachingSessionActionItemsQuery,
    GetEmployeeCoachingSessionActionItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeCoachingSessionActionItemsQuery,
    GetEmployeeCoachingSessionActionItemsQueryVariables
  >(GetEmployeeCoachingSessionActionItemsDocument, options);
}
export type GetEmployeeCoachingSessionActionItemsQueryHookResult = ReturnType<
  typeof useGetEmployeeCoachingSessionActionItemsQuery
>;
export type GetEmployeeCoachingSessionActionItemsLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeCoachingSessionActionItemsLazyQuery
>;
export type GetEmployeeCoachingSessionActionItemsQueryResult = Apollo.QueryResult<
  GetEmployeeCoachingSessionActionItemsQuery,
  GetEmployeeCoachingSessionActionItemsQueryVariables
>;
export const GetEmployeeForEditDocument = gql`
  query getEmployeeForEdit($id: ID!) {
    employee(id: $id) {
      id
      demotable
      profileForEdit {
        id
        countryCode
        fullName
        firstName
        hometown
        imageUrl
        location
        lastName
        stateOrCountry
        text
      }
      supervisor {
        id
        fullName
        primaryTeam {
          id
          name
        }
      }
      primaryTeam {
        id
        name
        owner {
          id
          profile {
            id
            fullName
          }
        }
      }
      status
      deactivated
      startDate
      licenseType
      lastActive
      email
      canManageTeams
      customEmployeeId
      customRole {
        id
        name
        legacy
        roleTemplate
      }
      employmentStatus
      channels
      employeeGroups {
        id
        name
      }
      reportingGroups {
        id
        name
        active
      }
    }
  }
`;

/**
 * __useGetEmployeeForEditQuery__
 *
 * To run a query within a React component, call `useGetEmployeeForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeForEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeForEditQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmployeeForEditQuery, GetEmployeeForEditQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeForEditQuery, GetEmployeeForEditQueryVariables>(
    GetEmployeeForEditDocument,
    options
  );
}
export function useGetEmployeeForEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeForEditQuery,
    GetEmployeeForEditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeForEditQuery, GetEmployeeForEditQueryVariables>(
    GetEmployeeForEditDocument,
    options
  );
}
export type GetEmployeeForEditQueryHookResult = ReturnType<typeof useGetEmployeeForEditQuery>;
export type GetEmployeeForEditLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeForEditLazyQuery
>;
export type GetEmployeeForEditQueryResult = Apollo.QueryResult<
  GetEmployeeForEditQuery,
  GetEmployeeForEditQueryVariables
>;
export const GetEmployeeForFilterDocument = gql`
  query getEmployeeForFilter($id: ID!) {
    employee(id: $id) {
      id
      profile {
        id
        firstName
        imageUrl
        lastName
      }
      primaryTeam {
        id
      }
      deactivated
      email
      customEmployeeId
    }
  }
`;

/**
 * __useGetEmployeeForFilterQuery__
 *
 * To run a query within a React component, call `useGetEmployeeForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeForFilterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeForFilterQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeForFilterQuery,
    GetEmployeeForFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeForFilterQuery, GetEmployeeForFilterQueryVariables>(
    GetEmployeeForFilterDocument,
    options
  );
}
export function useGetEmployeeForFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeForFilterQuery,
    GetEmployeeForFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeForFilterQuery, GetEmployeeForFilterQueryVariables>(
    GetEmployeeForFilterDocument,
    options
  );
}
export type GetEmployeeForFilterQueryHookResult = ReturnType<typeof useGetEmployeeForFilterQuery>;
export type GetEmployeeForFilterLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeForFilterLazyQuery
>;
export type GetEmployeeForFilterQueryResult = Apollo.QueryResult<
  GetEmployeeForFilterQuery,
  GetEmployeeForFilterQueryVariables
>;
export const GetEmployeeLifetimeCountersDocument = gql`
  query getEmployeeLifetimeCounters($employeeId: ID, $badgeKeys: [String!], $first: Int = 10) {
    lifetimeBadges(employeeId: $employeeId, badgeKeys: $badgeKeys, first: $first) {
      nodes {
        badgeKey
        count
        id
        name
        companyAchievement {
          id
          achievementCategory {
            id
            identifier
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeLifetimeCountersQuery__
 *
 * To run a query within a React component, call `useGetEmployeeLifetimeCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeLifetimeCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeLifetimeCountersQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      badgeKeys: // value for 'badgeKeys'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetEmployeeLifetimeCountersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployeeLifetimeCountersQuery,
    GetEmployeeLifetimeCountersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeLifetimeCountersQuery,
    GetEmployeeLifetimeCountersQueryVariables
  >(GetEmployeeLifetimeCountersDocument, options);
}
export function useGetEmployeeLifetimeCountersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeLifetimeCountersQuery,
    GetEmployeeLifetimeCountersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeLifetimeCountersQuery,
    GetEmployeeLifetimeCountersQueryVariables
  >(GetEmployeeLifetimeCountersDocument, options);
}
export type GetEmployeeLifetimeCountersQueryHookResult = ReturnType<
  typeof useGetEmployeeLifetimeCountersQuery
>;
export type GetEmployeeLifetimeCountersLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeLifetimeCountersLazyQuery
>;
export type GetEmployeeLifetimeCountersQueryResult = Apollo.QueryResult<
  GetEmployeeLifetimeCountersQuery,
  GetEmployeeLifetimeCountersQueryVariables
>;
export const GetEmployeeReportingGropsDocument = gql`
  query getEmployeeReportingGrops($id: ID!) {
    employee(id: $id) {
      id
      reportingGroups {
        id
        name
      }
    }
  }
`;

/**
 * __useGetEmployeeReportingGropsQuery__
 *
 * To run a query within a React component, call `useGetEmployeeReportingGropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeReportingGropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeReportingGropsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeReportingGropsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeReportingGropsQuery,
    GetEmployeeReportingGropsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeReportingGropsQuery, GetEmployeeReportingGropsQueryVariables>(
    GetEmployeeReportingGropsDocument,
    options
  );
}
export function useGetEmployeeReportingGropsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeReportingGropsQuery,
    GetEmployeeReportingGropsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeReportingGropsQuery,
    GetEmployeeReportingGropsQueryVariables
  >(GetEmployeeReportingGropsDocument, options);
}
export type GetEmployeeReportingGropsQueryHookResult = ReturnType<
  typeof useGetEmployeeReportingGropsQuery
>;
export type GetEmployeeReportingGropsLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeReportingGropsLazyQuery
>;
export type GetEmployeeReportingGropsQueryResult = Apollo.QueryResult<
  GetEmployeeReportingGropsQuery,
  GetEmployeeReportingGropsQueryVariables
>;
export const GetExportsDocument = gql`
  query getExports($exportType: ExportTypeEnum!) {
    exports(exportType: $exportType) {
      id
      expired
      state
      createdAt
      updatedAt
      exportType
      s3Url
    }
  }
`;

/**
 * __useGetExportsQuery__
 *
 * To run a query within a React component, call `useGetExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportsQuery({
 *   variables: {
 *      exportType: // value for 'exportType'
 *   },
 * });
 */
export function useGetExportsQuery(
  baseOptions: Apollo.QueryHookOptions<GetExportsQuery, GetExportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetExportsQuery, GetExportsQueryVariables>(GetExportsDocument, options);
}
export function useGetExportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetExportsQuery, GetExportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetExportsQuery, GetExportsQueryVariables>(
    GetExportsDocument,
    options
  );
}
export type GetExportsQueryHookResult = ReturnType<typeof useGetExportsQuery>;
export type GetExportsLazyQueryHookResult = ReturnType<typeof useGetExportsLazyQuery>;
export type GetExportsQueryResult = Apollo.QueryResult<GetExportsQuery, GetExportsQueryVariables>;
export const GetExportsPaginatedDocument = gql`
  query getExportsPaginated($exportType: ExportTypeEnum, $after: String, $first: Int) {
    exportsWithCursor(exportType: $exportType, after: $after, first: $first) {
      nodes {
        createdAt
        expired
        exportType
        fieldsCount
        id
        options
        s3Url
        state
        updatedAt
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useGetExportsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetExportsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportsPaginatedQuery({
 *   variables: {
 *      exportType: // value for 'exportType'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetExportsPaginatedQuery(
  baseOptions?: Apollo.QueryHookOptions<GetExportsPaginatedQuery, GetExportsPaginatedQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetExportsPaginatedQuery, GetExportsPaginatedQueryVariables>(
    GetExportsPaginatedDocument,
    options
  );
}
export function useGetExportsPaginatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExportsPaginatedQuery,
    GetExportsPaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetExportsPaginatedQuery, GetExportsPaginatedQueryVariables>(
    GetExportsPaginatedDocument,
    options
  );
}
export type GetExportsPaginatedQueryHookResult = ReturnType<typeof useGetExportsPaginatedQuery>;
export type GetExportsPaginatedLazyQueryHookResult = ReturnType<
  typeof useGetExportsPaginatedLazyQuery
>;
export type GetExportsPaginatedQueryResult = Apollo.QueryResult<
  GetExportsPaginatedQuery,
  GetExportsPaginatedQueryVariables
>;
export const GetExportsStateDocument = gql`
  query getExportsState($exportType: ExportTypeEnum!) {
    exportsState(exportType: $exportType) {
      inProgress
      unread
    }
  }
`;

/**
 * __useGetExportsStateQuery__
 *
 * To run a query within a React component, call `useGetExportsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportsStateQuery({
 *   variables: {
 *      exportType: // value for 'exportType'
 *   },
 * });
 */
export function useGetExportsStateQuery(
  baseOptions: Apollo.QueryHookOptions<GetExportsStateQuery, GetExportsStateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetExportsStateQuery, GetExportsStateQueryVariables>(
    GetExportsStateDocument,
    options
  );
}
export function useGetExportsStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetExportsStateQuery, GetExportsStateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetExportsStateQuery, GetExportsStateQueryVariables>(
    GetExportsStateDocument,
    options
  );
}
export type GetExportsStateQueryHookResult = ReturnType<typeof useGetExportsStateQuery>;
export type GetExportsStateLazyQueryHookResult = ReturnType<typeof useGetExportsStateLazyQuery>;
export type GetExportsStateQueryResult = Apollo.QueryResult<
  GetExportsStateQuery,
  GetExportsStateQueryVariables
>;
export const GetFeedbackExportFieldsDocument = gql`
  query getFeedbackExportFields {
    CUSTOM_PROPERTIES: feedbackExportFields(section: CUSTOM_PROPERTIES) {
      id
      label
    }
    SURVEY_RESPONSE: feedbackExportFields(section: SURVEY_RESPONSE) {
      id
      label
    }
  }
`;

/**
 * __useGetFeedbackExportFieldsQuery__
 *
 * To run a query within a React component, call `useGetFeedbackExportFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackExportFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackExportFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedbackExportFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFeedbackExportFieldsQuery,
    GetFeedbackExportFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFeedbackExportFieldsQuery, GetFeedbackExportFieldsQueryVariables>(
    GetFeedbackExportFieldsDocument,
    options
  );
}
export function useGetFeedbackExportFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFeedbackExportFieldsQuery,
    GetFeedbackExportFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFeedbackExportFieldsQuery, GetFeedbackExportFieldsQueryVariables>(
    GetFeedbackExportFieldsDocument,
    options
  );
}
export type GetFeedbackExportFieldsQueryHookResult = ReturnType<
  typeof useGetFeedbackExportFieldsQuery
>;
export type GetFeedbackExportFieldsLazyQueryHookResult = ReturnType<
  typeof useGetFeedbackExportFieldsLazyQuery
>;
export type GetFeedbackExportFieldsQueryResult = Apollo.QueryResult<
  GetFeedbackExportFieldsQuery,
  GetFeedbackExportFieldsQueryVariables
>;
export const GetFeedbackExportSectionsDocument = gql`
  query getFeedbackExportSections($includeFields: Boolean = false) {
    feedbackExportSections {
      nodes {
        id
        includeFutureQuestionField
        label
        order
        parentSectionLabel
        surveyType
        fields @include(if: $includeFields) {
          id
          order
          label
          usedIn
        }
      }
    }
  }
`;

/**
 * __useGetFeedbackExportSectionsQuery__
 *
 * To run a query within a React component, call `useGetFeedbackExportSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackExportSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackExportSectionsQuery({
 *   variables: {
 *      includeFields: // value for 'includeFields'
 *   },
 * });
 */
export function useGetFeedbackExportSectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFeedbackExportSectionsQuery,
    GetFeedbackExportSectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFeedbackExportSectionsQuery, GetFeedbackExportSectionsQueryVariables>(
    GetFeedbackExportSectionsDocument,
    options
  );
}
export function useGetFeedbackExportSectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFeedbackExportSectionsQuery,
    GetFeedbackExportSectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFeedbackExportSectionsQuery,
    GetFeedbackExportSectionsQueryVariables
  >(GetFeedbackExportSectionsDocument, options);
}
export type GetFeedbackExportSectionsQueryHookResult = ReturnType<
  typeof useGetFeedbackExportSectionsQuery
>;
export type GetFeedbackExportSectionsLazyQueryHookResult = ReturnType<
  typeof useGetFeedbackExportSectionsLazyQuery
>;
export type GetFeedbackExportSectionsQueryResult = Apollo.QueryResult<
  GetFeedbackExportSectionsQuery,
  GetFeedbackExportSectionsQueryVariables
>;
export const GetFeedbackExportTemplateDocument = gql`
  query getFeedbackExportTemplate($id: ID!) {
    feedbackExportTemplate(id: $id) {
      id
      name
      preselectedDateRange
      includeArchived
      withResponses
      surveyType
      startOfWeek
      startDate
      endDate
      fieldSectionOptions {
        surveyResponse {
          includeFutureQuestions
        }
      }
      startOfQuarter {
        month
        day
      }
      fields {
        id
        selected
        type
        label
        status
        section
        usedIn
      }
      schedule {
        month
        week
        dayOfWeek
        dayOfMonth
        day
        hour
      }
    }
  }
`;

/**
 * __useGetFeedbackExportTemplateQuery__
 *
 * To run a query within a React component, call `useGetFeedbackExportTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackExportTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackExportTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFeedbackExportTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFeedbackExportTemplateQuery,
    GetFeedbackExportTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFeedbackExportTemplateQuery, GetFeedbackExportTemplateQueryVariables>(
    GetFeedbackExportTemplateDocument,
    options
  );
}
export function useGetFeedbackExportTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFeedbackExportTemplateQuery,
    GetFeedbackExportTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFeedbackExportTemplateQuery,
    GetFeedbackExportTemplateQueryVariables
  >(GetFeedbackExportTemplateDocument, options);
}
export type GetFeedbackExportTemplateQueryHookResult = ReturnType<
  typeof useGetFeedbackExportTemplateQuery
>;
export type GetFeedbackExportTemplateLazyQueryHookResult = ReturnType<
  typeof useGetFeedbackExportTemplateLazyQuery
>;
export type GetFeedbackExportTemplateQueryResult = Apollo.QueryResult<
  GetFeedbackExportTemplateQuery,
  GetFeedbackExportTemplateQueryVariables
>;
export const GetFeedbackExportTemplatesDocument = gql`
  query getFeedbackExportTemplates(
    $templateType: Template
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    feedbackExportTemplates(
      filters: { templateType: $templateType }
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      nodes {
        id
        name
        fieldsCount
        startDate
        endDate
        preselectedDateRange
        createdAt
        includeArchived
        withResponses
        surveyType
        startOfWeek
        startOfQuarter {
          month
          day
        }
        fields {
          id
          selected
          type
        }
        schedule {
          month
          week
          dayOfWeek
          dayOfMonth
          day
          hour
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

/**
 * __useGetFeedbackExportTemplatesQuery__
 *
 * To run a query within a React component, call `useGetFeedbackExportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackExportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackExportTemplatesQuery({
 *   variables: {
 *      templateType: // value for 'templateType'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetFeedbackExportTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFeedbackExportTemplatesQuery,
    GetFeedbackExportTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFeedbackExportTemplatesQuery, GetFeedbackExportTemplatesQueryVariables>(
    GetFeedbackExportTemplatesDocument,
    options
  );
}
export function useGetFeedbackExportTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFeedbackExportTemplatesQuery,
    GetFeedbackExportTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFeedbackExportTemplatesQuery,
    GetFeedbackExportTemplatesQueryVariables
  >(GetFeedbackExportTemplatesDocument, options);
}
export type GetFeedbackExportTemplatesQueryHookResult = ReturnType<
  typeof useGetFeedbackExportTemplatesQuery
>;
export type GetFeedbackExportTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetFeedbackExportTemplatesLazyQuery
>;
export type GetFeedbackExportTemplatesQueryResult = Apollo.QueryResult<
  GetFeedbackExportTemplatesQuery,
  GetFeedbackExportTemplatesQueryVariables
>;
export const GetFollowUpsDocument = gql`
  query getFollowUps($filters: FollowUpFilterInput, $employeeId: ID!) {
    followUps(filters: $filters) {
      nodes {
        id
        note
        employee {
          id
        }
        createdBy {
          id
          profile {
            id
            fullName
            imageUrl
          }
        }
        followUpable {
          ... on Interaction {
            ...interactionFields
          }
          __typename
        }
      }
    }
  }
  ${InteractionFieldsFragmentDoc}
`;

/**
 * __useGetFollowUpsQuery__
 *
 * To run a query within a React component, call `useGetFollowUpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowUpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowUpsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetFollowUpsQuery(
  baseOptions: Apollo.QueryHookOptions<GetFollowUpsQuery, GetFollowUpsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFollowUpsQuery, GetFollowUpsQueryVariables>(
    GetFollowUpsDocument,
    options
  );
}
export function useGetFollowUpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFollowUpsQuery, GetFollowUpsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFollowUpsQuery, GetFollowUpsQueryVariables>(
    GetFollowUpsDocument,
    options
  );
}
export type GetFollowUpsQueryHookResult = ReturnType<typeof useGetFollowUpsQuery>;
export type GetFollowUpsLazyQueryHookResult = ReturnType<typeof useGetFollowUpsLazyQuery>;
export type GetFollowUpsQueryResult = Apollo.QueryResult<
  GetFollowUpsQuery,
  GetFollowUpsQueryVariables
>;
export const GetGroupsDocument = gql`
  query getGroups(
    $first: Int = 10
    $after: String = ""
    $name: String
    $status: EmployeeGroupStatusEnum = ACTIVE
  ) {
    employeeGroups(first: $first, after: $after, name: $name, status: $status) {
      edges {
        node {
          id
          name
          status
          members {
            id
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
}
export function useGetGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
}
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetReportingGroupPreviewDocument = gql`
  query getReportingGroupPreview(
    $after: String = ""
    $before: String = ""
    $criteriaAttributes: [CreateReportingGroupCriterionAttributes!]
    $first: Int = 50
    $matchAll: Boolean
  ) {
    reportingGroupParticipantsPreview(
      matchAll: $matchAll
      after: $after
      before: $before
      criteriaAttributes: $criteriaAttributes
      first: $first
    ) {
      edges {
        node {
          id
          profile {
            id
            fullName
            imageUrl
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

/**
 * __useGetReportingGroupPreviewQuery__
 *
 * To run a query within a React component, call `useGetReportingGroupPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingGroupPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingGroupPreviewQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      criteriaAttributes: // value for 'criteriaAttributes'
 *      first: // value for 'first'
 *      matchAll: // value for 'matchAll'
 *   },
 * });
 */
export function useGetReportingGroupPreviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportingGroupPreviewQuery,
    GetReportingGroupPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportingGroupPreviewQuery, GetReportingGroupPreviewQueryVariables>(
    GetReportingGroupPreviewDocument,
    options
  );
}
export function useGetReportingGroupPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportingGroupPreviewQuery,
    GetReportingGroupPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportingGroupPreviewQuery, GetReportingGroupPreviewQueryVariables>(
    GetReportingGroupPreviewDocument,
    options
  );
}
export type GetReportingGroupPreviewQueryHookResult = ReturnType<
  typeof useGetReportingGroupPreviewQuery
>;
export type GetReportingGroupPreviewLazyQueryHookResult = ReturnType<
  typeof useGetReportingGroupPreviewLazyQuery
>;
export type GetReportingGroupPreviewQueryResult = Apollo.QueryResult<
  GetReportingGroupPreviewQuery,
  GetReportingGroupPreviewQueryVariables
>;
export const GetInteractionsDocument = gql`
  query getInteractions(
    $filters: InteractionFilterInput!
    $sort: [InteractionSortInput!]
    $search: [InteractionSearchInput!]
    $first: Int = 10
    $after: String = ""
    $includeSummary: Boolean = false
    $employeeId: ID
  ) {
    interactions(filters: $filters, sort: $sort, search: $search, first: $first, after: $after) {
      nodes {
        id
        extInteractionId
        resolvedAt
        summary @include(if: $includeSummary)
        solicitations(filters: { employeeId: $employeeId }) {
          nodes {
            id
            recovered
            respondedAt
            surveyAnswers {
              nodes {
                id
                surveyQuestionId
                surveyOptions {
                  id
                }
              }
            }
          }
        }
        reviews(filters: { employeeId: $employeeId }) {
          nodes {
            ... on QaReviewRegular {
              id
            }
          }
        }
        followUps {
          nodes {
            id
            createdBy {
              id
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useGetInteractionsQuery__
 *
 * To run a query within a React component, call `useGetInteractionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInteractionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInteractionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      includeSummary: // value for 'includeSummary'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetInteractionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetInteractionsQuery, GetInteractionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInteractionsQuery, GetInteractionsQueryVariables>(
    GetInteractionsDocument,
    options
  );
}
export function useGetInteractionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInteractionsQuery, GetInteractionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInteractionsQuery, GetInteractionsQueryVariables>(
    GetInteractionsDocument,
    options
  );
}
export type GetInteractionsQueryHookResult = ReturnType<typeof useGetInteractionsQuery>;
export type GetInteractionsLazyQueryHookResult = ReturnType<typeof useGetInteractionsLazyQuery>;
export type GetInteractionsQueryResult = Apollo.QueryResult<
  GetInteractionsQuery,
  GetInteractionsQueryVariables
>;
export const GetInteractionSummaryDocument = gql`
  query getInteractionSummary($id: ID!) {
    interaction(id: $id) {
      id
      summary
    }
  }
`;

/**
 * __useGetInteractionSummaryQuery__
 *
 * To run a query within a React component, call `useGetInteractionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInteractionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInteractionSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInteractionSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInteractionSummaryQuery,
    GetInteractionSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInteractionSummaryQuery, GetInteractionSummaryQueryVariables>(
    GetInteractionSummaryDocument,
    options
  );
}
export function useGetInteractionSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInteractionSummaryQuery,
    GetInteractionSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInteractionSummaryQuery, GetInteractionSummaryQueryVariables>(
    GetInteractionSummaryDocument,
    options
  );
}
export type GetInteractionSummaryQueryHookResult = ReturnType<typeof useGetInteractionSummaryQuery>;
export type GetInteractionSummaryLazyQueryHookResult = ReturnType<
  typeof useGetInteractionSummaryLazyQuery
>;
export type GetInteractionSummaryQueryResult = Apollo.QueryResult<
  GetInteractionSummaryQuery,
  GetInteractionSummaryQueryVariables
>;
export const GetLeaderboardDocument = gql`
  query getLeaderboard(
    $interval: String
    $channel: String
    $time: Int
    $groupIds: [String!]
    $reportingGroupIds: [String!]
  ) {
    leaderboard(
      interval: $interval
      channel: $channel
      time: $time
      groupIds: $groupIds
      reportingGroupIds: $reportingGroupIds
    ) {
      topAgents {
        count
        delta
        fullName
        id
        image
        prevRank
        rank
        rating
      }
      intervals {
        label
        value
      }
      config {
        intervals
        activeInterval
        showStar
        metricTitle
        thresholds {
          day
          week
          month
          quarter
          year
        }
      }
    }
    channels {
      id
      active
      name
      slug
    }
  }
`;

/**
 * __useGetLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardQuery({
 *   variables: {
 *      interval: // value for 'interval'
 *      channel: // value for 'channel'
 *      time: // value for 'time'
 *      groupIds: // value for 'groupIds'
 *      reportingGroupIds: // value for 'reportingGroupIds'
 *   },
 * });
 */
export function useGetLeaderboardQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLeaderboardQuery, GetLeaderboardQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLeaderboardQuery, GetLeaderboardQueryVariables>(
    GetLeaderboardDocument,
    options
  );
}
export function useGetLeaderboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLeaderboardQuery, GetLeaderboardQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLeaderboardQuery, GetLeaderboardQueryVariables>(
    GetLeaderboardDocument,
    options
  );
}
export type GetLeaderboardQueryHookResult = ReturnType<typeof useGetLeaderboardQuery>;
export type GetLeaderboardLazyQueryHookResult = ReturnType<typeof useGetLeaderboardLazyQuery>;
export type GetLeaderboardQueryResult = Apollo.QueryResult<
  GetLeaderboardQuery,
  GetLeaderboardQueryVariables
>;
export const GetLeaderboardTeamsAndGroupsDocument = gql`
  query getLeaderboardTeamsAndGroups(
    $first: Int = 1
    $afterTeams: String
    $searchTeam: [TeamSearchInput!]
    $afterReportingGroups: String
    $searchGroup: String
    $filters: TeamFilterInput
  ) {
    teams(first: $first, after: $afterTeams, search: $searchTeam, filters: $filters) {
      edges {
        node {
          id
          owner {
            id
            profile {
              id
              fullName
              imageUrl
            }
          }
          parent {
            id
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
    reportingGroups(first: $first, after: $afterReportingGroups, name: $searchGroup) {
      edges {
        node {
          id
          name
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetLeaderboardTeamsAndGroupsQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardTeamsAndGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardTeamsAndGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardTeamsAndGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      afterTeams: // value for 'afterTeams'
 *      searchTeam: // value for 'searchTeam'
 *      afterReportingGroups: // value for 'afterReportingGroups'
 *      searchGroup: // value for 'searchGroup'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetLeaderboardTeamsAndGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLeaderboardTeamsAndGroupsQuery,
    GetLeaderboardTeamsAndGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLeaderboardTeamsAndGroupsQuery,
    GetLeaderboardTeamsAndGroupsQueryVariables
  >(GetLeaderboardTeamsAndGroupsDocument, options);
}
export function useGetLeaderboardTeamsAndGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLeaderboardTeamsAndGroupsQuery,
    GetLeaderboardTeamsAndGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLeaderboardTeamsAndGroupsQuery,
    GetLeaderboardTeamsAndGroupsQueryVariables
  >(GetLeaderboardTeamsAndGroupsDocument, options);
}
export type GetLeaderboardTeamsAndGroupsQueryHookResult = ReturnType<
  typeof useGetLeaderboardTeamsAndGroupsQuery
>;
export type GetLeaderboardTeamsAndGroupsLazyQueryHookResult = ReturnType<
  typeof useGetLeaderboardTeamsAndGroupsLazyQuery
>;
export type GetLeaderboardTeamsAndGroupsQueryResult = Apollo.QueryResult<
  GetLeaderboardTeamsAndGroupsQuery,
  GetLeaderboardTeamsAndGroupsQueryVariables
>;
export const GetMentionableEmployeesDocument = gql`
  query getMentionableEmployees(
    $filters: EmployeeFilterInput
    $limit: Int = 50
    $page: Int
    $search: [EmployeeSearchInput!]
  ) {
    employeesMentionable(filters: $filters, limit: $limit, page: $page, search: $search) {
      collection {
        id
        canManageTeams
        profile {
          id
          fullName
          imageUrl
        }
        primaryTeam {
          id
          name
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`;

/**
 * __useGetMentionableEmployeesQuery__
 *
 * To run a query within a React component, call `useGetMentionableEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentionableEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentionableEmployeesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMentionableEmployeesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMentionableEmployeesQuery,
    GetMentionableEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMentionableEmployeesQuery, GetMentionableEmployeesQueryVariables>(
    GetMentionableEmployeesDocument,
    options
  );
}
export function useGetMentionableEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMentionableEmployeesQuery,
    GetMentionableEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMentionableEmployeesQuery, GetMentionableEmployeesQueryVariables>(
    GetMentionableEmployeesDocument,
    options
  );
}
export type GetMentionableEmployeesQueryHookResult = ReturnType<
  typeof useGetMentionableEmployeesQuery
>;
export type GetMentionableEmployeesLazyQueryHookResult = ReturnType<
  typeof useGetMentionableEmployeesLazyQuery
>;
export type GetMentionableEmployeesQueryResult = Apollo.QueryResult<
  GetMentionableEmployeesQuery,
  GetMentionableEmployeesQueryVariables
>;
export const GetMetricsDataDocument = gql`
  query getMetricsData($filters: MetricFilterInput!, $metrics: [MetricInput!]!) {
    calculateMetrics(filters: $filters, metrics: $metrics) {
      max
      min
      title
      customTitle
      value
      metricName
      displayValue
      totalResults
      higherIsBetter
      questionIdentifier
    }
  }
`;

/**
 * __useGetMetricsDataQuery__
 *
 * To run a query within a React component, call `useGetMetricsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metrics: // value for 'metrics'
 *   },
 * });
 */
export function useGetMetricsDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetMetricsDataQuery, GetMetricsDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricsDataQuery, GetMetricsDataQueryVariables>(
    GetMetricsDataDocument,
    options
  );
}
export function useGetMetricsDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsDataQuery, GetMetricsDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricsDataQuery, GetMetricsDataQueryVariables>(
    GetMetricsDataDocument,
    options
  );
}
export type GetMetricsDataQueryHookResult = ReturnType<typeof useGetMetricsDataQuery>;
export type GetMetricsDataLazyQueryHookResult = ReturnType<typeof useGetMetricsDataLazyQuery>;
export type GetMetricsDataQueryResult = Apollo.QueryResult<
  GetMetricsDataQuery,
  GetMetricsDataQueryVariables
>;
export const GetMetricByGroupDocument = gql`
  query getMetricByGroup(
    $after: String = ""
    $filters: MetricFilterInput!
    $metric: MetricInput!
    $groupBy: MetricGroupByEnum!
  ) {
    company {
      id
      channels {
        id
        name
        slug
        active
      }
      qaForms {
        id
        name
        slug
        active
      }
    }
    calculateMetricByGroup(after: $after, groupBy: $groupBy, filters: $filters, metric: $metric) {
      edges {
        node {
          groupValue
          metricResult {
            value
            displayValue
            higherIsBetter
            totalResults
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
`;

/**
 * __useGetMetricByGroupQuery__
 *
 * To run a query within a React component, call `useGetMetricByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricByGroupQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useGetMetricByGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GetMetricByGroupQuery, GetMetricByGroupQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricByGroupQuery, GetMetricByGroupQueryVariables>(
    GetMetricByGroupDocument,
    options
  );
}
export function useGetMetricByGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMetricByGroupQuery, GetMetricByGroupQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricByGroupQuery, GetMetricByGroupQueryVariables>(
    GetMetricByGroupDocument,
    options
  );
}
export type GetMetricByGroupQueryHookResult = ReturnType<typeof useGetMetricByGroupQuery>;
export type GetMetricByGroupLazyQueryHookResult = ReturnType<typeof useGetMetricByGroupLazyQuery>;
export type GetMetricByGroupQueryResult = Apollo.QueryResult<
  GetMetricByGroupQuery,
  GetMetricByGroupQueryVariables
>;
export const GetMetricConfigsDocument = gql`
  query getMetricConfigs($metricConfigType: [MetricConfigTypeEnum!]) {
    metricConfigs(type: $metricConfigType) {
      higherIsBetter
      availableFilters
      availableGroupBy
      defaultGroupBy
      id
      metricName
      order
      questionIdentifier
      title
      customTitle
      type
      min
      max
      targetAnswers
      denominator
      nickname
      questionText
      questionType
    }
  }
`;

/**
 * __useGetMetricConfigsQuery__
 *
 * To run a query within a React component, call `useGetMetricConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricConfigsQuery({
 *   variables: {
 *      metricConfigType: // value for 'metricConfigType'
 *   },
 * });
 */
export function useGetMetricConfigsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMetricConfigsQuery, GetMetricConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricConfigsQuery, GetMetricConfigsQueryVariables>(
    GetMetricConfigsDocument,
    options
  );
}
export function useGetMetricConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMetricConfigsQuery, GetMetricConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricConfigsQuery, GetMetricConfigsQueryVariables>(
    GetMetricConfigsDocument,
    options
  );
}
export type GetMetricConfigsQueryHookResult = ReturnType<typeof useGetMetricConfigsQuery>;
export type GetMetricConfigsLazyQueryHookResult = ReturnType<typeof useGetMetricConfigsLazyQuery>;
export type GetMetricConfigsQueryResult = Apollo.QueryResult<
  GetMetricConfigsQuery,
  GetMetricConfigsQueryVariables
>;
export const GetMetricDataDocument = gql`
  query getMetricData($filters: MetricFilterInput!, $metric: MetricInput!) {
    calculateMetricTrend(filters: $filters, metric: $metric) {
      displayValue
      higherIsBetter
      max
      min
      title
      totalResults
      value
    }
  }
`;

/**
 * __useGetMetricDataQuery__
 *
 * To run a query within a React component, call `useGetMetricDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *   },
 * });
 */
export function useGetMetricDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetMetricDataQuery, GetMetricDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricDataQuery, GetMetricDataQueryVariables>(
    GetMetricDataDocument,
    options
  );
}
export function useGetMetricDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMetricDataQuery, GetMetricDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricDataQuery, GetMetricDataQueryVariables>(
    GetMetricDataDocument,
    options
  );
}
export type GetMetricDataQueryHookResult = ReturnType<typeof useGetMetricDataQuery>;
export type GetMetricDataLazyQueryHookResult = ReturnType<typeof useGetMetricDataLazyQuery>;
export type GetMetricDataQueryResult = Apollo.QueryResult<
  GetMetricDataQuery,
  GetMetricDataQueryVariables
>;
export const GetMetricGoalsDocument = gql`
  query getMetricGoals(
    $dateRange: DateRangeInput
    $status: GoalStatusEnum
    $employeeIds: [ID!]
    $teamIds: [ID!]
    $skipTeams: Boolean!
    $skipEmployees: Boolean!
  ) {
    teamMetricGoals: metricGoals(
      type: GROUP
      filters: { dateRange: $dateRange, entityIds: $teamIds, status: $status }
    ) @skip(if: $skipTeams) {
      pageInfo {
        endCursor
        startCursor
        hasNextPage
      }
      edges {
        node {
          ... on MetricGoalGroup {
            id
            archivedAt
            completedAt
            createdAt
            creator {
              id
              profile {
                id
                fullName
                imageUrl
              }
            }
            displayValue
            goal
            title
            threshold
            group {
              id
              agentsCount
            }
            startedAt
            endedAt
            metricConfig {
              metricName
              title
              id
              min
              max
            }
            permissions {
              canCompleteActionItems
              canManageGoal
            }
            reachedCount
          }
        }
      }
    }
    employeeMetricGoals: metricGoals(
      type: EMPLOYEE
      filters: { dateRange: $dateRange, entityIds: $employeeIds, status: $status }
    ) @skip(if: $skipEmployees) {
      pageInfo {
        endCursor
        startCursor
        hasNextPage
      }
      edges {
        node {
          ... on MetricGoalEmployee {
            id
            actionItems(status: ALL) {
              action
              actionable {
                ... on MetricGoalEmployee {
                  id
                }
              }
              completedAt
              createdAt
              id
            }
            archivedAt
            completedAt
            createdAt
            creator {
              id
              profile {
                id
                fullName
                imageUrl
              }
            }
            displayValue
            goal
            title
            threshold
            startedAt
            endedAt
            metricConfig {
              metricName
              title
              id
              min
              max
            }
            permissions {
              canCompleteActionItems
              canManageGoal
            }
            reachedCount
          }
        }
      }
    }
    freeformGoals: freeformGoals(filters: { entityIds: $employeeIds, status: $status })
      @skip(if: $skipEmployees) {
      pageInfo {
        endCursor
        startCursor
        hasNextPage
      }
      edges {
        node {
          actionItems(status: ALL) {
            action
            actionable {
              ... on MetricGoalEmployee {
                id
              }
            }
            completedAt
            createdAt
            id
          }
          archivedAt
          completedAt
          createdAt
          creator {
            id
            profile {
              id
              fullName
              imageUrl
            }
          }
          startedAt
          endedAt
          displayValue: title
          id
          permissions {
            canCompleteActionItems
            canManageGoal
          }
        }
      }
    }
  }
`;

/**
 * __useGetMetricGoalsQuery__
 *
 * To run a query within a React component, call `useGetMetricGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricGoalsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *      employeeIds: // value for 'employeeIds'
 *      teamIds: // value for 'teamIds'
 *      skipTeams: // value for 'skipTeams'
 *      skipEmployees: // value for 'skipEmployees'
 *   },
 * });
 */
export function useGetMetricGoalsQuery(
  baseOptions: Apollo.QueryHookOptions<GetMetricGoalsQuery, GetMetricGoalsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricGoalsQuery, GetMetricGoalsQueryVariables>(
    GetMetricGoalsDocument,
    options
  );
}
export function useGetMetricGoalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMetricGoalsQuery, GetMetricGoalsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricGoalsQuery, GetMetricGoalsQueryVariables>(
    GetMetricGoalsDocument,
    options
  );
}
export type GetMetricGoalsQueryHookResult = ReturnType<typeof useGetMetricGoalsQuery>;
export type GetMetricGoalsLazyQueryHookResult = ReturnType<typeof useGetMetricGoalsLazyQuery>;
export type GetMetricGoalsQueryResult = Apollo.QueryResult<
  GetMetricGoalsQuery,
  GetMetricGoalsQueryVariables
>;
export const GetMetricTrendByGroupDocument = gql`
  query getMetricTrendByGroup(
    $filters: MetricFilterInput!
    $metric: MetricInput!
    $groupBy: MetricGroupByEnum!
    $interval: TimePeriodEnum = WEEK
  ) {
    calculateMetricTrendByGroup(
      filters: $filters
      groupBy: $groupBy
      metric: $metric
      interval: $interval
    ) {
      dates
      dateRanges {
        endDate
        startDate
      }
      totalPercentage
      displayPercentage
      timeSeries {
        displayValues
        values
        totalResults
        name
        displayPercentages
        totalPercentages
        targetAnswers
      }
      title
      totalResults
      nickname
      questionIdentifier
    }
  }
`;

/**
 * __useGetMetricTrendByGroupQuery__
 *
 * To run a query within a React component, call `useGetMetricTrendByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricTrendByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricTrendByGroupQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      metric: // value for 'metric'
 *      groupBy: // value for 'groupBy'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useGetMetricTrendByGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMetricTrendByGroupQuery,
    GetMetricTrendByGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMetricTrendByGroupQuery, GetMetricTrendByGroupQueryVariables>(
    GetMetricTrendByGroupDocument,
    options
  );
}
export function useGetMetricTrendByGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMetricTrendByGroupQuery,
    GetMetricTrendByGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMetricTrendByGroupQuery, GetMetricTrendByGroupQueryVariables>(
    GetMetricTrendByGroupDocument,
    options
  );
}
export type GetMetricTrendByGroupQueryHookResult = ReturnType<typeof useGetMetricTrendByGroupQuery>;
export type GetMetricTrendByGroupLazyQueryHookResult = ReturnType<
  typeof useGetMetricTrendByGroupLazyQuery
>;
export type GetMetricTrendByGroupQueryResult = Apollo.QueryResult<
  GetMetricTrendByGroupQuery,
  GetMetricTrendByGroupQueryVariables
>;
export const GetMyQaAssignmentsDocument = gql`
  query getMyQaAssignments(
    $archived: Boolean = false
    $sort: MyQaAssignmentSortInput = { field: createdAt, direction: DESC }
    $limit: Int = 10
    $page: Int = 1
  ) {
    myQaAssignments(archived: $archived, sort: $sort, limit: $limit, page: $page) {
      collection {
        id
        name
        cadence
        numberOfDays
        progress
        assigned
        assignedBefore
        completed
        skipped
        totalReviewers
        totalReviewees
        initialStartDate
        startDate
        endDate
        archivedAt
        effectiveAt
        createdAt
        updatedAt
        qaFormId
        qaReviewType
        revieweesStats {
          added
          removed
        }
        reviewersStats {
          added
          removed
        }
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

/**
 * __useGetMyQaAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetMyQaAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyQaAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyQaAssignmentsQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetMyQaAssignmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMyQaAssignmentsQuery, GetMyQaAssignmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyQaAssignmentsQuery, GetMyQaAssignmentsQueryVariables>(
    GetMyQaAssignmentsDocument,
    options
  );
}
export function useGetMyQaAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyQaAssignmentsQuery,
    GetMyQaAssignmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyQaAssignmentsQuery, GetMyQaAssignmentsQueryVariables>(
    GetMyQaAssignmentsDocument,
    options
  );
}
export type GetMyQaAssignmentsQueryHookResult = ReturnType<typeof useGetMyQaAssignmentsQuery>;
export type GetMyQaAssignmentsLazyQueryHookResult = ReturnType<
  typeof useGetMyQaAssignmentsLazyQuery
>;
export type GetMyQaAssignmentsQueryResult = Apollo.QueryResult<
  GetMyQaAssignmentsQuery,
  GetMyQaAssignmentsQueryVariables
>;
export const GetMyQaAssignmentsStatusDocument = gql`
  query getMyQaAssignmentsStatus {
    myQaAssignmentsStatus {
      isChanged
    }
  }
`;

/**
 * __useGetMyQaAssignmentsStatusQuery__
 *
 * To run a query within a React component, call `useGetMyQaAssignmentsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyQaAssignmentsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyQaAssignmentsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyQaAssignmentsStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyQaAssignmentsStatusQuery,
    GetMyQaAssignmentsStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyQaAssignmentsStatusQuery, GetMyQaAssignmentsStatusQueryVariables>(
    GetMyQaAssignmentsStatusDocument,
    options
  );
}
export function useGetMyQaAssignmentsStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyQaAssignmentsStatusQuery,
    GetMyQaAssignmentsStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyQaAssignmentsStatusQuery, GetMyQaAssignmentsStatusQueryVariables>(
    GetMyQaAssignmentsStatusDocument,
    options
  );
}
export type GetMyQaAssignmentsStatusQueryHookResult = ReturnType<
  typeof useGetMyQaAssignmentsStatusQuery
>;
export type GetMyQaAssignmentsStatusLazyQueryHookResult = ReturnType<
  typeof useGetMyQaAssignmentsStatusLazyQuery
>;
export type GetMyQaAssignmentsStatusQueryResult = Apollo.QueryResult<
  GetMyQaAssignmentsStatusQuery,
  GetMyQaAssignmentsStatusQueryVariables
>;
export const GetMyQaAssignmentsStatusDetailsDocument = gql`
  query getMyQaAssignmentsStatusDetails {
    myQaAssignmentsStatus {
      isChanged
      assigned
      assignedBefore
      totalAssignmentsAffected
      revieweesStats {
        added
        allPeriod
        removed
        total
      }
      reviewersStats {
        added
        allPeriod
        removed
        total
      }
    }
  }
`;

/**
 * __useGetMyQaAssignmentsStatusDetailsQuery__
 *
 * To run a query within a React component, call `useGetMyQaAssignmentsStatusDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyQaAssignmentsStatusDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyQaAssignmentsStatusDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyQaAssignmentsStatusDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyQaAssignmentsStatusDetailsQuery,
    GetMyQaAssignmentsStatusDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMyQaAssignmentsStatusDetailsQuery,
    GetMyQaAssignmentsStatusDetailsQueryVariables
  >(GetMyQaAssignmentsStatusDetailsDocument, options);
}
export function useGetMyQaAssignmentsStatusDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyQaAssignmentsStatusDetailsQuery,
    GetMyQaAssignmentsStatusDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMyQaAssignmentsStatusDetailsQuery,
    GetMyQaAssignmentsStatusDetailsQueryVariables
  >(GetMyQaAssignmentsStatusDetailsDocument, options);
}
export type GetMyQaAssignmentsStatusDetailsQueryHookResult = ReturnType<
  typeof useGetMyQaAssignmentsStatusDetailsQuery
>;
export type GetMyQaAssignmentsStatusDetailsLazyQueryHookResult = ReturnType<
  typeof useGetMyQaAssignmentsStatusDetailsLazyQuery
>;
export type GetMyQaAssignmentsStatusDetailsQueryResult = Apollo.QueryResult<
  GetMyQaAssignmentsStatusDetailsQuery,
  GetMyQaAssignmentsStatusDetailsQueryVariables
>;
export const GetPaginatedUsersDataDocument = gql`
  query getPaginatedUsersData(
    $filters: EmployeeFilterInput
    $limit: Int
    $page: Int
    $sort: [EmployeeSortInput!]
  ) {
    employeesPaginated(filters: $filters, limit: $limit, page: $page, sort: $sort) {
      collection {
        id
        canManageTeams
        demotable
        profile {
          id
          fullName
          imageUrl
        }
        primaryTeam {
          id
          owner {
            id
            profile {
              id
              fullName
            }
          }
          agentsCount
        }
        supervisor {
          id
          fullName
        }
        status
        lastActive
        email
        customRole {
          id
          name
          legacy
          roleTemplate
        }
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

/**
 * __useGetPaginatedUsersDataQuery__
 *
 * To run a query within a React component, call `useGetPaginatedUsersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedUsersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedUsersDataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPaginatedUsersDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPaginatedUsersDataQuery,
    GetPaginatedUsersDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPaginatedUsersDataQuery, GetPaginatedUsersDataQueryVariables>(
    GetPaginatedUsersDataDocument,
    options
  );
}
export function useGetPaginatedUsersDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaginatedUsersDataQuery,
    GetPaginatedUsersDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPaginatedUsersDataQuery, GetPaginatedUsersDataQueryVariables>(
    GetPaginatedUsersDataDocument,
    options
  );
}
export type GetPaginatedUsersDataQueryHookResult = ReturnType<typeof useGetPaginatedUsersDataQuery>;
export type GetPaginatedUsersDataLazyQueryHookResult = ReturnType<
  typeof useGetPaginatedUsersDataLazyQuery
>;
export type GetPaginatedUsersDataQueryResult = Apollo.QueryResult<
  GetPaginatedUsersDataQuery,
  GetPaginatedUsersDataQueryVariables
>;
export const GetPastGoalsDocument = gql`
  query getPastGoals($filters: PastGoalFilterInput!) {
    pastGoals(filters: $filters) {
      pageInfo {
        endCursor
        startCursor
        hasNextPage
      }
      edges {
        node {
          id
          archivedAt
          completedAt
          createdAt
          creator {
            id
            profile {
              id
              fullName
              imageUrl
            }
          }
          title
          startedAt
          endedAt
        }
      }
    }
  }
`;

/**
 * __useGetPastGoalsQuery__
 *
 * To run a query within a React component, call `useGetPastGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastGoalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPastGoalsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPastGoalsQuery, GetPastGoalsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPastGoalsQuery, GetPastGoalsQueryVariables>(
    GetPastGoalsDocument,
    options
  );
}
export function useGetPastGoalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPastGoalsQuery, GetPastGoalsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPastGoalsQuery, GetPastGoalsQueryVariables>(
    GetPastGoalsDocument,
    options
  );
}
export type GetPastGoalsQueryHookResult = ReturnType<typeof useGetPastGoalsQuery>;
export type GetPastGoalsLazyQueryHookResult = ReturnType<typeof useGetPastGoalsLazyQuery>;
export type GetPastGoalsQueryResult = Apollo.QueryResult<
  GetPastGoalsQuery,
  GetPastGoalsQueryVariables
>;
export const GetPropertiesFilterDataDocument = gql`
  query getPropertiesFilterData(
    $propertyKeyId: ID
    $searchTerm: String
    $filterValues: [String!]
    $first: Int = 50
    $after: String = ""
  ) {
    properties(
      first: $first
      after: $after
      propertyKeyId: $propertyKeyId
      filterValues: $filterValues
      searchTerm: $searchTerm
    ) {
      edges {
        node {
          value
          id
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetPropertiesFilterDataQuery__
 *
 * To run a query within a React component, call `useGetPropertiesFilterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesFilterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesFilterDataQuery({
 *   variables: {
 *      propertyKeyId: // value for 'propertyKeyId'
 *      searchTerm: // value for 'searchTerm'
 *      filterValues: // value for 'filterValues'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPropertiesFilterDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPropertiesFilterDataQuery,
    GetPropertiesFilterDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPropertiesFilterDataQuery, GetPropertiesFilterDataQueryVariables>(
    GetPropertiesFilterDataDocument,
    options
  );
}
export function useGetPropertiesFilterDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPropertiesFilterDataQuery,
    GetPropertiesFilterDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPropertiesFilterDataQuery, GetPropertiesFilterDataQueryVariables>(
    GetPropertiesFilterDataDocument,
    options
  );
}
export type GetPropertiesFilterDataQueryHookResult = ReturnType<
  typeof useGetPropertiesFilterDataQuery
>;
export type GetPropertiesFilterDataLazyQueryHookResult = ReturnType<
  typeof useGetPropertiesFilterDataLazyQuery
>;
export type GetPropertiesFilterDataQueryResult = Apollo.QueryResult<
  GetPropertiesFilterDataQuery,
  GetPropertiesFilterDataQueryVariables
>;
export const GetQaCalibrationDocument = gql`
  query getQaCalibration($id: ID!, $currentPersonId: ID!) {
    qaCalibration(id: $id) {
      id
      completedAt
      alignmentScore
      meetingAt
      notes
      status
      interactionId
      participants {
        totalCount
      }
      employee {
        id
        profile {
          id
          fullName
          imageUrl
        }
      }
      currentPersonReview: qaReviews(reviewerId: $currentPersonId) {
        nodes {
          id
          completedAt
          interaction {
            id
            interactionEvents {
              id
            }
          }
        }
      }
      firstReview: qaReviews(first: 1) {
        nodes {
          id
          interaction {
            id
            interactionEvents {
              id
            }
          }
        }
      }
      completedReviews: qaReviews(status: COMPLETED) {
        totalCount
      }
    }
  }
`;

/**
 * __useGetQaCalibrationQuery__
 *
 * To run a query within a React component, call `useGetQaCalibrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaCalibrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaCalibrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currentPersonId: // value for 'currentPersonId'
 *   },
 * });
 */
export function useGetQaCalibrationQuery(
  baseOptions: Apollo.QueryHookOptions<GetQaCalibrationQuery, GetQaCalibrationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaCalibrationQuery, GetQaCalibrationQueryVariables>(
    GetQaCalibrationDocument,
    options
  );
}
export function useGetQaCalibrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQaCalibrationQuery, GetQaCalibrationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQaCalibrationQuery, GetQaCalibrationQueryVariables>(
    GetQaCalibrationDocument,
    options
  );
}
export type GetQaCalibrationQueryHookResult = ReturnType<typeof useGetQaCalibrationQuery>;
export type GetQaCalibrationLazyQueryHookResult = ReturnType<typeof useGetQaCalibrationLazyQuery>;
export type GetQaCalibrationQueryResult = Apollo.QueryResult<
  GetQaCalibrationQuery,
  GetQaCalibrationQueryVariables
>;
export const GetQaCalibrationsDocument = gql`
  query getQaCalibrations(
    $limit: Int = 10
    $page: Int = 1
    $filters: QaCalibrationsFilterInput
    $sort: SortInput
    $currentPersonId: ID
    $includeCurrentPersonReview: Boolean! = false
  ) {
    qaCalibrations(limit: $limit, page: $page, filters: $filters, sort: $sort) {
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
      collection {
        id
        meetingAt
        status
        alignmentScore
        completedAt
        createdAt
        interactionId
        participants(first: 8) {
          totalCount
          edges {
            node {
              id
              profile {
                id
                imageUrl
                fullName
              }
            }
          }
        }
        employee {
          id
          profile {
            id
            fullName
            imageUrl
          }
        }
        completedReviews: qaReviews(status: COMPLETED) {
          totalCount
        }
        currentPersonReview: qaReviews(reviewerId: $currentPersonId)
          @include(if: $includeCurrentPersonReview) {
          nodes {
            id
            completedAt
          }
        }
      }
    }
  }
`;

/**
 * __useGetQaCalibrationsQuery__
 *
 * To run a query within a React component, call `useGetQaCalibrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaCalibrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaCalibrationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      currentPersonId: // value for 'currentPersonId'
 *      includeCurrentPersonReview: // value for 'includeCurrentPersonReview'
 *   },
 * });
 */
export function useGetQaCalibrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetQaCalibrationsQuery, GetQaCalibrationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaCalibrationsQuery, GetQaCalibrationsQueryVariables>(
    GetQaCalibrationsDocument,
    options
  );
}
export function useGetQaCalibrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQaCalibrationsQuery, GetQaCalibrationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQaCalibrationsQuery, GetQaCalibrationsQueryVariables>(
    GetQaCalibrationsDocument,
    options
  );
}
export type GetQaCalibrationsQueryHookResult = ReturnType<typeof useGetQaCalibrationsQuery>;
export type GetQaCalibrationsLazyQueryHookResult = ReturnType<typeof useGetQaCalibrationsLazyQuery>;
export type GetQaCalibrationsQueryResult = Apollo.QueryResult<
  GetQaCalibrationsQuery,
  GetQaCalibrationsQueryVariables
>;
export const GetQaCalibrationReviewsDocument = gql`
  query getQaCalibrationReviews(
    $id: ID!
    $status: QaCalibrationReviewStatusEnum
    $search: [QaCalibrationReviewSearchInput!]
    $after: String
    $first: Int = 10
  ) {
    qaCalibration(id: $id) {
      id
      qaReviews(status: $status, search: $search, first: $first, after: $after) {
        totalCount
        edges {
          node {
            id
            completedAt
            startedAt
            reviewer {
              id
              profile {
                id
                fullName
                imageUrl
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

/**
 * __useGetQaCalibrationReviewsQuery__
 *
 * To run a query within a React component, call `useGetQaCalibrationReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaCalibrationReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaCalibrationReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetQaCalibrationReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQaCalibrationReviewsQuery,
    GetQaCalibrationReviewsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaCalibrationReviewsQuery, GetQaCalibrationReviewsQueryVariables>(
    GetQaCalibrationReviewsDocument,
    options
  );
}
export function useGetQaCalibrationReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQaCalibrationReviewsQuery,
    GetQaCalibrationReviewsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQaCalibrationReviewsQuery, GetQaCalibrationReviewsQueryVariables>(
    GetQaCalibrationReviewsDocument,
    options
  );
}
export type GetQaCalibrationReviewsQueryHookResult = ReturnType<
  typeof useGetQaCalibrationReviewsQuery
>;
export type GetQaCalibrationReviewsLazyQueryHookResult = ReturnType<
  typeof useGetQaCalibrationReviewsLazyQuery
>;
export type GetQaCalibrationReviewsQueryResult = Apollo.QueryResult<
  GetQaCalibrationReviewsQuery,
  GetQaCalibrationReviewsQueryVariables
>;
export const GetQaFormsDocument = gql`
  query getQaForms(
    $type: QaFormTypeEnum = REGULAR
    $archived: Boolean = false
    $after: String = ""
    $before: String = ""
    $first: Int = 20
    $id: ID
  ) {
    qaForms(
      type: $type
      archived: $archived
      after: $after
      before: $before
      first: $first
      id: $id
    ) {
      edges {
        node {
          id
          name
          type
          editable
          archived
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetQaFormsQuery__
 *
 * To run a query within a React component, call `useGetQaFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaFormsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      archived: // value for 'archived'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQaFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetQaFormsQuery, GetQaFormsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaFormsQuery, GetQaFormsQueryVariables>(GetQaFormsDocument, options);
}
export function useGetQaFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQaFormsQuery, GetQaFormsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQaFormsQuery, GetQaFormsQueryVariables>(
    GetQaFormsDocument,
    options
  );
}
export type GetQaFormsQueryHookResult = ReturnType<typeof useGetQaFormsQuery>;
export type GetQaFormsLazyQueryHookResult = ReturnType<typeof useGetQaFormsLazyQuery>;
export type GetQaFormsQueryResult = Apollo.QueryResult<GetQaFormsQuery, GetQaFormsQueryVariables>;
export const GetQaFormDetailsDocument = gql`
  query getQaFormDetails($id: ID!) {
    qaForm(id: $id) {
      id
      name
    }
  }
`;

/**
 * __useGetQaFormDetailsQuery__
 *
 * To run a query within a React component, call `useGetQaFormDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaFormDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaFormDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQaFormDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<GetQaFormDetailsQuery, GetQaFormDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaFormDetailsQuery, GetQaFormDetailsQueryVariables>(
    GetQaFormDetailsDocument,
    options
  );
}
export function useGetQaFormDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQaFormDetailsQuery, GetQaFormDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQaFormDetailsQuery, GetQaFormDetailsQueryVariables>(
    GetQaFormDetailsDocument,
    options
  );
}
export type GetQaFormDetailsQueryHookResult = ReturnType<typeof useGetQaFormDetailsQuery>;
export type GetQaFormDetailsLazyQueryHookResult = ReturnType<typeof useGetQaFormDetailsLazyQuery>;
export type GetQaFormDetailsQueryResult = Apollo.QueryResult<
  GetQaFormDetailsQuery,
  GetQaFormDetailsQueryVariables
>;
export const GetQaReviewHistoryDocument = gql`
  query getQaReviewHistory($id: ID!) {
    qaHistory(id: $id) {
      collection {
        attributeName
        createdAt
        event
        item {
          ... on QaAnswer {
            __typename
            id
            updatedAt
            qaQuestion {
              id
              qaFormSection {
                id
                title
                position
              }
              text
              position
              qaOptions {
                id
                text
              }
            }
            qaOption {
              id
              text
            }
          }
          ... on QaReviewRegular {
            id
            __typename
          }
        }
        valueAfter
        valueBefore
        employee {
          id
          profile {
            fullName
            id
            imageUrl
          }
        }
      }
    }
  }
`;

/**
 * __useGetQaReviewHistoryQuery__
 *
 * To run a query within a React component, call `useGetQaReviewHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaReviewHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaReviewHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQaReviewHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<GetQaReviewHistoryQuery, GetQaReviewHistoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQaReviewHistoryQuery, GetQaReviewHistoryQueryVariables>(
    GetQaReviewHistoryDocument,
    options
  );
}
export function useGetQaReviewHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQaReviewHistoryQuery,
    GetQaReviewHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQaReviewHistoryQuery, GetQaReviewHistoryQueryVariables>(
    GetQaReviewHistoryDocument,
    options
  );
}
export type GetQaReviewHistoryQueryHookResult = ReturnType<typeof useGetQaReviewHistoryQuery>;
export type GetQaReviewHistoryLazyQueryHookResult = ReturnType<
  typeof useGetQaReviewHistoryLazyQuery
>;
export type GetQaReviewHistoryQueryResult = Apollo.QueryResult<
  GetQaReviewHistoryQuery,
  GetQaReviewHistoryQueryVariables
>;
export const GetRecentlyCoachedEmployeesDocument = gql`
  query getRecentlyCoachedEmployees(
    $dateRange: DateRangeInput!
    $isRoot: Boolean = false
    $teamIds: [ID!]
  ) {
    coacheesData(
      filters: {
        dateRange: $dateRange
        isRoot: $isRoot
        teamIds: $teamIds
        entityType: EMPLOYEE
        allHierarchy: true
      }
      first: 10
      sort: { field: LAST_SESSION, direction: DESC }
    ) {
      edges {
        node {
          entityId
          entityType
          name
          imageUrl
        }
      }
    }
  }
`;

/**
 * __useGetRecentlyCoachedEmployeesQuery__
 *
 * To run a query within a React component, call `useGetRecentlyCoachedEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentlyCoachedEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentlyCoachedEmployeesQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      isRoot: // value for 'isRoot'
 *      teamIds: // value for 'teamIds'
 *   },
 * });
 */
export function useGetRecentlyCoachedEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRecentlyCoachedEmployeesQuery,
    GetRecentlyCoachedEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRecentlyCoachedEmployeesQuery,
    GetRecentlyCoachedEmployeesQueryVariables
  >(GetRecentlyCoachedEmployeesDocument, options);
}
export function useGetRecentlyCoachedEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecentlyCoachedEmployeesQuery,
    GetRecentlyCoachedEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRecentlyCoachedEmployeesQuery,
    GetRecentlyCoachedEmployeesQueryVariables
  >(GetRecentlyCoachedEmployeesDocument, options);
}
export type GetRecentlyCoachedEmployeesQueryHookResult = ReturnType<
  typeof useGetRecentlyCoachedEmployeesQuery
>;
export type GetRecentlyCoachedEmployeesLazyQueryHookResult = ReturnType<
  typeof useGetRecentlyCoachedEmployeesLazyQuery
>;
export type GetRecentlyCoachedEmployeesQueryResult = Apollo.QueryResult<
  GetRecentlyCoachedEmployeesQuery,
  GetRecentlyCoachedEmployeesQueryVariables
>;
export const GetReportingGroupWithCriteriaDocument = gql`
  query getReportingGroupWithCriteria($id: ID!) {
    reportingGroup(id: $id) {
      active
      color
      createdAt
      criteria {
        criterionType
        id
        operator
        period
        periodValue
        value
      }
      description
      emoji
      hidden
      filterable
      id
      image
      matchAll
      name
      parentId
      streamFooterDisplayable
      updatedAt
    }
  }
`;

/**
 * __useGetReportingGroupWithCriteriaQuery__
 *
 * To run a query within a React component, call `useGetReportingGroupWithCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingGroupWithCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingGroupWithCriteriaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportingGroupWithCriteriaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportingGroupWithCriteriaQuery,
    GetReportingGroupWithCriteriaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportingGroupWithCriteriaQuery,
    GetReportingGroupWithCriteriaQueryVariables
  >(GetReportingGroupWithCriteriaDocument, options);
}
export function useGetReportingGroupWithCriteriaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportingGroupWithCriteriaQuery,
    GetReportingGroupWithCriteriaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportingGroupWithCriteriaQuery,
    GetReportingGroupWithCriteriaQueryVariables
  >(GetReportingGroupWithCriteriaDocument, options);
}
export type GetReportingGroupWithCriteriaQueryHookResult = ReturnType<
  typeof useGetReportingGroupWithCriteriaQuery
>;
export type GetReportingGroupWithCriteriaLazyQueryHookResult = ReturnType<
  typeof useGetReportingGroupWithCriteriaLazyQuery
>;
export type GetReportingGroupWithCriteriaQueryResult = Apollo.QueryResult<
  GetReportingGroupWithCriteriaQuery,
  GetReportingGroupWithCriteriaQueryVariables
>;
export const GetReportingGroupsDocument = gql`
  query getReportingGroups(
    $first: Int = 10
    $after: String = ""
    $name: String
    $filters: ReportingGroupFilterInput = {}
    $employeeFilters: EmployeeFilterInput = { status: ACTIVE }
    $productArea: ProductArea
    $between: DateRangeInput
  ) {
    reportingGroups(
      first: $first
      after: $after
      name: $name
      filters: $filters
      productArea: $productArea
    ) {
      edges {
        node {
          id
          name
          color
          emoji
          image
          members(filters: $employeeFilters, between: $between) {
            nodes {
              id
            }
            totalCount
          }
          children {
            totalCount
            nodes {
              id
              name
              members(filters: $employeeFilters, between: $between) {
                totalCount
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetReportingGroupsQuery__
 *
 * To run a query within a React component, call `useGetReportingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      filters: // value for 'filters'
 *      employeeFilters: // value for 'employeeFilters'
 *      productArea: // value for 'productArea'
 *      between: // value for 'between'
 *   },
 * });
 */
export function useGetReportingGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetReportingGroupsQuery, GetReportingGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportingGroupsQuery, GetReportingGroupsQueryVariables>(
    GetReportingGroupsDocument,
    options
  );
}
export function useGetReportingGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportingGroupsQuery,
    GetReportingGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportingGroupsQuery, GetReportingGroupsQueryVariables>(
    GetReportingGroupsDocument,
    options
  );
}
export type GetReportingGroupsQueryHookResult = ReturnType<typeof useGetReportingGroupsQuery>;
export type GetReportingGroupsLazyQueryHookResult = ReturnType<
  typeof useGetReportingGroupsLazyQuery
>;
export type GetReportingGroupsQueryResult = Apollo.QueryResult<
  GetReportingGroupsQuery,
  GetReportingGroupsQueryVariables
>;
export const GetReportingTimestampConfigDocument = gql`
  query getReportingTimestampConfig {
    dateFilterConfig {
      solicitationReportingTimestamp
    }
  }
`;

/**
 * __useGetReportingTimestampConfigQuery__
 *
 * To run a query within a React component, call `useGetReportingTimestampConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingTimestampConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingTimestampConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportingTimestampConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportingTimestampConfigQuery,
    GetReportingTimestampConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportingTimestampConfigQuery,
    GetReportingTimestampConfigQueryVariables
  >(GetReportingTimestampConfigDocument, options);
}
export function useGetReportingTimestampConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportingTimestampConfigQuery,
    GetReportingTimestampConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportingTimestampConfigQuery,
    GetReportingTimestampConfigQueryVariables
  >(GetReportingTimestampConfigDocument, options);
}
export type GetReportingTimestampConfigQueryHookResult = ReturnType<
  typeof useGetReportingTimestampConfigQuery
>;
export type GetReportingTimestampConfigLazyQueryHookResult = ReturnType<
  typeof useGetReportingTimestampConfigLazyQuery
>;
export type GetReportingTimestampConfigQueryResult = Apollo.QueryResult<
  GetReportingTimestampConfigQuery,
  GetReportingTimestampConfigQueryVariables
>;
export const GetResponseTagsDocument = gql`
  query getResponseTags($responseTag: [ResponseTagTypeEnum!]) {
    responseTags(types: $responseTag) {
      caption
      id
      iconName
      imageUrl
      identifier
    }
  }
`;

/**
 * __useGetResponseTagsQuery__
 *
 * To run a query within a React component, call `useGetResponseTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponseTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponseTagsQuery({
 *   variables: {
 *      responseTag: // value for 'responseTag'
 *   },
 * });
 */
export function useGetResponseTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetResponseTagsQuery, GetResponseTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetResponseTagsQuery, GetResponseTagsQueryVariables>(
    GetResponseTagsDocument,
    options
  );
}
export function useGetResponseTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetResponseTagsQuery, GetResponseTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetResponseTagsQuery, GetResponseTagsQueryVariables>(
    GetResponseTagsDocument,
    options
  );
}
export type GetResponseTagsQueryHookResult = ReturnType<typeof useGetResponseTagsQuery>;
export type GetResponseTagsLazyQueryHookResult = ReturnType<typeof useGetResponseTagsLazyQuery>;
export type GetResponseTagsQueryResult = Apollo.QueryResult<
  GetResponseTagsQuery,
  GetResponseTagsQueryVariables
>;
export const GetReviewerStatsDocument = gql`
  query getReviewerStats(
    $limit: Int = 10
    $page: Int = 1
    $filters: QaReviewFilterInput!
    $sort: ReviewerSortInput
  ) {
    reviewerStats(limit: $limit, page: $page, filters: $filters, sort: $sort) {
      collection {
        id
        firstName
        fullName
        imageUrl
        reviewsTotal {
          current
          previous
        }
        averageAuditAlignmentScore {
          current
          delta
          previous
        }
        averageAuditScore {
          current
          delta
          previous
        }
        averageQaScore {
          delta
          previous
          current
        }
      }
      metadata {
        currentPage
        totalCount
        totalPages
        limitValue
      }
    }
  }
`;

/**
 * __useGetReviewerStatsQuery__
 *
 * To run a query within a React component, call `useGetReviewerStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewerStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewerStatsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetReviewerStatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetReviewerStatsQuery, GetReviewerStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReviewerStatsQuery, GetReviewerStatsQueryVariables>(
    GetReviewerStatsDocument,
    options
  );
}
export function useGetReviewerStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReviewerStatsQuery, GetReviewerStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReviewerStatsQuery, GetReviewerStatsQueryVariables>(
    GetReviewerStatsDocument,
    options
  );
}
export type GetReviewerStatsQueryHookResult = ReturnType<typeof useGetReviewerStatsQuery>;
export type GetReviewerStatsLazyQueryHookResult = ReturnType<typeof useGetReviewerStatsLazyQuery>;
export type GetReviewerStatsQueryResult = Apollo.QueryResult<
  GetReviewerStatsQuery,
  GetReviewerStatsQueryVariables
>;
export const GetReviewStatsDocument = gql`
  query getReviewStats($filters: QaReviewFilterInput!, $skipCalibrationAudit: Boolean = true) {
    calibrationStats(filters: $filters) {
      averageAlignmentScore
      calibrationsTotal
      calibrationsTotalByRanges
    }
    auditStats(filters: $filters, auditType: REGULAR) {
      auditsTotal
      auditorsTotal
      averageAuditScoreByRanges
      averageAuditScore {
        current
        delta
        previous
      }
    }
    calibrationAuditStats: auditStats(auditType: CALIBRATION, filters: $filters)
      @skip(if: $skipCalibrationAudit) {
      auditsTotal
      auditorsTotal
      averageAuditScoreByRanges
      averageAuditScore {
        current
        delta
        previous
      }
    }
    reviewStats(filters: $filters) {
      reviewsTotal {
        current
        delta
        previous
      }
      averageQaScore {
        current
        delta
        previous
      }
      appealStats {
        appealed
        resolved
        reviewsAcknowledged
      }
      reviewsOrigin {
        assignment
        initial
        stream
      }
      qaScoreStandardDeviation
      qaAssignmentsAssigned
      averageQaScoreByRanges
      reviewsTotalByRanges
      teamMemberStats {
        agentsTotal
        teamMembersTotal
        reviewedTeamMembersTotal
        reviewedTeamMembersTotalPrior
      }
    }
  }
`;

/**
 * __useGetReviewStatsQuery__
 *
 * To run a query within a React component, call `useGetReviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      skipCalibrationAudit: // value for 'skipCalibrationAudit'
 *   },
 * });
 */
export function useGetReviewStatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetReviewStatsQuery, GetReviewStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReviewStatsQuery, GetReviewStatsQueryVariables>(
    GetReviewStatsDocument,
    options
  );
}
export function useGetReviewStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReviewStatsQuery, GetReviewStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReviewStatsQuery, GetReviewStatsQueryVariables>(
    GetReviewStatsDocument,
    options
  );
}
export type GetReviewStatsQueryHookResult = ReturnType<typeof useGetReviewStatsQuery>;
export type GetReviewStatsLazyQueryHookResult = ReturnType<typeof useGetReviewStatsLazyQuery>;
export type GetReviewStatsQueryResult = Apollo.QueryResult<
  GetReviewStatsQuery,
  GetReviewStatsQueryVariables
>;
export const GetRolesDocument = gql`
  query getRoles(
    $first: Int = 10
    $after: String = ""
    $search: [RoleSearchInput!]
    $filters: RoleFilterInput
    $employeeFilters: EmployeeFilterInput
  ) {
    roles(first: $first, after: $after, search: $search, filters: $filters) {
      nodes {
        name
        id
        employees(filters: $employeeFilters) {
          totalCount
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      employeeFilters: // value for 'employeeFilters'
 *   },
 * });
 */
export function useGetRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
}
export function useGetRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
}
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetRolesEmployeeCountDocument = gql`
  query getRolesEmployeeCount(
    $search: [RoleSearchInput!]
    $filters: RoleFilterInput = {}
    $employeeFilters: EmployeeFilterInput = { status: ACTIVE }
    $productArea: ProductArea = QA
  ) {
    rolesEmployeeCount(
      roleSearch: $search
      employeeFilters: $employeeFilters
      productArea: $productArea
      roleFilters: $filters
    ) {
      totalEmployeeCount
    }
  }
`;

/**
 * __useGetRolesEmployeeCountQuery__
 *
 * To run a query within a React component, call `useGetRolesEmployeeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesEmployeeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesEmployeeCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      employeeFilters: // value for 'employeeFilters'
 *      productArea: // value for 'productArea'
 *   },
 * });
 */
export function useGetRolesEmployeeCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRolesEmployeeCountQuery,
    GetRolesEmployeeCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRolesEmployeeCountQuery, GetRolesEmployeeCountQueryVariables>(
    GetRolesEmployeeCountDocument,
    options
  );
}
export function useGetRolesEmployeeCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRolesEmployeeCountQuery,
    GetRolesEmployeeCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRolesEmployeeCountQuery, GetRolesEmployeeCountQueryVariables>(
    GetRolesEmployeeCountDocument,
    options
  );
}
export type GetRolesEmployeeCountQueryHookResult = ReturnType<typeof useGetRolesEmployeeCountQuery>;
export type GetRolesEmployeeCountLazyQueryHookResult = ReturnType<
  typeof useGetRolesEmployeeCountLazyQuery
>;
export type GetRolesEmployeeCountQueryResult = Apollo.QueryResult<
  GetRolesEmployeeCountQuery,
  GetRolesEmployeeCountQueryVariables
>;
export const GetSkippedInteractionsDocument = gql`
  query getSkippedInteractions(
    $id: ID!
    $page: Int = 1
    $limit: Int = 10
    $filters: SkippedSolicitationFilterInput = {}
    $sort: [SkippedSolicitationSortInput!] = []
  ) {
    qaAssignment(id: $id) {
      id
      archivedAt
      qaFormId
      blind
    }
    qaAssignmentSkippedSolicitations(
      id: $id
      limit: $limit
      page: $page
      filters: $filters
      sort: $sort
    ) {
      collection {
        channel
        reviewed
        qaAllocation {
          id
        }
        solicitation {
          id
          uuid
          interaction {
            id
            extInteractionId
          }
        }
        member {
          fullName
          id
          imageUrl
        }
        reviewer {
          id
          fullName
          imageUrl
        }
        skipReason
        skipReasonDetail
        skippedDate
      }
      metadata {
        limitValue
        currentPage
        totalCount
        totalPages
      }
    }
  }
`;

/**
 * __useGetSkippedInteractionsQuery__
 *
 * To run a query within a React component, call `useGetSkippedInteractionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkippedInteractionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkippedInteractionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSkippedInteractionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSkippedInteractionsQuery,
    GetSkippedInteractionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSkippedInteractionsQuery, GetSkippedInteractionsQueryVariables>(
    GetSkippedInteractionsDocument,
    options
  );
}
export function useGetSkippedInteractionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSkippedInteractionsQuery,
    GetSkippedInteractionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSkippedInteractionsQuery, GetSkippedInteractionsQueryVariables>(
    GetSkippedInteractionsDocument,
    options
  );
}
export type GetSkippedInteractionsQueryHookResult = ReturnType<
  typeof useGetSkippedInteractionsQuery
>;
export type GetSkippedInteractionsLazyQueryHookResult = ReturnType<
  typeof useGetSkippedInteractionsLazyQuery
>;
export type GetSkippedInteractionsQueryResult = Apollo.QueryResult<
  GetSkippedInteractionsQuery,
  GetSkippedInteractionsQueryVariables
>;
export const GetSkipReasonDetailsDocument = gql`
  query getSkipReasonDetails($search: String = "", $page: Int = 1, $limit: Int = 10) {
    skipReasonDetails(search: $search, limit: $limit, page: $page)
  }
`;

/**
 * __useGetSkipReasonDetailsQuery__
 *
 * To run a query within a React component, call `useGetSkipReasonDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkipReasonDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkipReasonDetailsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSkipReasonDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSkipReasonDetailsQuery,
    GetSkipReasonDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSkipReasonDetailsQuery, GetSkipReasonDetailsQueryVariables>(
    GetSkipReasonDetailsDocument,
    options
  );
}
export function useGetSkipReasonDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSkipReasonDetailsQuery,
    GetSkipReasonDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSkipReasonDetailsQuery, GetSkipReasonDetailsQueryVariables>(
    GetSkipReasonDetailsDocument,
    options
  );
}
export type GetSkipReasonDetailsQueryHookResult = ReturnType<typeof useGetSkipReasonDetailsQuery>;
export type GetSkipReasonDetailsLazyQueryHookResult = ReturnType<
  typeof useGetSkipReasonDetailsLazyQuery
>;
export type GetSkipReasonDetailsQueryResult = Apollo.QueryResult<
  GetSkipReasonDetailsQuery,
  GetSkipReasonDetailsQueryVariables
>;
export const GetSupervisorsDocument = gql`
  query getSupervisors($after: String = "", $employeeId: ID, $search: [EmployeeSearchInput!]) {
    supervisors(employeeId: $employeeId, search: $search, after: $after) {
      edges {
        node {
          id
          fullName
          imageUrl
          primaryTeam {
            id
            name
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetSupervisorsQuery__
 *
 * To run a query within a React component, call `useGetSupervisorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisorsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      employeeId: // value for 'employeeId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSupervisorsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSupervisorsQuery, GetSupervisorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSupervisorsQuery, GetSupervisorsQueryVariables>(
    GetSupervisorsDocument,
    options
  );
}
export function useGetSupervisorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisorsQuery, GetSupervisorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSupervisorsQuery, GetSupervisorsQueryVariables>(
    GetSupervisorsDocument,
    options
  );
}
export type GetSupervisorsQueryHookResult = ReturnType<typeof useGetSupervisorsQuery>;
export type GetSupervisorsLazyQueryHookResult = ReturnType<typeof useGetSupervisorsLazyQuery>;
export type GetSupervisorsQueryResult = Apollo.QueryResult<
  GetSupervisorsQuery,
  GetSupervisorsQueryVariables
>;
export const GetSurveyConfigurationDocument = gql`
  query getSurveyConfiguration($id: String!) {
    surveyConfiguration(uuid: $id) {
      availableQuestions {
        company_id: companyId
        created_at: createdAt
        id
        identifier
        metadata
        nickname
        show_comment: showComment
        show_on_stream: showOnStream
        survey_names: surveyNames
        options: surveyOptions {
          active
          created_at: createdAt
          id
          identifier
          integer_value: integerValue
          position
          survey_question_id: surveyQuestionId
          updated_at: updatedAt
        }
        translations
        type
        updated_at: updatedAt
      }
      configuration
      configurationHash
      createdAt
      features
      filterOptions
      globalMarketingSettings
      publishedConfiguration
      publishedHash
      updatedAt
      uuid
    }
  }
`;

/**
 * __useGetSurveyConfigurationQuery__
 *
 * To run a query within a React component, call `useGetSurveyConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSurveyConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSurveyConfigurationQuery,
    GetSurveyConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSurveyConfigurationQuery, GetSurveyConfigurationQueryVariables>(
    GetSurveyConfigurationDocument,
    options
  );
}
export function useGetSurveyConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSurveyConfigurationQuery,
    GetSurveyConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSurveyConfigurationQuery, GetSurveyConfigurationQueryVariables>(
    GetSurveyConfigurationDocument,
    options
  );
}
export type GetSurveyConfigurationQueryHookResult = ReturnType<
  typeof useGetSurveyConfigurationQuery
>;
export type GetSurveyConfigurationLazyQueryHookResult = ReturnType<
  typeof useGetSurveyConfigurationLazyQuery
>;
export type GetSurveyConfigurationQueryResult = Apollo.QueryResult<
  GetSurveyConfigurationQuery,
  GetSurveyConfigurationQueryVariables
>;
export const GetSurveyConfigurationsDocument = gql`
  query getSurveyConfigurations {
    surveyConfigurations {
      configuration
      configurationHash
      createdAt
      updatedAt
      uuid
      publishedHash
    }
  }
`;

/**
 * __useGetSurveyConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetSurveyConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveyConfigurationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSurveyConfigurationsQuery,
    GetSurveyConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSurveyConfigurationsQuery, GetSurveyConfigurationsQueryVariables>(
    GetSurveyConfigurationsDocument,
    options
  );
}
export function useGetSurveyConfigurationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSurveyConfigurationsQuery,
    GetSurveyConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSurveyConfigurationsQuery, GetSurveyConfigurationsQueryVariables>(
    GetSurveyConfigurationsDocument,
    options
  );
}
export type GetSurveyConfigurationsQueryHookResult = ReturnType<
  typeof useGetSurveyConfigurationsQuery
>;
export type GetSurveyConfigurationsLazyQueryHookResult = ReturnType<
  typeof useGetSurveyConfigurationsLazyQuery
>;
export type GetSurveyConfigurationsQueryResult = Apollo.QueryResult<
  GetSurveyConfigurationsQuery,
  GetSurveyConfigurationsQueryVariables
>;
export const GetTeamDocument = gql`
  query getTeam($id: ID!) {
    team(id: $id) {
      id
      label
      name
      owner {
        customEmployeeId
        email
        id
        isActive
        profile {
          id
          imageUrl
          firstName
          lastName
          fullName
        }
      }
      employees {
        totalCount
      }
    }
  }
`;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
}
export function useGetTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
}
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamQueryResult = Apollo.QueryResult<GetTeamQuery, GetTeamQueryVariables>;
export const GetTeamsDocument = gql`
  query getTeams(
    $first: Int = 10
    $after: String = ""
    $search: [TeamSearchInput!]
    $filters: TeamFilterInput
    $productArea: ProductArea = ADMINISTRATIVE
  ) {
    teams(
      first: $first
      after: $after
      search: $search
      filters: $filters
      productArea: $productArea
    ) {
      edges {
        node {
          id
          name
          owner {
            id
            profile {
              id
              imageUrl
            }
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetTeamsQuery__
 *
 * To run a query within a React component, call `useGetTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      productArea: // value for 'productArea'
 *   },
 * });
 */
export function useGetTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
}
export function useGetTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
}
export type GetTeamsQueryHookResult = ReturnType<typeof useGetTeamsQuery>;
export type GetTeamsLazyQueryHookResult = ReturnType<typeof useGetTeamsLazyQuery>;
export type GetTeamsQueryResult = Apollo.QueryResult<GetTeamsQuery, GetTeamsQueryVariables>;
export const GetTeamsFilterDataDocument = gql`
  query getTeamsFilterData(
    $first: Int = 50
    $after: String = ""
    $search: [TeamSearchInput!]
    $filters: TeamFilterInput = {}
    $employeeFilters: EmployeeFilterInput = { status: ACTIVE }
    $productArea: ProductArea = QA
  ) {
    teams(
      first: $first
      after: $after
      search: $search
      filters: $filters
      productArea: $productArea
    ) {
      edges {
        node {
          id
          name
          owner {
            id
            profile {
              id
              imageUrl
            }
          }
          employees(filters: $employeeFilters) {
            nodes {
              id
            }
            totalCount
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetTeamsFilterDataQuery__
 *
 * To run a query within a React component, call `useGetTeamsFilterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsFilterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsFilterDataQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      employeeFilters: // value for 'employeeFilters'
 *      productArea: // value for 'productArea'
 *   },
 * });
 */
export function useGetTeamsFilterDataQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTeamsFilterDataQuery, GetTeamsFilterDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamsFilterDataQuery, GetTeamsFilterDataQueryVariables>(
    GetTeamsFilterDataDocument,
    options
  );
}
export function useGetTeamsFilterDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTeamsFilterDataQuery,
    GetTeamsFilterDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamsFilterDataQuery, GetTeamsFilterDataQueryVariables>(
    GetTeamsFilterDataDocument,
    options
  );
}
export type GetTeamsFilterDataQueryHookResult = ReturnType<typeof useGetTeamsFilterDataQuery>;
export type GetTeamsFilterDataLazyQueryHookResult = ReturnType<
  typeof useGetTeamsFilterDataLazyQuery
>;
export type GetTeamsFilterDataQueryResult = Apollo.QueryResult<
  GetTeamsFilterDataQuery,
  GetTeamsFilterDataQueryVariables
>;
export const GetTeamBadgesDocument = gql`
  query getTeamBadges($teamIds: [ID!]!, $first: Int = 6) {
    teamEmployeeBadges(teamIds: $teamIds, first: $first) {
      nodes {
        id
        name
        earnedAt
        description
        iconSettings
        imageUrl
        badgeType
        badgeKey
        companyAchievement {
          id
          pathName
        }
        employee {
          id
          profile {
            firstName
            fullName
            imageUrl
            id
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useGetTeamBadgesQuery__
 *
 * To run a query within a React component, call `useGetTeamBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamBadgesQuery({
 *   variables: {
 *      teamIds: // value for 'teamIds'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetTeamBadgesQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamBadgesQuery, GetTeamBadgesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamBadgesQuery, GetTeamBadgesQueryVariables>(
    GetTeamBadgesDocument,
    options
  );
}
export function useGetTeamBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamBadgesQuery, GetTeamBadgesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamBadgesQuery, GetTeamBadgesQueryVariables>(
    GetTeamBadgesDocument,
    options
  );
}
export type GetTeamBadgesQueryHookResult = ReturnType<typeof useGetTeamBadgesQuery>;
export type GetTeamBadgesLazyQueryHookResult = ReturnType<typeof useGetTeamBadgesLazyQuery>;
export type GetTeamBadgesQueryResult = Apollo.QueryResult<
  GetTeamBadgesQuery,
  GetTeamBadgesQueryVariables
>;
export const GetTeamLeaderDocument = gql`
  query getTeamLeader($id: ID!) {
    employee(id: $id) {
      id
      primaryTeam {
        id
        owner {
          id
        }
      }
    }
  }
`;

/**
 * __useGetTeamLeaderQuery__
 *
 * To run a query within a React component, call `useGetTeamLeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamLeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamLeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamLeaderQuery(
  baseOptions: Apollo.QueryHookOptions<GetTeamLeaderQuery, GetTeamLeaderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamLeaderQuery, GetTeamLeaderQueryVariables>(
    GetTeamLeaderDocument,
    options
  );
}
export function useGetTeamLeaderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTeamLeaderQuery, GetTeamLeaderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamLeaderQuery, GetTeamLeaderQueryVariables>(
    GetTeamLeaderDocument,
    options
  );
}
export type GetTeamLeaderQueryHookResult = ReturnType<typeof useGetTeamLeaderQuery>;
export type GetTeamLeaderLazyQueryHookResult = ReturnType<typeof useGetTeamLeaderLazyQuery>;
export type GetTeamLeaderQueryResult = Apollo.QueryResult<
  GetTeamLeaderQuery,
  GetTeamLeaderQueryVariables
>;
export const GetUsersTableDataDocument = gql`
  query getUsersTableData(
    $before: String
    $after: String
    $search: [EmployeeSearchInput!]
    $filters: EmployeeFilterInput = {}
    $first: Int = 25
    $last: Int
  ) {
    employees(
      first: $first
      last: $last
      after: $after
      before: $before
      search: $search
      filters: $filters
      sort: { field: FIRST_NAME, direction: ASC }
      productArea: ADMINISTRATIVE
    ) {
      edges {
        node {
          id
          canManageTeams
          demotable
          profile {
            id
            fullName
            imageUrl
          }
          primaryTeam {
            id
            owner {
              id
              profile {
                id
                fullName
              }
            }
            agentsCount
          }
          supervisor {
            id
            fullName
          }
          status
          lastActive
          email
          customRole {
            id
            name
            legacy
            roleTemplate
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      totalCount
    }
  }
`;

/**
 * __useGetUsersTableDataQuery__
 *
 * To run a query within a React component, call `useGetUsersTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersTableDataQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetUsersTableDataQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>(
    GetUsersTableDataDocument,
    options
  );
}
export function useGetUsersTableDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>(
    GetUsersTableDataDocument,
    options
  );
}
export type GetUsersTableDataQueryHookResult = ReturnType<typeof useGetUsersTableDataQuery>;
export type GetUsersTableDataLazyQueryHookResult = ReturnType<typeof useGetUsersTableDataLazyQuery>;
export type GetUsersTableDataQueryResult = Apollo.QueryResult<
  GetUsersTableDataQuery,
  GetUsersTableDataQueryVariables
>;
export const GetWeekAndQuarterConfigurationDocument = gql`
  query getWeekAndQuarterConfiguration {
    dateFilterConfig {
      startOfWeek
      startOfQuarter {
        month
        day
      }
    }
  }
`;

/**
 * __useGetWeekAndQuarterConfigurationQuery__
 *
 * To run a query within a React component, call `useGetWeekAndQuarterConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeekAndQuarterConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeekAndQuarterConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWeekAndQuarterConfigurationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWeekAndQuarterConfigurationQuery,
    GetWeekAndQuarterConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWeekAndQuarterConfigurationQuery,
    GetWeekAndQuarterConfigurationQueryVariables
  >(GetWeekAndQuarterConfigurationDocument, options);
}
export function useGetWeekAndQuarterConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWeekAndQuarterConfigurationQuery,
    GetWeekAndQuarterConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWeekAndQuarterConfigurationQuery,
    GetWeekAndQuarterConfigurationQueryVariables
  >(GetWeekAndQuarterConfigurationDocument, options);
}
export type GetWeekAndQuarterConfigurationQueryHookResult = ReturnType<
  typeof useGetWeekAndQuarterConfigurationQuery
>;
export type GetWeekAndQuarterConfigurationLazyQueryHookResult = ReturnType<
  typeof useGetWeekAndQuarterConfigurationLazyQuery
>;
export type GetWeekAndQuarterConfigurationQueryResult = Apollo.QueryResult<
  GetWeekAndQuarterConfigurationQuery,
  GetWeekAndQuarterConfigurationQueryVariables
>;
export const ExportQaScorecardsDocument = gql`
  mutation exportQaScorecards(
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $teamIds: [ID!]
    $reportingGroupIds: [ID!]
    $employeeIds: [ID!]
    $reviewerIds: [ID!]
    $autofailed: Boolean!
    $languages: [String!]
    $channelEnumIds: [ID!]
    $propertyIds: [ID!]
  ) {
    createQaFormOverviewsExport(
      input: {
        dates: { startDate: $startDate, endDate: $endDate }
        autofailed: $autofailed
        forTeams: $teamIds
        forReportingGroups: $reportingGroupIds
        byEmployeeId: $employeeIds
        byReviewerId: $reviewerIds
        byLanguage: $languages
        byChannelEnumId: $channelEnumIds
        byPropertyId: $propertyIds
      }
    ) {
      errors {
        details
      }
      export {
        id
      }
    }
  }
`;
export type ExportQaScorecardsMutationFn = Apollo.MutationFunction<
  ExportQaScorecardsMutation,
  ExportQaScorecardsMutationVariables
>;

/**
 * __useExportQaScorecardsMutation__
 *
 * To run a mutation, you first call `useExportQaScorecardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportQaScorecardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportQaScorecardsMutation, { data, loading, error }] = useExportQaScorecardsMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      teamIds: // value for 'teamIds'
 *      reportingGroupIds: // value for 'reportingGroupIds'
 *      employeeIds: // value for 'employeeIds'
 *      reviewerIds: // value for 'reviewerIds'
 *      autofailed: // value for 'autofailed'
 *      languages: // value for 'languages'
 *      channelEnumIds: // value for 'channelEnumIds'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useExportQaScorecardsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportQaScorecardsMutation,
    ExportQaScorecardsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportQaScorecardsMutation, ExportQaScorecardsMutationVariables>(
    ExportQaScorecardsDocument,
    options
  );
}
export type ExportQaScorecardsMutationHookResult = ReturnType<typeof useExportQaScorecardsMutation>;
export type ExportQaScorecardsMutationResult = Apollo.MutationResult<ExportQaScorecardsMutation>;
export type ExportQaScorecardsMutationOptions = Apollo.BaseMutationOptions<
  ExportQaScorecardsMutation,
  ExportQaScorecardsMutationVariables
>;
export const ConfigureAreasOfExcellenceDocument = gql`
  mutation configureAreasOfExcellence($aoe: [Int!]!) {
    configureAreasOfExcellence(input: { aoe: $aoe }) {
      id
      caption
    }
  }
`;
export type ConfigureAreasOfExcellenceMutationFn = Apollo.MutationFunction<
  ConfigureAreasOfExcellenceMutation,
  ConfigureAreasOfExcellenceMutationVariables
>;

/**
 * __useConfigureAreasOfExcellenceMutation__
 *
 * To run a mutation, you first call `useConfigureAreasOfExcellenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureAreasOfExcellenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureAreasOfExcellenceMutation, { data, loading, error }] = useConfigureAreasOfExcellenceMutation({
 *   variables: {
 *      aoe: // value for 'aoe'
 *   },
 * });
 */
export function useConfigureAreasOfExcellenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfigureAreasOfExcellenceMutation,
    ConfigureAreasOfExcellenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfigureAreasOfExcellenceMutation,
    ConfigureAreasOfExcellenceMutationVariables
  >(ConfigureAreasOfExcellenceDocument, options);
}
export type ConfigureAreasOfExcellenceMutationHookResult = ReturnType<
  typeof useConfigureAreasOfExcellenceMutation
>;
export type ConfigureAreasOfExcellenceMutationResult =
  Apollo.MutationResult<ConfigureAreasOfExcellenceMutation>;
export type ConfigureAreasOfExcellenceMutationOptions = Apollo.BaseMutationOptions<
  ConfigureAreasOfExcellenceMutation,
  ConfigureAreasOfExcellenceMutationVariables
>;
export const ConfigureRewardsDocument = gql`
  mutation configureRewards(
    $rewardConfiguration: RewardTiersConfiguration!
    $thresholdsEnabled: Boolean!
    $fiveStarRewards: Boolean!
  ) {
    configureRewards(
      input: {
        rewardConfiguration: $rewardConfiguration
        thresholdsEnabled: $thresholdsEnabled
        fiveStarRewards: $fiveStarRewards
      }
    )
  }
`;
export type ConfigureRewardsMutationFn = Apollo.MutationFunction<
  ConfigureRewardsMutation,
  ConfigureRewardsMutationVariables
>;

/**
 * __useConfigureRewardsMutation__
 *
 * To run a mutation, you first call `useConfigureRewardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureRewardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureRewardsMutation, { data, loading, error }] = useConfigureRewardsMutation({
 *   variables: {
 *      rewardConfiguration: // value for 'rewardConfiguration'
 *      thresholdsEnabled: // value for 'thresholdsEnabled'
 *      fiveStarRewards: // value for 'fiveStarRewards'
 *   },
 * });
 */
export function useConfigureRewardsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfigureRewardsMutation,
    ConfigureRewardsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfigureRewardsMutation, ConfigureRewardsMutationVariables>(
    ConfigureRewardsDocument,
    options
  );
}
export type ConfigureRewardsMutationHookResult = ReturnType<typeof useConfigureRewardsMutation>;
export type ConfigureRewardsMutationResult = Apollo.MutationResult<ConfigureRewardsMutation>;
export type ConfigureRewardsMutationOptions = Apollo.BaseMutationOptions<
  ConfigureRewardsMutation,
  ConfigureRewardsMutationVariables
>;
export const ConnectSnappyDocument = gql`
  mutation connectSnappy($apiKey: String!) {
    setSnappyApiKey(input: { apiKey: $apiKey }) {
      id
      name
      enabled
    }
  }
`;
export type ConnectSnappyMutationFn = Apollo.MutationFunction<
  ConnectSnappyMutation,
  ConnectSnappyMutationVariables
>;

/**
 * __useConnectSnappyMutation__
 *
 * To run a mutation, you first call `useConnectSnappyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectSnappyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectSnappyMutation, { data, loading, error }] = useConnectSnappyMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useConnectSnappyMutation(
  baseOptions?: Apollo.MutationHookOptions<ConnectSnappyMutation, ConnectSnappyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConnectSnappyMutation, ConnectSnappyMutationVariables>(
    ConnectSnappyDocument,
    options
  );
}
export type ConnectSnappyMutationHookResult = ReturnType<typeof useConnectSnappyMutation>;
export type ConnectSnappyMutationResult = Apollo.MutationResult<ConnectSnappyMutation>;
export type ConnectSnappyMutationOptions = Apollo.BaseMutationOptions<
  ConnectSnappyMutation,
  ConnectSnappyMutationVariables
>;
export const DisconnectSnappyDocument = gql`
  mutation disconnectSnappy {
    disconnectSnappyIntegration(input: {}) {
      id
      name
      enabled
    }
  }
`;
export type DisconnectSnappyMutationFn = Apollo.MutationFunction<
  DisconnectSnappyMutation,
  DisconnectSnappyMutationVariables
>;

/**
 * __useDisconnectSnappyMutation__
 *
 * To run a mutation, you first call `useDisconnectSnappyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectSnappyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectSnappyMutation, { data, loading, error }] = useDisconnectSnappyMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectSnappyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisconnectSnappyMutation,
    DisconnectSnappyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisconnectSnappyMutation, DisconnectSnappyMutationVariables>(
    DisconnectSnappyDocument,
    options
  );
}
export type DisconnectSnappyMutationHookResult = ReturnType<typeof useDisconnectSnappyMutation>;
export type DisconnectSnappyMutationResult = Apollo.MutationResult<DisconnectSnappyMutation>;
export type DisconnectSnappyMutationOptions = Apollo.BaseMutationOptions<
  DisconnectSnappyMutation,
  DisconnectSnappyMutationVariables
>;
export const GetAreasOfExcellenceDocument = gql`
  query getAreasOfExcellence {
    company {
      id
      allAoe: areasOfExcellence {
        id
        caption
      }
      activeAoe: areasOfExcellence(status: SELECTED) {
        id
        caption
      }
    }
  }
`;

/**
 * __useGetAreasOfExcellenceQuery__
 *
 * To run a query within a React component, call `useGetAreasOfExcellenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreasOfExcellenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreasOfExcellenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAreasOfExcellenceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAreasOfExcellenceQuery,
    GetAreasOfExcellenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAreasOfExcellenceQuery, GetAreasOfExcellenceQueryVariables>(
    GetAreasOfExcellenceDocument,
    options
  );
}
export function useGetAreasOfExcellenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAreasOfExcellenceQuery,
    GetAreasOfExcellenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAreasOfExcellenceQuery, GetAreasOfExcellenceQueryVariables>(
    GetAreasOfExcellenceDocument,
    options
  );
}
export type GetAreasOfExcellenceQueryHookResult = ReturnType<typeof useGetAreasOfExcellenceQuery>;
export type GetAreasOfExcellenceLazyQueryHookResult = ReturnType<
  typeof useGetAreasOfExcellenceLazyQuery
>;
export type GetAreasOfExcellenceQueryResult = Apollo.QueryResult<
  GetAreasOfExcellenceQuery,
  GetAreasOfExcellenceQueryVariables
>;
export const GetChannelableIntegrationsDocument = gql`
  query getChannelableIntegrations {
    channelableIntegrations {
      id
      name
      enabled
    }
  }
`;

/**
 * __useGetChannelableIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetChannelableIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelableIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelableIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChannelableIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetChannelableIntegrationsQuery,
    GetChannelableIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelableIntegrationsQuery, GetChannelableIntegrationsQueryVariables>(
    GetChannelableIntegrationsDocument,
    options
  );
}
export function useGetChannelableIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChannelableIntegrationsQuery,
    GetChannelableIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChannelableIntegrationsQuery,
    GetChannelableIntegrationsQueryVariables
  >(GetChannelableIntegrationsDocument, options);
}
export type GetChannelableIntegrationsQueryHookResult = ReturnType<
  typeof useGetChannelableIntegrationsQuery
>;
export type GetChannelableIntegrationsLazyQueryHookResult = ReturnType<
  typeof useGetChannelableIntegrationsLazyQuery
>;
export type GetChannelableIntegrationsQueryResult = Apollo.QueryResult<
  GetChannelableIntegrationsQuery,
  GetChannelableIntegrationsQueryVariables
>;
export const GetChannelsDocument = gql`
  query getChannels {
    channels {
      id
      name
      slug
      active
      integrated
      integration {
        id
        name
        enabled
      }
    }
  }
`;

/**
 * __useGetChannelsQuery__
 *
 * To run a query within a React component, call `useGetChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChannelsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetChannelsQuery, GetChannelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelsQuery, GetChannelsQueryVariables>(GetChannelsDocument, options);
}
export function useGetChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsQuery, GetChannelsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelsQuery, GetChannelsQueryVariables>(
    GetChannelsDocument,
    options
  );
}
export type GetChannelsQueryHookResult = ReturnType<typeof useGetChannelsQuery>;
export type GetChannelsLazyQueryHookResult = ReturnType<typeof useGetChannelsLazyQuery>;
export type GetChannelsQueryResult = Apollo.QueryResult<
  GetChannelsQuery,
  GetChannelsQueryVariables
>;
export const GetCompanyPositiveFeedbackComponentsDocument = gql`
  query getCompanyPositiveFeedbackComponents {
    company {
      id
      positiveFeedbackComponents
    }
  }
`;

/**
 * __useGetCompanyPositiveFeedbackComponentsQuery__
 *
 * To run a query within a React component, call `useGetCompanyPositiveFeedbackComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPositiveFeedbackComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyPositiveFeedbackComponentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyPositiveFeedbackComponentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyPositiveFeedbackComponentsQuery,
    GetCompanyPositiveFeedbackComponentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCompanyPositiveFeedbackComponentsQuery,
    GetCompanyPositiveFeedbackComponentsQueryVariables
  >(GetCompanyPositiveFeedbackComponentsDocument, options);
}
export function useGetCompanyPositiveFeedbackComponentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyPositiveFeedbackComponentsQuery,
    GetCompanyPositiveFeedbackComponentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCompanyPositiveFeedbackComponentsQuery,
    GetCompanyPositiveFeedbackComponentsQueryVariables
  >(GetCompanyPositiveFeedbackComponentsDocument, options);
}
export type GetCompanyPositiveFeedbackComponentsQueryHookResult = ReturnType<
  typeof useGetCompanyPositiveFeedbackComponentsQuery
>;
export type GetCompanyPositiveFeedbackComponentsLazyQueryHookResult = ReturnType<
  typeof useGetCompanyPositiveFeedbackComponentsLazyQuery
>;
export type GetCompanyPositiveFeedbackComponentsQueryResult = Apollo.QueryResult<
  GetCompanyPositiveFeedbackComponentsQuery,
  GetCompanyPositiveFeedbackComponentsQueryVariables
>;
export const GetCompanyRewardsConfigurationDocument = gql`
  query getCompanyRewardsConfiguration {
    company {
      id
      rewards {
        id
        tier
        caption
        imageUrl
        threshold
        campaignId
        secondaryCampaignId
        displayName
      }
      thresholdsEnabled
      fiveStarRewards
      clearedAtByTier {
        low
        mid
        high
      }
    }
    snappy {
      apiKey
      enabled
    }
  }
`;

/**
 * __useGetCompanyRewardsConfigurationQuery__
 *
 * To run a query within a React component, call `useGetCompanyRewardsConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRewardsConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRewardsConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyRewardsConfigurationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyRewardsConfigurationQuery,
    GetCompanyRewardsConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCompanyRewardsConfigurationQuery,
    GetCompanyRewardsConfigurationQueryVariables
  >(GetCompanyRewardsConfigurationDocument, options);
}
export function useGetCompanyRewardsConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyRewardsConfigurationQuery,
    GetCompanyRewardsConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCompanyRewardsConfigurationQuery,
    GetCompanyRewardsConfigurationQueryVariables
  >(GetCompanyRewardsConfigurationDocument, options);
}
export type GetCompanyRewardsConfigurationQueryHookResult = ReturnType<
  typeof useGetCompanyRewardsConfigurationQuery
>;
export type GetCompanyRewardsConfigurationLazyQueryHookResult = ReturnType<
  typeof useGetCompanyRewardsConfigurationLazyQuery
>;
export type GetCompanyRewardsConfigurationQueryResult = Apollo.QueryResult<
  GetCompanyRewardsConfigurationQuery,
  GetCompanyRewardsConfigurationQueryVariables
>;
export const GetRewardsByTierDocument = gql`
  query getRewardsByTier($tier: TierEnum!) {
    rewardsByTier(tier: $tier) {
      id
      caption
      imageUrl
      tier
    }
  }
`;

/**
 * __useGetRewardsByTierQuery__
 *
 * To run a query within a React component, call `useGetRewardsByTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsByTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardsByTierQuery({
 *   variables: {
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useGetRewardsByTierQuery(
  baseOptions: Apollo.QueryHookOptions<GetRewardsByTierQuery, GetRewardsByTierQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRewardsByTierQuery, GetRewardsByTierQueryVariables>(
    GetRewardsByTierDocument,
    options
  );
}
export function useGetRewardsByTierLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRewardsByTierQuery, GetRewardsByTierQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRewardsByTierQuery, GetRewardsByTierQueryVariables>(
    GetRewardsByTierDocument,
    options
  );
}
export type GetRewardsByTierQueryHookResult = ReturnType<typeof useGetRewardsByTierQuery>;
export type GetRewardsByTierLazyQueryHookResult = ReturnType<typeof useGetRewardsByTierLazyQuery>;
export type GetRewardsByTierQueryResult = Apollo.QueryResult<
  GetRewardsByTierQuery,
  GetRewardsByTierQueryVariables
>;
export const GetSnappyCampaignsDocument = gql`
  query getSnappyCampaigns {
    snappyCampaigns {
      name
      extSnappyCampaignId
    }
  }
`;

/**
 * __useGetSnappyCampaignsQuery__
 *
 * To run a query within a React component, call `useGetSnappyCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnappyCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnappyCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSnappyCampaignsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSnappyCampaignsQuery, GetSnappyCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSnappyCampaignsQuery, GetSnappyCampaignsQueryVariables>(
    GetSnappyCampaignsDocument,
    options
  );
}
export function useGetSnappyCampaignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSnappyCampaignsQuery,
    GetSnappyCampaignsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSnappyCampaignsQuery, GetSnappyCampaignsQueryVariables>(
    GetSnappyCampaignsDocument,
    options
  );
}
export type GetSnappyCampaignsQueryHookResult = ReturnType<typeof useGetSnappyCampaignsQuery>;
export type GetSnappyCampaignsLazyQueryHookResult = ReturnType<
  typeof useGetSnappyCampaignsLazyQuery
>;
export type GetSnappyCampaignsQueryResult = Apollo.QueryResult<
  GetSnappyCampaignsQuery,
  GetSnappyCampaignsQueryVariables
>;
export const UpdateChannelIntegrationsDocument = gql`
  mutation updateChannelIntegrations($channelIntegrations: [ChannelIntegrationInput!]!) {
    updateChannelIntegrations(input: { channelIntegrations: $channelIntegrations }) {
      id
      integration {
        id
      }
    }
  }
`;
export type UpdateChannelIntegrationsMutationFn = Apollo.MutationFunction<
  UpdateChannelIntegrationsMutation,
  UpdateChannelIntegrationsMutationVariables
>;

/**
 * __useUpdateChannelIntegrationsMutation__
 *
 * To run a mutation, you first call `useUpdateChannelIntegrationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelIntegrationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelIntegrationsMutation, { data, loading, error }] = useUpdateChannelIntegrationsMutation({
 *   variables: {
 *      channelIntegrations: // value for 'channelIntegrations'
 *   },
 * });
 */
export function useUpdateChannelIntegrationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChannelIntegrationsMutation,
    UpdateChannelIntegrationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChannelIntegrationsMutation,
    UpdateChannelIntegrationsMutationVariables
  >(UpdateChannelIntegrationsDocument, options);
}
export type UpdateChannelIntegrationsMutationHookResult = ReturnType<
  typeof useUpdateChannelIntegrationsMutation
>;
export type UpdateChannelIntegrationsMutationResult =
  Apollo.MutationResult<UpdateChannelIntegrationsMutation>;
export type UpdateChannelIntegrationsMutationOptions = Apollo.BaseMutationOptions<
  UpdateChannelIntegrationsMutation,
  UpdateChannelIntegrationsMutationVariables
>;
